/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  AppBar,
  Avatar,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import InfoIcon from '@material-ui/icons/Info';
import SearchIcon from '@material-ui/icons/Search';
import { cloneDeep, isEmpty, isEqual, pickBy, set, uniqBy } from 'lodash-es';
import { MTableToolbar } from 'material-table';
import moment from 'moment';
import React, { JSX, ReactElement } from 'react';
import update from 'react-addons-update';
import { default as NumberFormat } from 'react-number-format';
import { Link } from 'react-router-dom';

import { BidderEventTypes, track } from '~/src/dash/analytics/analytics';
import { targetingInactiveAudienceSegments } from '~/src/dash/api/audience-segment';
import { IAdserverCampaign } from '~/src/dash/api/campaign/campaign';
import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import {
  createChannelList,
  getChannelListsPromise,
  updateChannelList,
} from '~/src/dash/api/channel-list';
import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import { createCompany, deleteCompany, ECompanyType, updateCompany } from '~/src/dash/api/company';
import {
  ABTestingActiveActive,
  ABTestingActiveInactive,
  AudienceSegmentActiveActive,
  bulkUpdateBidders,
  ConvertTargetingCoppaToText,
  createHeaderBidder,
  EAllowStatus,
  EHeaderBidder_PoddedRequestType,
  ExtendedIDSetting,
  ExtendedIDSettingDoNotPass,
  ExtendedIDSettingInherit,
  ExtendedIDSettingPass,
  FallbackBackfillDisabled,
  FallbackBackfillEnabled,
  genExportCampaignWithCampaignID,
  genExportCampaignWithoutCampaignID,
  getAudienceSegments,
  getBidderLabels,
  getCampaigns,
  getChannelIDs,
  getChannelLabels,
  getHeaderBidder,
  getReseller,
  HeaderBidderActiveActive,
  HeaderBidderActiveInactive,
  HeaderBidderCampaignTargetingAll,
  HeaderBidderCampaignTargetingHouse,
  HeaderBidderCampaignTargetingInactive,
  HeaderBidderCampaignTargetingPaid,
  HeaderBidderCampaignTargetingSelected,
  HeaderBidderOrderTargetingSelected,
  HeaderBidderPoddedRequestActiveActive,
  HeaderBidderPoddedRequestActiveInactive,
  IAudienceSegment,
  IBidderLabel,
  IChannelGroup,
  IChannelLabel,
  IChannelList,
  ICountryGroup,
  IHeaderBidder,
  IHeaderBidderDeviceAwareModel,
  IHeaderBidderParamOption,
  IPublisher,
  IReseller,
  ISite,
  ISitesInfo,
  makeTargetingChangeDescription,
  makeTargetingChangeInfoHover,
  MatchDealIDTypeDisabled,
  MatchDealIDTypeEnabled,
  PrivateAuctionTypeDisabled,
  PrivateAuctionTypeEnabled,
  PublicaTagFallbackDisabled,
  PublicaTagFallbackEnabled,
  queryHeaderBidders,
  ResourceActiveDisabled,
  ResourceActiveEnabled,
  reverseEAllowStatus,
  SegmentTargeting,
  SegmentTargetingAND,
  SegmentTargetingOR,
  TargetBoolTypeAll,
  TargetBoolTypeFalse,
  TargetBoolTypeTrue,
  TargetingCCPAAll,
  TargetingCCPANonOptOut,
  TargetingCCPAOptOut,
  TargetingCoppa0,
  TargetingCoppa1,
  TargetingCoppaAll,
  ETargetingDeviceIDTypes,
  TargetingGDPR0,
  TargetingGDPR1,
  TargetingGDPRAll,
  TargetingLogicAND,
  TargetingLogicOR,
  TargetingRequestedPodDurationNoMax,
  TargetingRequestedPodDurationNoMin,
  updateHeaderBidder,
  ExtendedIDTargetingTypeDisabled,
  ExtendedIDTargetingTypeEnabledIfPresent,
  ExtendedIDTargetingTypeEnabledIfMissing,
} from '~/src/dash/api/console-api';
import { getContextualSegmentsByPublisherID } from '~/src/dash/api/contextual-segments';
import { DemandSource, DemandSources } from '~/src/dash/globals/demand-sources';
import {
  commonRegionGroupsIDs,
  createCountryGroup,
  deleteCountryGroup,
  getCountryGroupsByIDs,
  getCountryGroupsByPublisherID,
  updateCountryGroup,
} from '~/src/dash/api/country-group';
import { DEAL_SSP_LIST, IDeal } from '~/src/dash/api/deals';
import { IMagniteCTVTier } from '~/src/dash/api/demand-settings/magnitectv/magnitectv-tiers_models';
import { ISamsungSSPTier } from '~/src/dash/api/demand-settings/samsungssp/samsungssp-tiers_models';
import { ISpotxTiers } from '~/src/dash/api/demand-settings/spotx/spotx-tiers_models';
import {
  convertECurrencyTypeToString,
  convertECurrencyTypeToSymbol,
  convertStringToECurrencyType,
  CurrencyDisplayedItem,
  CurrencyType,
  CurrencyTypeUSD,
  ECurrencyType,
} from '~/src/dash/api/exchange-rates';
import {
  EHeaderBidder_DealAtTargeting,
  EHeaderBidder_InventoryType,
  EHeaderBidder_PodSequenceTargeting,
  EHeaderBidder_PositionTargeting,
  EHeaderBidder_ShareOfVoiceType,
  EHeaderBidder_TargetedAdBreak,
  EStartDelay,
  HeaderBidderInventoryTypesToTitleMap,
  startDelayOverrideIsEmpty,
} from '~/src/dash/api/headerbidders/headerbidders_models';
import {
  convertPriorityToBidderTier,
  generatePriorityOptions,
  generateSubPriorityOptions,
  HeaderBidderDealAtTargetingToString,
  HeaderBidderPoddedRequestTypeToString,
  HeaderBidderPodSequenceTargetingToString,
  HeaderBidderPositionTargetingToString,
  HeaderBidderTargetedAdBreakToString,
  IPriorityOption,
} from '~/src/dash/api/headerbidders/utils_headerbidder';
import {
  generalGetLiveLogs,
  getBidRequestLogsQuery,
  getBidResponseLogsQuery,
} from '~/src/dash/api/live_logs/controller';
import { filterLiveLogs } from '~/src/dash/api/live_logs/helpers';
import { IBidRequestLiveLogs, IBidResponseUIData } from '~/src/dash/api/live_logs/models';
import { getAdserverOrders, IAdserverOrder } from '~/src/dash/api/order';
import { GetDebugHeaderbidderPacingData } from '~/src/dash/api/pacing/controller';
import { IHeaderbidderDebugPacingModel } from '~/src/dash/api/pacing/models';
import { genPlatformMarketplacePublishersList } from '~/src/dash/api/publisher';
import { IObject } from '~/src/dash/api/resource-transforms';
import { EBool } from '~/src/dash/api/types/bool';
import {
  FLEXIBLE_BIDDING_PILLS,
  flexibleBiddingStringToType,
  FlexibleBiddingType,
  flexibleBiddingTypeToString,
  IFlexibleBiddingThreshold,
} from '~/src/dash/api/types/flexible_bidding';
import {
  genNewSmartFloors,
  genNewSmartFloorConfig,
  createSmartFloorConfig,
  ISmartFloorConfigUI,
  ISmartFloorPayloadUI,
  smartFloorConfigCols,
  smartFloorRecalcKeys,
  updateSmartFloorConfig,
  updateSmartFloorParamsFromConfig,
} from '~/src/dash/apiV2/smartFloors/crud';
import {
  bidderTargetingFieldKeys,
  fetchTargetingPresetOptions,
  ITargetingPresetVars,
  validateBidderTargetingBulkUpdate,
  validateTargetingPresetSelections,
} from '~/src/dash/apiV2/targeting/targetingPresets';
import { IAccordionPanel, MultiAccordion } from '~/src/dash/components/accordion/multi-accordion';
import { AddEditCompanyModel, companyTypes } from '~/src/dash/components/add-edit-company-model';
import { BidFloorTable } from '~/src/dash/components/bid_floor_table';
import { BidderTests } from '~/src/dash/components/bidder-tests';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import { CurrencyConverter } from '~/src/dash/components/CurrencyConverter';
import {
  DateTimeRangeComponent,
  IDateRangeChangeEvent,
} from '~/src/dash/components/datepicker/date-time-range-component';
import {
  Day,
  DAYPARTING_TIMEZONES_BIDDER_PILLS,
  DaypartingSelector,
  daypartingTimezonesTypeToBoolean,
  daypartingTimezonesTypeToString,
  EDaypartingTimezonesType,
  handleAddDaypartingPeriod,
  handleDaypartingDateChange,
  handleDaypartingDayClick,
  handleDeleteDaypartingPeriod,
  IDaypartingInterval,
  parseDayparting,
  parseDaypartingGenerateDisplay,
  parseDaypartingIntervals,
} from '~/src/dash/components/dayparting-selector';
import { CompanyMultiSelect } from '~/src/dash/components/dropdowns/company-multi-select';
import { FocusedTextfield } from '~/src/dash/components/focused-textfield';
import { BidderInventoryTypeSelect } from '~/src/dash/components/form/bidder/bidder-inventory-type-select';
import { DealTargetingMultiSelect } from '~/src/dash/components/form/deal/deal-targeting-multi-select';
import { IABBlocklist } from '~/src/dash/components/iab-blocklist';
import { DoNotUseDemandSourceSettingsIconWithTooltip } from '~/src/dash/components/icons/do-not-use-demand-source-settings-icon-with-tooltip';
import { FlexibleBiddingIconWithTooltip } from '~/src/dash/components/icons/flexible-bidding-icon-with-tooltip';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { IInputRow, InputRow } from '~/src/dash/components/input-row';
import {
  ICountryGroupRowData,
  IListTableColumn,
  ListTable,
} from '~/src/dash/components/list-table';
import { LiveData } from '~/src/dash/components/live-data/live-data';
import {
  ILocalTargetingParameter,
  LocalTargeting,
  validateLocalTargeting,
} from '~/src/dash/components/local-targeting/local-targeting';
import { LogBidRequestTable } from '~/src/dash/components/logs-bid-request-table';
import { LogBidResponseTable } from '~/src/dash/components/logs-bid-response-table';
import { MaterialLabelDropdownMulti } from '~/src/dash/components/material-label-dropdown-multi';
import {
  getDefaultMenuList,
  MaterialSearchDropdownMulti,
} from '~/src/dash/components/material-search-dropdown-multi';
import ModelMissingPermission from '~/src/dash/components/model-missing-permission';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import PillSwitcher from '~/src/dash/components/pill-switcher';
import { genQuickFilter } from '~/src/dash/components/quick-filter-dropdown';
import { MakeTabProps, TabPanel } from '~/src/dash/components/TabPanel';
import { PillSwitcherV2 } from '~/src/dash/components/tabs/PillSwitcherV2';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { TextFieldWithDefaultValue } from '~/src/dash/components/text-field-with-default-value';
import { FlexibleBiddingDialog } from '~/src/dash/components/tier-free/flexible-bidding-dialog';
import { VastEditor } from '~/src/dash/components/vast-editor';
import {
  ALL_PLATFORM_CONNECTION_BIDDERS,
  APS_BIDDERS,
  BIDDERS_ADBREAK_TARGETING_ENABLED,
  BIDDERS_MULTI_BID_ENABLED,
  BIDDERS_PODDED_REQUEST_ENABLED,
  BIDDERS_SHARE_OF_VOICE_TYPE_ENABLED,
  BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR,
  DYNAMIC_PLATFORM_CONNECTION_BIDDERS,
  FIXED_PRICE_PLATFORM_CONNECTION_BIDDERS,
  NO_SECONDARY_REQUEST_BIDDERS,
  ORTB26_ENABLED_BIDDERS,
  ORTB26_ENABLED_PODDED_TYPE_DYNAMIC_BIDDERS,
  ORTB26_ENABLED_PODDED_TYPE_HYBRID_BIDDERS,
  ORTB26_ENABLED_PODDED_TYPE_STRUCTURED_BIDDERS,
} from '~/src/dash/globals/constants';
import { genTimezoneList } from '~/src/dash/globals/timezone';
import {
  borderRadius,
  Col,
  Cols,
  ct,
  fontSizing,
  ISimpleOptionSelect,
  Panel,
  Panels,
  Row,
  Rows,
  spacing,
  Text,
  TKey,
  TooltipWithTranslation,
} from '~/src/dash/publicaUI';
import { SESSION_ACTIONS_SET } from '~/src/dash/reducers/session-reducers';
import { IStore } from '~/src/dash/reducers/store';
import {
  getColorTheme,
  getResellerID,
  getResellerTitle,
  isOttera,
} from '~/src/dash/resellers/utils/importResellerConfig';
import { checkURLForValidDomain, isPBSDomain } from '~/src/dash/resellers/utils/utils';
import {
  extractRouteParams,
  navigate,
  navigateToRouteWithQueryParams,
  RouteBidderSettingsClone,
  RouteBidderSettingsExisting,
  RouteBidderSettingsList,
  RouteBrandSafetyList,
  RouteChannelExisting,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { CloneType, IBulkUpdateItem, IBulkUpdateMap } from '~/src/dash/utils/bulk-update';
import { ChipInactive } from '~/src/dash/utils/campaign-status';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  generateCountriesMenuList,
  generateCountryGroupMenuList,
  generateCountryMenuListFromIsos,
  generateNewTargetingCountryGroupList,
  getAllCountries,
  IGeo,
} from '~/src/dash/utils/countries';
import {
  formatDateFromUTCToOffset,
  formatDateWithOffsetToUTC,
  formatTime,
  parseDate,
} from '~/src/dash/utils/date';
import { decorate } from '~/src/dash/utils/decorator';
import {
  getDeviceEnvironmentAsItems,
  getDeviceEnvironmentModels,
  getDeviceEnvironmentModelsAsItems,
  getDeviceEnvironmentSubTypes,
  getDeviceEnvironmentSubTypesAsItems,
} from '~/src/dash/utils/device-environments';
import { deviceORTBTypes, IDeviceType } from '~/src/dash/utils/devices';
import {
  getHeaderBidderAdaptersForPublisher,
  IHeaderBidderAdapter,
  multiIndexBidders,
} from '~/src/dash/utils/header-bidder-adapters';
import {
  ENDPOINT_APAC_KEY,
  ENDPOINT_DEFAULT_KEY,
  ENDPOINT_EU_KEY,
  ENDPOINT_PROD_KEY,
  ENDPOINT_STAGING_KEY,
  ENDPOINT_US_WEST_KEY,
  ENDPOINT_APAC_NORTH_KEY,
  getParamDefaultValue,
  getParamOption,
  hasParamOption,
  getHeaderBidderParamsUIConfig,
  isStringKnownBidderType,
  shouldParamOptionOverwritten,
  sortParamOptions,
} from '~/src/dash/utils/headerbidder-params';
import { getSelectedLivestreamOptions } from '~/src/dash/utils/livestream-options';
import { backgroundColor, smallRadius } from '~/src/dash/utils/material-dashboard-react';
import { filterSitesByActive } from '~/src/dash/utils/models';
import { noopVoid } from '~/src/dash/utils/noop';
import { obfuscateBidderName } from '~/src/dash/utils/obfuscate';
import { ELogicalOperator } from '~/src/dash/utils/options';
import {
  getPacingTypeOption,
  getPacingTypeOptionByText,
  pacingTypeOptions,
} from '~/src/dash/utils/pacing-type-options';
import { exportLocalTargetingToJSON } from '~/src/dash/utils/params';
import { allowedEmptyIPermissionCheck, IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { getThirdPartyDataSharingItems } from '~/src/dash/utils/post-bid-data-share';
import {
  checkUserInfoMasked,
  hasPermSuperUser,
  hasRoleSuperUser,
  isSuper,
} from '~/src/dash/utils/roles';
import { convertIDStringToNumberArray } from '~/src/dash/utils/string';
import {
  isNinePublisher,
  isPhiloFallbackEnabledPublisher,
  isPhiloPublisher,
  isPublicaCampaignDisabled,
  isSamsungNAPublisher,
  isSamsungPublisher,
  isTestPublisher,
} from '~/src/dash/utils/ui';
import {
  apsGuaranteeValidationSettings,
  apsOpenAuctionValidationSettings,
  apsPMPValidationSettings,
  basePlatformConnectionValidationSetting,
  bidderValidationSetting,
  bulkUpdateBiddersValidationSetting,
  channelEditListValidationSetting,
  channelListValidationSetting,
  customValidatorFactory,
  fixedPricePlatformConnectionBidderValidationSetting,
  hasErrors,
  IErrors,
  IValidator,
  publicaBidderValidationSetting,
  regionValidationSetting,
  rokuHBBidderValidationSetting,
  rokuORTBBidderValidationSetting,
  validatorFactory,
} from '~/src/dash/utils/validator';
import { BidderSettingsDealsTable } from '~/src/dash/views/bidder/bidder-settings-deals-table';
import { SmartFloors } from '~/src/dash/views/bidders/Bidders/SmartFloors';
import { ButtonView } from '~/src/dash/views/button-view';
import MinMaxEditor from '~/src/dash/views/campaign/LineItem/MinMaxEditor';
import { RowButton } from '~/src/dash/views/component-view';
import { LoadingView } from '~/src/dash/views/loading-view';
import { AppOverrideKeys } from '~/src/dash/views/site-settings-list-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { TargetingIntegration } from '~/src/dash/views/tools/TargetingPresets/TargetingIntegration';
import { TargetingPresetParamKey } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/config';
import { highlight, languages } from '~/src/prismjs';
import { getEPGContentTogglesForPublisher } from '~/src/dash/api/demand-settings/epg/epg_methods';
import { IContentFromEPG } from '~/src/dash/api/demand-settings/epg/epg_models';
import { TopBar } from '~/src/dash/views/topbar/TopBar';
import {
  StaticAdvancedTargetingTooltip,
  StaticExtendedIDTooltip,
} from '~/src/dash/utils/customTooltips';
import { INewCalDates } from '~/src/dash/components/calendar/CalendarV2/common';
import { RadioOption, RadioTextButtons } from '~/src/dash/components/radio/RadioTextButtons';
import { BidderAuctionInsights } from '~/src/dash/views/bidder/BidderAuctionInsights';
import { PUB_OPS_TEAM_IDS } from '~/src/dash/utils/users';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  headerbidder: IHeaderBidder;
  headerbidderParamOptions: Record<string, IHeaderBidderParamOption[]>;
  existing: boolean;
  bulkUpdateIDs: string[];
  isSpotxTierEnabled?: EBool;
  spotxTiers?: ISpotxTiers[];
  isMagniteCTVTierEnabled?: EBool;
  magniteCTVTiers?: IMagniteCTVTier[];
  isSamsungSSPTierEnabled?: EBool;
  samsungSSPTiers?: ISamsungSSPTier[];
  cloneBidderEnabled: boolean;
  smartFloorConfigs: ISmartFloorConfigUI[];
  cloneBidderID?: number;
}

interface IRootKeyValueParameter extends IKeyValueParameter {
  prefix: string;
}

interface IGenerateRewriteInputRowsProps {
  stateKey: string;
  activeRows: Array<IRewriteActiveRow>;
  handleChange: (value: any) => void;
  selectTitle: string;
  textfieldTitle: string;
  placeholderText?: string;
  addButtonText?: string;
}

type RewriteInputRowsKey = 'AppStoreURL';

interface IRewriteActiveRow {
  device: string;
  text?: string;
}

interface IHandleChangeAppOverrideProps {
  rows: IRewriteActiveRow[];
  stateKey: RewriteInputRowsKey;
}

interface IState extends IBaseState, IHeaderBidder {
  campaigns: IAdserverCampaign[];
  orders: IAdserverOrder[];
  segments: IAudienceSegment[];
  updating: boolean;
  errors: IErrors;
  DeviceEnvironment: string[];
  ParamOptions: IHeaderBidderParamOption[];
  bidders: IHeaderBidder[]; // should only include the bidders needed (normally 1 bidder, might be multiple if bulk editting)
  cloneBidderID?: number;
  snackbarMessage: string;
  snackbarError: boolean;
  formMode: FormMode;
  bidRequestLiveLogs: IBidRequestLiveLogs[];
  bidResponseLiveLogs: IBidResponseUIData[];
  bidRequestLiveLogsOpenDialog: boolean;
  HybridStructuredSlotDurations: string;
  keyValueParameters: IKeyValueParameter[];
  rootKeyValueParameters: { [key: string]: IRootKeyValueParameter[] };
  localTargetingParameters: ILocalTargetingParameter[]; // Local only
  deviceTargetingCountrySelectMode: SelectMode;
  UIBidderType: string;
  bidderChannelList: IMenuList;
  targetingCountriesList: IMenuList;
  targetingCountryGroupList: IMenuList;
  sites: ISmallSite[];
  activeSites: ISmallSite[];
  openChannelSelectTable: boolean;
  openDealSelectTable: boolean;
  openRegionCreateEditDialog: boolean;
  openRegionSelectDialog: boolean;
  openRegionSelectTable: boolean;
  liveLogsTabIndex: number;
  requestLiveLogFilter: string;
  responseLiveLogFilter: string;
  viewTabIndex: number;
  SegmentTargeting: SegmentTargeting;
  CampaignTargeting: number;
  CampaignIDS: number[];
  OrderIDS: number[];
  bidderTargetedCampaignsList: IMenuList;
  bidderTargetedOrdersList: IMenuList;
  // state for confirm test launch modal
  currentlyWritingABTest: boolean;
  triggerTestLaunch: boolean;
  channelGroupsList: IMenuList;
  channelIDs: number[];
  // state for allowed ssp providers
  ssp: string;
  headerBidderAdapters: IHeaderBidderAdapter[];
  // state to make sure hasParsedParams only run once
  hasParsedParams: boolean;
  // is component loaded and ready to display
  loaded: boolean;
  createEditRegionName: string;
  createEditRegionList: IMenuList;
  createEditRegionID: string;
  updatingCountryGroup: boolean;
  publisherCountryGroups: ICountryGroup[];

  fixedPriceActive: boolean;
  frequencyLimitDuration: number;
  frequencyLimitUnit: string;
  dateStart?: moment.Moment;
  dateEnd?: moment.Moment;
  StartDate?: string;
  EndDate?: string;
  pacingImpressionsData?: IHeaderbidderDebugPacingModel;

  // map to determine which fields are marked for bulk edit
  bulkUpdateEnabledFields: IBulkUpdateMap;
  // certain fields not shown if the bulk update ids contain certain bidders
  bulkUpdateIDsIncludesDirectCampaign: boolean;
  bulkUpdateIDsIncludesBidderWithoutAdjFactor: boolean;

  flexibleBiddingDialogIsOpen: boolean;
  flexibleBiddingDialogNewPriority: number;
  flexibleBiddingDialogInvalidThresholds: IFlexibleBiddingThreshold[];
  contextualSegmentList: IMenuList;
  platformMarketplacePublishers: IPublisher[];
  PlatformMarketplaceTargetedPublisher: string | undefined;

  commonRegionGroups: ICountryGroup[] | undefined;
  DaypartingIntervals: IDaypartingInterval[];
  enableViewerTimezone: boolean;
  Timezone: string;
  timezonesList: IMenuList;

  // new smart floors states
  smartFloorConfigs: ISmartFloorConfigUI[];
  hasExistingSmartFloorConfig: boolean;
  hasExistingThompsonSampling: boolean;
  isSmartFloorActive: boolean;
  isWaitingToUpdateSmartFloorConfig: boolean;
  isChannelListDetailUpdated: boolean; // for when we updated what channels/channel groups a channel list targets
  selectedSiteIDForSmartFloorsChart: number;

  // channel Lists, CGL = Channel Groups List, CL = Channels List
  openChannelListDialog: boolean;
  openChannelListEditDialog: boolean;
  openEnableSponsorshipModeDialog: boolean;
  channelListCGL: IMenuList;
  channelListCL: IMenuList;
  listSettingsDialogActive: boolean;
  listSettingsDialogID: number;
  newChannelGroupActive: boolean;
  channelLists: IChannelList[];
  channelListsList: IMenuList;
  refreshingLiveLogs: boolean;
  refreshingLiveLogsTimestamp: string;
  bidderLabels: IBidderLabel[];
  BidderLabelsSelected: IBidderLabel[];
  TargetingRequestedPodDurationMin: number;
  TargetingRequestedPodDurationMax: number;
  IsAutoCreatedByPlatformConnect: EBool;
  PresetIDs: number[];
  presetConflicts: Record<string, TargetingPresetParamKey[]>;
  presetConflictedParamKeys: TargetingPresetParamKey[];

  // manage rewrite input rows,
  // for now just one: AppStoreURL
  rewriteInputRows: Record<RewriteInputRowsKey, Array<IRewriteActiveRow>>;
  appStoreURLs: Array<string>;
  AppStoreURL: IHeaderBidderDeviceAwareModel;
  AppStoreUrlOverrideIfEmpty: EBool;

  // buy type company
  BuyTypeID: number;
  BuyTypeName: string;
  AddEditBuyTypeModelActive: boolean;
  buyTypeUpdateCounter: number;
  demandSourceSettings: IContentFromEPG[];
  samplingPercentageDisabledUntilDays: number;
  showExtendedIDOptions: boolean;
  compareValues: boolean;
  selectedChartView: 'liveData' | 'insights';
  // Auction Insights
  auctionInsightsCalStartDate: moment.Moment;
  auctionInsightsCalEndDate: moment.Moment;
}

interface IGenericObject {
  [key: string]: any;
}

interface ISelectedChannelListMap {
  [key: string]: {
    currencyDisplayed: ECurrencyType;
    bidFloor: number;
    bidFloorUSD: number;
  };
}

enum SelectMode {
  Allowlist = 0,
  Denylist,
}

type FrequencyLimitUnit = string;
const FrequencyLimitUnitDays: FrequencyLimitUnit = 'Days';
const FrequencyLimitUnitHours: FrequencyLimitUnit = 'Hours';

const MimeTypeList = [
  { key: 'application/vnd.apple.mpegURL', text: 'application/vnd.apple.mpegURL' },
  { key: 'application/x-mpegURL', text: 'application/x-mpegURL' },
  { key: 'video/3gpp', text: 'video/3gpp' },
  { key: 'video/mp4', text: 'video/mp4' },
  { key: 'video/webm', text: 'video/webm' },
  { key: 'video/H264', text: 'video/H264' },
  { key: 'application/dash+xml', text: 'application/dash+xml' },
];

// IKeyValueParameter are special parameters used only for SpotX (PLAT-3151)
interface IKeyValueParameter {
  key: string;
  value: string;
  typ: string;
  isNotEditable?: boolean;
}

// generates the slots options for the dropdown
export const generateSlotOptions = () => {
  const slots = [] as Array<{ key: string; text: string }>;
  slots.push({ key: 'all', text: ct('All') });
  slots.push({ key: 'firstOrLast', text: ct('FirstOrLast') });
  slots.push({ key: '1', text: ct('First') });
  for (let i = 2; i < 11; i += 1) {
    slots.push({ key: '' + i, text: '' + i });
  }
  slots.push({ key: 'last', text: ct('Last') });
  return slots;
};

export const generatePositionOptions = () => {
  const positions = [] as Array<{ key: string; text: string }>;
  positions.push({
    key: EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_ALL as any,
    text: ct('All'),
  });
  positions.push({
    key: EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_PREROLL as any,
    text: ct('Preroll'),
  });
  positions.push({
    key: EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_MIDROLL as any,
    text: ct('Midroll'),
  });
  positions.push({
    key: EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_POSTROLL as any,
    text: ct('Postroll'),
  });
  return positions;
};

export const generateAtOptions = () => {
  const at = [] as Array<{ key: string; text: string }>;
  at.push({
    key: EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_None as any,
    text: ct('None'),
  });
  at.push({
    key: EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_First_Price as any,
    text: ct('FirstPriceValue1'),
  });
  at.push({
    key: EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_Fixed_Price as any,
    text: ct('FixedPriceValue3'),
  });
  return at;
};

export const generatePodSequenceTargetingOptions = () => {
  const podSequence = [] as Array<{ key: EHeaderBidder_PodSequenceTargeting; text: string }>;
  podSequence.push({
    key: EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_ANYPOD,
    text: ct('AnyPod'),
  });
  podSequence.push({
    key: EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_FIRSTPOD,
    text: ct('FirstPod'),
  });
  podSequence.push({
    key: EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_LASTPOD,
    text: ct('LastPod'),
  });
  podSequence.push({
    key: EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_FIRSTANDLASTPOD,
    text: ct('FirstAndLastPod'),
  });
  return podSequence;
};

export const generateAdbreakOptions = () => {
  const options = [] as Array<{ key: string; text: string }>;
  options.push({
    key: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL as any,
    text: ct('All'),
  });
  options.push({
    key: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_FIRST as any,
    text: ct('First'),
  });
  options.push({
    key: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_LAST as any,
    text: ct('Last'),
  });
  return options;
};

export const generateExtendedIDOptions = (): Array<{ key: ExtendedIDSetting; text: string }> => {
  const options = [] as Array<{ key: ExtendedIDSetting; text: string }>;
  options.push({
    key: ExtendedIDSettingInherit,
    text: ct('InheritFromDemandSource'),
  });
  options.push({
    key: ExtendedIDSettingPass,
    text: ct('PassID'),
  });
  options.push({
    key: ExtendedIDSettingDoNotPass,
    text: ct('DontPassID'),
  });
  return options;
};

export const ExtendedIDsToTitleMap: { [key: ExtendedIDSetting]: string } = {
  0: ct('InheritFromDemandSource'),
  1: ct('ExtendedIDSettingPass'),
  2: ct('DontPassID'),
};

export const generateShareOfVoiceTypeOptions = () => {
  const options = [] as Array<{ key: string; text: string }>;
  options.push({
    key: EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD as any,
    text: ct('SplitShareByPod'),
  });
  options.push({
    key: EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD_DURATION as any,
    text: ct('SplitShareByDuration'),
  });
  return options;
};

export const generateORTB26PoddedRequestTypeOptions = (demandSource: string) => {
  const poddedRequestTypes = [] as Array<{ key: string; text: string }>;

  if (ORTB26_ENABLED_PODDED_TYPE_STRUCTURED_BIDDERS.includes(demandSource)) {
    poddedRequestTypes.push({
      key: EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeStructured as any,
      text: ct('Structured'),
    });
  }
  if (ORTB26_ENABLED_PODDED_TYPE_DYNAMIC_BIDDERS.includes(demandSource)) {
    poddedRequestTypes.push({
      key: EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeDynamic as any,
      text: ct('Dynamic'),
    });
  }
  if (ORTB26_ENABLED_PODDED_TYPE_HYBRID_BIDDERS.includes(demandSource)) {
    poddedRequestTypes.push({
      key: EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeHybrid as any,
      text: ct('Hybrid'),
    });
  }
  return poddedRequestTypes;
};

const isKVPBidderAndPublisherEnabled = (bidder: string, params: string): boolean => {
  const kvpBidderList = [
    DemandSources.appnexus,
    DemandSources.criteo,
    DemandSources.dynamicGateway,
    DemandSources.dynamicPlatformConnection,
    DemandSources.finecast,
    DemandSources.freewheel,
    DemandSources.gateway,
    DemandSources.gatewayTier0,
    DemandSources.indexExchange,
    DemandSources.iponweb,
    DemandSources.magnitectv,
    DemandSources.nexstar,
    DemandSources.pubmatic,
    DemandSources.rhythmone,
    DemandSources.smartclip,
    DemandSources.telaria,
    DemandSources.thetradedesk,
    DemandSources.triplelift,
    DemandSources.trustx,
    DemandSources.verizon,
    DemandSources.platformConnection,
    DemandSources.videoHeroesRevShare,
    DemandSources.videoHeroesFixedCPM,
    DemandSources.videobyte,
  ];

  if (bidder === DemandSources.freewheelssp && params.includes(`"ortbType":"tvp"`)) {
    return true;
  }

  return kvpBidderList.includes(bidder);
};

// the coppa options for the dropdown
export const coppaOptions = [
  { key: TargetingCoppaAll, text: 'All' },
  { key: TargetingCoppa0, text: '0' },
  { key: TargetingCoppa1, text: '1' },
];

export const generateCOPPAOptions = (): Record<string, string | number>[] => {
  return [
    { key: TargetingCoppaAll, text: ct('All') },
    { key: TargetingCoppa0, text: '0' },
    { key: TargetingCoppa1, text: '1' },
  ];
};

// the LAT options for the dropdown
export const latOptions = [
  { key: TargetBoolTypeAll, text: 'All' },
  { key: TargetBoolTypeFalse, text: 'False' },
  { key: TargetBoolTypeTrue, text: 'True' },
];

// the Targeting Device ID Type options for the dropdown
export const targetingDeviceIDTypeOptions = [
  { key: ETargetingDeviceIDTypes.ALL, text: 'All' },
  { key: ETargetingDeviceIDTypes.ORIGINAL, text: 'Original DIDs' },
  { key: ETargetingDeviceIDTypes.SYNTHETIC, text: 'Synthetic DIDs' },
];

// the CCPA options for the dropdown
export const ccpaOptions = [
  { key: TargetingCCPAAll, text: 'All' },
  { key: TargetingCCPAOptOut, text: 'Opt Out' },
  { key: TargetingCCPANonOptOut, text: 'Non Opt Out' },
];

export const generateCCPAOptions = (): Record<string, string | number>[] => {
  return [
    { key: TargetingCCPAAll, text: ct('All') },
    { key: TargetingCCPAOptOut, text: ct('OptOut') },
    { key: TargetingCCPANonOptOut, text: ct('NonOptOut') },
  ];
};

// the GDPR options for the dropdown
export const GDPROptions = [
  { key: TargetingGDPRAll, text: 'All' },
  { key: TargetingGDPR0, text: '0' },
  { key: TargetingGDPR1, text: '1' },
];

export const GDPRConsentOptions = [
  { key: TargetBoolTypeAll, text: 'All' },
  { key: TargetBoolTypeFalse, text: 'False' },
  { key: TargetBoolTypeTrue, text: 'True' },
];

enum FormMode {
  Unknown = 0,
  NewBidder,
  EditBidder,
}

interface IRemoveContentToOverwriteContent {
  [key: string]: string;
}

const removeContentToOverwriteContent: IRemoveContentToOverwriteContent = {
  RemoveContentChannelFromBidRequest: 'ContentChannelOverride',
  RemoveContentNetworkFromBidRequest: 'ContentNetworkOverride',
  RemoveContentSeriesFromBidRequest: 'ContentSeriesOverride',
  RemoveContentTitleFromBidRequest: 'ContentTitleOverride',
  RemoveContentGenreFromBidRequest: 'ContentGenreOverride',
  RemoveContentDistribNameFromBidRequest: 'ContentDistribNameOverride',
  RemoveContentRatingFromBidRequest: 'ContentRatingOverride',
  RemoveContentCategoryFromBidRequest: 'ContentCategoryOverride',
  RemoveContentProdqualFromBidRequest: 'ContentProdqualOverride',
  RemoveContentProducerIDFromBidRequest: 'ContentProducerIDOverride',
  RemoveContentProducerNameFromBidRequest: 'ContentProducerNameOverride',
  RemoveContentKeywordsFromBidRequest: 'ContentKeywordsOverride',
  RemoveContentLanguageFromBidRequest: 'ContentLanguageOverride',
  RemoveContentIDFromBidRequest: 'ContentIDOverride',
  RemoveContentSeasonFromBidRequest: 'ContentSeasonOverride',
  RemoveInventoryPartnerDomainFromBidRequest: 'InventoryPartnerDomainOverride',
};

const overwriteContentToRemoveContent: IRemoveContentToOverwriteContent = {
  ContentChannelOverride: 'RemoveContentChannelFromBidRequest',
  ContentNetworkOverride: 'RemoveContentNetworkFromBidRequest',
  ContentSeriesOverride: 'RemoveContentSeriesFromBidRequest',
  ContentTitleOverride: 'RemoveContentTitleFromBidRequest',
  ContentGenreOverride: 'RemoveContentGenreFromBidRequest',
  ContentDistribNameOverride: 'RemoveContentDistribNameFromBidRequest',
  ContentRatingOverride: 'RemoveContentRatingFromBidRequest',
  ContentCategoryOverride: 'RemoveContentCategoryFromBidRequest',
  ContentProdqualOverride: 'RemoveContentProdqualFromBidRequest',
  ContentProducerIDOverride: 'RemoveContentProducerIDFromBidRequest',
  ContentProducerNameOverride: 'RemoveContentProducerNameFromBidRequest',
  ContentKeywordsOverride: 'RemoveContentKeywordsFromBidRequest',
  ContentLanguageOverride: 'RemoveContentLanguageFromBidRequest',
  ContentIDOverride: 'RemoveContentIDFromBidRequest',
  ContentSeasonOverride: 'RemoveContentSeasonFromBidRequest',
  InventoryPartnerDomainOverride: 'RemoveInventoryPartnerDomainFromBidRequest',
};

function isExistingBidder(bidder: IHeaderBidder) {
  return !!bidder.ID;
}

// gets the campaign ID from a vastURL
// ex: "http://getpublica.com/direct?campaign_id=12&lala=lili" => "12"
function getCampaignIDFromVastURL(vastURL: string): string {
  try {
    // get the 'campaign_id' parameter value
    const url = new URL(vastURL);
    const campaignIDStr = url.searchParams.get('campaign_id');
    // return value if found
    if (campaignIDStr !== null) {
      return campaignIDStr; // parameter found
    }
    return 'undefined'; // parameter not found
  } catch (err) {
    // error - return original value
    return vastURL;
  }
}

function getFormMode(props: IProps): FormMode {
  if (props.headerbidder.ID === '0' || props.headerbidder.ID === '') {
    // New bidder
    return FormMode.NewBidder;
  }
  // Edit bidder
  return FormMode.EditBidder;
}

function generatePriceLessThanBidFloorWarning(filteredChannelList: ISelectedChannelListMap) {
  return (
    <div>
      <p>{ct('BiddersMessageBidFloorWarning')}</p>
      <ul>
        {Object.keys(filteredChannelList).map((channel) => {
          return (
            <li>
              {channel} :{' '}
              {convertECurrencyTypeToSymbol(filteredChannelList[channel].currencyDisplayed)}{' '}
              {filteredChannelList[channel].bidFloor} {ct('Floor')}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function objectFilter(
  bidFloor: ISelectedChannelListMap,
  priceRow: IInputRow,
): ISelectedChannelListMap {
  return pickBy(bidFloor, (value) => value.bidFloorUSD > priceRow.value1 && priceRow.value1 !== '');
}

export const BidderSettingsFormView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
      },
      sidebarPaper: {
        backgroundColor: 'lightgrey',
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 2,
      },
      button: {
        margin: theme.spacing.unit,
      },
      drawerPaper: {
        width: '80%',
      },
      insideAccordionText: {
        fontSize: 14,
        fontWeight: 400,
        color: '$434343',
      },
      insideAccordionTextBold: {
        fontSize: 14,
        fontWeight: 500,
        color: '$434343',
      },
      insideAccordionTextfield: {
        fontSize: 12,
        fontWeight: 400,
        backgroundColor: '#F4F6FD',
        paddingLeft: 5,
        paddingTop: 8,
        paddingBottom: 8,
      },
      headingCategorySubtitle: {
        fontSize: 14,
        fontWeight: 400,
        color: '$434343',
        marginBottom: 15,
      },
      headingCategoryTitle: {
        fontSize: 18,
        fontWeight: 500,
        color: '$434343',
        marginBottom: 5,
      },
      headingCategorySubTitle: {
        fontSize: 16,
        fontWeight: 500,
        color: '$434343',
        marginTop: 10,
      },
      inputLabel: {
        fontSize: '16px',
        fontWeight: 500,
        color: 'black',
        width: 180,
      },
      centeredSwitch: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '40px',
      },
      spanActive: {
        display: 'inline-flex',
        alignItems: 'center',
        width: 80,
        fontSize: 12,
        fontWeight: 500,
      },
      spanDescription: {
        display: 'inline-flex',
        alignItems: 'center',
        margin: '15px 10px 0 10px',
        fontSize: 14,
      },
      spanSubHeader: {
        display: 'inline-flex',
        alignItems: 'center',
        width: 88,
        fontSize: 15,
      },
      centeredSwitchNoLeftMargin: {
        display: 'inline-flex',
        alignItems: 'center',
        marginRight: '40px',
      },
      checkbox: {
        transform: 'scale(0.8)',
        padding: 3,
      },
      input: {
        fontSize: 14,
        borderBottom: '1px solid darkgrey',
        maxWidth: 70,
      },
      inputWide: {
        fontSize: 14,
        maxWidth: 200,
      },
      inputExtraWide: {
        fontSize: 14,
        maxWidth: 400,
      },
      formControlLabel: {
        fontSize: 14,
      },
      menuItem: {
        fontSize: 14,
      },
      tabPanel: {
        // paddingTop: '15px',
      },
      tabPanelWhite: {
        backgroundColor: 'white',
      },
      indicator: {
        color: '#4952FF',
        backgroundColor: '#4952FF',
      },
      parameterHeaders: {
        paddingLeft: '45px',
        fontSize: '16px',
        fontWeight: 500,
        marginBottom: '15px',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    bidderBidFloor: ISelectedChannelListMap = {};

    constructor(props: IProps) {
      super(props);

      this.state = this.assignBidderToState();
    }
    assignBidderToState = () => {
      let frequencyLimitUnit = FrequencyLimitUnitHours;
      let frequencyLimitDuration = this.props.headerbidder.FrequencyTTL / 3600;
      const headerBidderAdapters = getHeaderBidderAdaptersForPublisher(
        '',
        false,
        this.props.session.publisher,
        hasRoleSuperUser(this.props.user.user),
        true,
      );
      if (frequencyLimitDuration % 24 === 0) {
        frequencyLimitUnit = FrequencyLimitUnitDays;
        frequencyLimitDuration = frequencyLimitDuration / 24;
      }

      const hasExistingSmartFloorConfig =
        EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) &&
        !isEmpty(this.props.smartFloorConfigs) &&
        !isEmpty(this.props.smartFloorConfigs[0]);

      const hasExistingThompsonSampling =
        hasExistingSmartFloorConfig && this.props.smartFloorConfigs[0].ThompsonSamplingEnabled;

      const isSmartFloorActive =
        EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) &&
        hasExistingSmartFloorConfig &&
        this.props.smartFloorConfigs[0].Active &&
        this.props.smartFloorConfigs[0].SmartFloors?.some((smartFloor) => smartFloor.Active);

      const smartFloorConfigs = hasExistingSmartFloorConfig
        ? this.props.smartFloorConfigs
        : [genNewSmartFloorConfig(Number(this.props.headerbidder?.ID) || 0)];

      const selectedSiteIDForSmartFloorsChart =
        hasExistingSmartFloorConfig && isSmartFloorActive
          ? smartFloorConfigs[0].SmartFloors[0]?.SiteID
          : 0;

      // TODO : AFTER BIDDER PAGE CLONE IS REFACTORED, REMOVE REDUX CHECK
      const clonedBidderID = this.props.cloneBidderID
        ? Number(this.props.cloneBidderID)
        : this.props.session.cloneBidderID
        ? parseInt(this.props.session.cloneBidderID, 10)
        : undefined;
      return Object.assign(this.props.headerbidder, {
        // ADD DEFAULT VALUES
        presetConflicts: {},
        presetConflictedParamKeys: [],
        PresetIDs: this.props.headerbidder.PresetIDs || [],
        PresetList: [],

        hasParsedParams: false,
        OriginalBidderChannelGroups: this.props.headerbidder.ChannelGroups as IChannelGroup[],
        OriginalBidderChannelListIDS: this.props.headerbidder.ChannelListIDS as number[],
        campaigns: [] as IAdserverCampaign[],
        orders: [] as IAdserverOrder[],
        segments: [] as IAudienceSegment[],
        updating: false,
        errors: {} as IErrors,
        defaultPriceIncrement: JSON.stringify(
          [
            { min: 5.0, max: 20.0, increment: 0.25 },
            { min: 20.0, max: 54.0, increment: 0.5 },
          ],
          null,
          2,
        ),
        TargetingDeviceSubTypes: (() => {
          if (this.props.headerbidder && this.props.headerbidder.TargetingDeviceSubTypes !== '') {
            return this.props.headerbidder.TargetingDeviceSubTypes;
          }
          return '0';
        })(),
        TargetingDeviceModels: (() => {
          if (this.props.headerbidder && this.props.headerbidder.TargetingDeviceModels !== '') {
            return this.props.headerbidder.TargetingDeviceModels;
          }
          return '0';
        })(),
        DeviceEnvironment: (() => {
          if (this.props.headerbidder && this.props.headerbidder.TargetingDevices !== '') {
            return this.props.headerbidder.TargetingDevices.split(',');
          }
          return ['0'];
        })(),
        TargetingDevices: (() => {
          if (this.props.headerbidder) {
            return this.props.headerbidder.TargetingDevices;
          }
          return '0';
        })(),
        LivestreamTargeting: (() => {
          if (this.props.headerbidder) {
            return this.props.headerbidder.LivestreamTargeting || '0';
          }
          return '0';
        })(),
        ParamOptions:
          this.props.headerbidder &&
          this.props.headerbidderParamOptions &&
          this.props.headerbidderParamOptions[this.props.headerbidder.Bidder]
            ? // set params default value as empty string
              this.props.headerbidderParamOptions[this.props.headerbidder.Bidder].map(
                (params: IHeaderBidderParamOption): IHeaderBidderParamOption => {
                  params.Value = '';
                  return params;
                },
              )
            : [],
        snackbarMessage: '',
        snackbarError: false,
        bidders: [] as IHeaderBidder[],
        cloneBidderID: clonedBidderID,
        formMode: getFormMode(this.props),
        bidRequestLiveLogs: [] as IBidRequestLiveLogs[],
        bidResponseLiveLogs: [] as IBidResponseUIData[],
        bidRequestLiveLogsOpenDialog: false,
        HybridStructuredSlotDurations: this.props.headerbidder.HybridStructuredSlotDurations || '',
        keyValueParameters: [] as IKeyValueParameter[],
        rootKeyValueParameters: {} as { [key: string]: IRootKeyValueParameter[] },
        localTargetingParameters: [] as ILocalTargetingParameter[],
        deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        bidderChannelList: {} as IMenuList,
        targetingCountriesList: generateCountriesMenuList(),
        targetingCountryGroupList: generateCountryGroupMenuList(
          this.props.headerbidder.CountryGroups || [],
        ),
        sites: [] as ISmallSite[],
        activeSites: [] as ISmallSite[],
        openChannelSelectTable: false,
        openDealSelectTable: false,
        openRegionCreateEditDialog: false,
        openRegionSelectDialog: false,
        openRegionSelectTable: false,
        updatingCountryGroup: false,
        liveLogsTabIndex: 0,
        requestLiveLogFilter: '',
        responseLiveLogFilter: '',
        viewTabIndex: 0,
        SegmentTargeting: this.props.headerbidder.SegmentTargeting || SegmentTargetingOR,
        CampaignTargeting: this.props.headerbidder.CampaignTargeting,
        // Campaigns targeted by bidder
        CampaignIDS: this.props.headerbidder.CampaignIDS || ([] as number[]),
        OrderIDS: this.props.headerbidder.OrderIDS || ([] as number[]),
        bidderTargetedCampaignsList: {} as IMenuList,
        bidderTargetedOrdersList: {} as IMenuList,
        // If user is editing ABTest
        currentlyWritingABTest: false,
        triggerTestLaunch: false,
        channelGroupsList: {} as IMenuList,
        ChannelGroups: this.props.headerbidder.ChannelGroups || [],
        channelLabels: [] as IChannelLabel[],
        channelIDs: [] as number[],
        quickFilterOptions: [] as Array<{ title: string; optionItems: IMenuList; type: string }>,
        ssp: '',
        headerBidderAdapters,
        EndpointDealIDPassthroughActive:
          this.props.headerbidder.EndpointDealIDPassthroughActive || EBool.EBool_FALSE,
        loaded: false,
        Deals: this.props.headerbidder.Deals || [],
        fixedPriceActive: this.props.headerbidder.FixedPrice !== -1,
        FixedPrice: this.props.headerbidder.FixedPrice,
        InventoryType:
          this.props.headerbidder.InventoryType ||
          EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_NONE,
        IsPublicaTagFallbackEnabled: this.props.headerbidder.IsPublicaTagFallbackEnabled,
        IsFallbackBackfillEnabled: this.props.headerbidder.IsFallbackBackfillEnabled,
        FallbackAuctionParticipationEnabled:
          this.props.headerbidder.FallbackAuctionParticipationEnabled,
        frequencyLimitDuration,
        frequencyLimitUnit,
        dateStart: this.props.headerbidder.StartDate
          ? formatDateFromUTCToOffset(
              this.props.headerbidder.StartDate,
              this.props.session.publisher.Timezone,
            )
          : undefined,
        dateEnd: this.props.headerbidder.EndDate
          ? formatDateFromUTCToOffset(
              this.props.headerbidder.EndDate,
              this.props.session.publisher.Timezone,
            )
          : undefined,
        StartDate: this.props.headerbidder.StartDate,
        EndDate: this.props.headerbidder.EndDate,
        Quantity: this.props.headerbidder.Quantity,
        CRONQuantityCount: this.props.headerbidder.CRONQuantityCount,
        CRONQuantityCountSinceLastTest: this.props.headerbidder.CRONQuantityCountSinceLastTest,
        pacingImpressionsData: undefined,
        UnpaidBidderEnabled: this.props.headerbidder.UnpaidBidderEnabled,
        ShareOfVoiceType: this.props.headerbidder.ShareOfVoiceType,
        AuctionParticipationPercentage: this.props.headerbidder.AuctionParticipationPercentage,
        DOOHEnabled: this.props.headerbidder.DOOHEnabled,
        EnableOptableEIDs: this.props.headerbidder.EnableOptableEIDs,
        TargetedAdBreak:
          this.props.headerbidder.TargetedAdBreak ||
          EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL,
        RemoveFmtJSON: this.props.headerbidder.RemoveFmtJSON,
        FlexibleBiddingEnabled: this.props.headerbidder.FlexibleBiddingEnabled,
        FlexibleBiddingThresholds: this.props.headerbidder.FlexibleBiddingThresholds || [],
        FlexibleBiddingType: this.props.headerbidder.FlexibleBiddingType,
        flexibleBiddingDialogIsOpen: false,
        flexibleBiddingDialogNewPriority: 0,
        flexibleBiddingDialogInvalidThresholds: [],
        bulkUpdateEnabledFields: {} as IBulkUpdateMap,
        bulkUpdateIDsIncludesDirectCampaign: false,
        bulkUpdateIDsIncludesBidderWithoutAdjFactor: false,
        createEditRegionID: '',
        createEditRegionName: '',
        createEditRegionList: generateCountriesMenuList(),
        publisherCountryGroups: [] as ICountryGroup[],
        EnableSpotxBidderAssociation: this.props.headerbidder.EnableSpotxBidderAssociation,
        EnableMagniteCTVBidderAssociation:
          this.props.headerbidder.EnableMagniteCTVBidderAssociation,
        EnableSamsungSSPBidderAssociation:
          this.props.headerbidder.EnableSamsungSSPBidderAssociation,
        EnableIrisSignal: this.props.headerbidder.EnableIrisSignal,

        contextualSegmentList: {} as IMenuList,
        ContextualSegmentIDS: this.props.headerbidder.ContextualSegmentIDS || [],
        IASDataSharing: this.props.headerbidder.IASDataSharing || [],
        DoubleVerifyDataSharing: this.props.headerbidder.DoubleVerifyDataSharing || [],
        EnforceSlotTargeting: this.props.headerbidder.EnforceSlotTargeting,
        PodSequenceTargeting:
          this.props.headerbidder.PodSequenceTargeting ||
          EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_ANYPOD,
        LocalTargetingLogic: this.props.headerbidder.LocalTargetingLogic,
        VastExtensionPriceEnabled: this.props.headerbidder.VastExtensionPriceEnabled,
        platformMarketplacePublishers: [{ name: 'None', ID: undefined }] as unknown as IPublisher[],
        openChannelListDialog: false,
        openChannelListEditDialog: false,
        channelListCGL: {} as IMenuList, // Channel List (Channel Groups List) for Dropdown
        channelListCL: {} as IMenuList, // Channel List (Channels List) for Dropdown
        channelListsList: {} as IMenuList, // List of Channel Lists for Dropdown
        channelLists: [] as IChannelList[], // Channel Lists Object retrived from the backend
        ChannelListChannelsIDS: [] as number[], // Channels IDS in the Channel Lists Object
        ChannelListGroupsIDS: [] as number[], // Channel Groups IDS in the Channel Lists Object
        editChannelListCGL: {} as IMenuList, // Channel List (Channel Groups List) for Dropdown Edit
        editChannelListCL: {} as IMenuList, // Channel List (Channels List) for Dropdown Edit
        editChannelListsList: {} as IMenuList, // List of Channel Lists for Dropdown Edit
        editChannelLists: [] as IChannelList[], // Channel Lists Object retrived from the backend for Edit
        editChannelListID: 0 as number,
        EditChannelListChannelsIDS: [] as number[], // Edit Channels IDS in the Channel Lists Object
        EditChannelListGroupsIDS: [] as number[], // Edit Channel Groups IDS in the Channel Lists Object
        BidderLabelsSelected: this.props.headerbidder.BidderLabels as IBidderLabel[],
        bidderLabels: [] as IBidderLabel[], // list of bidder labels for dropdown object
        listSettingsDialogActive: false,
        listSettingsDialogID: 0,
        newChannelGroupActive: false,
        PlatformMarketplaceTargetedPublisher: ((): string => {
          // get raw value from the bidder's params field (should be number)
          const rawValue = this.getValueFromBidderParams(
            this.props.headerbidder.Params,
            'platformMarketplacePublisher',
          );
          // check if the parameter exists
          if (rawValue === undefined) {
            return '0';
          }
          // return it as a string
          return rawValue.toString();
        })(),
        commonRegionGroups: [] as ICountryGroup[],
        Dayparting: this.props.headerbidder.Dayparting || '',
        DaypartingIsAllowed: this.props.headerbidder.DaypartingIsAllowed || EAllowStatus.ALLOW,
        DaypartingIntervals: [
          {
            ActiveDays: {
              Sunday: false,
              Monday: false,
              Tuesday: false,
              Wednesday: false,
              Thursday: false,
              Friday: false,
              Saturday: false,
            },
            StartTime: moment().startOf('day'),
            EndTime: moment().startOf('day').add(12, 'hours'),
            Error: '',
          },
        ],
        isDaypartingActive: false,
        enableViewerTimezone: false,
        Timezone: this.props.headerbidder.Timezone,
        timezonesList: {} as IMenuList,
        TmaxOffset: this.props.headerbidder.TmaxOffset,
        MimeTypeOverride: this.props.headerbidder.MimeTypeOverride || '',
        smartFloorConfigs,
        hasExistingSmartFloorConfig,
        hasExistingThompsonSampling,
        isSmartFloorActive,
        selectedSiteIDForSmartFloorsChart,
        isWaitingToUpdateSmartFloorConfig: false,
        isChannelListDetailUpdated: false,
        TargetingCCPA: this.props.headerbidder.TargetingCCPA || TargetingCCPAAll,
        EnableRemoveGPPFromBidRequest:
          this.props.headerbidder.EnableRemoveGPPFromBidRequest || EBool.EBool_FALSE,
        EnableSecondaryRequests:
          this.props.headerbidder.EnableSecondaryRequests || EBool.EBool_FALSE,
        EnableSponsorshipMode: this.props.headerbidder.EnableSponsorshipMode || EBool.EBool_FALSE,
        SamplingPercentageDisabledUntil:
          this.props.headerbidder.SamplingPercentageDisabledUntil || '',
        SamplingPercentage: this.props.headerbidder.SamplingPercentage,
        YahooConnectIDEnabled: this.props.headerbidder.YahooConnectIDEnabled || EBool.EBool_FALSE,
        DOOHDeviceTypeRewriteEnabled:
          this.props.headerbidder.DOOHDeviceTypeRewriteEnabled || EBool.EBool_FALSE,
        refreshingLiveLogs: false,
        refreshingLiveLogsTimestamp: '',
        TargetingRequestedPodDurationMin:
          this.props.headerbidder.TargetingRequestedPodDurationMin ||
          TargetingRequestedPodDurationNoMin,
        TargetingRequestedPodDurationMax:
          this.props.headerbidder.TargetingRequestedPodDurationMax ||
          TargetingRequestedPodDurationNoMax,
        TargetingGvinParamExists:
          this.props.headerbidder.TargetingGvinParamExists || EBool.EBool_FALSE,
        EnableTargetingFirstAdbreakInUserSession:
          this.props.headerbidder.EnableTargetingFirstAdbreakInUserSession || EBool.EBool_FALSE,
        AppStoreURL: this.props.headerbidder.AppStoreURL || ({} as IHeaderBidderDeviceAwareModel),
        AppStoreUrlOverrideIfEmpty:
          this.props.headerbidder.AppStoreUrlOverrideIfEmpty || EBool.EBool_FALSE,
        appStoreURLs: [...AppOverrideKeys].sort(),
        rewriteInputRows: {
          AppStoreURL: this.props.headerbidder.AppStoreURL
            ? [...AppOverrideKeys]
                .sort()
                .filter((url: string) => this.props.headerbidder.AppStoreURL[url])
                .map((url: string) => ({
                  device: url,
                  text: this.props.headerbidder.AppStoreURL[url],
                }))
            : [],
        },
        demandSourceSettings: [] as IContentFromEPG[],
        UID2ExtendedIDSetting:
          this.props.headerbidder.UID2ExtendedIDSetting || ExtendedIDSettingInherit,
        LiverampExtendedIDSetting:
          this.props.headerbidder.LiverampExtendedIDSetting || ExtendedIDSettingInherit,
        GooglePairExtendedIDSetting:
          this.props.headerbidder.GooglePairExtendedIDSetting || ExtendedIDSettingInherit,
        showExtendedIDOptions:
          this.props.headerbidder.LiverampExtendedIDSetting !== ExtendedIDSettingInherit ||
          this.props.headerbidder.GooglePairExtendedIDSetting !== ExtendedIDSettingInherit ||
          this.props.headerbidder.UID2ExtendedIDSetting !== ExtendedIDSettingInherit,
        // extended id targeting
        TargetingUID20TargetingType:
          this.props.headerbidder.TargetingUID20TargetingType || ExtendedIDTargetingTypeDisabled,
        TargetingGooglePairIDTargetingType:
          this.props.headerbidder.TargetingGooglePairIDTargetingType ||
          ExtendedIDTargetingTypeDisabled,
        TargetingLiveRampATSTargetingType:
          this.props.headerbidder.TargetingLiveRampATSTargetingType ||
          ExtendedIDTargetingTypeDisabled,
        TargetingIrisSignalTargetingType:
          this.props.headerbidder.TargetingIrisSignalTargetingType ||
          ExtendedIDTargetingTypeDisabled,
        // TargetingSamsungIdentityTargetingType:
        //   this.props.headerbidder.TargetingSamsungIdentityTargetingType ||
        //   ExtendedIDTargetingTypeDisabled,
        // TargetingSamsungEPGMetadataTargetingType:
        //   this.props.headerbidder.TargetingSamsungEPGMetadataTargetingType ||
        //   ExtendedIDTargetingTypeDisabled,
        selectedChartView: 'liveData',
        // Auction Insights
        auctionInsightsCalStartDate: moment().startOf('day'),
        auctionInsightsCalEndDate: moment().endOf('day'),
      });
    };

    HeaderBidderParamsUIconfig = getHeaderBidderParamsUIConfig(this.props.session.publisher.ID);

    componentDidMount() {
      this.getSites();
      this.getPresetList();
      this.getDemandSourceSettings();
    }

    componentDidUpdate(_prevProps: Readonly<IProps>, prevState: Readonly<IState>) {
      // ----- SmartFloors update logic
      // disable Smart Floors for VAST bidders
      if (
        prevState.Bidder !== DemandSources.publica &&
        this.state.Bidder === DemandSources.publica
      ) {
        this.setState({
          isSmartFloorActive: false,
          smartFloorConfigs: this.buildNewSmartFloorConfigs(0, 'SmartFloors', true, 0, true, false),
        });
      }

      // changes to targeted channels, channelgroups, channellists will update the state of existing Smart Floors
      if (
        this.state.isWaitingToUpdateSmartFloorConfig &&
        (prevState.SiteIDS !== this.state.SiteIDS ||
          prevState.ChannelGroupIDS !== this.state.ChannelGroupIDS ||
          prevState.ChannelListIDS !== this.state.ChannelListIDS ||
          this.state.isChannelListDetailUpdated)
      ) {
        this.setState({
          isWaitingToUpdateSmartFloorConfig: false,
          isChannelListDetailUpdated: false,
          smartFloorConfigs: this.buildNewSmartFloorConfigs(
            0,
            'SmartFloors',
            true,
            0,
            false,
            false,
          ),
        });
      }
      // ----- SmartFloors update logic

      if (isEqual(prevState.sites, this.state.sites)) {
        return;
      }

      this.trackEvent('Bidder Settings - View Bidder');
      if (getResellerID() > 0) {
        // TODO PERF: DO THIS GLOBALLY!!!!!
        getReseller({
          query: {
            reseller_id: getResellerID(),
          },
        }).then((reseller: IReseller) => {
          this.setState({
            ssp: reseller.SSP,
            headerBidderAdapters: getHeaderBidderAdaptersForPublisher(
              reseller.SSP,
              false,
              this.props.session.publisher,
              hasRoleSuperUser(this.props.user.user),
              false,
            ),
          });
        });
      } else {
        // add bidder that are filtered
        this.setState({
          headerBidderAdapters: getHeaderBidderAdaptersForPublisher(
            '',
            false,
            this.props.session.publisher,
            hasRoleSuperUser(this.props.user.user),
            false,
          ),
        });
      }

      if (this.state.Bidder === DemandSources.publicaCampaign) {
        this.getCampaigns();
        this.getAdserverOrders();
      }

      if (this.isBulkUpdate()) {
        this.setBulkBiddersAsInactiveByDefault();
      }

      this.getCountryGroupsByPublisherID();

      this.getCommonRegionGroupsByIDs();

      // TODO PERF: DO THIS GLOBALLY!!!!!
      getAudienceSegments({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then((segments: IAudienceSegment[]) => {
        this.setState({
          segments,
        });
      });

      this.fetchData();
      this.genBidderChannelList();
      this.parseDayparting();
      this.genTimezoneList();
    }

    setBulkBiddersAsInactiveByDefault = () => {
      this.setState({
        Active: HeaderBidderActiveInactive,
      });
    };

    parseDayparting = () => {
      const daypartingObj = parseDayparting(this.state.Dayparting);

      const isDaypartingActive = daypartingObj[0];
      const DaypartingIntervals = daypartingObj[1];
      const enableViewerTimezone = daypartingObj[2] || false;
      this.setState({
        isDaypartingActive,
        DaypartingIntervals,
        enableViewerTimezone,
      });
    };

    getBidderIndex = (key: string): number => {
      for (let i: number = 0; i < this.state.headerBidderAdapters.length; i += 1) {
        if (this.state.headerBidderAdapters[i].key === key) {
          return i;
        }
      }
      return -1;
    };

    getSiteIDFromParams = (param: string): string => {
      // We only split on first occurrence of : so that we don't split up VAST url: https://stackoverflow.com/questions/4607745/split-string-only-on-first-instance-of-specified-character
      const lines = this.state.Params.split('\n');
      for (let i = 0; i < lines.length; i++) {
        const params = lines[i].split(/:(.+)/);
        if (params.length > 1) {
          // Get and sanitize parameters
          const name = params[0].replace(/("|')/g, '');
          const value = params[1].replace(/("|,)/g, '');
          const re = /site_id=\d*/;
          if ([param].includes(name)) {
            if (param === 'vastURL') {
              const found = value.match(re);
              if (found && found.length > 0) {
                return found[0].split('=')[1];
              }
            } else if (param === 'siteID') {
              return value;
            }
          }
        }
      }
      return '';
    };

    genBidderChannelList = () => {
      // Create MenuList for Channel Targeting
      const bidderChannelList = {} as IMenuList;
      const channelListCL = {} as IMenuList;
      const selectedSitesID = this.state.SiteIDS.map((s: number) => String(s));

      // filter out inactive sites
      const activeSites: ISmallSite[] = filterSitesByActive(this.state.sites);

      // Fill MenuList with all active sites
      activeSites.forEach((s: ISmallSite) => {
        const siteName = checkUserInfoMasked(this.props.user.user) ? 'Channel_' + s.ID : s.Name;
        bidderChannelList[s.ID] = {
          selected: selectedSitesID.includes(s.ID.toString()),
          title: siteName,
          ID: s.ID.toString(),
        };
        channelListCL[s.ID] = {
          selected: false,
          title: siteName,
          ID: s.ID.toString(),
        };
      });
      // Apply
      this.setState({
        loaded: true,
        activeSites,
        bidderChannelList,
        channelListCL,
        editChannelListCL: channelListCL,
      });
    };

    genBidderCampaignList = (campaigns: IAdserverCampaign[]) => {
      // create campaign list
      const bidderTargetedCampaignsList: IMenuList = {};
      // filter campaigns to only active
      campaigns.forEach((campaign: IAdserverCampaign) => {
        const campaignName = checkUserInfoMasked(this.props.user.user)
          ? 'Line_Item_' + campaign.ID
          : campaign.Name;
        const selected = this.state.CampaignIDS.includes(parseInt(campaign.ID, 10));
        bidderTargetedCampaignsList[campaign.ID] = {
          title: campaignName,
          selected,
          ID: campaign.ID,
        };
      });
      this.setState({
        bidderTargetedCampaignsList,
        campaigns,
      });
    };

    genBidderOrderList = (orders: IAdserverOrder[]) => {
      // Create MenuList for Order Targeting
      const bidderTargetedOrdersList = {} as IMenuList;
      const selectedOrdersID = this.state.OrderIDS.map((s: number) => String(s));

      // Fill MenuList with all active orders
      orders.forEach((order: IAdserverOrder) => {
        const orderName = checkUserInfoMasked(this.props.user.user)
          ? 'Order_' + order.ID
          : order.Name;
        bidderTargetedOrdersList[order.ID] = {
          selected: selectedOrdersID.includes(order.ID.toString()),
          title: orderName,
          ID: order.ID.toString(),
        };
      });

      // Apply
      this.setState({
        orders,
        bidderTargetedOrdersList,
      });
    };

    fetchData() {
      this.getLiveLogs();

      if (
        this.props.headerbidder &&
        this.props.headerbidderParamOptions &&
        !this.state.hasParsedParams
      ) {
        this.setState(
          {
            hasParsedParams: true,
          },
          () => {
            this.updateParamOptionValues(
              this.props.headerbidderParamOptions[this.props.headerbidder.Bidder],
            );
          },
        );
      }

      this.parseKeyValueParametersFromParams();
      this.importLocalTargetingParamFromJSON(this.state.LocalTargeting);
      this.genChannelGroupsList();
      this.genChannelLists();
      this.genBidderLabels();
      this.populateTargetingCountriesList();
      this.populateTargetingCountryGroupList();
      this.populateContextualSegmentList();
      // Bidder pacing info
      // this.getBidderPacingImpressionsFromDebugRoute(); TODO reenable
      this.populatePlatformMarketplacePublishersList();
    }

    trackEvent = (eventTitle: BidderEventTypes): void => {
      const is_super_user = hasRoleSuperUser(this.props.user.user);
      if (eventTitle === 'Bidder Settings - Save Bidder') {
        track(
          eventTitle,
          {
            is_super_user,
            demand_source: this.state.Bidder,
            frequency_cap_enabled: this.state.FrequencyActive === ResourceActiveEnabled,
          },
          this.props.user.user,
        );
      } else {
        track(
          eventTitle,
          {
            is_super_user,
          },
          this.props.user.user,
        );
      }
    };

    populateContextualSegmentList = () => {
      getContextualSegmentsByPublisherID(this.props.session.publisher.ID)
        .then((resp) => {
          const contextualSegments = resp[0];
          const contextualSegmentList: IMenuList = {};
          for (const segment of contextualSegments || []) {
            if (segment.Active === ResourceActiveDisabled) {
              continue;
            }
            contextualSegmentList[segment.ID] = {
              title: segment.Name,
              selected: this.state.ContextualSegmentIDS.includes(segment.ID),
              ID: segment.ID.toString(),
            };
          }
          this.setState({
            contextualSegmentList,
          });
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', { item: ct('ContextualSegments') }),
          });
        });
    };

    // gets the list of publishers with managed platform connection enabled and publisher type of buyer or both - this is used for the dropdown in PC bidders
    populatePlatformMarketplacePublishersList = () => {
      genPlatformMarketplacePublishersList(this.props.session.publisher.ID)
        .then((resp) => {
          // API response OK
          // add the "None" choice to the list
          resp.splice(0, 0, { name: 'None', ID: '0' } as unknown as IPublisher);
          // remove the current publisher from the list - it makes no sense for the publisher to target itself in a
          // Marketplace connection
          resp = resp.filter(
            (r: IPublisher) => (r.ID || -1).toString() !== this.props.session.publisher.ID,
          );
          // set the state to the new list
          this.setState({
            platformMarketplacePublishers: resp,
          });
        })
        .catch(() => {
          // API response error
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', {
              item: ct('ManagedPlatformConnectionsPublishers'),
            }),
          });
        });
    };

    getCountryGroupsByPublisherID = () => {
      const { targetingCountryGroupList } = this.state;
      const { session } = this.props;

      getCountryGroupsByPublisherID(session.publisher.ID).then((countryGroups: ICountryGroup[]) => {
        // create the updated menu list and update the state
        const updatedCountryGroupMenuList = generateNewTargetingCountryGroupList(
          targetingCountryGroupList,
          countryGroups,
        );
        this.setState(
          {
            publisherCountryGroups: countryGroups,
            targetingCountryGroupList: updatedCountryGroupMenuList,
          },
          this.populateTargetingCountryGroupList,
        );
      });
    };

    getCommonRegionGroupsByIDs = () => {
      getCountryGroupsByIDs(commonRegionGroupsIDs, this.props.session.publisher.ID)
        .then((regionGroups) => {
          this.setState({ commonRegionGroups: regionGroups[0] });
        })
        .catch(() => {
          this.setState({
            commonRegionGroups: [],
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', { item: ct('CommonCountryGroups') }),
          });
        });
    };

    getCampaigns = (): void => {
      getCampaigns({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      })
        .then((campaigns: IAdserverCampaign[]) => {
          this.genBidderCampaignList(campaigns);
        })
        .catch(() => {
          this.setState({
            campaigns: [],
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', { item: ct('LineItems') }),
          });
        });
    };

    getAdserverOrders = (): void => {
      getAdserverOrders(this.props.session.publisher.ID)
        .then((orders: IAdserverOrder[]) => {
          this.genBidderOrderList(orders);
        })
        .catch(() => {
          this.setState({
            orders: [],
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', { item: ct('Orders') }),
          });
        });
    };

    // populateTargetingCountryGroupList sets the selected value in targetingCountryGroupList
    // based on the TargetingCountryGroupIDs on the headerbidder, then updates the state
    populateTargetingCountryGroupList = (): void => {
      const { targetingCountryGroupList, TargetingCountryGroupIDs } = this.state;

      const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
      const selectedCountryGroupIDs = TargetingCountryGroupIDs.split(',');

      for (const selectedCountryGroupID of selectedCountryGroupIDs) {
        if (clonedTargetingCountryGroupList[selectedCountryGroupID] !== undefined) {
          clonedTargetingCountryGroupList[selectedCountryGroupID].selected = true;
        }
      }

      this.setState({
        targetingCountryGroupList: clonedTargetingCountryGroupList,
      });
    };

    // Set the selected values for the targetingDeviceCountiesList
    populateTargetingCountriesList() {
      // Device local targeting countries setup
      // If number of selected countries < total/2, we are in Allow list mode
      const ckeys: string[] = this.state.TargetingDeviceCountry.split(',');
      if (ckeys.length < getAllCountries().length / 2) {
        // Allowlist mode
        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (this.state.targetingCountriesList[selectedCountry] !== undefined) {
            this.state.targetingCountriesList[selectedCountry].selected = true;
          }
        }
        this.setState({
          targetingCountriesList: this.state.targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        });
      } else {
        // Denylist mode
        for (const key of Object.keys(this.state.targetingCountriesList)) {
          this.state.targetingCountriesList[key].selected = true;
        }

        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (this.state.targetingCountriesList[selectedCountry] !== undefined) {
            this.state.targetingCountriesList[selectedCountry].selected = false;
          }
        }

        this.setState({
          targetingCountriesList: this.state.targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Denylist,
        });
      }
    }

    genChannelGroupsList = () => {
      const getChannelLabelPromise = getChannelLabels({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      });

      Promise.all([
        getChannelGroupsPromise({
          publisherID: this.props.session.publisher.ID,
        }),
        getChannelLabelPromise,
      ])
        .then((response: any[]) => {
          // if a headerbidder is selected from bidder list, use channel groups
          // if channel groups are in state, bidder was chosen from clone bidder
          const headerbidderChannelGroups = this.state.OriginalBidderChannelGroups || [];
          const headerbidderChannelGroupIDS = headerbidderChannelGroups.map(
            (cg: IChannelGroup) => cg.ID,
          );
          const channelGroupsList: IMenuList = {};
          const channelListCGL: IMenuList = {};
          const ChannelGroupIDS: number[] = [];
          // generate channelgroups list for dropdown
          response[0].channelGroups.forEach((cg: IChannelGroup) => {
            const channelGroupName = checkUserInfoMasked(this.props.user.user)
              ? `demo_channelgroup_` + cg.ID
              : `${cg.Name}: (${cg.SitesInfo.length} Sites)`;
            // new HBs should have selected all false to start
            // if hb is cloned or hb exists, look at headerbidderChannelGroupIDS to determine if this channel group is selected
            const selected = headerbidderChannelGroupIDS.includes(cg.ID);
            if (selected) {
              ChannelGroupIDS.push(cg.ID);
            }
            channelGroupsList[cg.ID] = {
              title: channelGroupName,
              selected,
              ID: cg.ID.toString(),
              channelGroup: cg,
            };
            channelListCGL[cg.ID] = {
              title: channelGroupName,
              selected: false,
              ID: cg.ID.toString(),
              channelGroup: cg,
            };
          });
          this.setState(
            {
              ChannelGroups: response[0].channelGroups,
              ChannelGroupIDS,
              channelGroupsList,
              channelLabels: response[1].channel_labels,
              channelListCGL,
              editChannelListCGL: channelListCGL,
            },
            () => {
              this.getHeaderBidders();
              this.getChannelIDs();
              this.setState({
                quickFilterOptions: genQuickFilter(
                  this.state.ChannelGroups,
                  this.state.channelLabels,
                  this.props.user.user.Username,
                ),
              });
            },
          );
        })
        .catch(() => {
          this.setState(
            {
              ChannelGroups: [],
              ChannelGroupIDS: [],
              channelGroupsList: {} as IMenuList,
              channelListCGL: {} as IMenuList,
              editChannelListCGL: {} as IMenuList,
            },
            this.getHeaderBidders,
          );
        });
    };

    getSites = () => {
      getSmallSites(this.props.session.publisher.ID, 'bid_floor')
        .then((response: any[]) => {
          const [smallSites, err] = response;
          if (err) {
            throw new Error();
          }
          const sites: ISmallSite[] = smallSites || [];
          this.setState({
            sites,
          });
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', { item: ct('Sites') }),
          });
          return;
        });
    };

    getDemandSourceSettings = (): void => {
      getEPGContentTogglesForPublisher(this.props.session.publisher.ID)
        .then(([demandSourceSettings, err]) => {
          if (err) {
            this.setState({
              snackbarError: true,
              snackbarMessage: ct('FailedToLoadItem', { item: ct('DemandSourceSettings') }),
            });
          } else if (demandSourceSettings) {
            this.setState({
              demandSourceSettings,
            });
          }
          return;
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('FailedToLoadItem', { item: ct('DemandSourceSettings') }),
          });
          return;
        });
    };

    getSitesInfoForChannelList = (channelList: IChannelList): ISitesInfo[] => {
      return channelList.Sites.map((site: ISite) => {
        return { ID: site.ID, Name: site.Name };
      });
    };

    genChannelLists = (newCreatedChannelList?: boolean, newChannelListID?: number) => {
      getChannelListsPromise({
        publisherID: this.props.session.publisher.ID,
      })
        .then((response: { channelLists: IChannelList[] }) => {
          // if a headerbidder is selected from bidder list, use channel Lists
          // if channel Lists are in state, bidder was chosen from clone bidder
          const headerbidderChannelListIDS = this.state.OriginalBidderChannelListIDS || [];
          const channelListsList: IMenuList = {};
          const ChannelListIDS: number[] = [];
          // generate channelLists list for dropdown
          response.channelLists.forEach((cg: IChannelList) => {
            const channelGroupsLength = cg.ChannelGroupIDs.split(',').length;
            let channelListName;
            if (cg.ChannelGroupIDs === '' || cg.ChannelGroupIDs === 'undefined') {
              channelListName = `${cg.Name}: ${ct('FormatLabelWithCount', {
                count: cg.SitesInfo.length,
                label: ct('Channels'),
              })}`;
            } else if (cg.ChannelIDs === '' || cg.ChannelIDs === 'undefined') {
              channelListName = `${cg.Name}: ${ct('FormatLabelWithCount', {
                count: channelGroupsLength,
                label: ct('ChannelGroups'),
              })}`;
            } else {
              channelListName = `${cg.Name}: ${ct('FormatLabelWithCount', {
                count: cg.SitesInfo.length,
                label: ct('Channels'),
              })} ${ct('FormatLabelWithCount', {
                count: channelGroupsLength,
                label: ct('ChannelGroups'),
              })}`;
            }

            // new HBs should have selected all false to start
            // if hb is cloned or hb exists, look at headerbidderChannelListIDS to determine if this channel List is selected
            const selected =
              headerbidderChannelListIDS.includes(cg.ID) ||
              this.state.ChannelListIDS.includes(cg.ID);
            if (selected) {
              ChannelListIDS.push(cg.ID);
            }

            channelListsList[cg.ID] = {
              title: channelListName,
              selected,
              ID: cg.ID.toString(),
              channelList: cg,
            };
          });

          if (!!newCreatedChannelList && newChannelListID !== undefined) {
            ChannelListIDS.push(newChannelListID);
            channelListsList[newChannelListID].selected = true;
          }
          this.setState(
            {
              channelLists: response.channelLists,
              ChannelListIDS,
              channelListsList,
            },
            () => {
              this.getHeaderBidders();
              this.getChannelIDs();
            },
          );
        })
        .catch(() => {
          this.setState(
            {
              channelLists: [],
              ChannelListIDS: [],
              channelListsList: {} as IMenuList,
            },
            this.getHeaderBidders,
          );
        });
    };

    getChannelIDs = () => {
      if (this.state.ChannelGroupIDS.length > 0) {
        getChannelIDs({
          query: {
            publisher_id: this.props.session.publisher.ID,
            channel_group_ids: this.state.ChannelGroupIDS.join(','),
          },
        })
          .then((channelIDs: number[]) => {
            this.setState({
              channelIDs: channelIDs || ([] as number[]),
            });
          })
          .catch(() => {
            this.setState({
              snackbarError: true,
              snackbarMessage: ct('BiddersSnackbarFailedToRetrieveChannelListByChannelGroups'),
              channelIDs: [] as number[],
            });
          });
      } else {
        this.setState({
          channelIDs: [] as number[],
        });
      }
    };

    getBidderLabelAddList = (): Array<{
      ID: string;
      Name: string;
      Bidders: IHeaderBidder[];
    }> => {
      return Object.values(this.state.BidderLabelsSelected);
    };

    genBidderLabels = () => {
      getBidderLabels({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then(({ bidder_labels }: { bidder_labels: IBidderLabel[] }) => {
        this.setState({
          bidderLabels: bidder_labels,
        });
      });
    };

    getLiveLogs = () => {
      if (!this.props.existing) {
        return;
      }
      this.setState(
        {
          refreshingLiveLogs: true,
        },
        () => {
          const hbIDS = [this.props.headerbidder.ID];

          // Bid Request Logs
          if (hbIDS.length > 0) {
            const bidRequestQuery = getBidRequestLogsQuery(+hbIDS[0]);

            generalGetLiveLogs<IBidRequestLiveLogs[]>(
              bidRequestQuery,
              this.props.session.publisher.ID,
              this.props.user.user.Username,
            ).then(([data, err]) => {
              if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
                if (isOttera()) {
                  data.forEach((datum) => {
                    datum.debugInfo = datum.debugInfo.replace(
                      'pbs.getpublica.com',
                      'obs.ads.ottera.tv',
                    );
                  });
                }
                this.setState({
                  bidRequestLiveLogs: data,
                });
              }
              if (err !== undefined) {
                console.error(err);
              }
              this.setState({
                refreshingLiveLogs: false,
                refreshingLiveLogsTimestamp: formatTime(
                  moment(),
                  this.props.user.publisher.Timezone,
                ),
              });
            });
          }

          // Bid Response Logs
          if (hbIDS.length > 0) {
            const bidResponseQuery = getBidResponseLogsQuery(+hbIDS[0]);

            generalGetLiveLogs<IBidResponseUIData[]>(
              bidResponseQuery,
              this.props.session.publisher.ID,
              this.props.user.user.Username,
            ).then(([data, err]) => {
              if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
                this.setState({
                  bidResponseLiveLogs: data,
                  refreshingLiveLogsTimestamp: formatTime(
                    moment(),
                    this.props.user.publisher.Timezone,
                  ),
                });
              }
              if (err !== undefined) {
                console.error(err);
              }
              this.setState({
                refreshingLiveLogs: false,
              });
            });
          }
        },
      );
    };

    // handlePlatformMarketplaceChange handles the change for the platform marketplace targeting.
    handlePlatformMarketplaceChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      // if the value is undefined, meaning the user selected the "None" option, replace it with an ID = 0
      if (target.value === undefined) {
        target.value = '0';
      }
      // assign the value to the bidder param
      // when saving the bidder we reset state.Params /w values from state.ParamOption
      this.assignValueToBidderParamOptions('platformMarketplacePublisher', target.value).then(
        () => {
          // call the rest of the handleChange function to change the main value in the state (not in bidder params)
          this.handleChange({ target } as React.ChangeEvent<HTMLInputElement>);
        },
      );
    };

    handleChangeFlexibleBiddingType = (newFlexibleBiddingTypeStr: string): void => {
      const FlexibleBiddingType = flexibleBiddingStringToType(newFlexibleBiddingTypeStr);
      if (this.state.FlexibleBiddingType === FlexibleBiddingType) {
        return;
      }
      this.setState({
        FlexibleBiddingType,
      });
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (
        [
          'SegmentTargeting',
          'MaxAdDurationOverride',
          'MinAdDurationOverride',
          'TargetingLiveStream',
          'FrequencyLimit',
          'Quantity',
          'TmaxOffset',
          'Timeout',
        ].includes(target.name)
      ) {
        this.setState({
          [target.name]: parseInt(target.value.split(',').join(''), 10)
            ? parseInt(target.value.split(',').join(''), 10)
            : 0,
        });
      } else if (target.name === 'frequencyLimitDuration') {
        const frequencyLimitDuration = parseInt(target.value, 10) || 0;
        let FrequencyTTL = 60 * 60 * frequencyLimitDuration;
        if (this.state.frequencyLimitUnit === 'Days') {
          FrequencyTTL = 24 * FrequencyTTL;
        }
        this.setState({
          frequencyLimitDuration,
          FrequencyTTL,
        });
      } else if (target.name === 'ShareOfVoiceType') {
        this.setState({
          ShareOfVoiceType: parseInt(target.value, 10),
          Pods:
            parseInt(target.value, 10) ===
            EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD_DURATION
              ? '1'
              : this.state.Pods,
        });
      } else if (target.name === 'frequencyLimitUnit') {
        if (
          target.value === FrequencyLimitUnitDays &&
          this.state.frequencyLimitUnit === FrequencyLimitUnitHours
        ) {
          this.setState({
            FrequencyTTL: this.state.FrequencyTTL * 24,
            frequencyLimitUnit: FrequencyLimitUnitDays,
          });
        } else if (
          target.value === FrequencyLimitUnitHours &&
          this.state.frequencyLimitUnit === FrequencyLimitUnitDays
        ) {
          this.setState({
            FrequencyTTL: this.state.FrequencyTTL / 24,
            frequencyLimitUnit: FrequencyLimitUnitHours,
          });
        }
      } else if (target.name === 'Bidder') {
        if (target.value === DemandSources.publicaCampaign && this.state.campaigns.length === 0) {
          this.getCampaigns();
        }
        if (target.value === DemandSources.publicaCampaign && this.state.orders.length === 0) {
          this.getAdserverOrders();
        }
        if (target.value === DemandSources.publicaCampaign) {
          this.setState({
            PresetIDs: [],
          });
        }
        // gatewayTier0 bidders must be tier 0, otherwise default the value to tier 1
        if (target.value === DemandSources.gatewayTier0) {
          this.setState({ Priority: 11 });
        } else {
          this.setState({ Priority: 10 });
        }
        this.updateParamOptionValues(this.props.headerbidderParamOptions[target.value], true);
        const override: Partial<IState> = { Params: '' };

        if (ALL_PLATFORM_CONNECTION_BIDDERS.includes(target.value)) {
          override.PoddedRequestActive = HeaderBidderPoddedRequestActiveActive;
          override.Slots = ['1'];
        }

        this.setState(
          Object.assign(
            {
              [target.name]: target.value,
            },
            override,
          ),
        );

        // Reset the podded requests switch
        if (!BIDDERS_ADBREAK_TARGETING_ENABLED.includes(this.state.Bidder)) {
          this.handlePoddedRequestActiveChange(false);
        }

        // Reset Adbreak Targeting
        if (!BIDDERS_ADBREAK_TARGETING_ENABLED.includes(this.state.Bidder)) {
          if (this.state.AdbreakTargeting === '1') {
            this.toggleAdbreakTargeting();
          }
        }

        // Reset the enable iris signal switch
        this.setState({
          EnableIrisSignal: EBool.EBool_FALSE,
        });

        //  // Remove uneditable iris context fields if they exist when switching demand sources
        if (this.state.Bidder !== DemandSources.magnitectv) {
          this.setState({
            keyValueParameters: this.state.keyValueParameters.filter(
              (keyValObj) => keyValObj.key !== 'c4' && !keyValObj.isNotEditable,
            ),
          });
        }
        if (this.state.Bidder !== DemandSources.videobyte) {
          this.setState({
            keyValueParameters: this.state.keyValueParameters.filter(
              (keyValObj) => keyValObj.key !== 'iris_context' && !keyValObj.isNotEditable,
            ),
          });
        }
        if (this.state.Bidder !== DemandSources.rhythmone) {
          this.setState({
            keyValueParameters: this.state.keyValueParameters.filter(
              (keyValObj) => !keyValObj.key.includes('customkey') && !keyValObj.isNotEditable,
            ),
          });
        }

        // Targeted Ad Break should default to last for APS bidders, but be set back to all for other bidders
        if (APS_BIDDERS.includes(target.value)) {
          this.setState({
            TargetedAdBreak: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_LAST,
          });
        } else if (APS_BIDDERS.includes(this.state.Bidder) && !APS_BIDDERS.includes(target.value)) {
          this.setState({
            TargetedAdBreak: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL,
          });
        }

        // Reset the bid adjustment factor
        if (!BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR.includes(this.state.Bidder)) {
          this.setState({
            BidAdjustmentFactor: 100,
          });
        }

        // set customName for VideoHeroes Demand Sources, will be hidden in UI
        if (
          [DemandSources.videoHeroesRevShare, DemandSources.videoHeroesFixedCPM].includes(
            target.value,
          )
        ) {
          this.setState({
            UIBidderType: 'Video Heroes',
          });
        }

        // reset enable deal priority tier override to false on any demand source change
        this.setState({
          EnableDealPriorityOverride: EBool.EBool_TRUE,
        });
      } else if (Object.keys(overwriteContentToRemoveContent).includes(target.name)) {
        // if one of the content names is being added, we should switch the remove content if it is active
        this.setState({
          [target.name]: target.value,
          [overwriteContentToRemoveContent[target.name]]: EBool.EBool_FALSE,
        });
      } else if (target.name === 'FrequencyActive') {
        this.setState({
          [target.name]:
            this.state.FrequencyActive === ResourceActiveEnabled
              ? ResourceActiveDisabled
              : ResourceActiveEnabled,
        });
      } else if (target.name === 'IsPublicaTagFallbackEnabled') {
        this.setState({
          [target.name]:
            this.state.IsPublicaTagFallbackEnabled === PublicaTagFallbackEnabled
              ? PublicaTagFallbackDisabled
              : PublicaTagFallbackEnabled,
          Slots: this.state.IsPublicaTagFallbackEnabled === PublicaTagFallbackEnabled ? [] : ['1'],
        });
      } else if (target.name === 'IsFallbackBackfillEnabled') {
        this.setState({
          [target.name]:
            this.state.IsFallbackBackfillEnabled === FallbackBackfillEnabled
              ? FallbackBackfillDisabled
              : FallbackBackfillEnabled,
        });
      } else if (target.name === 'Priority') {
        const newPriority = parseInt(target.value, 10);
        this.validateAndWarnOnPriorityChange(newPriority);
      } else if (target.name === 'SubPriority') {
        this.setState({ SubPriority: parseInt(target.value, 10) });
      } else if (target.name === 'LocalTargetingLogic') {
        this.setState({
          LocalTargetingLogic:
            this.state.LocalTargetingLogic === TargetingLogicOR
              ? TargetingLogicAND
              : TargetingLogicOR,
        });
      } else if (target.name === 'FlexibleBiddingEnabled') {
        // If disabling, clear thresholds, otherwise default with 1 threshold
        this.setState({
          FlexibleBiddingEnabled:
            this.state.FlexibleBiddingEnabled === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
          FlexibleBiddingThresholds:
            this.state.FlexibleBiddingEnabled === EBool.EBool_TRUE
              ? []
              : [{ BidderPriority: 10, CPMThreshold: 0 }],
          FlexibleBiddingType: FlexibleBiddingType.CPM,
        });
      } else if (target.name.startsWith('FlexibleBiddingThresholds[')) {
        let value;
        const currentFlexibleBiddingThresholdsState = {
          FlexibleBiddingThresholds: [...this.state.FlexibleBiddingThresholds],
        };

        if (target.name.endsWith('].BidderPriority')) {
          value = parseInt(target.value, 10);
        } else if (target.name.endsWith('].CPMThreshold')) {
          value = parseFloat(target.value);
        }

        // example target: 'FlexibleBiddingThresholds[1].CPMThreshold'
        // set will follow the path from state object to the nth FlexibleBiddingThresholds to modify its value
        set(currentFlexibleBiddingThresholdsState, target.name, value);

        // if we're changing the bidder priority, update the available bidder priority options
        currentFlexibleBiddingThresholdsState.FlexibleBiddingThresholds.sort(
          (a, b) => b.BidderPriority - a.BidderPriority,
        );

        // force refresh
        this.setState(currentFlexibleBiddingThresholdsState);
      } else if (
        [
          'FallbackAuctionParticipationEnabled',
          'EnableSpotxBidderAssociation',
          'EnableMagniteCTVBidderAssociation',
          'EnableSamsungSSPBidderAssociation',
          'EnableIrisSignal',
          'VastExtensionPriceEnabled',
        ].includes(target.name)
      ) {
        this.setState({
          [target.name]:
            this.state[target.name] === EBool.EBool_TRUE ? EBool.EBool_FALSE : EBool.EBool_TRUE,
        });
      } else if (target.name === 'CampaignTargeting') {
        if (
          parseInt(target.value, 10) !== HeaderBidderCampaignTargetingSelected &&
          parseInt(target.value, 10) !== HeaderBidderOrderTargetingSelected
        ) {
          Object.values(this.state.bidderTargetedCampaignsList).forEach((listItem: IListItem) => {
            if (listItem.selected) {
              this.state.bidderTargetedCampaignsList[listItem.ID].selected = false;
            }
          });
          Object.values(this.state.bidderTargetedOrdersList).forEach((order: IListItem) => {
            if (order.selected) {
              this.state.bidderTargetedOrdersList[order.ID].selected = false;
            }
          });
          this.setState({
            CampaignIDS: [],
            OrderIDS: [],
          });
        }
        this.setState(
          Object.assign({
            [target.name]: target.value,
          }),
        );
      } else if (target.name === 'DaypartingActive') {
        this.setState(
          {
            isDaypartingActive: !this.state.isDaypartingActive,
          },
          () => {
            if (this.state.DaypartingIntervals.length === 0) {
              this.handleAddDaypartingPeriod();
            }
          },
        );
        return;
      } else if (target.name === 'ChannelListName') {
        // If disabling, clear thresholds, otherwise default with 1 threshold
        this.setState({
          channelListName: target.value,
        });
      } else if (target.name === 'DailyRequestCap') {
        let value = parseInt(target.value, 10);
        if (isNaN(value)) {
          value = 0;
        }
        this.setState({
          DailyRequestCap: value,
        });
      } else {
        this.setState(
          Object.assign({
            [target.name]: target.value,
          }),
        );
      }
    };

    handleChangeHybridStructuredSlotDuration = (
      event: React.ChangeEvent<HTMLInputElement>,
      index: number,
      name: string,
    ) => {
      if (name === 'HybridStructuredSlotDuration') {
        const newVal = Number.isNaN(parseInt(event.target.value, 10))
          ? 0
          : parseInt(event.target.value, 10);
        const newSlotDurationsArr = this.state.HybridStructuredSlotDurations.split(',').map(
          (duration) => parseInt(duration, 10),
        );
        newSlotDurationsArr[index] = newVal;

        this.setState({
          HybridStructuredSlotDurations: newSlotDurationsArr.join(','),
        });
      }
    };

    // handles changes to a material search dropdown list
    handleChangeList = (name: string) => {
      if (name === 'TargetingDevices') {
        return (values: IMenuList) => {
          const selectedDevices = Object.values(values).filter((src: IListItem) => src.selected);
          let TargetingDevices = '0';
          // if all or no devices are selected, return '0' as the value, otherwise join the values
          if (
            selectedDevices.length !==
              Object.keys(getDeviceEnvironmentAsItems(this.state.TargetingDevices)).length ||
            selectedDevices.length === 0
          ) {
            TargetingDevices = selectedDevices.map((src: IListItem) => src.ID).join(',');
          }
          this.setState({
            TargetingDevices,
          });
        };
      } else if (name === 'TargetingDeviceSubTypes') {
        return (values: IMenuList) => {
          const selectedDeviceSubTypes = Object.values(values).filter(
            (src: IListItem) => src.selected,
          );
          let TargetingDeviceSubTypes = '0';
          // if all or no devices are selected, return '0' as the value, otherwise join the values
          if (
            selectedDeviceSubTypes.length !==
              Object.keys(
                getDeviceEnvironmentSubTypesAsItems(
                  this.state.TargetingDeviceSubTypes,
                  this.props.session.publisher.ID,
                  hasRoleSuperUser(this.props.user.user),
                ),
              ).length ||
            selectedDeviceSubTypes.length === 0
          ) {
            TargetingDeviceSubTypes = selectedDeviceSubTypes
              .map((src: IListItem) => src.ID)
              .join(',');
          }
          this.setState({
            TargetingDeviceSubTypes,
          });
        };
      } else if (name === 'TargetingDeviceModels') {
        return (values: IMenuList) => {
          const selectedDeviceModels = Object.values(values).filter(
            (src: IListItem) => src.selected,
          );
          let TargetingDeviceModels = '0';
          // if all or no devices are selected, return '0' as the value, otherwise join the values
          if (
            selectedDeviceModels.length !==
              Object.keys(
                getDeviceEnvironmentModelsAsItems(
                  this.state.TargetingDeviceModels,
                  this.props.session.publisher.ID,
                  hasRoleSuperUser(this.props.user.user),
                ),
              ).length ||
            selectedDeviceModels.length === 0
          ) {
            TargetingDeviceModels = selectedDeviceModels.map((src: IListItem) => src.ID).join(',');
          }
          this.setState({
            TargetingDeviceModels,
          });
        };
      } else if (name === 'LivestreamTargeting') {
        return (menuList: IMenuList) => {
          const selectedLivestreams = Object.values(menuList).filter(
            (livestreamOption) => livestreamOption.selected,
          );

          let livestreamTargeted = '0';

          // return '0' if none or all livestreams are selected, otherwise join the values
          if (
            selectedLivestreams.length === 0 ||
            selectedLivestreams.length !==
              Object.keys(
                getSelectedLivestreamOptions(
                  this.state.LivestreamTargeting,
                  this.state.Bidder,
                  this.props.user.publisher.ID,
                ),
              ).length
          ) {
            livestreamTargeted = selectedLivestreams.map((livestream) => livestream.ID).join(',');
          }

          this.setState({
            LivestreamTargeting: livestreamTargeted,
          });
        };
      } else if (name === 'timezonesList') {
        return (menuList: IMenuList) => {
          const newTimezone = Object.values(menuList).filter((timezone) => timezone.selected);

          this.setState({
            timezonesList: menuList,
            Timezone: newTimezone[0] ? newTimezone[0].title : this.state.Timezone,
          });
        };
      } else if (name === 'editChannelListsList') {
        return (menuList: IMenuList) => {
          let editChannelListName = '';
          let editChannelListID: number = 0;
          const EditChannelListChannelsIDS = [] as number[];
          const EditChannelListGroupsIDS = [] as number[];
          const { editChannelListCGL, editChannelListCL } = this.state;
          Object.values(menuList).forEach((listItem: IListItem) => {
            if (listItem.selected) {
              editChannelListID = parseInt(listItem.ID, 10);
            }
          });
          const clonedChannelLists = cloneDeep(this.state.channelLists);
          const foundChannelList = clonedChannelLists.find(
            (channelList: IChannelList) =>
              channelList.ID.toString() === editChannelListID.toString(),
          );
          if (foundChannelList !== undefined) {
            const ChannelGroupIDs: number[] =
              foundChannelList.ChannelGroupIDs.split(',').map(Number);
            const ChannelIDs: number[] = foundChannelList.ChannelIDs.split(',').map(Number);
            Object.values(editChannelListCGL).forEach((listItem: IListItem) => {
              if (ChannelGroupIDs.includes(parseInt(listItem.ID, 10))) {
                listItem.selected = true;
                EditChannelListGroupsIDS.push(parseInt(listItem.ID, 10));
              } else {
                listItem.selected = false;
              }
            });
            Object.values(editChannelListCL).forEach((listItem: IListItem) => {
              if (ChannelIDs.includes(parseInt(listItem.ID, 10))) {
                listItem.selected = true;
                EditChannelListChannelsIDS.push(parseInt(listItem.ID, 10));
              } else {
                listItem.selected = false;
              }
            });
            editChannelListName = foundChannelList.Name;
          }
          this.setState({
            editChannelListsList: menuList,
            editChannelListID,
            editChannelListName,
            editChannelListCL,
            editChannelListCGL,
            EditChannelListChannelsIDS,
            EditChannelListGroupsIDS,
          });
        };
      }

      return (list: IMenuList) => {
        this.setState(
          Object.assign({
            [name]: list,
          }),
        );
      };
    };

    handleChangeMimeTypeOverride = (_: string, value: string[]) => {
      const { MimeTypeOverride } = this.state;
      if (value.length === MimeTypeOverride.length) {
        this.setState({
          MimeTypeOverride: '',
        });
      } else {
        this.setState({
          MimeTypeOverride: value.join(','),
        });
      }
    };

    // handles changes to a multi select dropdown
    handleChangeMultiSelect = (name: string, value: string[]) => {
      if (name === 'Slots') {
        if (
          value.length > 1 &&
          this.state.Slots.indexOf('all') !== -1 &&
          value.indexOf('all') !== -1
        ) {
          value.splice(value.indexOf('all'), 1);
        } else if (value.indexOf('all') !== -1) {
          value = ['all'];
        }
      } else if (name === 'TargetingDeviceTypes') {
        // empty string represents all device types targeted
        if (value.length === deviceORTBTypes.length) {
          this.setState({
            TargetingDeviceTypes: '',
          });
          return;
        }
        this.setState({
          TargetingDeviceTypes: value.join(','),
        });
        return;
      } else if (name === 'PlaybackMethod') {
        this.setState({
          PlaybackMethod: value.join(','),
        });
        return;
      } else if (name === 'ExtendedContentIDVendors') {
        if (!value || value.length === 0) {
          const updatedKeyValueParameters = this.getUpdatedIrisContextKVP(
            EBool.EBool_FALSE,
            EBool.EBool_FALSE,
            this.state.Bidder,
            this.state.keyValueParameters,
          );
          this.setState({
            ExtendedContentIDVendors: '',
            EnableIrisSignal: EBool.EBool_FALSE,
            keyValueParameters: updatedKeyValueParameters,
          });
          return;
        }

        // separate legacy iris signal from the rest of the vendors as it is a boolean in the DB
        let extContentIDVendors = [] as string[];
        let irisSignalEnabled = EBool.EBool_FALSE;
        let newIrisCTVEnabled = EBool.EBool_FALSE;
        value.forEach((vendor) => {
          if (vendor === 'enableirissignal') {
            irisSignalEnabled = EBool.EBool_TRUE;
          } else if (vendor === 'iris.tv') {
            newIrisCTVEnabled = EBool.EBool_TRUE;
            extContentIDVendors.push(vendor);
          } else {
            extContentIDVendors.push(vendor);
          }
        });

        // update iris context key value pairs based on iris signal enablement (legacy OR new)
        const updatedKeyValueParameters = this.getUpdatedIrisContextKVP(
          irisSignalEnabled,
          newIrisCTVEnabled,
          this.state.Bidder,
          this.state.keyValueParameters,
        );
        this.setState({
          ExtendedContentIDVendors: extContentIDVendors.join(','),
          EnableIrisSignal: irisSignalEnabled,
          keyValueParameters: updatedKeyValueParameters,
        });
        return;
      }
      this.setState({
        [name]: value,
      });
    };

    // sets the ParamOptions.Value from the Form
    handleChangeParamOption = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      // for the publica-campaign bidder, reconstruct the vast-url bidder parameter since it has been changed to only the campaign ID by getCampaignIDFromVastURL
      if (
        target.name === 'vastURL' &&
        (/^\d+$/.test(target.value) || target.value === 'undefined')
      ) {
        // /^\d+$/ match only digit strings (ex: "12345")
        const siteID = (this.props.session.site || { ID: -1 }).ID.toString();
        if (target.value === 'undefined') {
          // when 'All' is selected, the key is 'undefined'
          // all campaigns are selected
          target.value = genExportCampaignWithoutCampaignID(siteID);
        } else {
          // a specific campaign is selected, and target.value is the campaign ID
          target.value = genExportCampaignWithCampaignID(siteID, target.value);
        }
      }

      const paramOptions = this.state.ParamOptions.map((option: IHeaderBidderParamOption) => {
        if (option.Name === target.name) {
          option.Value = target.value;
        }
        return option;
      });
      this.updateParams(paramOptions);
    };

    // handle change price for VAST-tag bidders
    // uiPrice & uiCurency are in the currency that the bidder configures, purely for display purpose
    // price is kept in USD, which is what we use for prebid in the backend
    handleChangePrice = ({
      price,
      uiPrice,
      uiCurrency,
    }: {
      price: string;
      uiPrice: string;
      uiCurrency: CurrencyType;
    }) => {
      const paramOptions = this.state.ParamOptions.map((option: IHeaderBidderParamOption) => {
        if (option.Name === 'price') {
          option.Value = price;
        }
        if (option.Name === 'uiPrice') {
          option.Value = uiPrice;
        }
        if (option.Name === 'uiCurrency') {
          option.Value = uiCurrency;
        }
        return option;
      });
      this.updateParams(paramOptions);
    };

    handleChangeBidFloorAndBidFloorCurrency = (
      price: string,
      bidFloor: string,
      currency: CurrencyType,
    ) => {
      const BidFloor = bidFloor === '-' ? '0' : bidFloor;
      this.setState({
        BidFloorCurrency: convertStringToECurrencyType(currency),
        BidFloor,
        BidFloorUSD: price,
      });
    };

    handleChangeSwitchOption = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const paramOptions = this.state.ParamOptions.map((option: IHeaderBidderParamOption) => {
        if (option.Name === target.name) {
          if (target.checked) {
            option.Value = this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].trueValue;
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            option.Value = this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].falseValue;
          }
        }
        return option;
      });
      this.updateParams(paramOptions);
    };

    // sets the ParamOptions.Value from the Form
    handleChangeParamOptionVASTUrl = (entry: string) => {
      const paramOptions = this.state.ParamOptions.map((option: IHeaderBidderParamOption) => {
        if (option.Name === 'vastURL') {
          option.Value = entry;
        }
        return option;
      });
      this.updateParams(paramOptions);
    };

    handleChangePacingTypeSelect = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const opt = getPacingTypeOptionByText(target.value);
      if (opt) {
        this.setState({
          PacingTypeText: target.value,
          PacingType: opt.value,
        });
      }
    };

    // sets the ParamOptions.Value from the Form for IABCategory
    handleChangeIABCategories = (entries: string[]) => {
      const paramOptions = this.state.ParamOptions.map((option: IHeaderBidderParamOption) => {
        if (option.Name === 'iabCategories') {
          option.Value = entries.join(',');
        }
        return option;
      });
      this.updateParams(paramOptions);
    };

    handleAddStructuredSlot = () => {
      let newSlotDurations = this.state.HybridStructuredSlotDurations;
      if (newSlotDurations.length === 0) {
        newSlotDurations += '0';
      } else {
        newSlotDurations += ',0';
      }
      this.setState({
        HybridStructuredSlotDurations: newSlotDurations,
      });
    };

    handleRemoveStructuredSlot = (index: number) => {
      const newSlotDurationsArr = this.state.HybridStructuredSlotDurations.split(',');
      newSlotDurationsArr.splice(index, 1);
      this.setState({
        HybridStructuredSlotDurations: newSlotDurationsArr.join(','),
      });
    };

    handleAddFlexibleBiddingThreshold = () => {
      // get tier options that are greater than the current header bidder tier that
      // do not exist in the currently selected state.FlexibleBiddingThresholds
      const flexibleBiddingAvailableTiers = generatePriorityOptions(
        this.props.session.publisher,
        false,
        this.state.Bidder,
      )
        .filter((option: IPriorityOption) => {
          return (
            option.value > this.state.Priority &&
            this.state.FlexibleBiddingThresholds.findIndex(
              (flexibleBiddingThreshold) =>
                option.value === flexibleBiddingThreshold.BidderPriority,
            ) === -1
          );
        })
        .sort((a, b) => (a.value < b.value ? 1 : 0));

      if (flexibleBiddingAvailableTiers.length > 0) {
        const currentFlexibleBiddingThresholdsState = {
          FlexibleBiddingThresholds: [...this.state.FlexibleBiddingThresholds],
        };
        currentFlexibleBiddingThresholdsState.FlexibleBiddingThresholds.push({
          CPMThreshold: 0,
          BidderPriority: flexibleBiddingAvailableTiers[0].value,
        });

        currentFlexibleBiddingThresholdsState.FlexibleBiddingThresholds.sort(
          (a, b) => b.BidderPriority - a.BidderPriority,
        );
        this.setState(currentFlexibleBiddingThresholdsState);
      }
    };

    handleSetUpdatingCountryGroup = (updatingCountryGroup: boolean) => {
      this.setState({ updatingCountryGroup });
    };

    handleOpenRegionSelectDialog = (countryGroupID: string) => {
      const { publisherCountryGroups } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      let newCreateEditRegionList = generateCountriesMenuList();
      let newCreateEditRegionName = '';
      if (foundCountryGroup) {
        newCreateEditRegionList = generateCountryMenuListFromIsos(
          foundCountryGroup.CountryIsos.split(','),
        );
        newCreateEditRegionName = foundCountryGroup.Name;
      }
      this.setState({
        createEditRegionID: countryGroupID,
        createEditRegionList: newCreateEditRegionList,
        createEditRegionName: newCreateEditRegionName,
        openRegionCreateEditDialog: true,
        openRegionSelectTable: false,
      });
    };

    handleContextualSegmentsAcceptClick = (contextualSegmentList: IMenuList): void => {
      const ContextualSegmentIDS = [] as number[];
      for (const { ID, selected } of Object.values(contextualSegmentList) as IListItem[]) {
        if (selected) {
          ContextualSegmentIDS.push(parseInt(ID, 10));
        }
      }
      this.setState({
        ContextualSegmentIDS,
        contextualSegmentList,
      });
    };

    handleRemoveFlexibleBiddingThreshold = (index: number) => {
      const currentFlexibleBiddingThresholdsState = update(this.state, {
        FlexibleBiddingThresholds: { $splice: [[index, 1]] },
      });
      this.setState(currentFlexibleBiddingThresholdsState);
    };

    handleDaypartingDateChange = (index: number, time: string, dateType: 'start' | 'end'): void => {
      if (!time) {
        return;
      }

      const DaypartingIntervals = handleDaypartingDateChange(
        index,
        time,
        dateType,
        this.state.DaypartingIntervals,
      );
      this.setState({
        DaypartingIntervals,
      });
    };

    handleDayClick = (day: Day, index: number): void => {
      const DaypartingIntervals = handleDaypartingDayClick(
        day,
        index,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    handleDeleteDaypartingPeriod = (index: number): void => {
      const DaypartingIntervals = handleDeleteDaypartingPeriod(
        index,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    handleAddDaypartingPeriod = (): void => {
      const DaypartingIntervals = handleAddDaypartingPeriod(this.state.DaypartingIntervals);
      this.setState({ DaypartingIntervals });
    };

    // --- Smart Floor handlers and functions --- //

    generateSmartFloorChannelAndGroupMaps = () => {
      const { sites, ChannelGroups } = this.state;

      const siteIDToName: { [key: string]: string } = sites.reduce(
        (acc, channel) => {
          acc[channel.ID] = channel.Name;
          return acc;
        },
        {} as { [key: string]: string },
      );

      const channelGroupIDToName: { [key: string]: string } = ChannelGroups.reduce(
        (acc, group) => {
          acc[group.ID] = group.Name;
          return acc;
        },
        {} as { [key: string]: string },
      );

      const channelAndGroupMaps = {
        channelMap: siteIDToName,
        channelGroupMap: channelGroupIDToName,
      };

      return channelAndGroupMaps;
    };

    // maybe only do this on save or only they go to the smart floors tab, instead of every time they add new channel?
    genSmartFloorsFromChannelsTargeting = (
      currSmartFloorConfig: ISmartFloorConfigUI,
      emptyOutSmartFloors: boolean,
      configWasUpdated: boolean,
    ): ISmartFloorPayloadUI[] => {
      // if smartFloors is disabled, we need to sent empty list to backend so to deactive all smart floors
      if (emptyOutSmartFloors) {
        return [] as ISmartFloorPayloadUI[];
      }

      const {
        HonorChannelFloor,
        BidFloor,
        Bidder,
        sites, // these are ALL sites, targeted and untargeted
        bidderChannelList, // Menu List is all channels
        channelGroupsList, // Menu List is all channel groups
        channelLists, // these are ALL channelLists
        ChannelListIDS, // the updated state of selected channelListIDs
      } = this.state;

      const { headerbidder } = this.props;
      const headerbidderID = parseInt(headerbidder.ID, 10);

      const bidderBidFloor =
        Bidder === DemandSources.publica
          ? this.getValueFromBidderParams(this.props.headerbidder.Params, 'price')
          : BidFloor;

      const currSmartFloors = currSmartFloorConfig.SmartFloors;

      // TODO or maybe these sets should be kept up to date in state so they dont have to be computed every time like this

      // create mapping of sID to cgID and back (only those that are selected)
      const selectedChannelGroupIDs = new Set(
        Object.keys(pickBy(channelGroupsList, (v) => v.selected)).map((key) => parseInt(key, 10)),
      );
      const siteIDToCGIDs: { [key: number]: Set<number> } = {};
      const cgIDToSiteIDs: { [key: number]: Set<number> } = {};
      Object.values(channelGroupsList).forEach(({ channelGroup: cg }) => {
        // only add to the map if channel group is selected
        if (cg && selectedChannelGroupIDs.has(cg.ID)) {
          const siteIDNums = cg.ChannelIDs.split(',').map((siteIDStr) => parseInt(siteIDStr, 10));

          siteIDNums.forEach((siteID) => {
            if (isEmpty(siteIDToCGIDs[siteID])) {
              siteIDToCGIDs[siteID] = new Set();
            }
            siteIDToCGIDs[siteID].add(cg.ID);
          });

          cgIDToSiteIDs[cg.ID] = new Set(siteIDNums);
        }
      });

      // get list of sites in the channel list exclude list
      const channeListExcludeList = new Set<number>();
      channelLists.forEach((cl) => {
        // if channel List is selected
        if (!isEmpty(ChannelListIDS) && ChannelListIDS.includes(cl.ID)) {
          const channelIDs = cl.ChannelIDs.split(',').map((id) => parseInt(id, 10));
          channelIDs.forEach((id) => channeListExcludeList.add(id));

          const channelGroupIDs = cl.ChannelGroupIDs.split(',').map((id) => parseInt(id, 10));
          channelGroupIDs.forEach((cgID) => {
            if (!isEmpty(cgIDToSiteIDs[cgID])) {
              cgIDToSiteIDs[cgID].forEach((id) => channeListExcludeList.add(id));
            }
          });
        }
      });

      // TODO when channelListIncludeList is added, we need to update this function

      // get current targeted siteFloors
      const sIDToSiteFloor: { [id: number]: number } = {};
      sites.forEach((s: ISmallSite) => {
        sIDToSiteFloor[s.ID] = !s.BidFloor ? 0 : s.BidFloor;
      });

      // now we can start populating the updated smartFloors list we will return
      const allSmartFloors = [] as ISmartFloorPayloadUI[];

      // get an updated map of siteID -> smartFloors (for only selected channels/ channelgroups)
      const selectedChannelIDs = new Set(
        Object.keys(pickBy(bidderChannelList, (v) => v.selected)).map((key) => parseInt(key, 10)),
      );
      const updatedSiteIDToSmartFloor: { [siteID: number]: ISmartFloorPayloadUI } = {};

      // first evaluate the existing smart floors
      currSmartFloors.forEach((sf) => {
        // only add to the map if site is not in the excluded list
        if (!channeListExcludeList.has(sf.SiteID)) {
          const updatedSmartFloor = updateSmartFloorParamsFromConfig(
            currSmartFloorConfig,
            sf.BaseBidFloor,
            sf,
            siteIDToCGIDs,
            selectedChannelIDs,
            configWasUpdated,
          );

          // only add to map if site is being targetted directly or through channel groups
          if (
            updatedSmartFloor.IsTargetedThroughChannelAssociation ||
            updatedSmartFloor.AssociatedChannelGroupIDs.length !== 0
          ) {
            updatedSiteIDToSmartFloor[sf.SiteID] = updatedSmartFloor;
            // push existing smart floor to final list
            allSmartFloors.push(updatedSmartFloor);
          }
        }
      });

      // create new smart floors from selected channelGroups that aren't in the updatedSiteIDToSmartFloor or in the channeListExcludeList
      selectedChannelGroupIDs.forEach((cgID) => {
        if (cgIDToSiteIDs[cgID]) {
          cgIDToSiteIDs[cgID].forEach((siteID) => {
            // exclude site from channel list exclude list and existing smart floor
            if (!channeListExcludeList.has(siteID) && !(siteID in updatedSiteIDToSmartFloor)) {
              // create new smartFloor
              const baseFloor =
                sIDToSiteFloor[siteID] !== 0 && EBool.isTrue(HonorChannelFloor)
                  ? sIDToSiteFloor[siteID]
                  : parseFloat(bidderBidFloor);
              const newSmartFloor = genNewSmartFloors(
                siteID,
                headerbidderID,
                baseFloor,
                currSmartFloorConfig,
                Array.from(siteIDToCGIDs[siteID]),
                false,
              );
              allSmartFloors.push(newSmartFloor);
              updatedSiteIDToSmartFloor[siteID] = newSmartFloor;
            }
          });
        }
      });

      // create new smartFloors from selected bidderChannels siteIDs that aren't in the updatedSiteIDToSmartFloor or in the channeListExcludeList
      selectedChannelIDs.forEach((siteID) => {
        // exclude site from channel list exclude list and existing smart floor
        if (!channeListExcludeList.has(siteID) && !(siteID in updatedSiteIDToSmartFloor)) {
          // create new smart floor
          const baseFloor =
            sIDToSiteFloor[siteID] !== 0 && EBool.isTrue(HonorChannelFloor)
              ? sIDToSiteFloor[siteID]
              : parseFloat(bidderBidFloor);
          const newSmartFloor = genNewSmartFloors(
            siteID,
            headerbidderID,
            baseFloor,
            currSmartFloorConfig,
            [],
            true,
          );
          allSmartFloors.push(newSmartFloor);
          updatedSiteIDToSmartFloor[siteID] = newSmartFloor;
        }
      });

      // Note: channels no longer targeted will not be in the allSmartFloors list, and the api will handle deactivating those smartFloors
      return allSmartFloors;
    };

    handleChangeSmartFloorConfig = (
      configIdx: number, // will always be the first index for now
      key: smartFloorConfigCols,
      value: any,
      siteID: number,
      emptyOutSmartFloors: boolean,
      shouldUpdateSmartFloorParams: boolean,
    ) => {
      switch (key as smartFloorConfigCols) {
        // this key only updates what to be displayed in the Live graph, and doesn't affect the smart floor config
        case 'isSiteIDSelected':
          if (siteID !== undefined && siteID !== 0) {
            let selectedSiteIDForSmartFloorsChart = 0;
            this.state.smartFloorConfigs[configIdx]?.SmartFloors?.forEach((sf) => {
              if (sf.SiteID === siteID) {
                selectedSiteIDForSmartFloorsChart = sf.SiteID;
              }
            });

            this.setState({
              selectedSiteIDForSmartFloorsChart,
            });
            return;
          }

        // all other keys will create a new smart floor config
        default: {
          this.setState({
            smartFloorConfigs: this.buildNewSmartFloorConfigs(
              configIdx,
              key,
              value,
              siteID,
              emptyOutSmartFloors,
              shouldUpdateSmartFloorParams,
            ),
          });
        }
      }
    };

    buildNewSmartFloorConfigs = (
      configIdx: number, // will always be the first index for now
      key: smartFloorConfigCols,
      value: any,
      siteID: number,
      emptyOutSmartFloors: boolean,
      shouldUpdateSmartFloorParams: boolean,
    ): ISmartFloorConfigUI[] => {
      const smartFloorConfigs = [...this.state.smartFloorConfigs];
      const smartFloorConfig = cloneDeep(smartFloorConfigs[configIdx]);
      smartFloorConfig.shouldAllowSortingTable = true; // always true exept for BaseBidFloor
      let smartFloors = [...smartFloorConfig.SmartFloors];

      switch (key as smartFloorConfigCols) {
        case 'BaseBidFloor':
          smartFloors = smartFloors.map((sf) => {
            if (sf.SiteID === siteID) {
              sf.BaseBidFloor = value;
            }
            return sf;
          });
          smartFloorConfig.shouldAllowSortingTable = false;
          break;
        case 'IsABTestEnabled':
          smartFloorConfig.IsABTestEnabled = value;
          smartFloorConfig.ControlTrafficPercentage = smartFloorConfig.IsABTestEnabled ? 50.0 : 5.0;
          break;
        case 'IsTestIncrementHighPercentage':
        case 'IsTestIncrementLowPercentage':
          smartFloorConfig.IsTestIncrementHighPercentage = value;
          smartFloorConfig.IsTestIncrementLowPercentage = value;
          break;
        case 'TestIncrementHigh':
        case 'TestIncrementLow':
          smartFloorConfig.TestIncrementHigh = value;
          smartFloorConfig.TestIncrementLow = value;
          break;
        case 'IsMaxBidFloorPercentage':
        case 'IsMinBidFloorPercentage':
          smartFloorConfig.IsMaxBidFloorPercentage = value;
          smartFloorConfig.IsMinBidFloorPercentage = value;
          break;
        case 'MaxBidFloor':
          smartFloorConfig.MaxBidFloor = value;
          break;
        case 'MinBidFloor':
          smartFloorConfig.MinBidFloor = value;
          break;
        case 'ThompsonSamplingEnabled':
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment
          smartFloorConfig.ThompsonSamplingEnabled = value;
          smartFloors = smartFloors.map((sf) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment
            sf.ThompsonSamplingEnabled = value;
            return sf;
          });
          break;
      }

      smartFloorConfig.SmartFloors = smartFloors;
      if (smartFloorRecalcKeys.has(key)) {
        smartFloors = this.genSmartFloorsFromChannelsTargeting(
          smartFloorConfig,
          emptyOutSmartFloors,
          shouldUpdateSmartFloorParams,
        );
      }

      smartFloorConfig.SmartFloors = smartFloors;
      smartFloorConfig.Active = !emptyOutSmartFloors;
      smartFloorConfigs[configIdx] = smartFloorConfig;

      return smartFloorConfigs;
    };

    toggleSmartFloorActive = () => {
      this.setState({
        isSmartFloorActive: !this.state.isSmartFloorActive,
        smartFloorConfigs: this.buildNewSmartFloorConfigs(
          0,
          'SmartFloors',
          true,
          0,
          this.state.isSmartFloorActive,
          false,
        ),
      });
    };

    isValidPrice = (price: number): boolean => {
      if (price <= 0) {
        return false;
      }
      const strPrice = String(price);
      const idx = strPrice.indexOf('.'); // 19.25 -> idx = 2
      if (idx > -1) {
        return strPrice.length - idx - 1 <= 3; // 5 -2 = 3. allow up to 3 decimals
      }
      return true;
    };

    validateSmartFloorConfig = () => {
      const { smartFloorConfigs, isSmartFloorActive, isWaitingToUpdateSmartFloorConfig } =
        this.state;
      const errors = {} as Record<string, string>;

      if (isSmartFloorActive) {
        if (isWaitingToUpdateSmartFloorConfig) {
          errors.smartFloorsUpdating = ct('BiddersErrorSmartFloorsAreUpdatingPleaseTrySavingAgain');
        }

        smartFloorConfigs.forEach(
          ({ SmartFloors, MinBidFloor, MaxBidFloor, TestIncrementLow, TestIncrementHigh }) => {
            if (!this.isValidPrice(MinBidFloor)) {
              errors.MinBidFloor = ct('BiddersErrorInputValidPriceForMinBidFloor');
            } else if (!this.isValidPrice(MaxBidFloor)) {
              errors.MaxBidFloor = ct('BiddersErrorInputValidPriceForMaxBidFloor');
            } else if (!this.isValidPrice(TestIncrementLow)) {
              errors.TestIncrementLow = ct('BiddersErrorInputValidPriceForTestIncrementLow');
            } else if (!this.isValidPrice(TestIncrementHigh)) {
              errors.TestIncrementHigh = ct('BiddersErrorInputValidPriceForTestIncrementHigh');
            }

            SmartFloors.forEach(
              ({ BaseBidFloor, MaxBidFloor, MinBidFloor, TestIncrementHigh, SiteID }) => {
                const baseBidFloor = BaseBidFloor;
                const maxBidFloor = MaxBidFloor;
                const minBidFloor = MinBidFloor;
                const testIncrement = TestIncrementHigh;
                if (SiteID === 0) {
                  errors.SiteID = ct('BiddersErrorSelectChannelForSmartFloor');
                } else if (!this.isValidPrice(baseBidFloor)) {
                  errors.BaseBidFloor = ct('BiddersErrorInputValidPriceForBaseBidFloorForSiteID', {
                    id: SiteID,
                  });
                } else if (!this.isValidPrice(maxBidFloor)) {
                  errors.MaxBidFloor = ct('BiddersErrorInputValidPriceForMaxBidFloorForSiteID', {
                    id: SiteID,
                  });
                } else if (!this.isValidPrice(minBidFloor)) {
                  errors.MinBidFloor = ct('BiddersErrorInputValidPriceForMinBidFloorForSiteID', {
                    id: SiteID,
                  });
                } else if (!this.isValidPrice(testIncrement)) {
                  errors.TestIncrement = ct(
                    'BiddersErrorInputValidPriceForTestIncrementForSiteID',
                    { id: SiteID },
                  );
                } else if (baseBidFloor + testIncrement > maxBidFloor) {
                  errors.TestIncrementCalculation = ct(
                    'BiddersErrorBasePlusIncrementExceedsMaxBidFloorForSiteID',
                    { id: SiteID },
                  );
                } else if (baseBidFloor - testIncrement < minBidFloor) {
                  errors.TestIncrementCalculation = ct(
                    'BiddersErrorBaseMinusIncrementIsBelowMaxBidFloorForSiteID',
                    { id: SiteID },
                  );
                }
              },
            );
          },
        );
      }
      return errors;
    };

    // --- CLONE BIDDER & BULK UPDATE HANDLERS --- //

    isCloneBidderOrBulkUpdate = () => {
      const { bulkUpdateIDs, cloneBidderEnabled } = this.props;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      return bulkUpdateEnabled || !!cloneBidderEnabled;
    };

    isBulkUpdate = () => {
      const { bulkUpdateIDs } = this.props;
      return !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
    };

    // --- CLONE BIDDER HANDLERS --- //

    // To be utilized in coming V2 changes
    getCloneValue = (key: string, otherValue?: any) => {
      if (!this.state.clonedBidder || !this.state.clonedBidder[key]) {
        return otherValue;
      }
      return this.state.clonedBidder[key].value;
    };

    // To be utilized in coming V2 changes
    getCloneType = (key: string): CloneType => {
      if (!this.state.clonedBidder || !this.state.clonedBidder[key]) {
        return CloneType.UNKNOWN;
      }
      return this.state.clonedBidder[key].type
        ? this.state.clonedBidder[key].type
        : CloneType.UNKNOWN;
    };

    // To be utilized in coming V2 changes
    // updates cloneBidder and sets the type to the type stated
    // updateCloneType = (key: string, type: CloneType) => {
    //   if (!this.state.clonedBidder || !this.state.clonedBidder[key]) {
    //     return;
    //   }
    //   const clonedBidder = cloneDeep(this.state.clonedBidder);
    //   clonedBidder[key].type = type;

    //   this.setState({clonedBidder});
    // }
    // ------------------------------ //

    // --- DEFAULT VALUE HANDLERS (CLONE BIDDERS) --- //

    // in the case that a default value needs to set multiple values to default, set that in thise list.
    additionalDefaultValueUpdates = (key: string, updateObj: IGenericObject) => {
      switch (key) {
        case 'StartDate':
          updateObj.dateStart = undefined;
        case 'EndDate':
          updateObj.dateEnd = undefined;
        case 'bidderChannelList':
          updateObj.SiteIDs = [] as number[];
        case 'targetingCountriesList':
          updateObj.TargetingDeviceCountry = '';
        default:
          break;
      }
    };

    // used to in the case of unchecking a value in cloned bidders
    // will set state of unchecked/disabled bidder values to their respective defaults
    updateCloneToDefaultValues = (cb: () => void) => {
      // Logic for using Default Value when cloning
      const updateObj: IGenericObject = {};
      const paramOptions = [...this.state.ParamOptions];
      // if cloning we do logic that replaces any values in state with default
      if (this.props.cloneBidderEnabled) {
        // loop through all values that at one point were non default
        Object.keys(this.state.bulkUpdateEnabledFields).forEach((key) => {
          const defaultValue = this.state.bulkUpdateEnabledFields[key].defaultValue;
          // if a value is disabled and defaultValue exists then we want to update
          if (!this.state.bulkUpdateEnabledFields[key].enabled && defaultValue !== undefined) {
            // if the key exists in state we want to update the updateObj
            if (this.state[key] !== undefined) {
              // add to update object
              updateObj[key] = defaultValue;
              // some cases need to update more than just the specified key
              // these other cases will be handled in this function
              this.additionalDefaultValueUpdates(key, updateObj);
              // If its not directly in state, we want to check param options too
            } else {
              // if the key exists in any param options, we update that value
              paramOptions.forEach((option: IHeaderBidderParamOption) => {
                if (option.Name === key) {
                  option.Value = defaultValue;
                }
              });
            }
          }
        });
      }

      // add in the updated param options
      updateObj.ParamOptions = paramOptions;

      // update state with the default values
      this.setState(updateObj, () => {
        // update params with the new param options
        // then run next function (cb)
        this.updateParams(paramOptions, cb);
      });
    };
    // ---------------------------------------------- //

    // sets the snackbar message from child component
    handleSetSnackbar = (message: string) => {
      this.setState({
        snackbarError: true,
        snackbarMessage: message,
      });
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    // setDefaultValue
    setDefaultValue = (name: string, value: any) => {
      this.setState(
        {
          [name]: value,
        },
        () => {
          const paramOptions = this.state.ParamOptions.map((option: IHeaderBidderParamOption) => {
            if (option.Name === name) {
              option.Value = value;
            }
            return option;
          });
          this.updateParams(paramOptions);
        },
      );
    };

    // assignValueToBidderParam assign a value to a specific bidder param (stored in state.ParamOptions)
    // if the parameter doesn't exists, this function does nothing
    assignValueToBidderParamOptions = (bidderParamName: string, newValue: any): Promise<null> => {
      return new Promise<null>((resolve) => {
        // find the corresponding param options
        const paramOptionIndex = this.state.ParamOptions.findIndex(
          (po) => po.Name === bidderParamName,
        );

        // if no corresponding param option is found, do nothing
        if (paramOptionIndex === -1) {
          return resolve(); // resolve and stop there
        }

        // copy state.ParamOptions so we don't modify the state directly
        const newParamOptions = this.state.ParamOptions;

        // assign new value to corresponding param option
        newParamOptions[paramOptionIndex].Value = newValue;

        // set the state and resolve
        this.setState(
          {
            ParamOptions: newParamOptions,
          },
          resolve,
        );
      });
    };

    // getValueFromBidderParams gets a value from the Params field of the given headerbidder
    getValueFromBidderParams = (hbParams: string, paramKey: string): any => {
      // transform the custom string into a valid JSON string
      const jsonParam = `{ ${hbParams} }`;

      // parse the JSON string as an object
      const paramsObj = JSON.parse(jsonParam);

      // return the value
      return paramsObj[paramKey];
    };

    // sets the ParamOptions.Value from the state.Params field
    // set 'reset' to true to reset the params to empty (for exemple when you switch the bidder type)
    updateParamOptionValues = (
      paramOptions: IHeaderBidderParamOption[],
      reset: boolean = false,
    ) => {
      if (paramOptions === undefined) {
        paramOptions = []; // Override previous params for bidder with no param
      }

      const paramsToParse = reset ? '' : this.state.Params;

      // check if the siteID param already has a value in the state
      const siteIDParam = this.state.ParamOptions.find(
        (p: IHeaderBidderParamOption) => p.Name === 'siteID',
      );
      const siteIDParamValue = siteIDParam ? siteIDParam.Value : undefined;

      try {
        const params = JSON.parse(`{` + paramsToParse + `}`);
        paramOptions = paramOptions.map((option: IHeaderBidderParamOption) => {
          // if the bidder is a pc bidder and the siteID is already set, don't reset it
          // used because we don't want to loose the site ID when we switch between fixed and dynamic pc bidder type
          if (
            ALL_PLATFORM_CONNECTION_BIDDERS.includes(option.Bidder) &&
            option.Name === 'siteID' &&
            siteIDParamValue
          ) {
            // assign the option value to the current value in state and return it
            option.Value = siteIDParamValue;
            return option;
          }

          option.Value =
            params[option.Name] !== null && params[option.Name] !== undefined
              ? params[option.Name]
              : '';
          if (
            option.Name === 'index' &&
            option.Bidder === DemandSources.rokuHB &&
            option.Value === ''
          ) {
            option.Value = '1';
          }

          if (
            option.Bidder === DemandSources.nexstar &&
            option.Name === 'endpoint' &&
            option.Value === ''
          ) {
            option.Value = 'smaato';
          }
          // If we are resetting the param options and there is a base value, then use that as the starting value
          if (
            this.HeaderBidderParamsUIconfig[option.Bidder][option.Name] !== undefined &&
            this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].baseValue &&
            (reset || option.Value === '')
          ) {
            option.Value = this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].baseValue;
          }
          return option;
        });
        this.updateParams(paramOptions);
      } catch (e) {
        // If unable to parse params, set empty values so that the page does not crash
        paramOptions = paramOptions.map((option: IHeaderBidderParamOption) => {
          option.Value = '';
          return option;
        });
        this.updateParams(paramOptions);
        this.setState({
          snackbarMessage: ct('BiddersSnackbarIssueParsingBidderParameters'),
          snackbarError: true,
        });
      }
    };

    // updates the Params field based on the given paramOptions
    updateParams = (paramOptions: IHeaderBidderParamOption[], callbackFn?: () => void) => {
      const { cloneBidderID, rootKeyValueParameters } = this.state;

      paramOptions = paramOptions.filter((option: IHeaderBidderParamOption) => {
        // hide these from UI if ortb2.6 podded requests is toggled off
        if (
          option.Name === 'required_duration' &&
          (this.state.PoddedRequestType ===
            EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeNonPodded ||
            this.state.PoddedRequestType ===
              EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeUnknown)
        ) {
          return false;
        }
        // (filter out if podded requests is ON and type is structured) OR (if not podded requests)
        if (
          option.Name === 'minimum_cpm_per_second' &&
          (this.state.PoddedRequestType ===
            EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeNonPodded ||
            this.state.PoddedRequestType ===
              EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeUnknown ||
            this.state.PoddedRequestType ===
              EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeStructured)
        ) {
          return false;
        }
        return true;
      });

      // enrich param options with defaults from UI config
      const paramOptionsWithDefaults = paramOptions.map((paramOption) => {
        if (
          this.HeaderBidderParamsUIconfig[paramOption.Bidder] &&
          this.HeaderBidderParamsUIconfig[paramOption.Bidder][paramOption.Name] &&
          this.HeaderBidderParamsUIconfig[paramOption.Bidder][paramOption.Name].hasOwnProperty(
            'defaultValue',
          )
        ) {
          const defaultValue =
            this.HeaderBidderParamsUIconfig[paramOption.Bidder][paramOption.Name].defaultValue;
          // if the value is empty or invalid, replace with default
          if (
            (paramOption.Type === 'string' && paramOption.Value === '') ||
            (paramOption.Type === 'number' && isNaN(parseFloat(paramOption.Value)))
          ) {
            paramOption.Value = defaultValue;
          }
        }
        return paramOption;
      });

      // Filter paramOptions with invalid numbers
      const paramOptionsFiltered = paramOptionsWithDefaults.filter((o) =>
        o.Type === 'number' ? !isNaN(Number(o.Value)) : true,
      );
      // Convert paramOptions to array of IKeyValueParameter
      const bidderParameters = paramOptionsFiltered.map(
        (o) => ({ key: o.Name, value: o.Value, typ: o.Type }) as IKeyValueParameter,
      ) as IKeyValueParameter[];
      // Add keyvalue- in from of key-value-parameters
      let bidderKeyValueParameters = this.state.keyValueParameters.map(
        (o) => ({ key: `keyvalue-${o.key}`, value: o.value, typ: '' }) as IKeyValueParameter,
      );

      const rootBidderParameters: IRootKeyValueParameter[] = [];
      for (const oldPrefix of Object.keys(rootKeyValueParameters)) {
        for (const rootBidderParameter of rootKeyValueParameters[oldPrefix]) {
          rootBidderParameters.push({
            key: `root-keyvalue-${rootBidderParameter.prefix}-${rootBidderParameter.key}`,
            value: rootBidderParameter.value,
            typ: rootBidderParameter.typ,
            prefix: rootBidderParameter.prefix,
          } as IRootKeyValueParameter);
        }
      }

      // if this is a cloned bidder, use the bidder params from the found bidder
      if (cloneBidderID && this.state.bidders.length) {
        const foundBidder = this.state.bidders.find(
          (bidder) => parseInt(bidder.ID, 10) === cloneBidderID,
        );
        if (foundBidder) {
          bidderKeyValueParameters = this.parseKeyValueParametersFromBidder(foundBidder);
        }
      }

      // Merge bidderParameters with bidderKeyValues
      const mergedParameters = bidderParameters.concat(
        bidderKeyValueParameters,
        rootBidderParameters,
      );

      const newState = {
        ParamOptions: paramOptions,
        Params: mergedParameters
          .map((o) => {
            if (o.typ === 'number') {
              const value = Number(o.value); // We force the value to be a number. +123 is a valid number but we force it to be 123
              return `"${o.key}":${value}`;
            } else if (o.typ === 'string') {
              // can be an int!
              try {
                return `"${o.key}":"${o.value.trim()}"`;
              } catch {
                return `"${o.key}":${o.value}`;
              }
            }
            return `"${o.key}":"${o.value}"`;
          })
          .join(',\n'),
      };

      if (callbackFn) {
        this.setState(newState, callbackFn);
      } else {
        this.setState(newState);
      }
      this.renderBidFloor(this.paramsDisabled());
    };

    addParamsOptionsValidationSupport = (cb: () => void) => {
      const kv: { [key: string]: string } = {};

      for (const key of Object.keys(bidderValidationSetting)) {
        if (key.indexOf('ParamsOptions_') > -1) {
          delete bidderValidationSetting[key];
        }
      }

      for (const option of this.state.ParamOptions) {
        if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'errorHandler')) {
          bidderValidationSetting['ParamsOptions_' + option.Name] =
            this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].errorHandler;
          kv['ParamsOptions_' + option.Name] = option.Value;
        }
      }

      this.setState(kv, cb);
    };

    updateBulkUpdateBidders = async () => {
      const updates = {} as { [key: string]: any };

      // if any targeting fields are active, we must make sure there are no presets associated to any of the bidders
      let needsPresetValidation = false;

      for (const item of Object.values(this.state.bulkUpdateEnabledFields)) {
        // handle specific cases where we cannot simply use state in the update map
        if (item.enabled) {
          if (!needsPresetValidation && bidderTargetingFieldKeys.has(item.key)) {
            needsPresetValidation = true;
          }

          if (
            ['frequencyLimitDuration', 'frequencyLimitUnit'].includes(item.key) &&
            updates.FrequencyTTL === undefined
          ) {
            updates.FrequencyTTL =
              this.state.frequencyLimitUnit === 'Days'
                ? this.state.frequencyLimitDuration * 60 * 60 * 24
                : this.state.frequencyLimitDuration * 60 * 60;
          } else if (
            ['TargetingDeviceCountry', 'deviceTargetingCountrySelectMode'].includes(item.key) &&
            updates.TargetingDeviceCountry === undefined
          ) {
            const targetingDeviceCountry = this.generateTargetingDeviceCountry();
            updates.TargetingDeviceCountry = targetingDeviceCountry
              .map((country: IGeo) => country.key.toUpperCase())
              .join(',');
          } else if (['LocalTargeting'].includes(item.key)) {
            updates.LocalTargeting = this.exportLocalTargetingParamToJSON();
          } else if (item.key === 'Slots') {
            updates.Pods = this.state[item.key];
          } else if (item.key === 'Dayparting') {
            updates[item.key] = parseDaypartingIntervals(
              this.state.DaypartingIntervals,
              this.state.isDaypartingActive,
              this.props.session.publisher.Timezone,
              true,
              this.state.enableViewerTimezone,
            );
          } else {
            updates[item.key] = this.state[item.key];
          }
        }
      }

      // validate for targeting presets
      if (needsPresetValidation) {
        const { isValid } = await validateBidderTargetingBulkUpdate(
          this.props.session.publisher.ID,
          {
            bidderIDs: this.props.bulkUpdateIDs,
          },
        ).catch((err) => {
          console.error(err);
          this.setState({
            snackbarMessage: ct('ErrorValidatingItemPleaseTryAgain', {
              item: ct('PresetAssociations'),
            }),
            snackbarError: true,
          });
        });

        if (!isValid) {
          this.setState({
            snackbarMessage:
              'Targeting fields cannot be bulk updated for bidders with associated presets.',
            snackbarError: true,
          });
          return;
        }
      }

      const errors = this.findErrors(updates, bulkUpdateBiddersValidationSetting);

      const channelIDs = this.getSiteIDSFromTargetedSites();
      if (
        (updates.SiteIDS || updates.ChannelGroupIDS) &&
        channelIDs.length === 0 &&
        this.state.ChannelGroupIDS.length === 0
      ) {
        this.setState({
          snackbarMessage: ct('NoticeSelectAtLeastOneChannelOrChannelGroup'),
          snackbarError: true,
        });
        return;
      }

      if (hasErrors(errors)) {
        const errorText = Object.values(errors)
          .filter((value) => value.length)
          .join('. ');
        this.setState(
          {
            errors,
            snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
              item: ct('Bidder'),
              text: errorText,
            }),
            snackbarError: true,
          },
          () => {
            setTimeout(this.snackbarClose, 6000);
          },
        );
        return;
      }

      if (Object.keys(updates).length === 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage: ct('BiddersSnackbarUseCheckboxBulkEdit'),
        });
        return;
      }

      bulkUpdateBidders(
        this.props.bulkUpdateIDs.join(','),
        this.props.session.publisher.ID,
        updates,
        Object.keys(updates)
          .map((key) => key)
          .join(','),
      )
        .then(() => {
          this.setState({
            snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', { item: ct('Bidders') }),
          });
        })
        .catch(() => {
          this.setState({
            snackbarMessage: ct('SnackbarFailedToUpdateItem', { item: ct('Bidders') }),
            snackbarError: true,
          });
        });
      setTimeout(this.gotoBidderListView, 1000);
    };

    generateTargetingDeviceCountry = (): IGeo[] => {
      let targetingDeviceCountry: IGeo[];
      const selectedCountries = Object.values(this.state.targetingCountriesList).filter(
        (item: IListItem) => item.selected,
      );
      const countries = getAllCountries();
      if (this.state.deviceTargetingCountrySelectMode === SelectMode.Denylist) {
        // Denylist - Save all the invert countries (if two countries are denied => allow all countries EXCEPT those two countries)
        const allowlist: IGeo[] = cloneDeep(countries);
        for (const selectedCountry of selectedCountries) {
          const index = allowlist.findIndex((item: IGeo) => selectedCountry.ID === item.key);
          if (index > -1) {
            allowlist.splice(index, 1);
          }
        }
        targetingDeviceCountry = allowlist;
      } else {
        // Allowlist - save all selected countries
        targetingDeviceCountry = selectedCountries.map((item: IListItem) => {
          return {
            key: item.ID,
            text: item.title,
          } as IGeo;
        });
      }

      if (targetingDeviceCountry.length === countries.length) {
        targetingDeviceCountry = []; // all selected with allow list = empty
        // backend code:
        // if hb.TargetingDeviceCountry == "" {
        // 		return true // No filtering = every country is accepted
        // 	}
      }

      return targetingDeviceCountry;
    };

    findErrors = (errorSource: IObject, validationSetting: IValidator): IErrors => {
      const { bulkUpdateIDs } = this.props;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      let errors = validatorFactory(validationSetting)(errorSource);
      if (!bulkUpdateEnabled) {
        // bidder specific error checks
        if (this.state.Bidder === DemandSources.publica) {
          // Special checks for DemandSources.publica bidder (Other - Vast)
          errors = {
            ...errors,
            ...customValidatorFactory(publicaBidderValidationSetting)(this.state),
          };
          if (this.state.SiteIDS.includes(+this.getSiteIDFromParams('vastURL'))) {
            errors.ParamsOptions_siteID = ct('BiddersErrorsInvalidVAST');
          }
          if (this.props.session.publisher.IsResellerPublisher === EBool.EBool_TRUE) {
            const paramOption = this.state.ParamOptions.filter(
              (option: IHeaderBidderParamOption) => option.Name === 'vastURL',
            );
            if (paramOption.length === 1) {
              const vastURL = paramOption[0].Value as string;
              const errorMsg = checkURLForValidDomain(vastURL);
              if (errorMsg !== '') {
                errors.ParamsOptions_vastURL = errorMsg;
              }
            }
          }
        } else if (FIXED_PRICE_PLATFORM_CONNECTION_BIDDERS.includes(this.state.Bidder)) {
          // Special checks for DemandSources.platformConnection bidder types
          errors = {
            ...errors,
            ...customValidatorFactory(fixedPricePlatformConnectionBidderValidationSetting)(
              this.state,
            ),
          };
        } else if (DYNAMIC_PLATFORM_CONNECTION_BIDDERS.includes(this.state.Bidder)) {
          // Special checks for 'dynamicPlatformConnection' bidder types
          errors = {
            ...errors,
            ...customValidatorFactory(basePlatformConnectionValidationSetting)(this.state),
          };
        } else if (this.state.Bidder === DemandSources.rokuHB) {
          errors = {
            ...errors,
            ...customValidatorFactory(rokuHBBidderValidationSetting)(this.state),
          };
        } else if (this.state.Bidder === DemandSources.apsOpenAuction) {
          errors = {
            ...errors,
            ...customValidatorFactory(apsOpenAuctionValidationSettings)(this.state),
          };
        } else if (this.state.Bidder === DemandSources.apsPMP) {
          errors = { ...errors, ...customValidatorFactory(apsPMPValidationSettings)(this.state) };
        } else if (this.state.Bidder === DemandSources.rokuORTB) {
          errors = {
            ...errors,
            ...customValidatorFactory(rokuORTBBidderValidationSetting)(this.state),
          };
        } else if (this.state.Bidder === DemandSources.apsGuarantee) {
          errors = {
            ...errors,
            ...customValidatorFactory(apsGuaranteeValidationSettings)(this.state),
          };
        }

        if ([DemandSources.apsPMP, DemandSources.apsGuarantee].includes(this.state.Bidder)) {
          if (!this.state.dateStart || !this.state.dateEnd) {
            errors.StartDate = ct('BiddersErrorsMissingFlightDates');
          }
          if (this.state.Quantity < 1000) {
            errors.Quantity = ct('BiddersErrorImpressionMinimum1000');
          }
        }

        // general non-bulk edit checks

        // Flexible Bidding Bidding validations
        if (this.state.FlexibleBiddingEnabled === ResourceActiveEnabled) {
          // Check duplicate tiers
          const uniquePriorityThresholds = uniqBy(
            this.state.FlexibleBiddingThresholds,
            (flexibleBiddingThreshold) => flexibleBiddingThreshold.BidderPriority,
          );
          if (uniquePriorityThresholds.length < this.state.FlexibleBiddingThresholds.length) {
            errors.FlexibleBiddingError = ct('BiddersErrorTiersMustBeUnique');
          }

          for (let i = 0; i < this.state.FlexibleBiddingThresholds.length; i++) {
            // Check CPM Thresholds <= 0
            if (this.state.FlexibleBiddingThresholds[i].CPMThreshold <= 0) {
              const tier = 11 - this.state.FlexibleBiddingThresholds[i].BidderPriority;
              errors.FlexibleBiddingError = ct(
                'BiddersErrorTierNumberThresholdMustBeGreaterThanZero',
                { number: tier },
              );
              break;
            }

            // Check if threshold priority is lower than Bidder priority
            if (this.state.FlexibleBiddingThresholds[i].BidderPriority <= this.state.Priority) {
              const tier = 11 - this.state.FlexibleBiddingThresholds[i].BidderPriority;
              const currentTier = 11 - this.state.Priority;
              errors.FlexibleBiddingError = ct('BiddersErrorTierNumberMustBeHigherThanTierNumber', {
                number: tier,
                altNumber: currentTier,
              });
              break;
            }

            // Check if CPM Thresholds are greater than the previous tier
            if (
              i >= 1 &&
              this.state.FlexibleBiddingThresholds[i].CPMThreshold >=
                this.state.FlexibleBiddingThresholds[i - 1].CPMThreshold
            ) {
              const thresholdATier =
                11 - this.state.FlexibleBiddingThresholds[i - 1].BidderPriority;
              const thresholdBTier = 11 - this.state.FlexibleBiddingThresholds[i].BidderPriority;

              errors.FlexibleBiddingError = ct(
                'BiddersErrorTierNumberThresholdMustBeGreaterThanTierNumber',
                { number: thresholdATier, altNumber: thresholdBTier },
              );
              break;
            }
          }
        }
      }

      // special check for campaign targeting
      if (
        this.state.Bidder === DemandSources.publicaCampaign &&
        this.state.CampaignTargeting === HeaderBidderCampaignTargetingSelected
      ) {
        if (this.state.CampaignIDS.length === 0) {
          errors.CampaignTargeting = ct('BiddersErrorTargetAtLeastOneLineItem');
        }
      }

      if (
        this.state.Bidder === DemandSources.publicaCampaign &&
        this.state.CampaignTargeting === HeaderBidderOrderTargetingSelected
      ) {
        if (this.state.OrderIDS.length === 0) {
          errors.OrderTargeting = ct('BiddersErrorTargetAtLeastOneOrder');
        }
      }

      // check to make sure maxAdDurationOverride >= minAdDurationOverride
      if (
        this.state.MaxAdDurationOverride > 0 &&
        this.state.MinAdDurationOverride > 0 &&
        this.state.MinAdDurationOverride > this.state.MaxAdDurationOverride
      ) {
        errors.AdDurationOverrides = ct('BiddersErrorInvalidAdDurationOverride');
      }
      // check to make sure that the startDelayOverride value is > -3, (-3 means it is not being used)
      if (this.state.StartDelayOverride < EStartDelay.StartDelay_UnknownNotSet) {
        errors.StartDelayOverride = ct('BiddersErrorStartDelayOverrideMustBeHigher');
      }
      // check to make sure start date is before end date
      if (
        this.state.dateStart &&
        this.state.dateEnd &&
        this.state.dateStart.isAfter(this.state.dateEnd)
      ) {
        errors.StartDate = ct('ErrorStartDateMustBeBeforeEndDate');
      }
      // check to make sure there is a start date and end date
      if (
        (this.state.dateStart && !this.state.dateEnd) ||
        (!this.state.dateStart && this.state.dateEnd)
      ) {
        errors.StartDate = ct('BiddersErrorStartAndEndDateMissing');
      }
      // check to make sure there is a quantity defined if there are start and end dates
      if (
        this.state.dateStart &&
        this.state.dateEnd &&
        this.state.dateStart.year() !== 1 &&
        this.state.dateEnd.year() !== 1 &&
        this.state.Quantity <= 0
      ) {
        errors.Quantity = ct('BiddersErrorImpressionGoalMustBeDefined');
      }

      if (this.state.FrequencyTTL < 0 || this.state.FrequencyTTL > 120 * 60 * 60 * 24) {
        errors.FrequencyTTL = ct('BiddersErrorFrequencyCap');
      }
      if (this.state.DailyRequestCap !== 0 && this.state.DailyRequestCap < 10000) {
        errors.DailyRequestCap = ct('BiddersErrorInvalidDailyRequestCap');
      }

      if (this.state.Timeout !== 0 && this.state.Timeout <= this.state.TmaxOffset) {
        errors.Timeout = ct('BiddersErrorTimeoutMustBeMoreThanTmaxOffset');
      }

      if (this.state.Timeout < 0 || isNaN(this.state.Timeout)) {
        errors.Timeout = ct('BiddersErrorInvalidTimeout');
      }

      if (this.state.TmaxOffset < 0 || isNaN(this.state.TmaxOffset)) {
        errors.TmaxOffset = ct('BiddersErrorInvalidTmaxOffset');
      }

      if (this.state.localTargetingParameters.length) {
        errors.localTargetingParameters = validateLocalTargeting(
          this.state.localTargetingParameters,
        ).join('; ');
      }

      return errors;
    };

    organizeRootKeyValueParameters = (rootKeyValueParameters: {
      [key: string]: IRootKeyValueParameter[];
    }): { [key: string]: IRootKeyValueParameter[] } => {
      const newRootKeyValueParameters = {} as { [key: string]: IRootKeyValueParameter[] };
      for (const oldPrefix of Object.keys(rootKeyValueParameters)) {
        for (const rootKeyValueParameter of rootKeyValueParameters[oldPrefix]) {
          const newPrefix = rootKeyValueParameter.prefix;

          // create the new prefix if it does not alreay exist
          if (!newRootKeyValueParameters[newPrefix]) {
            newRootKeyValueParameters[newPrefix] = [] as IRootKeyValueParameter[];
          }

          newRootKeyValueParameters[newPrefix].push({
            key: rootKeyValueParameter.key,
            value: rootKeyValueParameter.value,
            typ: rootKeyValueParameter.typ,
            prefix: rootKeyValueParameter.prefix,
          } as IRootKeyValueParameter);
        }
      }
      return newRootKeyValueParameters;
    };

    _saveBidder = async () => {
      const errors = this.findErrors(this.state, bidderValidationSetting);
      const { isDaypartingActive, DaypartingIntervals, DaypartingIsAllowed, enableViewerTimezone } =
        this.state;

      // Check channel targeting and ensure a channel or channel group is selected
      const channelIDs = this.getSiteIDSFromTargetedSites();
      if (channelIDs.length === 0 && this.state.ChannelGroupIDS.length === 0) {
        // If no channel ids, adds appropriate error text to errors
        errors.ChannelIds = ct('NoticeSelectAtLeastOneChannelOrChannelGroup');
      }

      // Check if bidder is targeting an inactive audience segments
      if (
        targetingInactiveAudienceSegments(
          this.state.segments,
          this.state.TargetingAudienceSegmentID,
        )
      ) {
        errors.TargetingAudienceSegmentID =
          'Remove inactive audience segments or activate the inactivate audience segments';
      }

      // saves the value as -3 when empty
      if (startDelayOverrideIsEmpty(this.state.StartDelayOverride)) {
        this.setState({
          StartDelayOverride: EStartDelay.StartDelay_UnknownNotSet,
        });
      }

      // check if platform connection site id is valid
      const site_id = this.getSiteIDFromParams('siteID');
      if (ALL_PLATFORM_CONNECTION_BIDDERS.includes(this.state.Bidder) && site_id !== '0') {
        for (const site of this.state.sites) {
          if (site.ID.toString() === site_id) {
            errors.ParamsOptions_SiteID =
              'Platform Connection bidders cannot target channels within their own publisher';
          }
        }
      }

      // Validate SmartFloors Config
      const smartFloorConfigErrors = this.validateSmartFloorConfig();
      for (const err in smartFloorConfigErrors) {
        if (smartFloorConfigErrors[err].length > 0) {
          this.setState(
            {
              errors,
              snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
                item: ct('SmartFloors'),
                text: smartFloorConfigErrors[err],
              }),
              snackbarError: true,
            },
            () => {
              setTimeout(this.snackbarClose, 6000);
            },
          );
          return;
        }
      }

      if (!isEmpty(this.state.PresetIDs)) {
        const { isValid, activeParameterInfo, conflictedParameters } =
          await validateTargetingPresetSelections(this.props.session.publisher.ID, {
            customTargeting: this.generateCustomTargetingPayload(),
            presetIDs: this.state.PresetIDs,
          }).catch((err) => {
            console.error(err);
            this.setState(
              {
                snackbarMessage: ct('ErrorValidatingItemPleaseTryAgain', {
                  item: ct('PresetAssociations'),
                }),
                snackbarError: true,
              },
              () => {
                setTimeout(this.snackbarClose, 6000);
              },
            );
          });

        if (!isValid) {
          this.setState(
            {
              presetConflicts: activeParameterInfo,
              presetConflictedParamKeys: conflictedParameters,
              errors,
              snackbarMessage: ct('BiddersSnackbarTargetingPresetConflicts'),
              snackbarError: true,
            },
            () => {
              setTimeout(this.snackbarClose, 6000);
            },
          );
          return;
        }
      }

      // Check if errors exists, if it does set state
      if (hasErrors(errors)) {
        const errorText = Object.values(errors)
          .filter((value) => value.length)
          .join('. ');
        this.setState(
          {
            errors,
            snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
              item: ct('Bidder'),
              text: errorText,
            }),
            snackbarError: true,
            presetConflicts: {},
            presetConflictedParamKeys: [],
          },
          () => {
            setTimeout(this.snackbarClose, 6000);
          },
        );
        return;
      }

      // Convert local countries targeting from denylist to allowlist
      const targetingDeviceCountry = this.generateTargetingDeviceCountry();

      // Add keyvalue pair with keyvalue prefix if it's samsung publishers and spotx bidder, or nine publishers and pubmatic bidder

      const addKeyValuePairsToAdd = (keyValuePairs: IKeyValueParameter[]) => {
        for (const keyValuePair of keyValuePairs) {
          const hasKeyValuePair = this.state.keyValueParameters.reduce(
            (ret: boolean, kvp: IKeyValueParameter) => {
              return ret || keyValuePair.key === kvp.key;
            },
            false,
          );
          if (!hasKeyValuePair) {
            keyValuePairsToAdd.push(keyValuePair);
          }
        }
      };

      const keyValuePairsToAdd: IKeyValueParameter[] = [];
      if (this.state.Bidder === 'spotx' && isSamsungPublisher(this.props.session.publisher.ID)) {
        // define the kvps need to insert for samsung spotx bidder
        const keyValuePairs: IKeyValueParameter[] = [
          {
            key: 'site_id',
            value: '[SITE_ID]',
            typ: '',
          },
          {
            key: 'category',
            value: '[CONTENT_CAT]',
            typ: '',
          },
          {
            key: 'genre',
            value: '[CONTENT_GENRE]',
            typ: '',
          },
        ];

        if (isSamsungNAPublisher(this.props.session.publisher.ID)) {
          keyValuePairs.push({
            key: 'channel_label',
            value: '[CHANNEL_LABEL_ID]',
            typ: '',
          });
        }

        // define extra kvps need to insert for samsung eu
        if (this.props.session.publisher.ID === '486') {
          keyValuePairs.push({
            key: 'opt_out_flag',
            value: '[DNT]',
            typ: '',
          });
        }

        addKeyValuePairsToAdd(keyValuePairs);
      } else if (
        this.state.Bidder === DemandSources.pubmatic &&
        isNinePublisher(this.props.session.publisher.ID)
      ) {
        const keyValuePairs: IKeyValueParameter[] = [
          {
            key: 'pmZoneId',
            value: '[PT_showname]',
            typ: '',
          },
        ];

        addKeyValuePairsToAdd(keyValuePairs);
      }

      const selectedCountryGroupItems = Object.values(this.state.targetingCountryGroupList).filter(
        (item) => item.selected,
      );
      const organizedRootKeyValueParameters = this.organizeRootKeyValueParameters(
        this.state.rootKeyValueParameters,
      );

      const callbackFn = () => {
        // check bidder type, if not publicaCampaign, campaign targeting should be HeaderBidderCampaignTargetingInactive
        // check bidder's campaign targeting type
        // if the type is not "selected", remove all Campaigns so associations are deleted

        // don't save tier mapping if disabled
        const isSpotxTierDisabled = this.props.isSpotxTierEnabled !== EBool.EBool_TRUE;
        let _enableSpotxBidderAssociation = this.state.EnableSpotxBidderAssociation;
        if (isSpotxTierDisabled) {
          _enableSpotxBidderAssociation = this.props.headerbidder.EnableSpotxBidderAssociation; // use the one from the props instead
        }

        const isMagniteCTVTierDisabled = this.props.isMagniteCTVTierEnabled !== EBool.EBool_TRUE;
        let _enableMagniteCTVBidderAssociation = this.state.EnableMagniteCTVBidderAssociation;
        if (isMagniteCTVTierDisabled) {
          _enableMagniteCTVBidderAssociation =
            this.props.headerbidder.EnableMagniteCTVBidderAssociation; // use the one from the props instead
        }

        const isSamsungSSPTierDisabled = this.props.isSamsungSSPTierEnabled !== EBool.EBool_TRUE;
        const _enableSamsungSSPBidderAssociation = isSamsungSSPTierDisabled
          ? this.props.headerbidder.EnableSamsungSSPBidderAssociation
          : this.state.EnableSamsungSSPBidderAssociation;

        // Create Dayparting Object
        // we always want to parse dayparting non-inverted for the DB
        const Dayparting = parseDaypartingIntervals(
          DaypartingIntervals,
          isDaypartingActive,
          this.props.session.publisher.Timezone,
          true,
          enableViewerTimezone,
        );

        // Parse bidder labels
        const bidderLabels = this.getBidderLabelAddList();
        for (const label of bidderLabels) {
          label.Bidders = [];
        }
        this.setState(
          {
            BidderLabels: bidderLabels,
            CampaignTargeting:
              this.state.Bidder === DemandSources.publicaCampaign
                ? this.state.CampaignTargeting
                : HeaderBidderCampaignTargetingInactive,
            CampaignIDS:
              this.state.CampaignTargeting === HeaderBidderCampaignTargetingSelected
                ? this.state.CampaignIDS
                : ([] as number[]),
            Dayparting,
            DaypartingIsAllowed,
            OrderIDS:
              this.state.CampaignTargeting === HeaderBidderOrderTargetingSelected
                ? this.state.OrderIDS
                : ([] as number[]),
            LocalTargeting: this.exportLocalTargetingParamToJSON(),
            TargetingAppBundleID: this.state.TargetingAppBundleID.split(',')
              .map((ID: string) => ID.trim().replace(/\r?\n|\r/g, ''))
              .filter((ID: string) => ID.length > 0)
              .join(','),
            TargetingDeviceCountry: targetingDeviceCountry
              .map((country: IGeo) => country.key.toUpperCase())
              .join(','),
            TargetingCountryGroupIDs: selectedCountryGroupItems.map((item) => item.ID).join(','),
            rootKeyValueParameters: organizedRootKeyValueParameters,
            EnableSpotxBidderAssociation: _enableSpotxBidderAssociation,
            EnableMagniteCTVBidderAssociation: _enableMagniteCTVBidderAssociation,
            EnableSamsungSSPBidderAssociation: _enableSamsungSSPBidderAssociation,
            updating: true,
            errors: {},
          },
          () => {
            // Create new bidder
            if (!isExistingBidder(this.state) || this.state.cloneBidderID) {
              const siteIDS = channelIDs.map((s: number) => String(s));
              const campaignIDS = this.state.CampaignIDS.map((s: number) => String(s));
              const orderIDS = this.state.OrderIDS.map((s: number) => String(s));
              const channelGroupIDS = this.state.ChannelGroupIDS.map((s: number) => String(s));
              const channelListIDS = this.state.ChannelListIDS.map((s: number) => String(s));
              const countryGroupIDs = (this.state.TargetingCountryGroupIDs || '').split(',');
              const contextualSegmentIDS = this.state.ContextualSegmentIDS.map((id) => String(id));
              const presetIds = (this.state.PresetIDs || []).map((id) => String(id));
              // remove the stored ID from the headerbidder when creating one because it is automatically assigned
              const hbRemoveID = Object.assign(cloneDeep(this.state), { ID: '0' });

              createHeaderBidder(
                hbRemoveID as IHeaderBidder,
                parseInt(this.props.session.publisher.ID, 10),
                siteIDS,
                campaignIDS,
                orderIDS,
                channelGroupIDS,
                countryGroupIDs,
                contextualSegmentIDS,
                channelListIDS,
                presetIds,
              ).then(([newHB, err]) => {
                // error handler
                if (err !== undefined) {
                  this.setState({
                    updating: false,
                    snackbarMessage: ct('BiddersSnackbarSavingBidderFailedReason', {
                      item: err.toString(),
                    }),
                    snackbarError: true,
                    presetConflicts: {},
                    presetConflictedParamKeys: [],
                  });
                } else {
                  // succesfully created bidder
                  if (newHB) {
                    // create smart floors if needed
                    const shouldCreateSmartFloors =
                      EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) &&
                      this.state.isSmartFloorActive &&
                      !isEmpty(this.state.smartFloorConfigs[0]?.SmartFloors);
                    if (shouldCreateSmartFloors) {
                      this.state.smartFloorConfigs[0].HeaderbidderID = parseInt(newHB.ID, 10);
                      createSmartFloorConfig(
                        this.props.session.publisher.ID,
                        newHB.ID,
                        this.state.smartFloorConfigs[0],
                      ).then((config) => {
                        // error handler
                        if (isEmpty(config)) {
                          this.setState({
                            updating: false,
                            snackbarMessage: ct('BiddersSnackbarCreatingSmartFloorConfigFailed'),
                            snackbarError: true,
                            presetConflicts: {},
                            presetConflictedParamKeys: [],
                          });
                        } else {
                          // succesfully created smart floors
                          const message = newHB.OptionalMessage
                            ? `${ct('SnackbarSuccessfullySavedItem', { item: ct('Bidder') })}. ${ct(
                                'BiddersSnackbarMarkedAsInactiveNoSyncSSSP',
                              )}. ${ct('SnackbarSuccessfullyCreatedItem', {
                                item: ct('SmartFloors'),
                              })}`
                            : `${ct('SnackbarSuccessfullySavedItem', { item: ct('Bidder') })}. ${ct(
                                'SnackbarSuccessfullyCreatedItem',
                              )}`;
                          this.setState(
                            Object.assign({}, this.state, newHB, {
                              smartFloorConfigs: [config],
                              hasExistingSmartFloorConfig: true,
                              hasExistingThompsonSampling: config.ThompsonSamplingEnabled,
                              updating: false,
                              snackbarMessage: message,
                              snackbarError: false,
                              presetConflicts: {},
                              presetConflictedParamKeys: [],
                            }),
                          );
                          this.updateParamOptionValues(
                            this.props.headerbidderParamOptions[newHB.Bidder],
                          );
                          setTimeout(() => this.gotoBidderPage(newHB.ID), 1000); // Go back to bidder's page
                        }
                      });
                    } else {
                      // no need to create Smart Floors
                      const message = newHB.OptionalMessage
                        ? `${ct('SnackbarSuccessfullySavedItem', { item: ct('Bidder') })}. ${ct(
                            'BiddersSnackbarMarkedAsInactiveNoSyncSSSP',
                          )}`
                        : ct('SnackbarSuccessfullySavedItem', { item: ct('Bidder') });
                      this.setState(
                        Object.assign({}, this.state, newHB, {
                          updating: false,
                          snackbarMessage: message,
                          snackbarError: false,
                          presetConflicts: {},
                          presetConflictedParamKeys: [],
                        }),
                      );
                      this.updateParamOptionValues(
                        this.props.headerbidderParamOptions[newHB.Bidder],
                      );
                      setTimeout(() => this.gotoBidderPage(newHB.ID), 1000); // Go back to bidder's page
                    }
                  }
                }
              });
            } else {
              // Update existing bidder
              updateHeaderBidder({
                query: {
                  publisher_id: this.props.session.publisher.ID,
                  bidder_id: this.state.ID,
                  channel_group_ids: this.state.ChannelGroupIDS.join(','),
                  channel_list_ids: this.state.ChannelListIDS.join(','),
                  channel_ids: (channelIDs || []).join(','),
                  update_dates: true,
                  preset_ids: (this.state.PresetIDs || []).join(','),
                  AppStoreURL: this.state.AppStoreURL,
                },
                body: {
                  headerbidder: this.state,
                  custom_targeting_payload: !isEmpty(this.state.PresetIDs)
                    ? this.generateCustomTargetingPayload()
                    : {},
                },
              }).then(
                (headerbidder: IHeaderBidder) => {
                  const shouldCreateSmartFloors =
                    !this.state.hasExistingSmartFloorConfig &&
                    this.state.isSmartFloorActive &&
                    !isEmpty(this.state.smartFloorConfigs[0]?.SmartFloors);
                  const shouldUpdateSmartFloors = this.state.hasExistingSmartFloorConfig;

                  // need to update smart floors
                  if (
                    EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) &&
                    (shouldCreateSmartFloors || shouldUpdateSmartFloors)
                  ) {
                    const doSmartFloorConfigAPICall = shouldUpdateSmartFloors
                      ? updateSmartFloorConfig
                      : createSmartFloorConfig;

                    // reset all smart floors' optimized floor to base floor if we turn off previously-on Thompson Sampling
                    let config = this.state.smartFloorConfigs[0];
                    if (
                      this.state.hasExistingThompsonSampling &&
                      !this.state.smartFloorConfigs[0].ThompsonSamplingEnabled
                    ) {
                      config = {
                        ...config,
                        SmartFloors: config.SmartFloors.map((sf) => ({
                          ...sf,
                          OptimizedFloor: sf.BaseBidFloor,
                        })),
                      };
                    }

                    doSmartFloorConfigAPICall(
                      this.props.session.publisher.ID,
                      headerbidder.ID,
                      config,
                    ).then((config) => {
                      // error handler
                      if (isEmpty(config)) {
                        this.setState({
                          updating: false,
                          snackbarMessage: ct('BiddersSnackbarUpdatingSmartFloorConfigFailed'),
                          snackbarError: true,
                          presetConflicts: {},
                          presetConflictedParamKeys: [],
                        });
                      } else {
                        // succesfully update smart floors
                        this.setState(
                          Object.assign({}, this.state, headerbidder, {
                            smartFloorConfigs: [config],
                            updating: false,
                            snackbarMessage: ct('SnackbarSuccessfullySavedItem', {
                              item: ct('Bidder'),
                            }),
                            snackbarError: false,
                            presetConflicts: {},
                            presetConflictedParamKeys: [],
                            hasExistingSmartFloorConfig: true,
                            hasExistingThompsonSampling: config.ThompsonSamplingEnabled,
                            // preserve contextual segment ids since the api doesn't return them
                            ContextualSegmentIDS: this.state.ContextualSegmentIDS,
                          }),
                        );

                        this.updateParamOptionValues(
                          this.props.headerbidderParamOptions[headerbidder.Bidder],
                        );
                      }
                    });
                  } else {
                    // no update to SmartFloors
                    this.setState(
                      Object.assign({}, this.state, headerbidder, {
                        updating: false,
                        snackbarMessage: ct('SnackbarSuccessfullySavedItem', {
                          item: ct('Bidder'),
                        }),
                        snackbarError: false,
                        presetConflicts: {},
                        presetConflictedParamKeys: [],
                        // preserve contextual segment ids since the api doesn't return them
                        ContextualSegmentIDS: this.state.ContextualSegmentIDS,
                      }),
                    );
                    this.updateParamOptionValues(
                      this.props.headerbidderParamOptions[headerbidder.Bidder],
                    );
                  }
                },
                (err: string) => {
                  this.setState({
                    updating: false,
                    snackbarMessage: ct('BiddersSnackbarSavingBidderFailedReason', {
                      item: String(err),
                    }),
                    snackbarError: true,
                    presetConflicts: {},
                    presetConflictedParamKeys: [],
                  });
                },
              );
            }
          },
        );
      };

      if (keyValuePairsToAdd.length > 0) {
        this.setState(
          {
            keyValueParameters: update(this.state.keyValueParameters, {
              $push: keyValuePairsToAdd,
            }),
          },
          () => this.updateParams(this.state.ParamOptions, callbackFn),
        );
      } else {
        callbackFn();
      }
    };

    handleActiveChange = (checked: boolean) => {
      const newActiveState = checked ? HeaderBidderActiveActive : HeaderBidderActiveInactive;
      this.setState({
        Active: newActiveState,
        isSmartFloorActive:
          newActiveState === HeaderBidderActiveInactive ? false : this.state.isSmartFloorActive,
        smartFloorConfigs:
          newActiveState === HeaderBidderActiveInactive
            ? this.buildNewSmartFloorConfigs(0, 'SmartFloors', true, 0, true, false) // remove all smart floors if bidder is inactive
            : this.state.smartFloorConfigs,
      });
    };

    handlePoddedRequestActiveChange = (checked: boolean) => {
      const poddedRequestTypeOptions = generateORTB26PoddedRequestTypeOptions(this.state.Bidder);
      let poddedOptionType = EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeNonPodded;
      if (poddedRequestTypeOptions.length > 0) {
        poddedOptionType = Number(poddedRequestTypeOptions[0].key);
      }

      const PoddedRequestActive = checked
        ? HeaderBidderPoddedRequestActiveActive
        : HeaderBidderPoddedRequestActiveInactive;

      const PoddedRequestType =
        PoddedRequestActive === HeaderBidderPoddedRequestActiveActive
          ? poddedOptionType
          : EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeNonPodded;

      this.setState(
        {
          PoddedRequestActive,
          PoddedRequestType,
          MultiBidActive: EBool.EBool_FALSE,
          Slots: BIDDERS_PODDED_REQUEST_ENABLED.includes(this.state.Bidder)
            ? checked
              ? ['1']
              : []
            : this.state.Slots,
        },
        () => {
          this.updateParamOptionValues(this.props.headerbidderParamOptions[this.state.Bidder]);
        },
      );
    };

    handlePoddedRequestTypeChange = ({ target }: any) => {
      this.setState(
        {
          PoddedRequestType: target.value,
        },
        () => {
          if (
            this.state.PoddedRequestType !==
            EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeHybrid
          ) {
            this.setState({
              HybridStructuredSlotDurations: '',
            });
          }
          this.updateParamOptionValues(this.props.headerbidderParamOptions[this.state.Bidder]);
        },
      );
    };

    handleMultiBidActiveChange = (checked: boolean) => {
      this.setState({
        MultiBidActive: checked ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        PoddedRequestActive: HeaderBidderPoddedRequestActiveInactive,
      });
    };

    getUpdatedIrisContextKVP = (
      irisSignalEnabled: EBool,
      newIrisCTVEnabled: EBool,
      bidder: string,
      keyValueParameters: IKeyValueParameter[],
    ): IKeyValueParameter[] => {
      const shouldEnable = EBool.isTrue(irisSignalEnabled) || EBool.isTrue(newIrisCTVEnabled);
      const updatedKeyValueParameters = [...keyValueParameters];

      if (bidder === DemandSources.videobyte) {
        if (shouldEnable && !updatedKeyValueParameters.find((kvp) => kvp.key === 'iris_context')) {
          updatedKeyValueParameters.unshift({
            key: 'iris_context',
            value: '[IRIS_CONTEXT]',
            typ: '',
            isNotEditable: true,
          } as IKeyValueParameter);
        } else if (!shouldEnable) {
          const irisContextIndex = updatedKeyValueParameters.findIndex(
            (kvp) => kvp.key === 'iris_context',
          );
          if (irisContextIndex >= 0) {
            updatedKeyValueParameters.splice(irisContextIndex, 1);
          }
        }
      }

      if (bidder === DemandSources.magnitectv) {
        if (shouldEnable && !updatedKeyValueParameters.find((kvp) => kvp.key === 'c4')) {
          updatedKeyValueParameters.unshift({
            key: 'c4',
            value: '[IRIS_CONTEXT]',
            typ: '',
            isNotEditable: true,
          } as IKeyValueParameter);
        } else if (!shouldEnable) {
          const c4Index = updatedKeyValueParameters.findIndex((kvp) => kvp.key === 'c4');
          if (c4Index >= 0) {
            updatedKeyValueParameters.splice(c4Index, 1);
          }
        }
      }
      return updatedKeyValueParameters;
    };

    handleReverseToggle = (fieldName: string) => {
      this.setState({
        [fieldName]: EBool.reverse(this.state[fieldName]),
        openEnableSponsorshipModeDialog:
          fieldName === 'EnableSponsorshipMode' && this.state[fieldName] === EBool.EBool_FALSE,
      });
    };

    saveBidder = () => {
      this.trackEvent('Bidder Settings - Save Bidder');
      this.addParamsOptionsValidationSupport(() => {
        this.updateCloneToDefaultValues(this._saveBidder);
      });
    };

    validateAndWarnOnPriorityChange = (newPriority: number) => {
      const uniqueSelectedPriorities = uniqBy(
        this.state.FlexibleBiddingThresholds,
        (flexibleBiddingThreshold) => flexibleBiddingThreshold.BidderPriority,
      );
      const flexibleBiddingDialogInvalidThresholds = uniqueSelectedPriorities.filter(
        (threshold) => threshold.BidderPriority <= newPriority,
      );

      // check if no valid threshold tiers
      if (flexibleBiddingDialogInvalidThresholds.length > 0) {
        // check if some invalid threshold tiers exist
        this.setState({
          flexibleBiddingDialogIsOpen: true,
          flexibleBiddingDialogNewPriority: newPriority,
          flexibleBiddingDialogInvalidThresholds,
        });
      } else {
        this.setState({
          Priority: newPriority,
          FlexibleBiddingEnabled:
            newPriority === 10 || this.state.FlexibleBiddingEnabled === ResourceActiveDisabled
              ? ResourceActiveDisabled
              : ResourceActiveEnabled,
        });
      }
    };

    removeInvalidFlexibleBiddingBiddingThresholdsAndCloseDialog = () => {
      const uniqueSelectedPriorityThresholds = uniqBy(
        this.state.FlexibleBiddingThresholds,
        (flexibleBiddingThreshold) => flexibleBiddingThreshold.BidderPriority,
      );
      const validThresholds = uniqueSelectedPriorityThresholds.filter(
        (threshold) => threshold.BidderPriority > this.state.flexibleBiddingDialogNewPriority,
      );
      this.setState({
        FlexibleBiddingEnabled: validThresholds.length > 0 ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        Priority: this.state.flexibleBiddingDialogNewPriority,
        FlexibleBiddingThresholds: validThresholds,
        flexibleBiddingDialogIsOpen: false,
      });
    };

    revertFlexibleBiddingBidderPriorityChange = () => {
      this.setState({
        flexibleBiddingDialogIsOpen: false,
        Priority: this.state.flexibleBiddingDialogNewPriority,
        FlexibleBiddingEnabled: ResourceActiveEnabled,
      });
    };

    // ############################## GO TO FUNCTIONS ##############################=

    gotoBidderListView = () => {
      navigate(
        RouteBidderSettingsList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    gotoBidderPage = (bidderID: string) => {
      navigate(RouteBidderSettingsExisting, extractRouteParams(this.props), {
        b: bidderID,
      });
    };

    gotoCreativeURLs = () => {
      if (!this.props.headerbidder.ID) {
        return;
      }
      navigateToRouteWithQueryParams(
        RouteBrandSafetyList,
        { bidder_id: this.props.headerbidder.ID },
        extractRouteParams(this.props),
      );
    };

    generateDemandSources = () => {
      const { Bidder } = this.state;
      const demandSources = getHeaderBidderAdaptersForPublisher(
        this.state.ssp,
        false,
        this.props.session.publisher,
        hasRoleSuperUser(this.props.user.user),
        false,
      )
        .filter((hb: IHeaderBidderAdapter) => {
          if (hb.key === DemandSources.consumable && Bidder !== DemandSources.consumable) {
            return false;
          }
          return (
            hb.key !== DemandSources.publicaCampaign ||
            !isPublicaCampaignDisabled(this.props.session.publisher)
          );
        })
        .map((hb: IHeaderBidderAdapter) => {
          return { key: hb.key, text: hb.text };
        });
      return demandSources;
    };

    genTimezoneList = () => {
      const { Timezone } = this.state;

      const timezonesList = genTimezoneList(Timezone || this.props.session.publisher.Timezone);

      this.setState({
        timezonesList,
      });
    };

    handleChangeBidderLabelList = (list: IBidderLabel[]) => {
      this.setState({
        BidderLabelsSelected: list,
      });
    };

    generateMaxBidResponsesDuration = () => {
      return [30, 60, 120].map((duration) => {
        return { key: duration, text: duration };
      });
    };

    getDisplayedSlots = () => {
      if (this.state.Slots.length === 0) {
        this.setState({
          Slots: ['all'],
        });
        return ['all'];
      }

      return this.state.Slots;
    };

    // empty string represents all device types
    getDisplayedDeviceTypes = (getAll: boolean): string[] => {
      if (this.state.TargetingDeviceTypes.length > 0 && !getAll) {
        return this.state.TargetingDeviceTypes.split(',');
      }
      return deviceORTBTypes.map((deviceType: IDeviceType) => deviceType.key);
    };

    // Playback method options for the dropdown
    playbackMethodList = [
      {
        key: 1,
        text: ct('PageLoadSoundOn'),
      },
      {
        key: 2,
        text: ct('PageLoadSoundOff'),
      },
      {
        key: 3,
        text: ct('ClickSoundOn'),
      },
      {
        key: 4,
        text: ct('MouseOverSoundOn'),
      },
      {
        key: 5,
        text: ct('EnteringViewportSoundOn'),
      },
      {
        key: 6,
        text: ct('EnteringViewportSoundOff'),
      },
    ];

    getDisplayedPlaybackMethods = (): number[] => {
      if (this.state.PlaybackMethod === '') {
        this.setState({
          PlaybackMethod: '1',
        });
      }
      const selected = this.state.PlaybackMethod.split(',');
      return this.playbackMethodList.map((pbm) =>
        selected.includes(pbm.key.toString()) ? pbm.key : 0,
      );
    };

    getDisplayedMimeTypeOverride = (getAll: boolean): string[] => {
      const { MimeTypeOverride } = this.state;
      if (!getAll) {
        return MimeTypeOverride.split(',');
      }
      // const selectedMimeTypeOverrides = MimeTypeOverride.split(',');
      return MimeTypeList.map((mimeType) => mimeType.key);
    };

    // Convert segments list to list of objects {key, text} for displaying in segment dropdown
    getAudienceSegmentsAsItems = (): IMenuList => {
      const list = {} as IMenuList;
      const selected = this.state.TargetingAudienceSegmentID.split(',');

      this.state.segments.forEach((segment) => {
        list[segment.ID] = {
          title:
            segment.Active === AudienceSegmentActiveActive
              ? segment.Name
              : `${segment.Name} [inactive]`,
          ID: segment.ID,
          selected: selected.includes(segment.ID),
        } as IListItem;
      });
      return list;
    };

    updateSnackbar = (message: string, error: boolean) => {
      this.setState(
        {
          snackbarMessage: message,
          snackbarError: error,
        },
        () => {
          setTimeout(this.snackbarClose, 6000);
        },
      );
    };

    getBidder = () => {
      getHeaderBidder({
        query: {
          publisher_id: this.props.session.publisher.ID,
          bidder_id: this.state.ID,
        },
      }).then((bidder: IHeaderBidder) => {
        // update bidder
        this.setState(
          Object.assign({}, this.state, bidder, {
            updating: false,
            snackbarError: false,
          }),
        );
        this.updateParamOptionValues(this.props.headerbidderParamOptions[bidder.Bidder]);
      });
    };

    getPresetList = () => {
      fetchTargetingPresetOptions(this.props.session.publisher.ID)
        .then(({ Presets }) => {
          // update bidder
          this.setState({
            PresetList: Presets,
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            PresetList: [],
          });
        });
    };

    // should only get the bidders that are needed
    // the bidder to clone, the bidder that was selected OR all the selected bidders if bulk editing
    getHeaderBidders = () => {
      const { bulkUpdateIDs, headerbidder, session } = this.props;
      const { ID, cloneBidderID } = this.state;
      if (ID === '' && cloneBidderID === undefined && bulkUpdateIDs.length === 0) {
        this.genBidderChannelList();
      } else if (ID !== '' || cloneBidderID !== undefined || bulkUpdateIDs.length > 0) {
        // get bidder(s) for single bidder, cloned bidder or bulk bidders
        let hb_ids = '';
        if (cloneBidderID) {
          hb_ids = cloneBidderID.toString();
        } else if (bulkUpdateIDs.length) {
          hb_ids = bulkUpdateIDs.join(',');
        } else if (headerbidder && headerbidder.ID !== '0') {
          hb_ids = headerbidder.ID;
        }
        queryHeaderBidders({
          query: {
            publisher_id: session.publisher.ID,
            site_ids: '',
            include_deleted: false,
            all_fields: true,
            hb_ids,
          },
        })
          .then((bidders: IHeaderBidder[]) => {
            // if cloning, we should remove the id from the bidder
            if (cloneBidderID && bidders.length === 1) {
              bidders[0].ID = '';
            }

            // for bulk update, determine what types of bidders are selected
            let bulkUpdateIDsIncludesDirectCampaign = false;
            let bulkUpdateIDsIncludesBidderWithoutAdjFactor = false;
            for (const bidder of bidders) {
              if (
                bulkUpdateIDs.includes(bidder.ID) &&
                bidder.Bidder === DemandSources.publicaCampaign
              ) {
                bulkUpdateIDsIncludesDirectCampaign = true;
              }
              if (
                bulkUpdateIDs.includes(bidder.ID) &&
                BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR.includes(bidder.Bidder)
              ) {
                bulkUpdateIDsIncludesBidderWithoutAdjFactor = true;
              }
            }

            this.setState(
              {
                bidders,
                bulkUpdateIDsIncludesDirectCampaign,
                bulkUpdateIDsIncludesBidderWithoutAdjFactor,
              },
              () => {
                // If the clone button from bidder-list is clicked, import that bidder
                if (cloneBidderID !== undefined) {
                  this.importClonedBidderSettingsAndParams();
                } else {
                  this.genBidderChannelList();
                }
              },
            );
          })
          .catch(() => {
            this.genBidderChannelList();
            this.setState({
              bidders: [],
              snackbarError: true,
              snackbarMessage: ct('ErrorLoadingItem', { item: ct('Bidders') }),
            });
          });
      }
    };

    handleChannelListGroupsAcceptClick = (): void => {
      const ChannelListGroupsIDS: number[] = [];
      Object.values(this.state.channelListCGL).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelListGroupsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        ChannelListGroupsIDS,
      });
    };

    handleChannelListChannelsAcceptClick = (): void => {
      const ChannelListChannelsIDS = [] as number[];
      Object.values(this.state.channelListCL).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelListChannelsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        ChannelListChannelsIDS,
      });
    };

    handleChannelListsAcceptClick = (): void => {
      const ChannelListIDS: number[] = [];
      Object.values(this.state.channelListsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelListIDS.push(parseInt(listItem.ID, 10));
        }
      });

      this.setState({
        ChannelListIDS,
        isWaitingToUpdateSmartFloorConfig: this.state.isSmartFloorActive,
      });
    };

    handleEditChannelListGroupsAcceptClick = (): void => {
      const EditChannelListGroupsIDS: number[] = [];
      Object.values(this.state.editChannelListCGL).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          EditChannelListGroupsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        EditChannelListGroupsIDS,
      });
    };

    handleEditChannelListChannelsAcceptClick = (): void => {
      const EditChannelListChannelsIDS = [] as number[];
      Object.values(this.state.editChannelListCL).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          EditChannelListChannelsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        EditChannelListChannelsIDS,
      });
    };

    handleChannelGroupsAcceptClick = (): void => {
      const ChannelGroupIDS: number[] = [];
      Object.values(this.state.channelGroupsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelGroupIDS.push(parseInt(listItem.ID, 10));
        }
      });

      this.setState(
        {
          ChannelGroupIDS,
          isWaitingToUpdateSmartFloorConfig: this.state.isSmartFloorActive,
        },
        this.getChannelIDs,
      );
    };

    handleChannelAcceptClick = (): void => {
      const SiteIDS = [] as number[];
      Object.values(this.state.bidderChannelList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          SiteIDS.push(parseInt(listItem.ID, 10));
        }
      });

      this.setState({
        SiteIDS,
        isWaitingToUpdateSmartFloorConfig: this.state.isSmartFloorActive,
      });
    };

    handleTargetedCampaignsAcceptClick = (): void => {
      const CampaignIDS: number[] = [];
      Object.values(this.state.bidderTargetedCampaignsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          const campaignID = this.state.bidderTargetedCampaignsList[listItem.ID].ID;
          CampaignIDS.push(parseInt(campaignID, 10));
        }
      });
      const bidderTargetedOrdersList = cloneDeep(this.state.bidderTargetedOrdersList);
      Object.values(bidderTargetedOrdersList).forEach((order: IListItem) => {
        if (order.selected) {
          bidderTargetedOrdersList[order.ID].selected = false;
        }
      });
      this.setState({
        CampaignIDS,
        OrderIDS: [],
        bidderTargetedOrdersList,
      });
    };

    handleTargetedOrdersAcceptClick = (): void => {
      const OrderIDS: number[] = [];
      Object.values(this.state.bidderTargetedOrdersList).forEach((order: IListItem) => {
        if (order.selected) {
          const orderID = this.state.bidderTargetedOrdersList[order.ID].ID;
          OrderIDS.push(parseInt(orderID, 10));
        }
      });
      const bidderTargetedCampaignsList = cloneDeep(this.state.bidderTargetedCampaignsList);
      Object.values(bidderTargetedCampaignsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          bidderTargetedCampaignsList[listItem.ID].selected = false;
        }
      });
      this.setState({
        OrderIDS,
        CampaignIDS: [],
        bidderTargetedCampaignsList,
      });
    };

    // handleTargetingCountryChange handles changes in 'Devices Targeting Countries'
    handleTargetingCountryChange = (selectedCountries: IGeo[]) => {
      this.setState({
        localTargetingDeviceCountry: selectedCountries,
      });
    };

    setStateCallback = (keys: string[], values: any[], setStateCallbacks: Array<() => void>) => {
      const stateObj = {} as IState;
      for (let i = 0; i < keys.length; i++) {
        stateObj[keys[i]] = values[i];
      }
      this.setState(stateObj, () => {
        setStateCallbacks.forEach((callback: () => void) => callback());
      });
    };

    implementABTestParams = (params: any) => {
      this.setState(Object.assign({}, this.state, params), this.saveBidder);
    };

    importClonedBidderSettingsAndParams = () => {
      if (!this.state.cloneBidderID) {
        return;
      }
      getHeaderBidder({
        query: {
          publisher_id: this.props.session.publisher.ID,
          bidder_id: this.state.cloneBidderID,
        },
      }).then((bidder: IHeaderBidder) => {
        let frequencyLimitUnit = FrequencyLimitUnitHours;
        let frequencyLimitDuration = bidder.FrequencyTTL / 3600;

        if (frequencyLimitDuration % 24 === 0) {
          frequencyLimitUnit = FrequencyLimitUnitDays;
          frequencyLimitDuration = frequencyLimitDuration / 24;
        }
        // Clones all existing params in the bidder object
        // As long as the JSON conversion correctly matches the key in state this should translate correctly
        const clonedBidderObj: IGenericObject = { ...bidder };

        // If there are new/updated values in bidders for the clone, add them here
        const updateObj: IGenericObject = {
          ID: 0,
          Name: bidder.Name + ' - Copy',
          Active: EBool.EBool_FALSE,
          frequencyLimitDuration,
          frequencyLimitUnit,
          dateStart: bidder.StartDate
            ? formatDateFromUTCToOffset(bidder.StartDate, this.props.session.publisher.Timezone)
            : undefined,
          dateEnd: bidder.EndDate
            ? formatDateFromUTCToOffset(bidder.EndDate, this.props.session.publisher.Timezone)
            : undefined,
          CRONQuantityCount: 0,
          OriginalBidderChannelGroups: bidder.ChannelGroups,
          OriginalBidderChannelListIDS: bidder.ChannelListIDS,
          Dayparting: bidder.Dayparting,
          // Pacing
          PacingTypeText: (() => {
            if (bidder && bidder.PacingType) {
              const opt = getPacingTypeOption(bidder.PacingType);
              if (opt) {
                return opt.text;
              }
            }
            return pacingTypeOptions[0].text;
          })(),
          PacingType: (() => {
            if (bidder && bidder.PacingType) {
              const opt = getPacingTypeOption(bidder.PacingType);
              if (opt) {
                return opt.value;
              }
            }
            return pacingTypeOptions[0].value;
          })(),

          InventoryType:
            bidder.InventoryType || EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_NONE,
          TargetedAdBreak:
            bidder.TargetedAdBreak ||
            EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL,
          HybridStructuredSlotDurations: '', // reset the hybrid structured slot durations
        };

        // Save the cloned settings and type in state
        // to be used in V2 update to denote values as cloned values vs changed values
        const clonedBidder: IGenericObject = {
          ID: { value: bidder.ID },
          Name: { value: bidder.Name },
        };
        // Object.keys(clonedBidderObj).forEach((key) => {
        //   if (key === 'Params') {
        //     const params: IGenericObject = this.parseJSONParamsSafely(`{` + clonedBidderObj[key] + `}`);
        //     Object.keys(params).forEach((key) => {
        //       clonedBidder[key] = {value: params[key], type: CloneType.CLONED};
        //     });
        //   } else {
        //     clonedBidder[key] = {value: clonedBidderObj[key], type: CloneType.CLONED};
        //   }
        // });

        // Create the merged object to update state
        Object.assign(clonedBidderObj, updateObj, { clonedBidder });

        this.setState(clonedBidderObj, () => {
          this.updateParamOptionValues(this.props.headerbidderParamOptions[bidder.Bidder]);
          this.parseKeyValueParametersFromParams();
          this.importLocalTargetingParamFromJSON(this.state.LocalTargeting);
          this.genBidderChannelList();
          this.getAdserverOrders();
          this.getCampaigns();
          this.genChannelGroupsList();
          this.genBidderLabels();
          this.populateContextualSegmentList();
          this.populateTargetingCountriesList();
          this.populateTargetingCountryGroupList();
          this.parseDayparting();

          // after importing the bidder, then clear the cloneBidderID from state and props
          this.setState({
            cloneBidderID: undefined,
            compareValues: true,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              cloneBidderID: undefined,
            }),
          );
        });
      });
    };

    // Get the channel ids from the bidderChannelList dropdown
    getSiteIDSFromTargetedSites = (): number[] => {
      const { bidderChannelList } = this.state;
      const filteredChannelNames = Object.keys(bidderChannelList).filter(
        (channelName) => bidderChannelList[channelName].selected,
      );
      return filteredChannelNames.map((channelName) =>
        parseInt(bidderChannelList[channelName].ID, 10),
      );
    };

    makeTargetingChangeDescription = (isAllowing: boolean) => {
      if (isAllowing) {
        return ct('MessageTargetingFieldFromExcludingToIncluding');
      }
      return ct('MessageTargetingFieldFromIncludingToExcluding');
    };

    toggleHonorChannelFloor = () => {
      this.setState({ HonorChannelFloor: EBool.reverse(this.state.HonorChannelFloor) });
    };

    toggleSkip = () => {
      this.setState({ Skip: EBool.reverse(this.state.Skip) });
    };

    toggleAdbreakTargeting = () => {
      this.setState({ AdbreakTargeting: this.state.AdbreakTargeting === '1' ? '' : '1' });
    };

    toggle = (target: string) => {
      this.setState({
        [target]: !this.state[target],
      });
    };

    handleChangeDate = ({ start, end }: IDateRangeChangeEvent) => {
      this.setState({
        dateStart: start,
        dateEnd: end,
        StartDate: start
          ? formatDateWithOffsetToUTC(start, this.props.session.publisher.Timezone)
          : undefined,
        EndDate: end
          ? formatDateWithOffsetToUTC(end, this.props.session.publisher.Timezone)
          : undefined,
      });
    };

    // clears the creative's start and end dates
    clearDates = () => {
      this.setState({
        dateStart: undefined,
        dateEnd: undefined,
        StartDate: undefined,
        EndDate: undefined,
      });
    };

    clearMinMaxPodDuration = () => {
      this.setState({
        TargetingRequestedPodDurationMin: TargetingRequestedPodDurationNoMin,
        TargetingRequestedPodDurationMax: TargetingRequestedPodDurationNoMax,
      });
    };

    getParamsInTesting = (): string[] => {
      const { abTests } = this.state;

      let paramsInTesting = [] as string[];
      let currentABTest;
      if (this.props.existing) {
        currentABTest = abTests.filter((test) => {
          return test.Active === ABTestingActiveActive;
        })[0];

        if (currentABTest !== undefined) {
          const testParams = this.parseJSONParamsSafely(currentABTest.Tests[1].Parameters);
          paramsInTesting = Object.keys(testParams);
        }
      }
      return paramsInTesting;
    };

    handleChangeEBool = (name: string) => {
      const currStatus = this.state[name];
      const nextStatus = EBool.reverse(currStatus);
      if (currStatus !== undefined) {
        // if switching to remove content, we should remove the override value and switch if empty false
        if (
          Object.keys(removeContentToOverwriteContent).includes(name) &&
          nextStatus === EBool.EBool_TRUE
        ) {
          const overrideName = removeContentToOverwriteContent[name];
          const overrideIfEmptyName = overrideName + 'IfEmpty';
          this.setState({
            [overrideName]: '',
            [overrideIfEmptyName]: EBool.EBool_FALSE,
            [name]: nextStatus,
          });
        } else {
          this.setState({ [name]: nextStatus });
        }
      }
    };

    // Generates Inputs for App Store URL Override
    generateRewriteInputRows = ({
      stateKey,
      activeRows = [],
      handleChange,
      selectTitle,
      textfieldTitle,
      placeholderText = '',
      addButtonText = ct('PlusAdd'),
    }: IGenerateRewriteInputRowsProps): IInputRow[] => {
      const activeItems: string[] = activeRows.map((row: IRewriteActiveRow) => row.device);
      const inactiveItems = this.state.appStoreURLs.filter(
        (device: string) => !activeItems.includes(device),
      );

      const handleSelect = ({ e, idx }: { e: React.ChangeEvent<HTMLLIElement>; idx: number }) => {
        const newRows = [...activeRows];
        newRows[idx].device = String(e.target?.value);
        handleChange({ rows: newRows, stateKey });
      };

      const handleTextFieldChange = ({ value, idx }: { value: string; idx: number }) => {
        const newRows = [...activeRows];
        newRows[idx].text = value;
        handleChange({ rows: newRows, stateKey });
      };

      const handleAdd = () => {
        handleChange({ rows: [...activeRows, { device: inactiveItems[0], text: '' }], stateKey });
      };

      const handleRemove = (idx: number) => {
        const newRows = [...activeRows];
        newRows.splice(idx, 1);
        handleChange({ rows: newRows, stateKey });
      };

      const inputRows = activeRows.map((row: IRewriteActiveRow, idx: number) => {
        const { device, text } = row;
        const title = device === 'Xbox' ? 'Microsoft or Xbox' : device;
        const items = [device, ...inactiveItems];
        return {
          renderType: 'SelectTextfieldRemove',
          idx,
          // SELECT
          title1: selectTitle,
          simpleSelectItems: items,
          value1: device,
          handleChange1: handleSelect,
          // TEXTFIELD
          title2: textfieldTitle,
          value2: text,
          placeholderText,
          handleChange2: handleTextFieldChange,
          // REMOVE BUTTON
          handleClick1: handleRemove,
          // OPTIONAL
          isActiveValue1: () => !!device,
          getActiveTag1: (active: boolean) => (active ? title : ''),
        } as IInputRow;
      });

      // +ADD button
      inputRows.push({
        renderType: 'AddRowModelSecondaryButton',
        title1: addButtonText,
        handleClick1: handleAdd,
        disabled1: inactiveItems.length === 0,
        // Props below are mandatory for IInputRow
        // but are not applicable to this component
        isActiveValue1: () => false,
        getActiveTag1: (active: boolean) => (active ? '' : ''),
      } as IInputRow);

      return inputRows;
    };

    handleChangeAppStoreURLOverride = ({ rows, stateKey }: IHandleChangeAppOverrideProps) => {
      if (!this.props.headerbidder) return;
      const result: { [device: string]: string } = Object.fromEntries(
        rows.map((row) => [row.device, row.text]),
      );
      const updatedData = Object.assign({}, this.state[stateKey]);
      AppOverrideKeys.forEach((device: string) => {
        if (result[device]) {
          updatedData[device] = result[device];
        } else {
          updatedData[device] = '';
        }
      });
      this.setState({
        [stateKey]: updatedData,
        rewriteInputRows: {
          ...this.state.rewriteInputRows,
          [stateKey]: rows,
        },
      });
    };

    // Handles the change of the toggle for Bid Request Rewrite → PMP → Private Auction.
    handlePrivateAuctionChange = () => {
      this.setState({
        PrivateAuction:
          this.state.PrivateAuction === PrivateAuctionTypeEnabled
            ? PrivateAuctionTypeDisabled
            : PrivateAuctionTypeEnabled,
        Deals: [], // clear the selected deals as the deal filtering is different when Private Auction is on
        MatchDealID:
          this.state.PrivateAuction === PrivateAuctionTypeDisabled
            ? MatchDealIDTypeDisabled
            : this.state.MatchDealID,
      });
    };

    // Handles the change of the toggle for EnableDealPriorityOverrideChange.
    handleEnableDealPriorityOverrideChange = () => {
      this.setState({
        EnableDealPriorityOverride:
          this.state.EnableDealPriorityOverride === EBool.EBool_TRUE
            ? EBool.EBool_FALSE
            : EBool.EBool_TRUE,
      });
    };

    // Handles the change of the toggle for Bid Request Rewrite → PMP → Match deal id.
    handleMatchDealIDChange = () => {
      this.setState({
        MatchDealID:
          this.state.MatchDealID === MatchDealIDTypeEnabled
            ? MatchDealIDTypeDisabled
            : MatchDealIDTypeEnabled,
      });
    };

    handleDealSelectChange = (elem: { target: { value: IDeal[] } }): void => {
      const { value } = elem.target;
      this.setState({ Deals: value });
    };

    hasNoWriteRights = (): boolean => {
      return (
        !IS_AUTHORIZED(['write_bidder'], this.props.user.user).isAuthorized ||
        this.state.IsAutoCreatedByPlatformConnect === EBool.EBool_TRUE
      );
    };

    handleChangeSamplingDays = (elem: React.ChangeEvent<HTMLInputElement>): void => {
      if (elem.target.value === '') {
        this.setState({
          samplingPercentageDisabledUntilDays: 0,
          SamplingPercentageDisabledUntil: '',
        });
      } else {
        const samplingPercentageDisabledUntilDays = parseInt(elem.target.value, 10);
        if (
          Number.isNaN(samplingPercentageDisabledUntilDays) ||
          samplingPercentageDisabledUntilDays > 8
        ) {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('BiddersSnackbarDebugDaysMustBeBetween0And8'),
          });
        } else {
          this.setState({
            samplingPercentageDisabledUntilDays,
            SamplingPercentageDisabledUntil:
              samplingPercentageDisabledUntilDays !== 0
                ? moment(
                    moment.utc(new Date()).add(samplingPercentageDisabledUntilDays, 'day'),
                  ).format('YYYY-MM-DDTHH:mm:ssZ')
                : moment(moment.utc(new Date())).format('YYYY-MM-DDTHH:mm:ssZ'),
          });
        }
      }
    };

    renderExchangeAdornment = (value: string) => {
      const currencySymbol = convertECurrencyTypeToSymbol(
        this.props.session.publisher.CurrencyDisplayed,
      );
      if (
        value === undefined ||
        value === '' ||
        currencySymbol === '$' ||
        this.state.BidFloorCurrency !== ECurrencyType.CURRENCY_TYPE_USD
      ) {
        return <></>;
      }

      return (
        <InputAdornment position='end'>
          {currencySymbol +
            (
              parseFloat(value.replace(/,/g, '')) *
              this.props.session.publisher.ExchangeRate.ExchangeValueToUSD
            ).toFixed(2)}
        </InputAdornment>
      );
    };

    renderActive = (disableParams: boolean) => {
      const { Active } = this.state;
      const bulkUpdateEnabled = this.isBulkUpdate();
      const bidderRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipActiveBidders'),
        title1: ct('Bidder'),
        field1: 'Active',
        value1: Active === EBool.EBool_TRUE,
        defaultValue1: false,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        helperText: Active === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('Active'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Active']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Active',
              displayTitle: ct('Bidder'),
              genDisplayValue: () => EBool.toBoolString(this.state.Active),
              enabled: false,
              genType: () => this.getCloneType('Active'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      return <InputRow rowInfo={bidderRow} disableEdit={disableParams} />;
    };

    renderBidFloor = (disableParams: boolean) => {
      const {
        bidderChannelList,
        channelIDs,
        errors,
        openChannelSelectTable,
        BidFloor,
        BidFloorUSD,
        BidFloorCurrency,
        HonorChannelFloor,
      } = this.state;
      const { cloneBidderEnabled } = this.props;

      // if there have been new impressions since the last test was created, params used in testing are disabled
      const newImpressionsSinceLastTest =
        this.state.CRONQuantityCount !== this.state.CRONQuantityCountSinceLastTest;
      const paramsInTesting = this.getParamsInTesting();
      const disableParamTesting =
        paramsInTesting.includes('BidFloor') && newImpressionsSinceLastTest;

      const options: ISimpleOptionSelect[] = [
        {
          key: 'fixed',
          value: EBool.toBoolString(EBool.EBool_FALSE),
          label: ct('Fixed'),
          icon: 'checkmark-2',
          isSelected: !this.state.isSmartFloorActive,
          isDisabled: false,
        },
        {
          key: 'smart',
          value: EBool.toBoolString(EBool.EBool_TRUE),
          label: ct('Smart'),
          icon: 'arrow-up',
          isSelected: this.state.isSmartFloorActive,
          isDisabled: false,
        },
      ];
      const bidFloorElement = (
        <Rows>
          {EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) && (
            <Row noPadding>
              <Text
                extraSmall
                muted
                bold
                style={{
                  marginBottom: EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled)
                    ? spacing.small
                    : 0,
                }}
              >
                Logic
              </Text>
              <Cols paddingLeft={spacing.base}>
                <Col style={{ marginRight: spacing.small }}>
                  <PillSwitcherV2
                    size='small'
                    options={options}
                    onChange={() => this.toggleSmartFloorActive()}
                  />
                  {/* if smart floor is on, add link to go to Smart Floors tab */}
                  {this.state.isSmartFloorActive && (
                    <Cols
                      paddingTop={spacing.small}
                      onClick={() => this.setState({ viewTabIndex: 5 })}
                      style={{ width: 'fit-content', alignItems: 'center', cursor: 'pointer' }}
                    >
                      <Col>
                        <Text
                          bold
                          small
                          color={publicaColors.blue}
                          tKey={'SetItem'}
                          tProps={{ item: ct('SmartFloors') }}
                        />
                      </Col>
                      <Col style={{ marginLeft: spacing.extraSmall }}>
                        <IconV2 small name='externalLink' color={publicaColors.blue} />
                      </Col>
                    </Cols>
                  )}
                </Col>
                <Col>
                  <Text
                    bold
                    extraSmall
                    style={{
                      borderRadius: borderRadius.small,
                      background: publicaColors.veryLightBlue,
                      paddingLeft: spacing.small,
                      paddingRight: spacing.small,
                    }}
                    tKey={'BiddersMessageSmartFloors'}
                  />
                </Col>
              </Cols>
            </Row>
          )}

          {/* if smart floor is on, disable custom bid floor setting */}
          {(!EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) ||
            !this.state.isSmartFloorActive) && (
            <Row
              smallHorizontalPadding
              verticalPadding
              paddingTop='0'
              style={{ width: 'fit-content' }}
            >
              <Cols
                style={{ alignItems: 'flex-end' }}
                paddingLeft={
                  EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled)
                    ? spacing.base
                    : '0px'
                }
              >
                <Col>
                  {EBool.isTrue(this.props.session.publisher.EnableOtherCurrency) ? (
                    <CurrencyConverter
                      className='pb-bidder-settings-form-view_textfield-bid-floor'
                      currencies={CurrencyDisplayedItem}
                      currency={convertECurrencyTypeToString(BidFloorCurrency) || CurrencyTypeUSD}
                      isDisabled={disableParams || disableParamTesting}
                      isErrored={!!errors.BidFloor}
                      onChange={({ price, uiPrice, uiCurrency }) =>
                        this.handleChangeBidFloorAndBidFloorCurrency(price, uiPrice, uiCurrency)
                      }
                      price={BidFloor === '0' ? '' : BidFloor}
                      displayCurrencyLabel={false}
                    />
                  ) : (
                    <NumberFormat
                      name='BidFloor'
                      value={BidFloor === '0' ? '' : BidFloor}
                      className='pb-bidder-settings-form-view_textfield-bid-floor'
                      disabled={disableParams || disableParamTesting}
                      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                        if (target.value === '-') {
                          this.setState({ BidFloor: '0', BidFloorUSD: '0' });
                        } else {
                          this.setState({ BidFloor: target.value, BidFloorUSD: target.value });
                        }
                      }}
                      helperText={
                        disableParamTesting ? ct('DisabledWhileInTesting') : errors.BidFloor
                      }
                      error={!!errors.BidFloor}
                      customInput={TextField}
                      thousandSeparator={true}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            {convertECurrencyTypeToSymbol(BidFloorCurrency)}
                          </InputAdornment>
                        ),
                        endAdornment: this.renderExchangeAdornment(BidFloor),
                        classes: {
                          input: this.props.classes.input,
                        },
                      }}
                    />
                  )}
                </Col>

                <Col style={{ marginLeft: spacing.base, alignSelf: 'center' }}>
                  <TooltipWithTranslation tKey='BiddersTooltipBidFloor' placement='bottom-start'>
                    <InfoIcon
                      style={{
                        verticalAlign: 'bottom',
                        width: '1rem',
                        color: publicaColors.mediumGray,
                      }}
                    />
                  </TooltipWithTranslation>
                </Col>
              </Cols>
            </Row>
          )}

          <Row noPadding>
            <Text extraSmall muted bold tKey='Option' />
            <Cols style={{ alignItems: 'center', paddingLeft: spacing.base }}>
              <Col>
                <Text
                  small
                  bold={EBool.isTrue(HonorChannelFloor)}
                  muted={HonorChannelFloor === EBool.EBool_FALSE}
                  tKey='HonorChannelFloor'
                />
              </Col>
              <Col>
                <Switch
                  className='pb-bidder-settings-form-view_button_honor-channel-floor'
                  disabled={this.hasNoWriteRights() || disableParams}
                  checked={EBool.isTrue(HonorChannelFloor)}
                  onChange={this.toggleHonorChannelFloor}
                />
              </Col>
            </Cols>
          </Row>

          <Row noPadding paddingLeft={spacing.base} marginBottom={spacing.base}>
            <Cols
              style={{ alignItems: 'center', cursor: 'pointer' }}
              onClick={() => this.setState({ openChannelSelectTable: true })}
            >
              <Col displayFlex marginRight={spacing.extraSmall}>
                <IconV2 large name='columns' color={publicaColors.blue} />
              </Col>
              <Col>
                <Text
                  bold
                  small
                  color={publicaColors.blue}
                  tKey='ViewCurrentItem'
                  tProps={{ item: ct('ChannelFloors') }}
                />
              </Col>
            </Cols>
            <Dialog
              fullWidth
              maxWidth='sm'
              keepMounted
              open={openChannelSelectTable}
              onClose={() => this.setState({ openChannelSelectTable: false })}
            >
              <BidFloorTable
                user={this.props.user.user}
                title={ct('ChannelFloors')}
                channels={this.state.sites.filter((s: ISmallSite) => {
                  if (bidderChannelList[s.ID]) {
                    if (bidderChannelList[s.ID].selected === true && s.BidFloor != null) {
                      this.bidderBidFloor[s.Name] = {
                        currencyDisplayed: s.CurrencyDisplayed || ECurrencyType.CURRENCY_TYPE_USD,
                        bidFloor: s.BidFloor || 0,
                        bidFloorUSD: s.BidFloorUSD || 0,
                      };
                    } else {
                      delete this.bidderBidFloor[s.Name];
                    }
                  }
                  // if channel s has been selected
                  return (
                    (bidderChannelList[s.ID] || { selected: false }).selected ||
                    // if channel s is in the channel groups selected and its BidFloor is not 0
                    (channelIDs.includes(s.ID) && (s.BidFloor ?? 0) > 0)
                  );
                })}
                currencyDisplayed={BidFloorCurrency}
                interactive={true}
                bidderFloor={BidFloor || BidFloorUSD}
                bidderFloorUSD={BidFloorUSD || 0}
                isHonorChannelFloorEnabled={EBool.toBool(HonorChannelFloor)}
                onSelectRow={(siteID: string) => {
                  this.setState({ openChannelSelectTable: false });
                  navigate(RouteChannelExisting, extractRouteParams(this.props), {
                    ch: siteID,
                  });
                }}
              />
            </Dialog>
          </Row>
        </Rows>
      );

      const checkIfRowIsMarkedArr = ['BidFloor', 'HonorChannelFloor'];
      const changeMarkedArr = [
        {
          key: 'BidFloor',
          displayTitle: ct('BidFloor'),
          genDisplayValue: () => '$' + (this.state.BidFloor || 0).toString(),
          enabled: false,
          genType: () => this.getCloneType('BidFloor'),
          defaultValue: '0',
          tab: 'Parameters',
        },
        {
          key: 'HonorChannelFloor',
          displayTitle: ct('HonorChannelFloor'),
          genDisplayValue: () => EBool.toBoolString(this.state.HonorChannelFloor),
          enabled: false,
          genType: () => this.getCloneType('HonorChannelFloor'),
          defaultValue: EBool.EBool_TRUE,
          tab: 'Parameters',
        },
      ];
      if (EBool.isTrue(this.props.session.publisher.EnableOtherCurrency)) {
        checkIfRowIsMarkedArr.unshift('BidFloorCurrency');
        changeMarkedArr.unshift({
          key: 'BidFloorCurrency',
          displayTitle: ct('BidFloorCurrency'),
          genDisplayValue: () => convertECurrencyTypeToString(this.state.BidFloorCurrency || 0),
          enabled: false,
          genType: () => this.getCloneType('BidFloorCurrency'),
          defaultValue: convertStringToECurrencyType(CurrencyTypeUSD).toString(),
          tab: 'Parameters',
        });
      }

      const bidFloorRow = {
        renderType: 'custom',
        customRender: (rowInfo: IInputRow) =>
          this.renderCustomRow(bidFloorElement, ct('BidFloor'), rowInfo, 'start')(),
        title1: '',
        field1: '',
        value1: this.state.BidFloor || '0',
        defaultValue1: '0',
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(checkIfRowIsMarkedArr),
        handleChangeMarked: () => this.handleChangeMarked(changeMarkedArr),
      } as IInputRow;
      return <InputRow rowInfo={bidFloorRow} disableEdit={disableParams} />;
    };

    updateCurrentlyWritingABTest = (status: boolean) => {
      this.setState({ currentlyWritingABTest: status });
    };

    // Note: having a parent component trigger a function in a child component runs counter to good React design
    // The below will need to be refactored in V2 of ABTesting to lift up all testing functionality to this parent component
    // It has been introduced only to solve V1 functionality needs quickly
    updateTriggerTestLaunch = (status: boolean) => {
      this.setState({ triggerTestLaunch: status });
    };

    getSaveButtonStyles = () => {
      return {
        backgroundColor: getColorTheme('channelBidderPrimaryButton'),
        color: getColorTheme('channelBidderPrimaryButtonText'),
      };
    };

    renderBulkUpdateReview = () => {
      const { bulkUpdateEnabledFields } = this.state;
      const { classes } = this.props;
      const bulkFieldsSelected =
        Object.keys(bulkUpdateEnabledFields).filter((key1) => bulkUpdateEnabledFields[key1].enabled)
          .length > 0;
      if (!bulkFieldsSelected) {
        return <Grid></Grid>;
      } else {
        return (
          <Grid>
            <Typography style={{ color: '#666EFA' }}>{ct('ReviewEditedFields')}:</Typography>
            <Grid
              style={{
                border: '#cbcbcb',
                borderStyle: 'solid',
                borderWidth: 'thin',
                display: true ? 'block' : 'none',
                padding: 10,
                marginTop: 10,
              }}
            >
              <Grid container direction='column' alignItems='flex-start' spacing={1}>
                {Object.keys(bulkUpdateEnabledFields)
                  .filter((key1) => bulkUpdateEnabledFields[key1].enabled)
                  .map((key2) => {
                    const item = bulkUpdateEnabledFields[key2];
                    return (
                      <Grid item container direction='row' alignItems='center' spacing={1}>
                        <Grid item xs={1}>
                          <Checkbox
                            className={classes.checkbox}
                            checked={true}
                            onChange={() => this.handleDisableMarkedForBulkUpdate(key2)}
                          />
                        </Grid>
                        <Grid item xs={1} />
                        <Grid item xs={4}>
                          <Typography className={classes.insideAccordionTextBold}>
                            {item.displayTitle + ':'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography className={classes.insideAccordionText}>
                            {item.genDisplayValue()}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
        );
      }
    };

    renderSaveButton = () => {
      const dialogMessage = ct('BiddersTooltipABTestNotLaunched');
      if (this.state.currentlyWritingABTest) {
        return (
          <ConfirmationDialogButton
            title={ct('ConfirmSaveItem', { item: ct('Bidder') })}
            description={dialogMessage}
            acceptButtonTitle={ct('LaunchTest')}
            acceptButtonCallBack={() => this.updateTriggerTestLaunch(true)}
            refuseButtonTitle={ct('SaveWithoutLaunching')}
            refuseButtonCallBack={this.saveBidder}
          >
            <Grid item>
              <Button
                disabled={this.state.updating || this.hasNoWriteRights()}
                style={this.getSaveButtonStyles()}
              >
                {ct('Save')}
              </Button>
            </Grid>
          </ConfirmationDialogButton>
        );
      } else if (this.props.bulkUpdateIDs && this.props.bulkUpdateIDs.length > 0) {
        return (
          <ConfirmationDialogButton
            title={ct('ConfirmBulkEditItem', {
              item: ct('Bidders'),
            })}
            description={ct('BiddersBulkEditMessageNumSelectedBidders', {
              count: this.props.bulkUpdateIDs.length,
            })}
            renderReactElement={this.renderBulkUpdateReview}
            generateAcceptButtonStyles={this.getSaveButtonStyles}
            acceptButtonTitle={ct('YesConfirmUpdates')}
            acceptButtonCallBack={this.updateBulkUpdateBidders}
            refuseButtonTitle={ct('Cancel')}
            refuseButtonCallBack={noopVoid}
          >
            <Grid item>
              <Button
                disabled={this.state.updating || this.hasNoWriteRights()}
                style={this.getSaveButtonStyles()}
              >
                {ct('Save')}
              </Button>
            </Grid>
          </ConfirmationDialogButton>
        );
      } else if (this.props.cloneBidderEnabled) {
        return (
          <Grid item>
            <Button
              className='pb-bidder-settings-form-view-button-save'
              onClick={this.saveBidder}
              disabled={this.state.updating || this.hasNoWriteRights()}
              style={this.getSaveButtonStyles()}
            >
              {ct('SaveItem', { item: ct('Clone') })}
            </Button>
          </Grid>
        );
      } else {
        return (
          <Grid item>
            <Button
              className='pb-bidder-settings-form-view-button-save'
              onClick={this.saveBidder}
              disabled={this.state.updating || this.hasNoWriteRights()}
              style={this.getSaveButtonStyles()}
            >
              {ct('Save')}
            </Button>
          </Grid>
        );
      }
    };

    paramsDisabled() {
      // Default disable params value is false (HB-961 remove account bidder references)
      let disableParams = false;
      if (this.props.existing && this.hasNoWriteRights()) {
        disableParams = true;
      }
      return disableParams;
    }

    computeBidderPacingRatio(currentReq: number, goalForNow: number): number {
      if (goalForNow === 0) {
        return 100;
      }
      return Math.trunc((currentReq / goalForNow) * 100);
    }

    parseJSONParamsSafely(str: string): {} {
      try {
        return JSON.parse(str);
      } catch (e) {
        // Return an empty object
        return {};
      }
    }

    // Handles the changes to the UIBidderType value.
    handleUIBidderTypeChange({ target }: React.ChangeEvent<HTMLInputElement>) {
      const newUIBidderTypeValue = target.value;

      // Check if the name is a known bidder type (ex: 'spotx').
      if (
        !newUIBidderTypeValue &&
        isStringKnownBidderType(newUIBidderTypeValue.trim(), this.props.session.publisher)
      ) {
        // Name is a known bidder name.
        this.setState({
          errors: {
            ...this.state.errors,
            UIBidderType: ct('ErrorThisNameIsAKnownDemandSourceType'),
          }, // Error.
          UIBidderType: newUIBidderTypeValue,
        });
        return;
      }

      // All good, update the state.
      this.setState({
        errors: { ...this.state.errors, UIBidderType: '' }, // No error.
        UIBidderType: newUIBidderTypeValue,
      });
    }

    deleteCountryGroupFunc = (countryGroupID: string, reloadBidder: boolean) => {
      const { publisherCountryGroups, targetingCountryGroupList } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup) => countryGroup.ID.toString() === countryGroupID,
      );
      if (foundCountryGroup) {
        const clonedPublisherCountryGroups = cloneDeep(publisherCountryGroups);
        const filteredPublisherCountryGroups = clonedPublisherCountryGroups.filter(
          (countryGroup) => countryGroup.ID !== foundCountryGroup.ID,
        );

        const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
        delete clonedTargetingCountryGroupList[foundCountryGroup.ID];

        deleteCountryGroup(foundCountryGroup).then(() => {
          this.setState(
            {
              openRegionCreateEditDialog: false,
              openRegionSelectTable: false,
              publisherCountryGroups: filteredPublisherCountryGroups,
              targetingCountryGroupList: clonedTargetingCountryGroupList,
              updatingCountryGroup: false,
              snackbarMessage: ct('SnackbarSuccessfullyDeletedItem', {
                item: ct('CountryGroup'),
              }),
              snackbarError: false,
            },
            reloadBidder ? this.getCountryGroupsByPublisherID : undefined,
          );
        });
      }

      return Promise.resolve(undefined);
    };

    renderToolbar() {
      const { Active, Name, Priority, FlexibleBiddingEnabled, FlexibleBiddingThresholds } =
        this.state;

      const { cloneBidderEnabled, headerbidder } = this.props;

      const isSpotxTierDisabled = this.props.isSpotxTierEnabled !== EBool.EBool_TRUE;
      const isMagniteCTVTierDisabled = this.props.isMagniteCTVTierEnabled !== EBool.EBool_TRUE;
      const isSamsungSSPTierDisabled = this.props.isSamsungSSPTierEnabled !== EBool.EBool_TRUE;
      const linkDestination = {
        pathname: `/app/pub/${this.props.session.publisher.ID}/change-logs`,
        state: {
          resourceID: this.state.ID,
        },
      };

      if (!this.isCloneBidderOrBulkUpdate()) {
        return (
          <Cols largeHorizontalPadding smallVerticalPadding rowBreakSize='medium'>
            {/* COLUMN ONE */}
            {/* Bidder Name */}
            <Col flex responsive mediumStyle={{ paddingBottom: '4px' }}>
              <ModernTextField
                value={obfuscateBidderName(headerbidder, this.props.user.user.Username, Name)}
                onChange={this.handleChange}
                disabled={this.hasNoWriteRights()}
              />
            </Col>
            {/* COLUMN TWO */}
            <Col flex>
              <Cols
                wrap
                responsive
                style={{
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
                mediumStyle={{ justifyContent: 'space-between' }}
              >
                {/* ROW TWO COLUMN ONE */}
                <Col>
                  <Cols gap={spacing.medium} style={{ alignItems: 'center' }}>
                    {/* Bidder Active Switch */}
                    <Col>
                      <Cols>
                        <Col>
                          <Switch
                            disabled={this.hasNoWriteRights()}
                            checked={Active === HeaderBidderActiveActive}
                            onChange={(_, c: boolean) => {
                              this.handleActiveChange(c);
                            }}
                          />
                        </Col>
                        <Col paddingTop='8px'>
                          <Text small tKey='Active' />
                        </Col>
                      </Cols>
                    </Col>
                    {/* Link to Change Logs */}
                    <Col>
                      <Cols>
                        <Link
                          to={linkDestination}
                          style={{ textDecoration: 'none', fontSize: fontSizing.small }}
                        >
                          {ct('ChangeLogs')}
                        </Link>
                      </Cols>
                    </Col>
                    {/* Bidder Tier */}
                    <Col>
                      <Cols
                        paddingRight={spacing.medium}
                        style={{
                          alignItems: 'center',
                          columnGap: spacing.extraSmall,
                        }}
                      >
                        <Col>
                          <Text
                            bold
                            tKey='TierNumber'
                            tProps={{ number: convertPriorityToBidderTier(Priority.toString()) }}
                          />
                        </Col>
                        {FlexibleBiddingEnabled === EBool.EBool_TRUE &&
                          FlexibleBiddingThresholds.length > 0 && (
                            <Col paddingTop='5px'>
                              <FlexibleBiddingIconWithTooltip />
                            </Col>
                          )}
                        {((this.state.Bidder === 'spotx' &&
                          !isSpotxTierDisabled &&
                          this.state.EnableSpotxBidderAssociation === EBool.EBool_TRUE) ||
                          (this.state.Bidder === DemandSources.magnitectv &&
                            !isMagniteCTVTierDisabled &&
                            this.state.EnableMagniteCTVBidderAssociation === EBool.EBool_TRUE) ||
                          (this.state.Bidder === DemandSources.samsungssp &&
                            !isSamsungSSPTierDisabled &&
                            this.state.EnableSamsungSSPBidderAssociation === EBool.EBool_TRUE)) && (
                          <Col paddingTop='5px'>
                            <DoNotUseDemandSourceSettingsIconWithTooltip />
                          </Col>
                        )}
                      </Cols>
                    </Col>
                  </Cols>
                </Col>
                {/* ROW TWO COLUMN TWO */}
                <Col>
                  {/* Buttons */}
                  <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
                    {/* Clone Icon Button */}
                    {!this.props.cloneBidderEnabled && !!this.state.ID && (
                      <Col paddingRight={spacing.small}>
                        <Tooltip title={ct('Clone')}>
                          <IconButton
                            style={{ padding: 0 }}
                            aria-label='clone'
                            className='pb-bidder-settings-form-view_iconbutton-clone'
                            onClick={this.handleCloneBidder}
                            disabled={this.hasNoWriteRights()}
                          >
                            <FileCopyIcon />
                          </IconButton>
                        </Tooltip>
                      </Col>
                    )}
                    {/* Save Button */}
                    <Col>
                      {this.hasNoWriteRights() ? (
                        <ChipInactive label={ct('ReadOnly')} />
                      ) : (
                        this.renderSaveButton()
                      )}
                    </Col>
                    {/* Close Button */}
                    <Col>
                      <Button onClick={this.gotoBidderListView} style={{ color: '#545454' }}>
                        {ct('Close')}
                      </Button>
                    </Col>
                  </Cols>
                </Col>
              </Cols>
            </Col>
          </Cols>
        );
      }

      return (
        <Cols largeHorizontalPadding smallVerticalPadding>
          <Col>
            <Text small bold>
              {cloneBidderEnabled
                ? ct('BiddersCloneInstructions')
                : ct('BiddersBulkEditInstructions')}
            </Text>
          </Col>
          <Col flex>
            <Cols
              gap={spacing.small}
              paddingLeft={spacing.medium}
              style={{
                justifyContent: 'flex-end',
              }}
            >
              <Col>
                {this.hasNoWriteRights() ? (
                  <ChipInactive label={ct('ReadOnly')} />
                ) : (
                  this.renderSaveButton()
                )}
              </Col>
              <Col>
                <Button onClick={this.gotoBidderListView} style={{ color: '#545454' }}>
                  {ct('Close')}
                </Button>
              </Col>
            </Cols>
          </Col>
        </Cols>
      );
    }

    renderParameters = () => {
      const { classes, session, user, cloneBidderEnabled } = this.props;
      const {
        bulkUpdateIDsIncludesBidderWithoutAdjFactor,
        errors,
        AuctionParticipationPercentage,
        BidAdjustmentFactor,
        BidAdjustmentValue,
        Bidder,
        EnableRemoveGPPFromBidRequest,
        EnableSecondaryRequests,
        EnableSponsorshipMode,
        FixedPrice,
        DailyRequestCap,
        PacingType,
        ShareOfVoice,
        Timeout,
        TmaxOffset,
        UIBidderType,
        InventoryType,
        IsFallbackBackfillEnabled,
        FallbackAuctionParticipationEnabled,
        IsPublicaTagFallbackEnabled,
        FrequencyActive,
        UnpaidBidderEnabled,
        DOOHEnabled,
        RemoveFmtJSON,
        Name,
        Active,
        timezonesList,
        YahooConnectIDEnabled,
        EnableOptableEIDs,
      } = this.state;
      const disableParams = this.paramsDisabled();
      const bulkUpdateEnabled = !!this.props.bulkUpdateIDs && this.props.bulkUpdateIDs.length > 0;

      const isKVPBidder = isKVPBidderAndPublisherEnabled(Bidder, this.state.Params);

      // Cloned Page Only
      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: ct('Name'),
        field1: 'Name',
        value1: Name,
        defaultValue1: this.getCloneValue(
          'Name',
          ct('NewItemName', { item: ct('Bidder') }),
        ) as string,
        maxWidth: 400,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        disableCheck: !!cloneBidderEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Name']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Name',
              displayTitle: ct('Name'),
              genDisplayValue: () => (this.state.Name || '').toString(),
              enabled: false,
              genType: () => this.getCloneType('Name'),
              defaultValue: this.getCloneValue(
                'Name',
                ct('NewItemName', { resource: ct('Bidder') }),
              ) as string,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      // Cloned Page Only
      const ActiveRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        title1: ct('Status'),
        field1: 'Active',
        value1: Active === EBool.EBool_TRUE,
        defaultValue1: false,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        helperText: Active === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('Active'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Active']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Active',
              displayTitle: ct('Status'),
              genDisplayValue: () =>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
                this.state.Active === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('Active'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const DemandSourceRow = {
        renderType: 'SimpleSingleSelect',
        enableSmallRow: true,
        simpleSelectItems: this.generateDemandSources() || [],
        title1: ct('DemandSource'),
        field1: 'Bidder',
        value1: Bidder,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        helperText: errors.Bidder,
        resource: 'demandsource',
        tooltipText: !!cloneBidderEnabled && ct('BiddersTooltipBidderSelectionDisabled'),

        disableCheck: !!cloneBidderEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Bidder']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Bidder',
              displayTitle: ct('DemandSource'),
              genDisplayValue: () => {
                const demandSources = this.generateDemandSources();
                const hb = demandSources.find(
                  (hb: IHeaderBidderAdapter) => hb.key === this.state.Bidder,
                );
                return hb !== undefined ? hb.text : this.state.Bidder;
              },
              enabled: false,
              genType: () => this.getCloneType('Bidder'),
              defaultValue: '',
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const BidderLabelRow = {
        renderType: 'custom',
        customRender: (rowInfo: IInputRow) =>
          this.renderCustomRow(
            <Grid item xs={7} style={{ height: '68px', alignItems: 'center' }}>
              <MaterialLabelDropdownMulti
                menuTitle={ct('BidderLabel')}
                width={'100%'}
                list={this.state.bidderLabels}
                selected={this.state.BidderLabelsSelected}
                onChange={(list: IBidderLabel[]) => {
                  this.handleChangeBidderLabelList(list);
                }}
              />
            </Grid>,
            ct('BidderLabel'),
            rowInfo,
          )(),
        title1: '',
        field1: '',
        value1: '',
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
      } as IInputRow;

      const UIBidderTypeRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: ct('CustomItemName', { item: ct('Bidder') }),
        field1: 'UIBidderType',
        value1: UIBidderType,
        defaultValue1: '',
        maxWidth: 400,
        handleChange1: (target: any) => this.handleUIBidderTypeChange(target),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        tooltipText: ct('TooltipCustomName'),
        helperText: errors.UIBidderType
          ? errors.UIBidderType
          : ct('PlaceholderEnterCustomItemName', { item: ct('Bidder') }),
        placeholderText: errors.UIBidderType
          ? errors.UIBidderType
          : ct('PlaceholderEnterCustomItemName', { item: ct('Bidder') }),

        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['UIBidderType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'UIBidderType',
              displayTitle: ct('CustomItemName', { item: ct('Bidder') }),
              genDisplayValue: () => (this.state.UIBidderType || '').toString(),
              enabled: false,
              genType: () => this.getCloneType('UIBidderType'),
              defaultValue: '',
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const TimezoneRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: ct('Timezone'),
        field1: 'Timezone',
        value1: timezonesList,
        defaultValue1: false,
        handleChange1: this.handleChangeList('timezonesList'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        helperText: errors.Timezone,
        tooltipText: ct('BiddersTooltipTimezone'),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Timezone']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Timezone',
              displayTitle: ct('Timezone'),
              genDisplayValue: () =>
                (this.state.Timezone || this.props.session.publisher.Timezone).toString(),
              enabled: false,
              genType: () => this.getCloneType('Timezone'),
              defaultValue: '',
              tab: 'Parameters',
            },
          ]),
        materialDropdownEnableMultiSelect: false,
      } as IInputRow;

      const bidAdjustmentRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        title1: ct('BidAdjustment'),
        field1: 'BidAdjustmentFactor',
        value1: BidAdjustmentFactor,
        defaultValue1: 100,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: disableParams,
        tooltipText: ct('BiddersTooltipBidAdjustment'),
        helperText: errors.BidAdjustmentFactor,
        error: !!errors.BidAdjustmentFactor,
        endAdornment: <InputAdornment position='end'>%</InputAdornment>,

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['BidAdjustmentFactor']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'BidAdjustmentFactor',
              displayTitle: ct('BidAdjustment'),
              genDisplayValue: () => (this.state.BidAdjustmentFactor || 0).toString() + '%',
              enabled: false,
              genType: () => this.getCloneType('BidAdjustmentFactor'),
              defaultValue: 100,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const bidAdjustmentValueRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        title1: ct('BidAdjValue'),
        field1: 'BidAdjustmentValue',
        value1: BidAdjustmentValue,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: disableParams,
        tooltipText: ct('BiddersTooltipBidAdjValue'),
        helperText: errors.BidAdjustmentValue,
        error: !!errors.BidAdjustmentValue,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['BidAdjustmentValue']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'BidAdjustmentValue',
              displayTitle: ct('BidAdjValue'),
              genDisplayValue: () => '$' + (this.state.BidAdjustmentValue || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('BidAdjustmentValue'),
              defaultValue: 0,
              tab: 'Parameters',
            },
          ]),
        endAdornment: <InputAdornment position='end'>$</InputAdornment>,
      } as IInputRow;
      const fixedPriceRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        title1: ct('FixedPrice'),
        field1: 'FixedPrice',
        value1: FixedPrice,
        defaultValue1: '',
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: disableParams,
        helperText: errors.FixedPrice,
        error: !!errors.FixedPrice,
        endAdornment: (
          <InputAdornment position='end'>
            {convertECurrencyTypeToSymbol(this.state.BidFloorCurrency)}
          </InputAdornment>
        ),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['FixedPrice']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'FixedPrice',
              displayTitle: ct('FixedPrice'),
              genDisplayValue: () => (this.state.FixedPrice || 0).toString() + '$',
              enabled: false,
              genType: () => this.getCloneType('FixedPrice'),
              defaultValue: '',
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const shareOfVoiceRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        title1: ct('ShareOfVoice'),
        field1: 'ShareOfVoice',
        value1: ShareOfVoice,
        defaultValue1: 100,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: disableParams,
        tooltipText: ct('BiddersTooltipShareOfVoice'),
        helperText: errors.ShareOfVoice,
        error: !!errors.ShareOfVoice,
        endAdornment: <InputAdornment position='end'>%</InputAdornment>,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['ShareOfVoice']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'ShareOfVoice',
              displayTitle: ct('ShareOfVoice'),
              genDisplayValue: () => (this.state.ShareOfVoice || 0).toString() + '%',
              enabled: false,
              genType: () => this.getCloneType('ShareOfVoice'),
              defaultValue: 100,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const auctionParticipationPercentageRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        title1: ct('AuctionParticipationPercentage'),
        field1: 'AuctionParticipationPercentage',
        value1: AuctionParticipationPercentage,
        defaultValue1: 100,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: disableParams,
        tooltipText: ct('BiddersTooltipAuctionParticipationPercentage'),
        helperText: errors.AuctionParticipationPercentage,
        error: !!errors.AuctionParticipationPercentage,
        endAdornment: <InputAdornment position='end'>%</InputAdornment>,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AuctionParticipationPercentage']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AuctionParticipationPercentage',
              displayTitle: ct('AuctionParticipationPercentage'),
              genDisplayValue: () => (this.state.ShareOfVoice || 0).toString() + '%',
              enabled: false,
              genType: () => this.getCloneType('AuctionParticipationPercentage'),
              defaultValue: 100,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const bidderTimeoutRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        title1: ct('BidderTimeout'),
        field1: 'Timeout',
        value1: Timeout,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        tooltipText: ct('BiddersTooltipBidderTimeout'),
        disabled1: disableParams,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Timeout']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Timeout',
              displayTitle: ct('BidderTimeout'),
              genDisplayValue: () => (this.state.Timeout || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('Timeout'),
              defaultValue: 0,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const tmaxOffsetRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipTmaxOffset'),
        title1: ct('TmaxOffset'),
        field1: 'TmaxOffset',
        value1: TmaxOffset,
        defaultValue1: 150,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: disableParams,
        helperText: errors.TmaxOffset,
        error: !!errors.TmaxOffset,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TmaxOffset']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TmaxOffset',
              displayTitle: ct('TmaxOffset'),
              genDisplayValue: () => (this.state.TmaxOffset || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('TmaxOffset'),
              defaultValue: 0,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const shareOfVoiceTypeRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generateShareOfVoiceTypeOptions() || [],
        tooltipText: ct('BiddersTooltipShareOfVoiceType'),
        title1: ct('ShareOfVoiceType'),
        field1: 'ShareOfVoiceType',
        enableSmallRow: true,
        value1: this.state.ShareOfVoiceType,
        defaultValue1: EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.ShareOfVoiceType !==
          EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD,
        getActiveTag1: (active: boolean) => (active ? ct('ByPodDuration') : ct('ByPod')),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['ShareOfVoiceType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'ShareOfVoiceType',
              displayTitle: ct('ShareOfVoiceType'),
              genDisplayValue: () =>
                this.state.ShareOfVoiceType !==
                EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD
                  ? ct('ByPod')
                  : ct('ByPodDuration'),
              enabled: false,
              genType: () => this.getCloneType('ShareOfVoiceType'),
              defaultValue: EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const unpaidBidderRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipUnpaidBidder'),
        title1: ct('UnpaidBidder'),
        field1: 'UnpaidBidderEnabled',
        value1: UnpaidBidderEnabled === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: UnpaidBidderEnabled === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('UnpaidBidderEnabled'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['UnpaidBidderEnabled']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'UnpaidBidderEnabled',
              displayTitle: ct('UnpaidBidder'),
              genDisplayValue: () => EBool.toBoolString(this.state.UnpaidBidderEnabled),
              enabled: false,
              genType: () => this.getCloneType('UnpaidBidderEnabled'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const doohBidderRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipDOOHBidder'),
        title1: ct('DOOHBidder'),
        field1: 'DOOHBidderEnabled',
        value1: DOOHEnabled === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: DOOHEnabled === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('DOOHEnabled'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['DOOHEnabled']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'DOOHEnabled',
              displayTitle: ct('DOOHBidder'),
              genDisplayValue: () => EBool.toBoolString(this.state.DOOHEnabled),
              enabled: false,
              genType: () => this.getCloneType('DOOHBidderEnabled'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const removeFmtJSONRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        title1: ct('RemoveFMTJSON'),
        field1: 'RemoveFmtJSON',
        value1: RemoveFmtJSON === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: RemoveFmtJSON === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('RemoveFmtJSON'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['RemoveFmtJSON']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'RemoveFmtJSON',
              displayTitle: ct('RemoveFMTJSON'),
              genDisplayValue: () => EBool.toBoolString(this.state.RemoveFmtJSON),
              enabled: false,
              genType: () => this.getCloneType('RemoveFmtJSON'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const optableEIDsRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipEnableOptableEIDs'),
        title1: ct('EnableOptableEIDs'),
        field1: 'EnableOptableEIDs',
        value1: EnableOptableEIDs === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: EnableOptableEIDs === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('EnableOptableEIDs'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['EnableOptableEIDs']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnableOptableEIDs',
              displayTitle: ct('EnableOptableEIDs'),
              genDisplayValue: () => EBool.toBoolString(this.state.EnableOptableEIDs),
              enabled: false,
              genType: () => this.getCloneType('EnableOptableEIDs'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const checkIfRowIsMarkedArr = [
        'Priority',
        'FlexibleBiddingEnabled',
        'FlexibleBiddingType',
        'FlexibleBiddingThresholds',
      ];
      const changeMarkedArr = [
        {
          key: 'Priority',
          displayTitle: ct('BidderTier'),
          genDisplayValue: () =>
            `Tier ${convertPriorityToBidderTier(this.state.Priority.toString())}`,
          enabled: false,
          genType: () => this.getCloneType('Priority'),
          defaultValue: 10,
          tab: 'Parameters',
        },
        {
          key: 'FlexibleBiddingEnabled',
          displayTitle: ct('FlexibleBiddingEnabled'),
          genDisplayValue: () =>
            this.state.FlexibleBiddingEnabled === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
          enabled: false,
          genType: () => this.getCloneType('FlexibleBiddingEnabled'),
          defaultValue: EBool.EBool_FALSE,
          tab: 'Parameters',
        },
        {
          key: 'FlexibleBiddingType',
          displayTitle: ct('CPMOrCPMS'),
          genDisplayValue: () => flexibleBiddingTypeToString(this.state.FlexibleBiddingType),
          enabled: false,
          genType: () => this.getCloneType('FlexibleBiddingType'),
          defaultValue: this.state.FlexibleBiddingType,
          tab: 'Parameters',
        },
        {
          key: 'FlexibleBiddingThresholds',
          displayTitle: ct('FlexibleBiddingThresholds'),
          genDisplayValue: () => {
            return (
              <>
                {this.state.FlexibleBiddingThresholds.map((FlexibleBiddingThreshold) => (
                  <div>
                    <div>
                      ${flexibleBiddingTypeToString(this.state.FlexibleBiddingType)} Threshold: $
                      {FlexibleBiddingThreshold.CPMThreshold}
                    </div>
                    <div>
                      {ct('MaxTier')}: {11 - FlexibleBiddingThreshold.BidderPriority}
                    </div>
                    <div>---------</div>
                  </div>
                ))}
              </>
            );
          },
          enabled: false,
          genType: () => this.getCloneType('FlexibleBiddingThresholds'),
          defaultValue: this.state.FlexibleBiddingThresholds,
          tab: 'Parameters',
        },
      ];
      // subtier (aka subpriority) is only for samsung publisher
      if (isSuper(this.props.user.user) || isSamsungPublisher(this.props.session.publisher.ID)) {
        checkIfRowIsMarkedArr.splice(1, 0, 'SubPriority');
        changeMarkedArr.splice(1, 0, {
          key: 'SubPriority',
          displayTitle: ct('BidderSubTier'),
          genDisplayValue: () =>
            `Subtier ${convertPriorityToBidderTier(this.state.SubPriority.toString())}`,
          enabled: false,
          genType: () => this.getCloneType('SubPriority'),
          defaultValue: 10,
          tab: 'Parameters',
        });
      }
      const flexibleBiddingBiddingRow = {
        // Also the Bidder Tier Row (bidderTierRow)
        renderType: 'custom',
        customRender: this.renderFlexibleBiddingBidding,
        title1: '',
        field1: '',
        value1: this.state.Priority,
        defaultValue1: 10,
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(checkIfRowIsMarkedArr),
        handleChangeMarked: () => this.handleChangeMarked(changeMarkedArr),
      } as IInputRow;

      const keyValueParametersRow = {
        renderType: 'custom',
        customRender: this.renderKeyValueParameters,
        title1: '',
        field1: '',
        value1: this.state.keyValueParameters.length,
        defaultValue1: 0,
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['keyValueParameters']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'keyValueParameters',
              displayTitle: ct('KeyValueParameters'),
              genDisplayValue: () => JSON.stringify(this.state.keyValueParameters),
              enabled: false,
              genType: () => this.getCloneType('rootKeyValueParameters'),
              defaultValue: [] as IKeyValueParameter[],
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const rootKeyValueParametersRow = {
        renderType: 'custom',
        customRender: this.renderRootKeyValueParameters,
        title1: '',
        field1: '',
        value1: Object.keys(this.state.rootKeyValueParameters).length,
        defaultValue1: 0,
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['rootKeyValueParameters']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'rootKeyValueParameters',
              displayTitle: ct('ExtensionKeyValueParameters'),
              genDisplayValue: () => JSON.stringify(this.state.rootKeyValueParameters['']),
              enabled: false,
              genType: () => this.getCloneType('rootKeyValueParameters'),
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const dailyRequestCapRow = {
        renderType: 'NumberTextfield',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipDailyRequestCap'),
        title1: ct('DailyRequestCap'),
        field1: 'DailyRequestCap',
        value1: DailyRequestCap,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['DailyRequestCap']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'DailyRequestCap',
              displayTitle: ct('DailyRequestCap'),
              genDisplayValue: () => (this.state.DailyRequestCap || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('DailyRequestCap'),
              defaultValue: 0,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const pacingTypeRow = {
        renderType: 'custom',
        customRender: this.renderPacingType,
        title1: '',
        field1: '',
        value1: PacingType,
        defaultValue1: 1,
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['PacingType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'PacingType',
              displayTitle: ct('Pacing'),
              genDisplayValue: () =>
                (getPacingTypeOption(this.state.PacingType) || { text: '' }).text,
              enabled: false,
              genType: () => this.getCloneType('PacingType'),
              defaultValue: 1,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const inventoryTypeRow = {
        renderType: 'custom',
        customRender: (rowInfo: IInputRow) =>
          this.renderCustomRow(
            <Grid item style={{ width: 200, marginBottom: 10 }}>
              <BidderInventoryTypeSelect
                name='InventoryType'
                value={InventoryType}
                onChange={this.handleChange}
              />
            </Grid>,
            ct('InventoryType'),
            rowInfo,
          )(),
        title1: '',
        field1: '',
        value1: InventoryType,
        defaultValue1: EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_NONE,
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['InventoryType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'InventoryType',
              displayTitle: ct('InventoryType'),
              genDisplayValue: () => HeaderBidderInventoryTypesToTitleMap[this.state.InventoryType],
              enabled: false,
              genType: () => this.getCloneType('InventoryType'),
              defaultValue: EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_NONE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const fallbackAuctionParticipationEnabledRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipFallbackAuctionParticipationPercentage'),
        title1: ct('FallbackAuctionParticipation'),
        field1: 'FallbackAuctionParticipationEnabled',
        value1: FallbackAuctionParticipationEnabled === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText:
          FallbackAuctionParticipationEnabled === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('FallbackAuctionParticipationEnabled'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['FallbackAuctionParticipationEnabled']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'FallbackAuctionParticipationEnabled',
              displayTitle: ct('EnableItem', { item: ct('FallbackAuctionParticipation') }),
              genDisplayValue: () =>
                EBool.toBoolString(this.state.FallbackAuctionParticipationEnabled),
              enabled: false,
              genType: () => this.getCloneType('FallbackAuctionParticipationEnabled'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const isPublicaTagFallbackEnabledRow = {
        renderType: 'custom',
        customRender: this.renderIsPublicaTagFallbackEnabled,
        title1: '',
        field1: '',
        value1: IsPublicaTagFallbackEnabled,
        defaultValue1: PublicaTagFallbackDisabled,
        handleChange1: noopVoid,
        value2: IsFallbackBackfillEnabled,
        defaultValue2: FallbackBackfillDisabled,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'IsPublicaTagFallbackEnabled',
          'IsFallbackBackfillEnabled',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'IsPublicaTagFallbackEnabled',
              displayTitle: ct('EnableItem', { item: ct('SOVParallelAuctions') }),
              genDisplayValue: () =>
                this.state.IsPublicaTagFallbackEnabled === PublicaTagFallbackEnabled
                  ? ct('True')
                  : ct('False'),
              enabled: false,
              genType: () => this.getCloneType('IsPublicaTagFallbackEnabled'),
              defaultValue: PublicaTagFallbackDisabled,
              tab: 'Parameters',
            },
            {
              key: 'IsFallbackBackfillEnabled',
              displayTitle: ct('EnableItem', { item: ct('SOVBackfill') }),
              genDisplayValue: () =>
                this.state.IsFallbackBackfillEnabled === FallbackBackfillEnabled
                  ? ct('True')
                  : ct('False'),
              enabled: false,
              genType: () => this.getCloneType('IsFallbackBackfillEnabled'),
              defaultValue: FallbackBackfillDisabled,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const frequencyCappingRow = {
        renderType: 'custom',
        customRender: this.renderFrequencyCapping,
        title1: '',
        field1: '',
        value1: FrequencyActive,
        defaultValue1: ResourceActiveDisabled,
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'FrequencyActive',
          'FrequencyLimit',
          'frequencyLimitDuration',
          'frequencyLimitUnit',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'FrequencyActive',
              displayTitle: ct('FrequencyCapping'),
              genDisplayValue: () =>
                this.state.FrequencyActive === ResourceActiveEnabled
                  ? ct('Active')
                  : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('FrequencyActive'),
              defaultValue: ResourceActiveDisabled,
              tab: 'Parameters',
            },
            {
              key: 'FrequencyLimit',
              displayTitle: ct('FrequencyImpressionsLimit'),
              genDisplayValue: () => this.state.FrequencyLimit.toString(),
              enabled: false,
              genType: () => this.getCloneType('FrequencyLimit'),
              defaultValue: 1,
              tab: 'Parameters',
            },
            {
              key: 'frequencyLimitDuration',
              displayTitle: ct('FrequencyDuration'),
              genDisplayValue: () => this.state.frequencyLimitDuration.toString(),
              enabled: false,
              genType: () => this.getCloneType('frequencyLimitDuration'),
              defaultValue: 0,
              tab: 'Parameters',
            },
            {
              key: 'frequencyLimitUnit',
              displayTitle: ct('FrequencyUnit'),
              genDisplayValue: () => this.state.frequencyLimitUnit,
              enabled: false,
              genType: () => this.getCloneType('frequencyLimitUnit'),
              defaultValue: FrequencyLimitUnitDays,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const enableRemoveGPPFromBidRequestRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipRemoveGPP'),
        title1: ct('EnableItem', { item: ct('RemoveGPPFromBidRequest') }),
        field1: 'EnableRemoveGPPFromBidRequest',
        value1: EnableRemoveGPPFromBidRequest === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText:
          EnableRemoveGPPFromBidRequest === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('EnableRemoveGPPFromBidRequest'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['EnableRemoveGPPFromBidRequest']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnableRemoveGPPFromBidRequest',
              displayTitle: ct('EnableItem', { item: ct('RemoveGPPFromBidRequest') }),
              genDisplayValue: () => EBool.toBoolString(this.state.EnableRemoveGPPFromBidRequest),
              enabled: false,
              genType: () => this.getCloneType('EnableRemoveGPPFromBidRequest'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const enableSecondaryRequestsRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        title1: ct('EnableItem', { item: ct('SecondaryRequests') }),
        field1: 'EnableSecondaryRequests',
        value1: EnableSecondaryRequests === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: EnableSecondaryRequests === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('EnableSecondaryRequests'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['EnableSecondaryRequests']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnableSecondaryRequests',
              displayTitle: ct('EnableItem', { item: ct('SecondaryRequests') }),
              genDisplayValue: () => EBool.toBoolString(this.state.EnableSecondaryRequests),
              enabled: false,
              genType: () => this.getCloneType('EnableSecondaryRequests'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      // kenny todo make sure its enabled by publisher switch
      const enableSponsorshipModeRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        title1: ct('EnableItem', { item: ct('SponsorshipMode') }),
        field1: 'EnableSponsorshipMode',
        tooltipText: ct('BiddersTooltipEnableSponsorshipMode'),
        value1: EnableSponsorshipMode === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: EnableSponsorshipMode === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('EnableSponsorshipMode'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues as boolean,
        marked: this.checkIfRowIsMarked(['EnableSponsorshipMode']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnableSponsorshipMode',
              displayTitle: ct('EnableItem', { item: ct('SponsorshipMode') }),
              genDisplayValue: () => EBool.toBoolString(this.state.EnableSponsorshipMode),
              enabled: false,
              genType: () => this.getCloneType('EnableSponsorshipMode'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const enableYahooConnectIDRow = {
        renderType: 'SimpleSwitch',
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipEnableYahooConnectID'),
        title1: ct('EnableItem', { item: ct('YahooConnectID') }),
        field1: 'YahooConnectIDEnabled',
        value1: YahooConnectIDEnabled === EBool.EBool_TRUE,
        defaultValue1: false,
        helperText: YahooConnectIDEnabled === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
        handleChange1: () => this.handleReverseToggle('YahooConnectIDEnabled'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['YahooConnectIDEnabled']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'YahooConnectIDEnabled',
              displayTitle: ct('EnableItem', { item: ct('YahooConnectID') }),
              genDisplayValue: () => EBool.toBoolString(this.state.YahooConnectIDEnabled),
              enabled: false,
              genType: () => this.getCloneType('YahooConnectIDEnabled'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const liverampExtendedIDSettingRow = {
        renderType: 'SimpleSingleSelect',
        enableSmallRow: true,
        simpleSelectItems: generateExtendedIDOptions() || [],
        title1: ct('Liveramp'),
        field1: 'LiverampExtendedIDSetting',
        value1: this.state.LiverampExtendedIDSetting,
        defaultValue1: ExtendedIDSettingInherit,
        handleChange1: this.handleChange,
        isActiveValue1: (): boolean =>
          this.state.LiverampExtendedIDSetting !== ExtendedIDSettingInherit,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['LiverampExtendedIDSetting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'LiverampExtendedIDSetting',
              displayTitle: ct('LiverampExtendedIDSetting'),
              genDisplayValue: () => ExtendedIDsToTitleMap[this.state.LiverampExtendedIDSetting],
              enabled: false,
              genType: () => this.getCloneType('LiverampExtendedIDSetting'),
              defaultValue: ExtendedIDSettingInherit,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const uid2ExtendedIDSettingRow = {
        renderType: 'SimpleSingleSelect',
        enableSmallRow: true,
        simpleSelectItems: generateExtendedIDOptions() || [],
        title1: ct('UID20'),
        field1: 'UID2ExtendedIDSetting',
        value1: this.state.UID2ExtendedIDSetting,
        defaultValue1: ExtendedIDSettingInherit,
        handleChange1: this.handleChange,
        isActiveValue1: (): boolean =>
          this.state.UID2ExtendedIDSetting !== ExtendedIDSettingInherit,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['UID2ExtendedIDSetting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'UID2ExtendedIDSetting',
              displayTitle: ct('UID20ExtendedIDSetting'),
              genDisplayValue: () => ExtendedIDsToTitleMap[this.state.UID2ExtendedIDSetting],
              enabled: false,
              genType: () => this.getCloneType('UID2ExtendedIDSetting'),
              defaultValue: ExtendedIDSettingInherit,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const googlePairExtendedIDSettingRow = {
        renderType: 'SimpleSingleSelect',
        enableSmallRow: true,
        simpleSelectItems: generateExtendedIDOptions() || [],
        title1: ct('GooglePair'),
        field1: 'GooglePairExtendedIDSetting',
        value1: this.state.GooglePairExtendedIDSetting,
        defaultValue1: ExtendedIDSettingInherit,
        handleChange1: this.handleChange,
        isActiveValue1: (): boolean =>
          this.state.GooglePairExtendedIDSetting !== ExtendedIDSettingInherit,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['GooglePairExtendedIDSetting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'GooglePairExtendedIDSetting',
              displayTitle: ct('GooglePairExtendedIDSetting'),
              genDisplayValue: () => ExtendedIDsToTitleMap[this.state.GooglePairExtendedIDSetting],
              enabled: false,
              genType: () => this.getCloneType('GooglePairExtendedIDSetting'),
              defaultValue: ExtendedIDSettingInherit,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const showExtendedIDOptionsRow = {
        renderType: 'SimpleSwitch',
        title1: ct('BidderLevelExtendedID'),
        tooltipText: ct('BiddersTooltipBidderLevelExtendedID'),
        enableSmallRow: true,
        field1: 'showExtendedIDOptions',
        value1: this.state.showExtendedIDOptions,
        defaultValue1: false,
        isActiveValue1: () => false,
        handleChange1: (allow: boolean): void => {
          if (allow) {
            this.setState({
              showExtendedIDOptions: true,
            });
          } else {
            this.setState({
              showExtendedIDOptions: false,
              LiverampExtendedIDSetting: ExtendedIDSettingInherit,
              GooglePairExtendedIDSetting: ExtendedIDSettingInherit,
              UID2ExtendedIDSetting: ExtendedIDSettingInherit,
            });
          }
        },
      } as IInputRow;

      const showExtendedIDOptions =
        this.state.LiverampExtendedIDSetting !== ExtendedIDSettingInherit ||
        this.state.GooglePairExtendedIDSetting !== ExtendedIDSettingInherit ||
        this.state.UID2ExtendedIDSetting !== ExtendedIDSettingInherit ||
        this.state.showExtendedIDOptions;

      // CTV-383
      let fixedPriceLessThanBidFloorWarning;
      const filteredChannelListFPPC = objectFilter(this.bidderBidFloor, fixedPriceRow);
      if (Object.keys(filteredChannelListFPPC).length !== 0) {
        this.renderBidFloor(this.paramsDisabled());
        fixedPriceLessThanBidFloorWarning =
          generatePriceLessThanBidFloorWarning(filteredChannelListFPPC);
      }

      // If Extended Content IDs are enabled, override Iris Signal
      let enableIrisSignal = false;
      let enableExtendedContentIDs = false;
      for (const setting of this.state.demandSourceSettings) {
        if (setting.DemandSource === this.state.Bidder) {
          if (setting.EnableExtendedContentIDs === EBool.EBool_TRUE) {
            enableExtendedContentIDs = true;
          }
          if (setting.EnableIrisSignal === EBool.EBool_TRUE) {
            enableIrisSignal = true;
          }
        }
      }

      return (
        <Grid item style={{ paddingLeft: 80, maxWidth: '1200px' }}>
          {cloneBidderEnabled && (
            <>
              {/* Name (Clone Bidder Only) */}
              <InputRow rowInfo={NameRow} disableEdit={disableParams} />

              {/* Active Status (Clone Bidder Only) */}
              <InputRow rowInfo={ActiveRow} disableEdit={disableParams} />
            </>
          )}

          {/* Timezone */}
          <InputRow rowInfo={TimezoneRow} disableEdit={disableParams} />

          {/* Bidder Label */}
          <InputRow
            rowInfo={BidderLabelRow}
            disableEdit={disableParams || cloneBidderEnabled || !bulkUpdateEnabled}
          />

          {/* Demand Source */}
          {!bulkUpdateEnabled && (
            <InputRow rowInfo={DemandSourceRow} disableEdit={disableParams || cloneBidderEnabled} />
          )}

          {/* UI Bidder Type */}
          {[
            DemandSources.dynamicGateway,
            DemandSources.dynamicPlatformConnection,
            DemandSources.gateway,
            DemandSources.gatewayTier0,
            DemandSources.platformConnection,
            DemandSources.publica,
            DemandSources.publicaCampaign,
          ].includes(Bidder as DemandSource) && (
            <div className={classes.section}>
              <InputRow rowInfo={UIBidderTypeRow} disableEdit={disableParams} />
            </div>
          )}

          {/* Flexible Bidding Bidding aka Flexible Bidding */}
          <div>
            <InputRow rowInfo={flexibleBiddingBiddingRow} disableEdit={disableParams} />
          </div>

          {/* Podded Request */}
          {/** Podded Request Toggle for Xander (appnexus) is hidden, see BIDDERS_PODDED_REQUEST_ENABLED */}
          {BIDDERS_PODDED_REQUEST_ENABLED.includes(this.state.Bidder) &&
            !bulkUpdateEnabled &&
            !ALL_PLATFORM_CONNECTION_BIDDERS.includes(this.state.Bidder) && (
              <div>{this.renderPoddedRequest()}</div>
            )}

          {/* Podded Request Type */}
          {BIDDERS_PODDED_REQUEST_ENABLED.includes(this.state.Bidder) &&
            ORTB26_ENABLED_BIDDERS.includes(this.state.Bidder) &&
            this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive && (
              <div>{this.renderPoddedRequestType()}</div>
            )}

          {/* Multi Bid */}
          {BIDDERS_MULTI_BID_ENABLED.includes(this.state.Bidder) && !bulkUpdateEnabled && (
            <div>{this.renderMultiBid()}</div>
          )}

          {/* Bidder Parameters */}
          {!bulkUpdateEnabled && (
            <Grid style={{ width: '100%' }}>
              {this.renderParamOptions(hasRoleSuperUser(user.user), disableParams)}
            </Grid>
          )}

          {/* Key-Value parameters | Specified bidders ONLY */}
          {isKVPBidder && <InputRow rowInfo={keyValueParametersRow} disableEdit={disableParams} />}

          {/* Extended Content IDs (now includes Iris Signal) */}
          {(enableExtendedContentIDs || enableIrisSignal) &&
            this.renderExtendedContentIDVendors(enableIrisSignal, enableExtendedContentIDs)}

          {/* Root Key-Value Parameters */}
          {[DemandSources.appnexus].includes(Bidder) && (
            <InputRow rowInfo={rootKeyValueParametersRow} disableEdit={disableParams} />
          )}

          {/* Fixed Price Row */}
          {FIXED_PRICE_PLATFORM_CONNECTION_BIDDERS.includes(Bidder) && (
            <div>
              <InputRow rowInfo={fixedPriceRow} disableEdit={disableParams} />
              <div style={{ color: 'red' }}>{fixedPriceLessThanBidFloorWarning}</div>
            </div>
          )}
          {/* Bulk Update Disable-Enable Bidders */}
          {![DemandSources.publica].includes(Bidder) &&
            !cloneBidderEnabled &&
            bulkUpdateEnabled &&
            this.renderActive(disableParams)}

          {/* Buy Type */}
          {isPhiloPublisher(this.props.session.publisher.ID) &&
            ![DemandSources.publicaCampaign].includes(Bidder) &&
            this.renderBuyTypeDrowdown()}

          {/* Bid Floor */}
          {![DemandSources.publica].includes(Bidder) && this.renderBidFloor(disableParams)}

          {/* Adjustments */}
          <Grid container spacing={1} style={{ width: '100%' }}>
            {((!bulkUpdateEnabled &&
              !BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR.includes(Bidder.toLowerCase())) ||
              (bulkUpdateEnabled && !bulkUpdateIDsIncludesBidderWithoutAdjFactor)) && (
              <InputRow rowInfo={bidAdjustmentRow} disableEdit={disableParams} />
            )}
            {((!bulkUpdateEnabled &&
              !BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR.includes(Bidder.toLowerCase())) ||
              (bulkUpdateEnabled && !bulkUpdateIDsIncludesBidderWithoutAdjFactor)) && (
              <InputRow rowInfo={bidAdjustmentValueRow} disableEdit={disableParams} />
            )}
          </Grid>

          <InputRow rowInfo={dailyRequestCapRow} disableEdit={disableParams} />
          {DailyRequestCap >= 10000 && (
            <InputRow rowInfo={pacingTypeRow} disableEdit={disableParams} />
          )}

          {/* Bidder Timeout */}
          {!multiIndexBidders.includes(Bidder) && hasRoleSuperUser(this.props.user.user) && (
            <InputRow rowInfo={bidderTimeoutRow} disableEdit={disableParams} />
          )}

          {/* Tmax Offset - not available on multiIndexBidders since they have their own special timeout */}
          {!multiIndexBidders.includes(Bidder) && (
            <InputRow rowInfo={tmaxOffsetRow} disableEdit={disableParams} />
          )}

          {/* Auction Participation Percentage Row */}
          <InputRow rowInfo={auctionParticipationPercentageRow} disableEdit={disableParams} />

          {/* Share of Voice */}
          <InputRow rowInfo={shareOfVoiceRow} disableEdit={disableParams} />

          {/* Inventory Type */}
          {IsPublicaTagFallbackEnabled !== PublicaTagFallbackEnabled && (
            <InputRow rowInfo={inventoryTypeRow} disableEdit={disableParams} />
          )}

          {/* ShareOfVoice Type */}
          {IsPublicaTagFallbackEnabled !== PublicaTagFallbackEnabled &&
            BIDDERS_SHARE_OF_VOICE_TYPE_ENABLED.includes(Bidder) &&
            [
              EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_SHARED_NO_BACKFILL,
              EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_SHARED_WITH_BACKFILL,
            ].includes(this.state.InventoryType) && (
              <InputRow rowInfo={shareOfVoiceTypeRow} disableEdit={disableParams} />
            )}

          {/* fallbackAuctionParticipationEnabledRow */}
          {isPhiloFallbackEnabledPublisher(session.publisher.ID) && (
            <InputRow
              rowInfo={fallbackAuctionParticipationEnabledRow}
              disableEdit={disableParams}
            />
          )}

          {/* Publica Tag Fallback | publica only */}
          {Bidder === DemandSources.publica &&
            (hasRoleSuperUser(user.user) || session.publisher.ID === '381') && (
              <InputRow rowInfo={isPublicaTagFallbackEnabledRow} disableEdit={disableParams} />
            )}

          {/* Frequency Capping */}
          <InputRow rowInfo={frequencyCappingRow} disableEdit={disableParams} />

          {/* Unpaid Bidder */}
          <InputRow rowInfo={unpaidBidderRow} disableEdit={disableParams} />

          {/* DOOH Bidder */}
          <InputRow rowInfo={doohBidderRow} disableEdit={disableParams} />
          {hasRoleSuperUser(user.user) && (
            <InputRow rowInfo={optableEIDsRow} disableEdit={disableParams} />
          )}

          {/* Remove Fmt JSON Row | Telaria only */}
          {Bidder === DemandSources.telaria && (
            <InputRow rowInfo={removeFmtJSONRow} disableEdit={disableParams} />
          )}

          {(hasRoleSuperUser(user.user) || this.props.session.publisher.ID === '381') && (
            <InputRow rowInfo={enableRemoveGPPFromBidRequestRow} disableEdit={disableParams} />
          )}

          {(hasRoleSuperUser(user.user) || isPhiloPublisher(this.props.session.publisher.ID)) &&
            !NO_SECONDARY_REQUEST_BIDDERS.includes(Bidder) &&
            this.state.PoddedRequestActive !== HeaderBidderPoddedRequestActiveActive && (
              <InputRow rowInfo={enableSecondaryRequestsRow} disableEdit={disableParams} />
            )}

          {this.props.session.publisher.EnableSponsorshipMode === EBool.EBool_TRUE && (
            <InputRow rowInfo={enableSponsorshipModeRow} disableEdit={disableParams} />
          )}

          {Bidder === DemandSources.verizon && (
            <InputRow rowInfo={enableYahooConnectIDRow} disableEdit={disableParams} />
          )}

          <InputRow rowInfo={showExtendedIDOptionsRow} disableEdit={disableParams} />

          {showExtendedIDOptions && (
            <>
              <InputRow rowInfo={liverampExtendedIDSettingRow} disableEdit={disableParams} />
              <InputRow rowInfo={googlePairExtendedIDSettingRow} disableEdit={disableParams} />
              <InputRow rowInfo={uid2ExtendedIDSettingRow} disableEdit={disableParams} />
            </>
          )}
        </Grid>
      );
    };

    renderBulkUpdateSidebar = () => {
      const {
        bulkUpdateEnabledFields,
        bulkUpdateIDsIncludesDirectCampaign,
        bulkUpdateIDsIncludesBidderWithoutAdjFactor,
      } = this.state;
      const { classes, cloneBidderEnabled } = this.props;
      const sidebarTitleMsgs = [];
      const bulkFieldsSelected =
        Object.keys(bulkUpdateEnabledFields).filter((key1) => bulkUpdateEnabledFields[key1].enabled)
          .length > 0;

      const clonedName = this.getCloneValue('Name', 'Cloned Bidder');
      const clonedID = this.getCloneValue('ID', 'Cloned ID');

      if (!bulkFieldsSelected) {
        sidebarTitleMsgs.push('Select a field to edit.');
      }
      if (bulkUpdateIDsIncludesDirectCampaign) {
        sidebarTitleMsgs.push(
          'Targeting fields are limited since a Direct Campaign Bidder was selected.',
        );
      }
      if (bulkUpdateIDsIncludesBidderWithoutAdjFactor) {
        sidebarTitleMsgs.push(
          'Adjustment factor/value not available since a Demand Source without adjustment factors was selected.',
        );
      }
      const sidebarTitle = sidebarTitleMsgs.join(',');
      const tabName = ['Parameters', 'Targeting', 'Rewrites'][this.state.viewTabIndex];
      const tabNameToTKey: Record<string, TKey> = {
        Parameters: 'Parameters',
        Targeting: 'Targeting',
        Rewrites: 'Rewrites',
      };
      return (
        <Grid
          item
          style={{
            backgroundColor: '#F5F5F5',
            width: '100%',
            height: '100%',
            padding: '16px 16px 96px',
          }}
        >
          <Typography className={classes.headingCategoryTitle}>{ct('Summary')}</Typography>
          {cloneBidderEnabled ? (
            <>
              <Typography className={classes.headingCategorySubTitle}>
                {ct('CloneItem', { item: ct('Bidder') })}:
              </Typography>
              <Typography className={classes.insideAccordionText}>
                {`${clonedName} [${clonedID}]`}
              </Typography>
              <Typography className={classes.headingCategorySubTitle}>
                {ct(tabNameToTKey[tabName])}
              </Typography>
              <Grid container direction='column' alignItems='flex-start' spacing={1}>
                {Object.keys(bulkUpdateEnabledFields)
                  .filter(
                    (key1) =>
                      bulkUpdateEnabledFields[key1].enabled &&
                      bulkUpdateEnabledFields[key1].tab === tabName,
                  )
                  .sort((key1, key2) =>
                    bulkUpdateEnabledFields[key1].displayTitle.toLowerCase() >
                    bulkUpdateEnabledFields[key2].displayTitle.toLowerCase()
                      ? 1
                      : -1,
                  )
                  .map((key2) => {
                    const item = bulkUpdateEnabledFields[key2];
                    const type = item.genType ? item.genType() : CloneType.UNKNOWN;
                    return (
                      <Grid item container direction='row' alignItems='center' spacing={1}>
                        <Grid item xs={1}>
                          <Checkbox
                            className={classes.checkbox}
                            checked={true}
                            onChange={() => this.handleDisableMarkedForBulkUpdate(key2)}
                          />
                        </Grid>
                        <Grid item xs={1} />
                        <Grid item xs={3}>
                          <Typography className={classes.insideAccordionTextBold}>
                            {item.displayTitle + ':'}
                          </Typography>
                        </Grid>
                        <Grid item xs={1}>
                          {type === CloneType.NEW && (
                            <Avatar
                              variant='rounded'
                              style={{
                                backgroundColor: '#80e8e0',
                                fontSize: 15,
                                fontWeight: 'bold',
                                height: '17px',
                                width: '17px',
                              }}
                            >
                              {type}
                            </Avatar>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <Typography className={classes.insideAccordionText}>
                            {item.genDisplayValue()}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
            </>
          ) : (
            <>
              <Typography className={classes.insideAccordionText}>
                {ct('CurrentEditsWillImpactTheFollowing')}:
              </Typography>
              <Typography className={classes.headingCategorySubTitle}>{ct('Bidders')}</Typography>
              <Typography className={classes.insideAccordionText}>
                {ct('NumSelected', { count: this.props.bulkUpdateIDs.length })}
              </Typography>
              <Typography className={classes.headingCategorySubTitle}>
                {ct('ActiveFields')}
              </Typography>
              <Typography className={classes.insideAccordionText}>{sidebarTitle}</Typography>
              <Grid container direction='column' alignItems='flex-start' spacing={1}>
                {Object.keys(bulkUpdateEnabledFields)
                  .filter((key1) => bulkUpdateEnabledFields[key1].enabled)
                  .map((key2) => {
                    const item = bulkUpdateEnabledFields[key2];
                    return (
                      <Grid item container direction='row' alignItems='center' spacing={1}>
                        <Grid item xs={1}>
                          <Checkbox
                            className={classes.checkbox}
                            checked={true}
                            onChange={() => this.handleDisableMarkedForBulkUpdate(key2)}
                          />
                        </Grid>
                        <Grid item xs={1} />
                        <Grid item xs={6}>
                          <Typography className={classes.insideAccordionTextBold}>
                            {item.displayTitle + ':'}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className={classes.insideAccordionText}>
                            {item.genDisplayValue()}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
            </>
          )}
        </Grid>
      );
    };

    // renderCustomToolbar renders the toolbar at the top of the list table
    renderCustomToolbar = (props: any): ReactElement => {
      const { classes } = this.props;
      const { updatingCountryGroup } = this.state;

      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '300px' },
      };

      return (
        <Grid item className={classes.toolbarRow}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid item>
              <MTableToolbar {...copyProps} />
            </Grid>
            <RowButton
              right={
                <ButtonView
                  onClick={() => {
                    this.setState({
                      openRegionSelectTable: false,
                      openRegionCreateEditDialog: true,
                    });
                  }}
                  text={ct('CreateItem', { item: ct('Region') })}
                  active={updatingCountryGroup}
                />
              }
            />
          </Grid>
        </Grid>
      );
    };

    renderRegionListTableDialog = () => {
      const { user } = this.props;
      const { publisherCountryGroups, updatingCountryGroup } = this.state;

      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: ct('RegionName'),
          renderType: 'modal3',
          searchable: true,
          maxWidth: '200px',
        },
        {
          field: 'CountriesTargeted',
          title: ct('CountriesTargeted'),
          renderType: 'normal',
          searchable: false,
          maxWidth: '100px',
        },
        { field: 'Actions', title: ct('Actions'), renderType: 'delete', searchable: false },
      ];

      const listTableData: ICountryGroupRowData[] = publisherCountryGroups.map(
        (countryGroup: ICountryGroup) => {
          const countryGroupName = checkUserInfoMasked(user.user)
            ? `demo_site_${countryGroup.ID}`
            : countryGroup.Name;
          return {
            ID: countryGroup.ID.toString(),
            Name: countryGroupName,
            CountriesTargeted:
              (countryGroup.CountryIsos && countryGroup.CountryIsos.split(',').length) || 0,
          };
        },
      );

      return (
        <Grid item style={{ margin: '20px 15px 5px 15px', width: '97%' }}>
          <ListTable
            title={''}
            columns={listTableColumns}
            data={listTableData}
            isUpdating={updatingCountryGroup}
            handleSetUpdating={this.handleSetUpdatingCountryGroup}
            handleDeleteItem={(countryGroupID: string) =>
              this.deleteCountryGroupFunc(countryGroupID, true)
            }
            handleOpenModal3={this.handleOpenRegionSelectDialog}
            fixedEnabled={true}
            renderCustomToolbar={this.renderCustomToolbar}
            pageSize={10}
            readRoleName={'read_channel'}
            writeRoleName={'write_channel'}
          />
        </Grid>
      );
    };

    renderCreateEditRegionDialog = () => {
      const { classes, session, user } = this.props;
      const {
        createEditRegionID,
        createEditRegionList,
        createEditRegionName,
        errors,
        openRegionCreateEditDialog,
        commonRegionGroups,
      } = this.state;
      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);

      const onCloseFn = (reloadBidder: boolean, redirectToAllRegions?: boolean) => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadBidder ? this.getCountryGroupsByPublisherID : undefined,
        );
      };

      const newCountryIsos = Object.keys(createEditRegionList).filter(
        (key) => createEditRegionList[key].selected,
      );
      const newCountryGroup = {
        CountryIsos: newCountryIsos.map((countryIso) => countryIso.toUpperCase()).join(','),
        Name: createEditRegionName,
        PublisherID: parseInt(session.publisher.ID, 10),
      } as ICountryGroup;

      // clicking on pre-selectable common region selects all default countries in that region
      const onCommonRegionClick = (countryGroup: ICountryGroup) => {
        this.setState({
          createEditRegionList: generateCountryMenuListFromIsos(
            countryGroup.CountryIsos.split(','),
          ),
          createEditRegionName: countryGroup.Name,
        });
      };

      return openRegionCreateEditDialog ? (
        <Grid item style={{ width: '100%' }}>
          <Dialog
            fullWidth
            maxWidth='sm'
            keepMounted
            open={openRegionCreateEditDialog}
            onClose={() => onCloseFn(false, false)}
          >
            <Grid item style={{ width: '100%' }}>
              <Typography
                className={classes.parameterHeaders}
                style={{ marginTop: 30, fontSize: 20 }}
              >
                {!createEditRegionID
                  ? ct('CreateNewItem', { item: ct('Region') })
                  : ct('EditItem', { item: ct('Region') })}
              </Typography>
              <Grid item style={{ marginLeft: 50 }}>
                <TextField
                  label={ct('RegionName')}
                  name='createEditRegionName'
                  value={createEditRegionName}
                  onChange={this.handleChange}
                  error={!!errors.createEditRegionName}
                  helperText={errors.createEditRegionName}
                />
                <Grid>
                  {(commonRegionGroups || []).map((countryGroup: ICountryGroup) => {
                    return (
                      <Button
                        key={countryGroup.ID}
                        style={{ marginTop: 10 }}
                        onClick={() => onCommonRegionClick(countryGroup)}
                      >
                        {countryGroup.Name}
                      </Button>
                    );
                  })}
                </Grid>
              </Grid>

              <Divider style={{ margin: 10, height: 1, color: 'black' }} />

              <Typography className={classes.headingCategorySubtitle} style={{ paddingLeft: 50 }}>
                {ct('SelectCountriesToIncludeInRegion')}
              </Typography>
              <Grid item style={{ marginLeft: 50, height: 500 }}>
                <MaterialSearchDropdownMulti
                  forceOpen={true}
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  fontSize='14px'
                  selectAll={true}
                  menuTitle={''}
                  list={createEditRegionList}
                  disabled={!writeAuthorization.isAuthorized}
                  onChange={this.handleChangeList('createEditRegionList')}
                  handleMenuAcceptClick={() => null}
                  isNoneSelectedAllSelected={true}
                  keepDropdownOpen={true}
                />
              </Grid>
              <DialogActions>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => {
                    const regionValidationErrors = this.findErrors(
                      this.state,
                      regionValidationSetting,
                    );
                    if (hasErrors(regionValidationErrors)) {
                      const errorText = Object.values(errors)
                        .filter((value) => value.length)
                        .join('. ');
                      this.setState(
                        {
                          errors: regionValidationErrors,
                          snackbarMessage: ct(
                            'SnackbarPleaseFixErrorsBeforeSavingItemWithReasons',
                            {
                              item: ct('Region'),
                              text: errorText,
                            },
                          ),
                          snackbarError: true,
                        },
                        () => {
                          setTimeout(() => {
                            this.setState({
                              errors: {} as IErrors,
                            });
                            this.snackbarClose();
                          }, 6000);
                        },
                      );
                      return;
                    }

                    if (!createEditRegionID) {
                      createCountryGroup(newCountryGroup).then(() => {
                        this.setState({
                          snackbarError: false,
                          snackbarMessage: ct('SnackbarSuccessfullyCreatedItem', {
                            item: ct('Region'),
                          }),
                        });
                        onCloseFn(true, false);
                      });
                    } else {
                      newCountryGroup.ID = parseInt(createEditRegionID, 10);
                      this.setState(
                        {
                          updatingCountryGroup: true,
                        },
                        () => {
                          updateCountryGroup(newCountryGroup).then(() => {
                            this.setState(
                              {
                                snackbarError: false,
                                snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', {
                                  item: ct('Region'),
                                }),
                                updatingCountryGroup: false,
                              },
                              this.getBidder,
                            );
                            onCloseFn(true, false);
                          });
                        },
                      );
                    }
                  }}
                >
                  {ct('Save')}
                </Button>
                <Button autoFocus color='primary' onClick={() => onCloseFn(false, true)}>
                  {ct('Cancel')}
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      ) : null;
    };

    renderAllRegionsDialog = (regionRow: IInputRow) => {
      const { user } = this.props;
      const { openRegionSelectTable } = this.state;

      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);

      const onCloseFn = (reloadBidder: boolean, redirectToAllRegions?: boolean) => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadBidder ? this.getCountryGroupsByPublisherID : undefined,
        );
      };

      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={regionRow} disableEdit={!writeAuthorization.isAuthorized} />
          {openRegionSelectTable ? (
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={openRegionSelectTable}
              onClose={() => this.setState({ openRegionSelectTable: false })}
            >
              {this.renderRegionListTableDialog()}
              <DialogActions>
                <Button autoFocus color='primary' onClick={() => onCloseFn(false, false)}>
                  {ct('Close')}
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            this.renderCreateEditRegionDialog()
          )}
        </Grid>
      );
    };

    renderChannelCreateList = () => {
      const {
        openChannelListDialog,
        channelListName,
        channelListCGL,
        channelListCL,
        ChannelListChannelsIDS,
        ChannelListGroupsIDS,
      } = this.state;
      const { classes } = this.props;

      const onCloseFn = (openDialog?: boolean) => {
        this.handleCloseChannelList();
        this.setState({
          openRegionCreateEditDialog: false,
          openChannelListDialog: !!openDialog,
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = this.findErrors(this.state, channelListValidationSetting);
        // Check channel targeting and ensure a channel or channel group is selected
        if (
          (ChannelListChannelsIDS === undefined && ChannelListGroupsIDS === undefined) ||
          (ChannelListChannelsIDS === '' && ChannelListGroupsIDS === '')
        ) {
          // If no channel ids, adds appropriate error text to errors
          errors.ChannelIds = ct('NoticeSelectAtLeastOneChannelOrChannelGroup');
        }

        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
                item: ct('ChannelList'),
                text: errorText,
              }),
              snackbarError: true,
            },
            () => {
              setTimeout(this.snackbarClose, 5000);
            },
          );
          return;
        }
        this.handleChangeChannelList(channelListName, ChannelListChannelsIDS, ChannelListGroupsIDS);
        this.cleanChannelListsGroupsandChannels();
        this.setState({
          openRegionCreateEditDialog: false,
          openChannelListDialog: !!openDialog,
        });
      };

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: ct('Name'),
        field1: 'ChannelListName',
        value1: channelListName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;
      const ListChannelRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: ct('Channels'),
        value1: channelListCL,
        defaultValue1: false,
        handleChange1: this.handleChangeList('channelListCL'),
        handleAccept1: this.handleChannelListChannelsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                count: ChannelListChannelsIDS.length,
                label: ct('Channels'),
              })
            : ct('AllItems', { item: ct('Channels') }),
        materialDropdownShowPrefixID: true,
      } as IInputRow;
      const ListChannelGroupRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: ct('ChannelGroups'),
        value1: channelListCGL,
        defaultValue1: false,
        handleChange1: this.handleChangeList('channelListCGL'),
        handleAccept1: this.handleChannelListGroupsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                count: ChannelListGroupsIDS.length,
                label: ct('ChannelGroups'),
              })
            : ct('AllItems', { item: ct('ChannelGroups') }),
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openChannelListDialog}
          onClose={() => this.setState({ openChannelListDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>
            {ct('CreateItem', { item: ct('ChannelList') })}
          </DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section} style={{ paddingBottom: 10 }}>
              <InputRow rowInfo={NameRow} disableEdit={false} />
            </Grid>
            <Grid className={classes.section} style={{ paddingBottom: 10 }}>
              <InputRow rowInfo={ListChannelRow} disableEdit={false} />
            </Grid>
            <Grid className={classes.section} style={{ paddingBottom: 400 }}>
              <InputRow rowInfo={ListChannelGroupRow} disableEdit={false} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              {ct('Cancel')}
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              {ct('Save')}
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderChannelEditList = () => {
      const {
        openChannelListEditDialog,
        editChannelListName,
        EditChannelListChannelsIDS,
        EditChannelListGroupsIDS,
        editChannelListsList,
        editChannelListID,
      } = this.state;
      const { classes } = this.props;
      const onCloseFn = (openDialog?: boolean) => {
        this.cleanEditChannelLists();
        this.setState({
          openChannelListEditDialog: !!openDialog,
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = this.findErrors(this.state, channelEditListValidationSetting);
        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
                item: ct('ChannelList'),
                text: errorText,
              }),
              snackbarError: true,
            },
            () => {
              setTimeout(this.snackbarClose, 5000);
            },
          );
          return;
        }
        this.handleEditChannelList(
          editChannelListID,
          editChannelListName,
          EditChannelListChannelsIDS,
          EditChannelListGroupsIDS,
        );
        this.setState({
          openChannelListEditDialog: !!openDialog,
        });
      };

      const ChannelListRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: ct('ChannelList'),
        value1: editChannelListsList,
        defaultValue1: false,
        handleChange1: this.handleChangeList('editChannelListsList'),
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                count: editChannelListID.length,
                label: ct('Channels'),
              })
            : ct('AllItems', { item: ct('Channels') }),
        materialDropdownShowPrefixID: true,
        materialDropdownEnableMultiSelect: false,
        disableSelectAll: true,
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openChannelListEditDialog}
          onClose={() => this.setState({ openChannelListEditDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>
            {ct('EditItem', { item: ct('ChannelList') })}
          </DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section} style={{ paddingBottom: 10 }}>
              <InputRow rowInfo={ChannelListRow} disableEdit={false} />
            </Grid>
            {this.state.editChannelListID !== 0 ? (
              this.loadSelectedEditChannelList()
            ) : (
              <Grid style={{ paddingBottom: 480 }} />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              {ct('Cancel')}
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              {ct('Save')}
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    loadSelectedEditChannelList = () => {
      const {
        editChannelListCGL,
        editChannelListCL,
        ChannelListChannelsIDS,
        ChannelListGroupsIDS,
        editChannelListName,
      } = this.state;
      const { classes } = this.props;

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: ct('Name'),
        field1: 'editChannelListName',
        value1: editChannelListName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;
      const ListChannelRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: ct('Channels'),
        value1: editChannelListCL,
        defaultValue1: false,
        handleChange1: this.handleChangeList('editChannelListCL'),
        handleAccept1: this.handleEditChannelListChannelsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                count: ChannelListChannelsIDS.length,
                label: ct('Channels'),
              })
            : ct('AllItems', { item: ct('Channels') }),
        materialDropdownShowPrefixID: true,
      } as IInputRow;
      const ListChannelGroupRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: ct('ChannelGroups'),
        value1: editChannelListCGL,
        defaultValue1: false,
        handleChange1: this.handleChangeList('editChannelListCGL'),
        handleAccept1: this.handleEditChannelListGroupsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                count: ChannelListGroupsIDS.length,
                label: ct('ChannelGroups'),
              })
            : ct('AllItems', { item: ct('ChannelGroups') }),
      } as IInputRow;

      return (
        <Grid>
          <Grid className={classes.section} style={{ paddingBottom: 10 }}>
            <InputRow rowInfo={NameRow} disableEdit={false} />
          </Grid>
          <Grid className={classes.section} style={{ paddingBottom: 10 }}>
            <InputRow rowInfo={ListChannelRow} disableEdit={false} />
          </Grid>
          <Grid className={classes.section} style={{ paddingBottom: 300 }}>
            <InputRow rowInfo={ListChannelGroupRow} disableEdit={false} />
          </Grid>
        </Grid>
      );
    };

    renderChannelListDialog = (channelListRow: IInputRow) => {
      const { user } = this.props;
      const { openChannelListDialog, openChannelListEditDialog } = this.state;
      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);

      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={channelListRow} disableEdit={!writeAuthorization.isAuthorized} />
          {openChannelListDialog && this.renderChannelCreateList()}
          {openChannelListEditDialog && this.renderChannelEditList()}
        </Grid>
      );
    };

    handleCloseChannelList = () => {
      const { channelLists, newChannelListActive } = this.state;

      // if this is a new channel list, if we close editor and don't save, filter it out
      let clonedChannelLists = cloneDeep(channelLists);
      if (newChannelListActive) {
        clonedChannelLists = clonedChannelLists.filter((channelList) => channelList.ID !== 0);
      }
      this.setState({
        selectedChannelIDs: [] as string[],
        newChannelListActive: false,
        channelLists: clonedChannelLists,
        selectedChannelListLabels: [],
        listSettingsDialogActive: false,
        listSettingsDialogID: 0,
      });
    };

    addChannelList = () => {
      const { session } = this.props;
      // push an empty channel group to state
      this.setState(
        {
          channelLists: update(this.state.channelLists, {
            $push: [
              {
                PublisherID: session.publisher.ID,
                ID: 0,
                Name: '',
                ChannelIDs: [],
                ChannelGroupIDs: [],
                ChannelListIsAllowed: 1,
              },
            ],
          }),
        },
        () => {
          this.setState({
            newChannelListActive: true, // boolean to determine if channel group is being created
            listSettingsDialogActive: true, // boolean to determine if the channel group dialog is opened
            listSettingsDialogID: 0, // integer ID to determine what info to show in the dialog
          });
        },
      );

      return Promise.resolve();
    };

    cleanChannelListsGroupsandChannels = () => {
      const channelListCGL: IMenuList = this.state.channelListCGL;
      const channelListCL: IMenuList = this.state.channelListCL;
      Object.values(this.state.channelListCL).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          channelListCL[listItem.ID].selected = false;
        }
      });
      Object.values(this.state.channelListCGL).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          channelListCGL[listItem.ID].selected = false;
        }
      });
      this.setState({
        channelListCL,
        channelListCGL,
        ChannelListChannelsIDS: [],
        ChannelListGroupsIDS: [],
        channelListName: '',
      });
    };

    cleanEditChannelLists = () => {
      const editChannelListsList: IMenuList = cloneDeep(this.state.channelListsList);
      Object.values(editChannelListsList).forEach((listItem: IListItem) => {
        editChannelListsList[listItem.ID].selected = false;
      });
      Object.values(this.state.editChannelListCL).forEach((listItem: IListItem) => {
        listItem.selected = false;
      });
      Object.values(this.state.editChannelListCGL).forEach((listItem: IListItem) => {
        listItem.selected = false;
      });
      this.setState({
        editChannelListsList,
        editChannelListID: 0,
      });
    };

    handleChangeChannelList = (name: string, channelIDs: string, channelGroupIDs: string) => {
      const { channelLists, listSettingsDialogID } = this.state;

      const clonedChannelLists = cloneDeep(channelLists);
      const foundChannelList = clonedChannelLists.find(
        (channelList: IChannelList) =>
          channelList.ID.toString() === listSettingsDialogID.toString(),
      );
      if (foundChannelList) {
        foundChannelList.Name = name;
        foundChannelList.ChannelIDs = channelIDs;
        foundChannelList.ChannelGroupIDs = channelGroupIDs;

        this.setState(
          {
            channelLists: clonedChannelLists,
            updatingChannelLists: true,
          },
          () => {
            // create a new channel list
            createChannelList(foundChannelList).then((response: any[]) => {
              const [channelList, err] = response;
              const newCreatedChannelListID = response[0].ID;
              if (err) {
                this.setState({
                  channelLists: clonedChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: ct('SnackbarFailedToCreateItem', {
                    item: ct('ChannelList'),
                  }),
                  snackbarError: true,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
              } else {
                const updatedChannelLists = cloneDeep(this.state.channelLists);
                channelList.SitesInfo = this.getSitesInfoForChannelList(channelList);
                updatedChannelLists.push(channelList);
                this.setState({
                  channelLists: updatedChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: ct('SnackbarSuccessfullySavedItem', {
                    item: ct('ChannelList'),
                  }),
                  snackbarError: false,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
                this.genChannelLists(true, newCreatedChannelListID);
              }
            });
          },
        );
      }
    };

    handleEditChannelList = (
      channelListID: number,
      name: string,
      channelIDs: string,
      channelGroupIDs: string,
    ) => {
      const { channelLists } = this.state;

      const clonedChannelLists = cloneDeep(channelLists);
      const foundChannelList = clonedChannelLists.find(
        (channelList) => channelList.ID.toString() === channelListID.toString(),
      );
      if (foundChannelList) {
        foundChannelList.Name = name;
        foundChannelList.ChannelIDs = channelIDs;
        foundChannelList.ChannelGroupIDs = channelGroupIDs;

        this.setState(
          {
            channelLists: clonedChannelLists,
            updatingChannelLists: true,
          },
          () => {
            // update the existing channel list
            updateChannelList(foundChannelList).then((response: any[]) => {
              const [channelList, err] = response;
              if (err) {
                this.setState({
                  channelLists: clonedChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: ct('SnackbarFailedToUpdateItem', {
                    item: ct('ChannelList'),
                  }),
                  snackbarError: true,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
              } else {
                const sessionChannelLists = cloneDeep(this.state.channelLists);
                for (let idx = 0; idx < sessionChannelLists.length; idx++) {
                  if (sessionChannelLists[idx].ID === foundChannelList.ID) {
                    channelList.SitesInfo = this.getSitesInfoForChannelList(channelList);
                    sessionChannelLists[idx] = channelList;
                    break;
                  }
                }
                this.setState({
                  isWaitingToUpdateSmartFloorConfig: this.state.isSmartFloorActive,
                  isChannelListDetailUpdated: this.state.isSmartFloorActive,
                  channelLists: sessionChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', {
                    item: ct('ChannelList'),
                  }),
                  snackbarError: false,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
                this.genChannelLists();
              }
            });
          },
        );
      }
    };

    renderDataSharing = () => {
      const { classes } = this.props;
      const disableParams = this.paramsDisabled();
      const { IASDataSharing, DoubleVerifyDataSharing } = this.state;

      const iasDataSharingRow = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems: getThirdPartyDataSharingItems(),
        title1: ct('PostBidAdvertiserReportingIAS'),
        field1: 'IASDataSharing',
        tooltipText: ct('BiddersTooltipPostBidAdvertiserReportingIAS'),
        value1: IASDataSharing || [],
        handleChange1: this.handleChangeMultiSelect,
        isActiveValue1: () => !!IASDataSharing,
      } as IInputRow;

      const doubleVerifyDataSharingRow = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems: getThirdPartyDataSharingItems(),
        title1: ct('PostBidAdvertiserReportingDoubleVerify'),
        field1: 'DoubleVerifyDataSharing',
        tooltipText: ct('BiddersTooltipPostBidAdvertiserReportingDoubleVerify'),
        value1: DoubleVerifyDataSharing || [],
        handleChange1: this.handleChangeMultiSelect,
        isActiveValue1: () => !!DoubleVerifyDataSharing,
      } as IInputRow;

      const dataSharingRows = [iasDataSharingRow, doubleVerifyDataSharingRow];

      return (
        <Grid item style={{ maxWidth: 1200, marginTop: 20 }}>
          {/* Header */}
          <Typography className={classes.parameterHeaders}>{ct('DataSharing')}</Typography>
          <Typography className={classes.headingCategorySubtitle} style={{ paddingLeft: 50 }}>
            {ct('BiddersMessageDataSharing')}
          </Typography>
          <Grid container direction='column' style={{ paddingLeft: 80, paddingBottom: 50 }}>
            {dataSharingRows.map((dataShareRow) => (
              <InputRow rowInfo={dataShareRow} disableEdit={disableParams} />
            ))}
          </Grid>
        </Grid>
      );
    };

    handleApplySelectedPresets = (presetIDs: Set<number>) => {
      this.setState({
        PresetIDs: Array.from(presetIDs),
      });
    };

    generateCustomTargetingPayload = () => {
      const selectedCountryGroupItems = Object.values(this.state.targetingCountryGroupList).filter(
        (item) => item.selected,
      );
      const selectedCountryGroupIDs = selectedCountryGroupItems.map((item) => item.ID).join(',');
      const isCountryExcluded = this.state.deviceTargetingCountrySelectMode === SelectMode.Denylist;
      const customTargeting: ITargetingPresetVars = {
        // CONTENT
        TargetingContentChannel: this.state.TargetingContentChannel,
        TargetingContentChannelIsAllowed: this.state.TargetingContentChannelIsAllowed,
        TargetingContentDistributor: this.state.TargetingContentDistributor,
        TargetingContentDistributorIsAllowed: this.state.TargetingContentDistributorIsAllowed,
        TargetingContentGenre: this.state.TargetingContentGenre,
        TargetingContentGenreIsAllowed: this.state.TargetingContentGenreIsAllowed,
        TargetingContentID: this.state.TargetingContentID,
        TargetingContentIDIsAllowed: this.state.TargetingContentIDIsAllowed,
        TargetingContentNetwork: this.state.TargetingContentNetwork,
        TargetingContentNetworkIsAllowed: this.state.TargetingContentNetworkIsAllowed,
        TargetingContentProducer: this.state.TargetingContentProducer,
        TargetingContentProducerIsAllowed: this.state.TargetingContentProducerIsAllowed,
        TargetingContentRating: this.state.TargetingContentRating,
        TargetingContentRatingIsAllowed: this.state.TargetingContentRatingIsAllowed,
        TargetingContentSeries: this.state.TargetingContentSeries,
        TargetingContentSeriesIsAllowed: this.state.TargetingContentSeriesIsAllowed,
        TargetingContentTitle: this.state.TargetingContentTitle,
        TargetingContentTitleIsAllowed: this.state.TargetingContentTitleIsAllowed,
        TargetingContentCategory: this.state.TargetingContentCategory,
        TargetingContentCategoryIsAllowed: this.state.TargetingContentCategoryIsAllowed,
        TargetingContentLanguage: this.state.TargetingContentLanguage,
        TargetingContentLanguageIsAllowed: this.state.TargetingContentLanguageIsAllowed,
        // GEO
        TargetingCountryGroupIDs: convertIDStringToNumberArray(selectedCountryGroupIDs),
        TargetingCountryGroupIDsIsAllowed: this.state.TargetingCountryGroupIDsIsAllowed,
        TargetingDeviceCountry: Object.values(this.state.targetingCountriesList)
          .filter((item: IListItem) => item.selected)
          .map((item: IListItem) => item.ID.toUpperCase())
          .join(','),
        TargetingDeviceCountryIsAllowed: isCountryExcluded ? EAllowStatus.DENY : EAllowStatus.ALLOW,
        LocalTargetingAllowed: this.state.LocalTargetingIsAllowed
          ? this.exportLocalTargetingParamToJSON()
          : '',
        LocalTargetingAllowedLogic: this.state.LocalTargetingIsAllowed
          ? this.state.LocalTargetingLogic
          : ELogicalOperator.OR,
        LocalTargetingDisallowed: !this.state.LocalTargetingIsAllowed
          ? this.exportLocalTargetingParamToJSON()
          : '',
        LocalTargetingDisallowedLogic: !this.state.LocalTargetingIsAllowed
          ? this.state.LocalTargetingLogic
          : ELogicalOperator.OR,
        // DAYPARTING
        Dayparting: this.state.Dayparting,
        DaypartingIsAllowed: this.state.DaypartingIsAllowed,
        // PRIVACY
        TargetingCoppa: this.state.TargetingCoppa,
        TargetingLimitedAdTracking: this.state.TargetingLimitedAdTracking,
        TargetingCCPA: this.state.TargetingCCPA,
        TargetingGDPR: this.state.TargetingGDPR,
        TargetingGDPRConsent: this.state.TargetingGDPRConsent,
        TargetingDeviceIDType: this.state.TargetingDeviceIDType,
        // CUSTOM
        Custom4: this.state.Custom4,
        Custom4Inclusion: this.state.Custom4Inclusion,
        Custom5: this.state.Custom5,
        Custom5Inclusion: this.state.Custom5Inclusion,
        Custom6: this.state.Custom6,
        Custom6Inclusion: this.state.Custom6Inclusion,
        Custom7: this.state.Custom7,
        Custom7Inclusion: this.state.Custom7Inclusion,
        Custom8: this.state.Custom8,
        Custom8Inclusion: this.state.Custom8Inclusion,
        Custom9: this.state.Custom9,
        Custom9Inclusion: this.state.Custom9Inclusion,
        Custom10: this.state.Custom10,
        Custom10Inclusion: this.state.Custom10Inclusion,
        Custom11: this.state.Custom11,
        Custom11Inclusion: this.state.Custom11Inclusion,
        Custom12: this.state.Custom12,
        Custom12Inclusion: this.state.Custom12Inclusion,
        Custom13: this.state.Custom13,
        Custom13Inclusion: this.state.Custom13Inclusion,
        Custom14: this.state.Custom14,
        Custom14Inclusion: this.state.Custom14Inclusion,
        Custom15: this.state.Custom15,
        Custom15Inclusion: this.state.Custom15Inclusion,
        Custom16: this.state.Custom16,
        Custom16Inclusion: this.state.Custom16Inclusion,
        Custom17: this.state.Custom17,
        Custom17Inclusion: this.state.Custom17Inclusion,
        Custom18: this.state.Custom18,
        Custom18Inclusion: this.state.Custom18Inclusion,
        CustomTargeting: this.state.CustomTargeting,
        CustomTargetingInclusion: this.state.CustomTargetingInclusion,
        // DEVICE
        TargetingDevices: this.state.TargetingDevices,
        TargetingDevicesIsAllowed: this.state.TargetingDevicesIsAllowed,
        TargetingDeviceTypes: this.state.TargetingDeviceTypes,
        TargetingDeviceTypesIsAllowed: this.state.TargetingDeviceTypesIsAllowed,
        TargetingDeviceSubTypes: this.state.TargetingDeviceSubTypes,
        TargetingDeviceSubTypesIsAllowed: this.state.TargetingDeviceSubTypesIsAllowed,
        TargetingDeviceModels: this.state.TargetingDeviceModels,
        TargetingDeviceModelsIsAllowed: this.state.TargetingDeviceModelsIsAllowed,
        IPFilter: this.state.IPFilter,
        // APP
        TargetingAppBundleID: this.state.TargetingAppBundleID,
        TargetingAppBundleIDIsAllowed: this.state.TargetingAppBundleIDIsAllowed,
        TargetingAppBundleSitePagesLogic: this.state.TargetingAppBundleSitePagesLogic,
        // DEALS
        TargetingDealID: this.state.TargetingDealID,
        TargetingDealIDIsAllowed: this.state.TargetingDealIDIsAllowed as number,
        TargetingFWSectionIDs: this.state.TargetingFWSectionIDs,
        TargetingFWSectionIDsIsAllowed: this.state.TargetingFWSectionIDsIsAllowed,
        // STREAM
        TargetingLivestream: this.state.LivestreamTargeting,
        // SEGMENTS
        TargetingAudienceSegmentIDs: convertIDStringToNumberArray(
          this.state.TargetingAudienceSegmentID,
        ),
        TargetingAudienceSegmentIDsIsAllowed: this.state.TargetingAudienceSegmentIDIsAllowed,
        SegmentTargeting: this.state.SegmentTargeting,
        TargetingContextualSegmentIDs: this.state.ContextualSegmentIDS,
        // SITE PAGES
        TargetingSitePages: this.state.TargetingSitePages,
        TargetingSitePagesIsAllowed: this.state.TargetingSitePagesIsAllowed,
        // SITE DOMAINS
        TargetingSiteDomain: this.state.TargetingSiteDomain,
        TargetingSiteDomainIsAllowed: this.state.TargetingSiteDomainIsAllowed,
        // EXTENDED IDS
        TargetingUID20TargetingType: this.state.TargetingUID20TargetingType,
        TargetingGooglePairIDTargetingType: this.state.TargetingGooglePairIDTargetingType,
        TargetingLiveRampATSTargetingType: this.state.TargetingLiveRampATSTargetingType,
        TargetingIrisSignalTargetingType: this.state.TargetingIrisSignalTargetingType,
        // TargetingSamsungIdentityTargetingType: this.state.TargetingSamsungIdentityTargetingType,
        // TargetingSamsungEPGMetadataTargetingType:
        //   this.state.TargetingSamsungEPGMetadataTargetingType,
      };
      return customTargeting;
    };

    handleApplyAuctionInsightsDatesChange = ({ newStartDate, newEndDate }: INewCalDates): void => {
      this.setState({
        auctionInsightsCalStartDate: newStartDate.clone().startOf('day'),
        auctionInsightsCalEndDate: newEndDate.clone().endOf('day').hours(23).minutes(0).seconds(0),
      });
      track(
        'Bidder Auction Insights - Dates Changed',
        { isSuperUser: hasRoleSuperUser(this.props.user.user) },
        this.props.user.user,
        PUB_OPS_TEAM_IDS,
      );
    };

    render() {
      const { bulkUpdateIDs, classes, existing, user, session, location } = this.props;
      const { pathname } = location;
      const { abTests, loaded, snackbarError, snackbarMessage, triggerTestLaunch, viewTabIndex } =
        this.state;
      const { AddEditBuyTypeModelActive, buyTypeUpdateCounter } = this.state;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      const readAuthorization = IS_AUTHORIZED(['read_bidder'], user.user);
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      let currentABTest;
      let pastABTests;
      if (existing) {
        currentABTest = abTests.filter((test) => {
          return test.Active === ABTestingActiveActive;
        })[0];
        pastABTests = abTests.filter((test) => {
          return test.Active === ABTestingActiveInactive;
        });
      }

      let canDisplay: boolean;
      let hasRight = allowedEmptyIPermissionCheck;

      if (existing) {
        canDisplay = readAuthorization.isAuthorized;
        if (this.hasNoWriteRights()) {
          hasRight = readAuthorization;
        }
      } else {
        canDisplay = !this.hasNoWriteRights();
        hasRight = IS_AUTHORIZED(['write_bidder'], user.user);
      }

      if (!canDisplay) {
        return (
          <div>
            <ModelMissingPermission missingPermissions={hasRight.missingPermissions} />
          </div>
        );
      }
      if (!loaded) {
        return (
          <LoadingView active={true} text={ct('LoadingItemSettings', { item: ct('Bidder') })} />
        );
      }

      const isCloneBidderOrBulkUpdate = this.isCloneBidderOrBulkUpdate();

      const chartOptions: RadioOption[] = [
        { tKey: 'LiveData', value: 'liveData' },
        {
          tKey: 'Insights',
          value: 'insights',
          stickerTKey: 'New',
        },
      ];

      return (
        <Panels max vertical relative minWidthMain style={{ minHeight: '100vh' }}>
          <Panel largeHorizontalPadding smallVerticalPadding>
            <TopBar
              title='Bidder Settings'
              enableUINotices
              tKey={'ItemSettings'}
              tProps={{ item: ct('Bidder') }}
            />
          </Panel>
          {/* Bidder Status Bar */}
          <Panel>
            <AppBar
              position='relative'
              elevation={0}
              style={{
                backgroundColor: '#F8faff',
                border: '#cbcbcb',
                borderBottomStyle: 'solid',
                borderBottomWidth: 'thin',
                borderTopStyle: 'none',
                borderTopWidth: isCloneBidderOrBulkUpdate ? '0px' : 'thin',
              }}
            >
              {isCloneBidderOrBulkUpdate && (
                <Button
                  onClick={this.gotoBidderListView}
                  style={{
                    width: '150px',
                    paddingTop: '0px',
                    fontSize: 12,
                    color: '#666EFA',
                    textTransform: 'none',
                    backgroundColor: '#F8FAFF',
                    fontWeight: 'normal',
                  }}
                >
                  {ct('BackToItemList', { item: ct('Bidder') })}
                </Button>
              )}
              {this.renderToolbar()}
            </AppBar>
          </Panel>
          {/* only show live data if the bidder is not a clone or new */}
          <Panel flex scroll>
            {!!this.state.ID && !isCloneBidderOrBulkUpdate && (
              <>
                <Rows paddingBottom={spacing.base}>
                  <Row
                    largeHorizontalPadding
                    paddingTop={spacing.base}
                    paddingBottom={spacing.none}
                  >
                    {/* CHART OPTIONS */}
                    <RadioTextButtons
                      options={chartOptions}
                      value={this.state.selectedChartView}
                      onChange={(value) => {
                        this.setState({ selectedChartView: value as 'liveData' | 'insights' });
                        track(
                          'Bidder Settings View - Toggle Chart View',
                          { chart: value as 'liveData' | 'insights' },
                          user.user,
                        );
                      }}
                    />
                  </Row>
                  {this.state.selectedChartView === 'insights' && (
                    <Row noPadding>
                      <BidderAuctionInsights
                        bidderID={Number(this.state.ID)}
                        calStartDateStr={this.state.auctionInsightsCalStartDate.format(
                          'YYYY-MM-DD HH:mm:ss',
                        )}
                        calEndDateStr={this.state.auctionInsightsCalEndDate.format(
                          'YYYY-MM-DD HH:mm:ss',
                        )}
                        handleApplyDatesChange={this.handleApplyAuctionInsightsDatesChange}
                      />
                    </Row>
                  )}
                </Rows>
                {this.state.selectedChartView === 'liveData' && (
                  <Grid>
                    <LiveData
                      headerbidders={this.state.bidders}
                      resourceIDs={this.state.ID}
                      resourceType={'Bidder'}
                      timezone={this.props.session.publisher.Timezone}
                      publisher={this.props.session.publisher}
                      userInfo={this.props.user.user}
                      bidderViewTabIndex={viewTabIndex}
                    />
                  </Grid>
                )}
              </>
            )}
            {!isCloneBidderOrBulkUpdate && <Grid>{this.renderAppBar()}</Grid>}

            {/* BIDDER PARAMETERS TAB */}
            <TabPanel
              value={viewTabIndex}
              index={0}
              className={classes.tabPanelWhite}
              positionAbsolute
              maxHeight={isCloneBidderOrBulkUpdate}
              maxWidth
            >
              <Grid
                container
                direction='row'
                alignItems='flex-start'
                spacing={0}
                style={{ paddingBottom: '96px' }}
              >
                <Grid item xs={9}>
                  {isCloneBidderOrBulkUpdate && <Grid>{this.renderAppBar()}</Grid>}
                  <Grid style={{ paddingRight: '15px' }}>
                    {/* General Header */}
                    <Typography className={classes.parameterHeaders} style={{ paddingTop: '15px' }}>
                      {ct('General')}
                    </Typography>

                    {/* AB Testing Notice */}
                    {currentABTest !== undefined &&
                      this.state.CRONQuantityCount !== this.state.CRONQuantityCountSinceLastTest &&
                      Object.keys(currentABTest).length > 0 && (
                        <Grid>
                          <Grid item style={{ marginBottom: '5px' }}>
                            <Button
                              style={{
                                width: '100%',
                                textAlign: 'left',
                                fontSize: '0.85rem',
                                color: '#707070',
                                textTransform: 'none',
                                justifyContent: 'flex-start',
                                backgroundColor: '#fcfcde',
                              }}
                              disabled={true}
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='16'
                                height='18'
                                viewBox='0 0 16 18'
                                style={{ marginRight: 3, marginLeft: 3, alignItems: 'flex-end' }}
                              >
                                <path
                                  id='Path_457'
                                  data-name='Path 457'
                                  d='M17,4H14a2,2,0,1,0-4,0H7A3,3,0,0,0,4,7V17a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3Zm2,13a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V7A2,2,0,0,1,7,5H8A1,1,0,0,0,9,6h6a1,1,0,0,0,1-1h1a2,2,0,0,1,2,2Zm-6-7v3a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm0,6a1,1,0,1,1-1-1A1,1,0,0,1,13,16Z'
                                  transform='translate(-4 -2)'
                                  fill='#707070'
                                />
                              </svg>
                              &nbsp; {ct('BiddersABTestingNotice')}
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    {/* Parameters */}
                    {this.renderParameters()}

                    {/* Flighting */}
                    {this.state.Bidder !== DemandSources.publicaCampaign && this.renderFlighting()}

                    {isSuperUser &&
                      this.props.session.publisher.LogSamplingEnabled === EBool.EBool_TRUE &&
                      this.state.ID !== '' && (
                        <Grid item style={{ maxWidth: 1200, marginTop: 20 }}>
                          <Typography className={this.props.classes.parameterHeaders}>
                            {ct('DisableSamplingWithAsterisk')}
                          </Typography>
                          <Grid container direction='column' style={{ paddingLeft: 80 }}>
                            <Grid item>
                              <TextField
                                label={ct('SamplingDaysDisabled')}
                                name={ct('BiddersMessageDisableSamplingMax8Days')}
                                style={{ width: '180px' }}
                                value={this.state.samplingPercentageDisabledUntilDays}
                                onChange={this.handleChangeSamplingDays}
                              />
                            </Grid>
                            <Grid item>
                              <Typography>
                                {ct('SamplingDisabledUntil')} *:{' '}
                                {this.state.SamplingPercentageDisabledUntil}
                              </Typography>
                              <Typography>
                                {ct('SamplingPercentage')}: {this.state.SamplingPercentage}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                    {(isSamsungPublisher(this.props.session.publisher.ID) ||
                      this.props.session.publisher.ID === '1') &&
                      !isCloneBidderOrBulkUpdate &&
                      this.renderDataSharing()}
                  </Grid>
                </Grid>
                {isCloneBidderOrBulkUpdate && (
                  <Grid xs={3}>
                    <Grid
                      container
                      direction='column'
                      alignItems='flex-start'
                      style={{
                        height: '100%',
                        width: '25%',
                        position: 'absolute',
                      }}
                    >
                      {this.renderBulkUpdateSidebar()}
                    </Grid>
                  </Grid>
                )}
                {this.state.openEnableSponsorshipModeDialog && (
                  <Dialog
                    fullWidth
                    maxWidth='lg'
                    keepMounted
                    open={this.state.openEnableSponsorshipModeDialog}
                  >
                    <DialogTitle style={{ paddingLeft: 50, paddingTop: 50 }}>
                      {ct('BiddersMessageEnableSponsorship')}
                    </DialogTitle>
                    <DialogContent style={{ paddingLeft: 50 }}></DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() =>
                          this.setState({
                            openEnableSponsorshipModeDialog: false,
                            EnableSponsorshipMode: EBool.EBool_TRUE,
                          })
                        }
                        color='primary'
                        autoFocus
                      >
                        {ct('Enable')}
                      </Button>
                      <Button
                        onClick={() =>
                          this.setState({
                            openEnableSponsorshipModeDialog: false,
                            EnableSponsorshipMode: EBool.EBool_FALSE,
                          })
                        }
                        color='primary'
                        autoFocus
                      >
                        {ct('Disable')}
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}
              </Grid>
            </TabPanel>

            {/* TARGETING TAB */}
            <TabPanel
              value={viewTabIndex}
              index={1}
              className={classes.tabPanel}
              positionAbsolute
              maxHeight={isCloneBidderOrBulkUpdate}
              maxWidth
            >
              <Cols style={{ height: '100%' }}>
                <Col flex>
                  <Rows paddingTop={spacing.base}>
                    {!bulkUpdateEnabled && this.state.Bidder !== DemandSources.publicaCampaign && (
                      <Row>
                        <TargetingIntegration
                          generateCustomTargeting={this.generateCustomTargetingPayload}
                          handleApplySelectedPresets={this.handleApplySelectedPresets}
                          presetIDs={this.state.PresetIDs}
                          presetOptions={this.state.PresetList}
                          conflicts={this.state.presetConflicts}
                          conflictedParamKeys={this.state.presetConflictedParamKeys}
                          key={'bidderIntegrationString'}
                          parentType='Bidder'
                        />
                      </Row>
                    )}
                    {isCloneBidderOrBulkUpdate && <Row>{this.renderAppBar()}</Row>}
                    <Row paddingTop={spacing.none}>{this.renderBidderTargeting()}</Row>
                  </Rows>
                </Col>
                {/* Bulk Edit Sidebar */}
                {isCloneBidderOrBulkUpdate && (
                  <Col style={{ width: '26.1%' }}>{this.renderBulkUpdateSidebar()}</Col>
                )}
              </Cols>
            </TabPanel>

            {/* BID REQUEST REWRITE TAB */}
            <TabPanel
              value={viewTabIndex}
              index={2}
              className={classes.tabPanel}
              positionAbsolute
              maxHeight={isCloneBidderOrBulkUpdate}
              maxWidth
            >
              <Cols style={{ height: '100%' }}>
                <Col flex>
                  <Rows>
                    {isCloneBidderOrBulkUpdate && <Row>{this.renderAppBar()}</Row>}
                    <Row style={{ padding: '8px 16px 96px' }}>{this.renderBidRequestRewrite()}</Row>
                  </Rows>
                </Col>
                {isCloneBidderOrBulkUpdate && (
                  <Col style={{ height: '100%' }}>{this.renderBulkUpdateSidebar()}</Col>
                )}
              </Cols>
            </TabPanel>

            {/* BIDDER AB TESTS TAB */}
            {existing && (
              <TabPanel value={viewTabIndex} index={3} className={classes.tabPanel}>
                <BidderTests
                  bidder={this.state}
                  currentABTest={currentABTest}
                  pastABTests={pastABTests}
                  getBidder={this.getBidder}
                  implementParams={this.implementABTestParams}
                  updateCurrentlyWritingABTest={this.updateCurrentlyWritingABTest}
                  updateSnackbar={this.updateSnackbar}
                  snackbarClose={this.snackbarClose}
                  snackbarError={snackbarError}
                  snackbarMessage={snackbarMessage}
                  updateTriggerTestLaunch={this.updateTriggerTestLaunch}
                  testLaunchTriggered={triggerTestLaunch}
                />
              </TabPanel>
            )}

            {/* BRAND SAFETY TAB */}
            {existing && !isCloneBidderOrBulkUpdate && (
              <TabPanel value={viewTabIndex} index={4} className={classes.tabPanel}>
                <Grid
                  container
                  direction='column'
                  justify='center'
                  alignItems='stretch'
                  style={{ width: '83%', marginLeft: '28px' }}
                  spacing={1}
                >
                  {/* Creative URLs */}
                  <Grid item>
                    <Typography
                      style={{
                        fontSize: '16px',
                        fontWeight: 500,
                        marginBottom: '15px',
                      }}
                    >
                      {ct('BrandSafety')}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={() => this.gotoCreativeURLs()}
                      style={{ color: getColorTheme('secondaryButtonText') }}
                    >
                      {ct('CreativeURLs')}
                    </Button>
                  </Grid>
                </Grid>
              </TabPanel>
            )}

            {/* AUTOMATED BID FLOOR TAB */}
            {existing && !this.isCloneBidderOrBulkUpdate() && (
              <TabPanel value={viewTabIndex} index={5} className={classes.tabPanel}>
                <SmartFloors
                  channelAndGroupMaps={this.generateSmartFloorChannelAndGroupMaps()}
                  smartFloorConfigs={this.state.smartFloorConfigs}
                  selectedSiteIDForSmartFloorsChart={this.state.selectedSiteIDForSmartFloorsChart}
                  handleChangeSmartFloorConfig={this.handleChangeSmartFloorConfig}
                />
              </TabPanel>
            )}

            {/* Model for Add/Editing Buy Types Companys */}
            <AddEditCompanyModel
              publisherID={session.publisher.ID}
              active={AddEditBuyTypeModelActive}
              forcedSelection={ECompanyType.TYPE_BUY_TYPE}
              onClose={() => this.setState({ AddEditBuyTypeModelActive: false })}
              onUpdate={this.addOrUpdateCompany}
              onDelete={this.deleteCompany}
              counter={buyTypeUpdateCounter}
              username={this.props.user.user.Username}
            />

            {/* Snackbar */}
            {!bulkUpdateEnabled && this.renderLiveLogs()}
            <SnackbarView
              open={!!snackbarMessage}
              error={!!snackbarError}
              onClose={this.snackbarClose}
            >
              {snackbarMessage}
            </SnackbarView>
          </Panel>
        </Panels>
      );
    }

    // generates the active tags for comma sep values for the accordions (i.e. 2 IDs, 4 Producers)
    // fieldValue represents the textfield (contentid1,contentid2,contentid3) and
    // fieldName represents the name to be shown (Content ID)
    // multi-accordion-panel will ignore an empty string active tag
    generateActiveTagForCommaSepField = (fieldValue: string, fieldName: string) => {
      if (fieldValue.length > 0) {
        // split the field and get rid of empty strings to count
        const count = fieldValue.split(',').filter((part: string) => part !== '').length;
        return count === 1 ? `1 ${fieldName}` : `${count} ${fieldName}s`;
      } else {
        return '';
      }
    };

    renderAppBar = () => {
      const { bulkUpdateIDs, classes, existing } = this.props;
      const { abTests, viewTabIndex, isSmartFloorActive } = this.state;

      let currentABTest;
      if (existing) {
        currentABTest = abTests.filter((test) => {
          return test.Active === ABTestingActiveActive;
        })[0];
      }
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      return (
        <AppBar
          position='static'
          style={{ backgroundColor: '#F8faff', boxShadow: 'none', color: 'black' }}
        >
          <Tabs
            variant='scrollable'
            value={viewTabIndex}
            onChange={(_: any, newIndex: number) => this.setState({ viewTabIndex: newIndex })}
            aria-label='simple tabs'
            classes={{ indicator: classes.indicator }}
          >
            <Tab
              label={ct('Parameters')}
              {...MakeTabProps(0)}
              style={{ color: viewTabIndex === 0 ? '#4952FF' : '#757575' }}
            />
            <Tab
              label={ct('Targeting')}
              {...MakeTabProps(1)}
              style={{ color: viewTabIndex === 1 ? '#4952FF' : '#757575' }}
            />
            <Tab
              label={ct('BidRequestRewrite')}
              {...MakeTabProps(2)}
              style={{ color: viewTabIndex === 2 ? '#4952FF' : '#757575' }}
            />
            {!bulkUpdateEnabled &&
              (currentABTest !== undefined && Object.keys(currentABTest).length > 0 ? (
                <Tab
                  label={
                    <div>
                      <FiberManualRecordIcon
                        style={{ verticalAlign: 'middle', color: 'red', fontSize: '1rem' }}
                      />
                      &nbsp;{ct('Tests')}
                    </div>
                  }
                  {...MakeTabProps(3)}
                  disabled={!existing}
                />
              ) : (
                <Tab
                  label={ct('Tests')}
                  {...MakeTabProps(3)}
                  disabled={!existing}
                  style={{ color: viewTabIndex === 3 ? '#4952FF' : '#757575' }}
                />
              ))}
            <Tab
              label={ct('BrandSafety')}
              {...MakeTabProps(4)}
              disabled={!existing}
              style={{ color: viewTabIndex === 4 ? '#4952FF' : '#757575' }}
            />
            {isSmartFloorActive &&
              this.state.Bidder !== DemandSources.publica &&
              EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled) && (
                <Tab
                  label={ct('SmartFloors')}
                  {...MakeTabProps(5)}
                  disabled={
                    !isSmartFloorActive ||
                    this.state.Bidder === DemandSources.publica ||
                    !EBool.isTrue(this.props.session.publisher.SmartFloorsEnabled)
                  }
                  style={{ color: viewTabIndex === 5 ? '#4952FF' : '#757575' }}
                />
              )}
          </Tabs>
          <Divider
            style={{
              width: '100%',
            }}
          />
        </AppBar>
      );
    };

    getBidderPacingImpressionsFromDebugRoute = () => {
      // skip for new headerbidders
      if (this.state.ID !== '') {
        GetDebugHeaderbidderPacingData(this.props.session.publisher.ID, this.state.ID).then(
          ([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                pacingImpressionsData: data,
              });
            }
            if (err !== undefined) {
              console.error(err);
            }
          },
        );
      }
    };

    renderTargetingRequestedPodDuration = (): ReactElement => {
      const { TargetingRequestedPodDurationMin, TargetingRequestedPodDurationMax } = this.state;
      const shouldBold =
        TargetingRequestedPodDurationMin !== TargetingRequestedPodDurationNoMin ||
        TargetingRequestedPodDurationMax !== TargetingRequestedPodDurationNoMax;
      return (
        <Grid
          container
          direction='row'
          alignItems='center'
          spacing={2}
          style={{ marginTop: '-20px' }}
        >
          <Grid item xs={3} style={{ marginTop: '25px' }}>
            <Text
              small
              style={{
                fontWeight: shouldBold ? FONT_WEIGHT.bold : FONT_WEIGHT.none,
                marginLeft: '5px',
              }}
              tKey='RequestedPodDurationSeconds'
            >
              <Tooltip title={ct('BiddersTooltipAdDuration')} placement='bottom-start'>
                <InfoIcon
                  style={{
                    width: '1rem',
                    color: publicaColors.mediumLightGray,
                    position: 'relative',
                    top: 8,
                    left: 8,
                  }}
                />
              </Tooltip>
            </Text>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={6}>
            <MinMaxEditor
              min={TargetingRequestedPodDurationMin}
              max={TargetingRequestedPodDurationMax}
              handleOnChangeMinMax={this.handleChangeMinMaxPodDurationSelection}
              onClear={this.clearMinMaxPodDuration}
              minLimit={TargetingRequestedPodDurationNoMin}
              maxLimit={TargetingRequestedPodDurationNoMax}
            />
          </Grid>
        </Grid>
      );
    };

    handleChangeMinMaxPodDurationSelection = (value: string, name: string) => {
      const { TargetingRequestedPodDurationMax } = this.state;
      const parsedValue = parseInt(value, 10);
      if (!Number.isNaN(parsedValue)) {
        if (name === 'Min') {
          this.setState({
            TargetingRequestedPodDurationMin:
              parsedValue >= TargetingRequestedPodDurationMax
                ? TargetingRequestedPodDurationNoMin
                : parsedValue,
          });
        } else {
          this.setState({
            TargetingRequestedPodDurationMax:
              parsedValue >= TargetingRequestedPodDurationNoMax
                ? TargetingRequestedPodDurationNoMax
                : parsedValue,
          });
        }
      }
    };

    renderFlighting = () => {
      const { bulkUpdateIDs, classes, cloneBidderEnabled, session } = this.props;
      const { errors, Quantity, dateStart, dateEnd } = this.state;
      let impressions = parseInt(this.state.CRONQuantityCount.toString(), 10);
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      if (this.state.pacingImpressionsData !== undefined) {
        impressions = this.state.pacingImpressionsData.total_impressions;
      }

      const renderFlightDates = (rowInfo: IInputRow) => (
        <Grid item>
          <Grid container wrap='nowrap' spacing={1}>
            <Grid item xs={3} style={{ flexShrink: 0, paddingTop: 28 }}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {this.isCloneBidderOrBulkUpdate() && (
                  <Grid item>
                    <Checkbox
                      className={classes.checkbox}
                      checked={rowInfo.marked}
                      onChange={rowInfo.handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography className={classes.insideAccordionText}>
                    {ct('FlightDates')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={10}>
              <Grid container direction='row' alignItems='center' spacing={2}>
                <Grid item>
                  <DateTimeRangeComponent
                    enableClearSelection={true}
                    disabled={this.hasNoWriteRights()}
                    timezone={session.publisher.Timezone}
                    start={dateStart}
                    end={dateEnd}
                    // @ts-ignore
                    onChange={(e) => this.handleChangeDate(e)}
                    openDirection={'up'}
                    helperText={errors.StartDate}
                    error={!!errors.StartDate}
                    enablePresets={true}
                  />
                </Grid>
                <Grid item style={{ paddingTop: 28 }}>
                  <ModelSecondaryButton
                    disabled={this.hasNoWriteRights()}
                    style={{
                      padding: '6px 12px',
                    }}
                    onClick={this.clearDates}
                  >
                    <Typography
                      noWrap
                      style={{
                        textTransform: 'uppercase',
                        fontSize: 14,
                        fontWeight: 500,
                        marginLeft: 5,
                      }}
                    >
                      {ct('ClearDates')}
                    </Typography>
                  </ModelSecondaryButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );

      const renderFlightImps = (rowInfo: IInputRow) => (
        <Grid item>
          <Grid container alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {this.isCloneBidderOrBulkUpdate() && (
                  <Grid item>
                    <Checkbox
                      className={classes.checkbox}
                      checked={rowInfo.marked}
                      onChange={rowInfo.handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography className={classes.insideAccordionText}>
                    {ct('ImpressionGoal')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <NumberFormat
                label=''
                name='Quantity'
                fullWidth
                value={Quantity}
                onChange={this.handleChange}
                helperText={errors.Quantity}
                error={!!errors.Quantity}
                customInput={TextField}
                thousandSeparator={true}
                disabled={this.hasNoWriteRights()}
              />
            </Grid>
            {!this.isCloneBidderOrBulkUpdate() && (
              <Grid item xs={2}>
                <Typography style={{ fontSize: 12 }}>
                  {`(${impressions.toLocaleString('en', {
                    minimumFractionDigits: 0,
                  })} ${ct('DeliveredToDate')})`}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      );

      const flightDatesRow = {
        renderType: 'custom',
        customRender: renderFlightDates,
        title1: '',
        field1: '',
        value1: this.state.dateStart,
        defaultValue1: undefined,
        handleChange1: noopVoid,
        value2: this.state.dateEnd,
        defaultValue2: undefined,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['StartDate', 'EndDate']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'StartDate',
              displayTitle: ct('FlightStartDate'),
              genDisplayValue: () =>
                this.state.dateStart ? this.state.dateStart.format('MM-DD-YYYY') : 'No Date',
              enabled: false,
              genType: () => this.getCloneType('StartDate'),
              defaultValue: null,
              tab: 'Parameters',
            },
            {
              key: 'EndDate',
              displayTitle: ct('FlightEndDate'),
              genDisplayValue: () =>
                this.state.dateEnd ? this.state.dateEnd.format('MM-DD-YYYY') : 'No Date',
              enabled: false,
              genType: () => this.getCloneType('EndDate'),
              defaultValue: null,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      const flightImpsRow = {
        renderType: 'custom',
        customRender: renderFlightImps,
        title1: '',
        field1: '',
        value1: this.state.Quantity,
        defaultValue1: 0,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Quantity']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Quantity',
              displayTitle: ct('FlightingImpressionGoal'),
              genDisplayValue: () => this.state.Quantity.toString(),
              enabled: false,
              genType: () => this.getCloneType('Quantity'),
              defaultValue: 0,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      return (
        <Grid item style={{ maxWidth: 1200, marginTop: 20 }}>
          {/* Header */}
          <Typography className={classes.parameterHeaders}>{ct('FlightDates')}</Typography>
          <Typography className={classes.headingCategorySubtitle} style={{ paddingLeft: 50 }}>
            {ct('BiddersMessageFlightDates')}
          </Typography>
          <Grid container direction='column' style={{ paddingLeft: 80 }}>
            <InputRow rowInfo={flightDatesRow} disableEdit={this.paramsDisabled()} />
            <InputRow rowInfo={flightImpsRow} disableEdit={this.paramsDisabled()} />
          </Grid>
        </Grid>
      );
    };

    // Read notes in multi-accordion and multi-accordion-panel components to understand
    // props required to use that component
    renderBidderTargeting = () => {
      const { user, cloneBidderEnabled } = this.props;
      const {
        bulkUpdateIDsIncludesDirectCampaign,
        TargetingRequestedPodDurationMax,
        TargetingRequestedPodDurationMin,
      } = this.state;
      const bulkUpdateEnabled = !!this.props.bulkUpdateIDs && this.props.bulkUpdateIDs.length > 0;
      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);
      // if there have been new impressions since the last test was created, params used in testing are disabled
      const newImpressionsSinceLastTest =
        this.state.CRONQuantityCount !== this.state.CRONQuantityCountSinceLastTest;
      const paramsInTesting = this.getParamsInTesting();
      const slotsRowTexts = [] as string[];
      if (paramsInTesting.includes('Pods') && newImpressionsSinceLastTest) {
        slotsRowTexts.push(ct('DisabledWhileInTesting'));
      }
      if (this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive) {
        slotsRowTexts.push(
          `${
            !ALL_PLATFORM_CONNECTION_BIDDERS.includes(this.state.Bidder)
              ? ct('BiddersPlatformConnectMessageActive')
              : ct('BiddersPlatformConnectMessageDefaultActive')
          }`,
        );
      } else {
        slotsRowTexts.push(ct('BiddersPoddedRequestContactAccountManager'));
      }
      // INVENTORY PANEL AND ROWS
      const ChannelRow = {
        renderType: 'MaterialDropdown',
        title1: ct('Channels'),
        value1: this.state.bidderChannelList,
        defaultValue1: false,
        handleChange1: this.handleChangeList('bidderChannelList'),
        handleAccept1: this.handleChannelAcceptClick,
        isActiveValue1: () =>
          this.state.SiteIDS.length !== Object.values(this.state.bidderChannelList).length,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                count: this.state.SiteIDS.length,
                label: ct('Channels'),
              })
            : ct('AllItems', { item: ct('Channel') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['SiteIDS']),
        materialDropdownShowPrefixID: true,
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'SiteIDS',
              displayTitle: ct('TargetedChannels'),
              genDisplayValue: () => {
                const displayNames = [] as string[];
                this.state.SiteIDS.forEach((id: number) => {
                  if (this.state.bidderChannelList[id]) {
                    displayNames.push(`${this.state.bidderChannelList[id].title} [${id}]`);
                  }
                });
                return displayNames.join('  |  ');
              },
              enabled: false,
              genType: () => this.getCloneType('bidderChannelList'),
              defaultValue: [] as number[],
              tab: 'Targeting',
            },
          ]),
        quickFilterOptions: this.state.quickFilterOptions,
      } as IInputRow;
      const ChannelGroupRow = {
        renderType: 'MaterialDropdown',
        title1: ct('ChannelGroups'),
        value1: this.state.channelGroupsList,
        defaultValue1: false,
        handleChange1: this.handleChangeList('channelGroupsList'),
        handleAccept1: this.handleChannelGroupsAcceptClick,
        isActiveValue1: () => this.state.ChannelGroupIDS.length !== 0,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                count: this.state.ChannelGroupIDS.length,
                label: ct('ChannelGroups'),
              })
            : ct('AllItems', { item: ct('ChannelGroups') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['ChannelGroupIDS']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'ChannelGroupIDS',
              displayTitle: ct('TargetedChannelGroups'),
              genDisplayValue: () => {
                const displayNames = [] as string[];
                this.state.ChannelGroupIDS.forEach((id: number) => {
                  if (this.state.channelGroupsList[id]) {
                    displayNames.push(`${this.state.channelGroupsList[id].title} [${id}]`);
                  }
                });
                return displayNames.join('  |  ');
              },
              enabled: false,
              genType: () => this.getCloneType('ChannelGroupIDS'),
              defaultValue: [] as number[],
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const countryGroupCount = Object.values(this.state.targetingCountryGroupList).filter(
        (item) => item.selected,
      ).length;
      const ChannelListRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderChannelListDialog({
            renderType: 'MaterialDropdown',
            title1: ct('ChannelLists'),
            value1: this.state.channelListsList,
            defaultValue1: false,
            handleChange1: this.handleChangeList('channelListsList'),
            handleAccept1: this.handleChannelListsAcceptClick,
            isActiveValue1: () => this.state.ChannelListIDS.length !== 0,
            getActiveTag1: (active: boolean) =>
              active
                ? ct('FormatLabelWithCount', {
                    count: this.state.ChannelListIDS.length,
                    label: ct('ChannelLists'),
                  })
                : ct('AllItems', { item: ct('ChannelLists') }),
            value2: false,
            defaultValue2: true,
            showStaticTargetingIcon: true,
            markedEnabled: bulkUpdateEnabled,
            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked(['ChannelListIDS']),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: 'ChannelListIDS',
                  displayTitle: ct('TargetedChannelLists'),
                  genDisplayValue: () => {
                    const displayNames = [] as string[];
                    this.state.ChannelListIDS.forEach((id: number) => {
                      if (this.state.channelListsList[id]) {
                        displayNames.push(`${this.state.channelListsList[id].title} [${id}]`);
                      }
                    });
                    return displayNames.join('  |  ');
                  },
                  enabled: false,
                  genType: () => this.getCloneType('ChannelListIDS'),
                  defaultValue: [] as number[],
                  tab: 'Targeting',
                },
              ]),
            showModalButtonUnderDropdown: this.state.channelLists.length > 0,
            showModalButton: this.state.channelLists.length === 0,
            modalButton: (
              <Grid>
                <ModelSecondaryButton
                  onClick={() => {
                    this.setState({ openChannelListDialog: true });
                    this.addChannelList().then();
                  }}
                  disabled={!writeAuthorization.isAuthorized}
                >
                  {ct('PlusItem', { item: ct('ChannelList') })}
                </ModelSecondaryButton>
                <ModelSecondaryButton
                  style={{ color: publicaColors.gray }}
                  onClick={() => {
                    this.setState({ openChannelListEditDialog: true });
                    this.cleanEditChannelLists();
                  }}
                  disabled={!writeAuthorization.isAuthorized}
                >
                  <EditIcon style={{ fontSize: 20, padding: 3 }} />
                  {ct('EditItem', { item: ct('ChannelList') })}
                </ModelSecondaryButton>
              </Grid>
            ),
            showDropdown: !!(this.state.channelLists.length > 0),
          });
        },
        title1: '',
        isActiveValue1: () => countryGroupCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                count: countryGroupCount,
                label: ct('Regions'),
              })
            : ct('AllItems', { item: ct('Regions') }),
      } as IInputRow;
      const SlotsRow = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems: generateSlotOptions(),
        tooltipText: slotsRowTexts.join(' '),
        title1: ct('Slots'),
        field1: 'Slots',
        value1: this.getDisplayedSlots(),
        defaultValue1: ['all'],
        handleChange1: this.handleChangeMultiSelect,
        isActiveValue1: () => this.getDisplayedSlots()[0] !== 'all',
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                count: this.state.Slots.length,
                label: ct('Slots'),
              })
            : ct('AllItems', { item: ct('Slots') }),
        disabled1:
          APS_BIDDERS.includes(this.state.Bidder) ||
          this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive ||
          this.state.IsPublicaTagFallbackEnabled === PublicaTagFallbackEnabled ||
          // if bidder is spotx, we should allow user to select targeting_slot
          (this.state.MultiBidActive === EBool.EBool_TRUE && this.state.Bidder !== 'spotx') ||
          (paramsInTesting.includes('Pods') && newImpressionsSinceLastTest),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Slots']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Slots',
              displayTitle: ct('Slots'),
              genDisplayValue: () => this.state.Slots.join(', ') || ct('All'),
              enabled: false,
              genType: () => this.getCloneType('Slots'),
              defaultValue: ['all'],
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const EnforceSlotTargetingToggle = {
        renderType: 'SimpleSwitch',
        enableSmallRow: false,
        title1: ct('EnforceSlotTargeting'),
        value1: this.state.EnforceSlotTargeting === EBool.EBool_TRUE,
        handleChange1: () => this.handleReverseToggle('EnforceSlotTargeting'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        marked: this.checkIfRowIsMarked(['EnforceSlotTargeting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnforceSlotTargeting',
              displayTitle: ct('EnforceSlotTargeting'),
              genDisplayValue: () => EBool.toBoolString(this.state.EnforceSlotTargeting),
              enabled: false,
            },
          ]),
      };
      const PositionRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generatePositionOptions() || [],
        title1: ct('Position'),
        field1: 'PositionTargeting',
        value1: this.state.PositionTargeting,
        defaultValue1: EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_ALL,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.PositionTargeting !==
          EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_ALL,
        getActiveTag1: (active: boolean) =>
          active ? HeaderBidderPositionTargetingToString(this.state.PositionTargeting) : ct('All'),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['PositionTargeting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'PositionTargeting',
              displayTitle: ct('Position'),
              genDisplayValue: () =>
                HeaderBidderPositionTargetingToString(this.state.PositionTargeting),
              enabled: false,
              genType: () => this.getCloneType('PositionTargeting'),
              defaultValue: EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_ALL,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const PodSequenceRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generatePodSequenceTargetingOptions() || [],
        title1: ct('PodSequence'),
        field1: 'PodSequenceTargeting',
        value1: this.state.PodSequenceTargeting,
        defaultValue1: EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_ANYPOD,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.PodSequenceTargeting !==
          EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_ANYPOD,
        getActiveTag1: (active: boolean) =>
          active
            ? HeaderBidderPodSequenceTargetingToString(this.state.PodSequenceTargeting)
            : 'Any Pod',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['PodSequenceTargeting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'PodSequenceTargeting',
              displayTitle: ct('PodSequence'),
              genDisplayValue: () =>
                HeaderBidderPodSequenceTargetingToString(this.state.PodSequenceTargeting),
              enabled: false,
              genType: () => this.getCloneType('PodSequenceTargeting'),
              defaultValue:
                EHeaderBidder_PodSequenceTargeting.HeaderBidder_PodSequenceTargeting_ANYPOD,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const TargetingRequestedPodDurationRow = {
        renderType: 'custom',
        customRender: () => this.renderTargetingRequestedPodDuration(),
        title1: '',
        isActiveValue1: () =>
          TargetingRequestedPodDurationMin !== TargetingRequestedPodDurationNoMin ||
          TargetingRequestedPodDurationMax !== TargetingRequestedPodDurationNoMax,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', {
                count: this.state.TargetingRequestedPodDurationMin,
                label: ct('PodDurations'),
              })
            : ct('AllItems', { item: ct('PodDurations') }),
      } as IInputRow;
      const AdbreakRow = {
        renderType: 'SimpleSwitch',
        tooltipText: ct('BiddersTooltipCombineVMAPRequests'),
        title1: ct('CombineVMAPRequestsWithAsterisk'),
        field1: 'AdbreakTargeting',
        value1: !!this.state.AdbreakTargeting,
        defaultValue1: '',
        handleChange1: this.toggleAdbreakTargeting,
        isActiveValue1: () => this.state.AdbreakTargeting === '1',
        getActiveTag1: (active: boolean) => (active ? '1' : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AdbreakTargeting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AdbreakTargeting',
              displayTitle: ct('CombineVMAPRequests'),
              genDisplayValue: () =>
                this.state.AdbreakTargeting === '1' ? ct('Active') : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('AdbreakTargeting'),
              defaultValue: '',
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const TargetedAdbreakRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generateAdbreakOptions() || [],
        title1: ct('AdBreakWithAsterisk'),
        field1: 'TargetedAdBreak',
        value1: this.state.TargetedAdBreak,
        defaultValue1: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetedAdBreak !==
          EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL,
        getActiveTag1: (active: boolean) =>
          active ? HeaderBidderTargetedAdBreakToString(this.state.TargetedAdBreak) : ct('All'),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetedAdbreak']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetedAdbreak',
              displayTitle: ct('TargetedAdBreaks'),
              genDisplayValue: () =>
                this.state.TargetedAdBreak ===
                EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL
                  ? ct('Active')
                  : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('TargetedAdbreak'),
              defaultValue: EHeaderBidder_TargetedAdBreak.HeaderBidder_TARGETED_ADBREAK_ALL,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const EnableTargetingFirstAdbreakInUserSessionParamRow = {
        renderType: 'SimpleSwitch',
        title1: ct('TargetFirstAdbreakInSessionWithAsterisk'),
        value1: this.state.EnableTargetingFirstAdbreakInUserSession === EBool.EBool_TRUE,
        handleChange1: () => this.handleReverseToggle('EnableTargetingFirstAdbreakInUserSession'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        marked: this.checkIfRowIsMarked(['EnableTargetingFirstAdbreakInUserSession']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnableTargetingFirstAdbreakInUserSession',
              displayTitle: ct('TargetFirstAdbreakInSessionWithAsterisk'),
              genDisplayValue: () =>
                EBool.toBoolString(this.state.EnableTargetingFirstAdbreakInUserSession),
              enabled: false,
            },
          ]),
      } as IInputRow;
      const TargetGvinQueryParamRow = {
        renderType: 'SimpleSwitch',
        title1: ct('GivnTargeting'),
        value1: this.state.TargetingGvinParamExists === EBool.EBool_TRUE,
        handleChange1: () => this.handleReverseToggle('TargetingGvinParamExists'),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        markedEnabled: bulkUpdateEnabled,
        marked: this.checkIfRowIsMarked(['TargetingGvinParamExists']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingGvinParamExists',
              displayTitle: ct('GivnTargeting'),
              genDisplayValue: () => EBool.toBoolString(this.state.TargetingGvinParamExists),
              enabled: false,
            },
          ]),
      } as IInputRow;
      const InventoryPanel = {
        title: ct('Inventory'),
        panelInactiveRowTag: '',
        panelActiveChipTitle: ct('Custom'),
        rows: [
          ChannelRow,
          ChannelGroupRow,
          ChannelListRow,
          SlotsRow,
          EnforceSlotTargetingToggle,
          PositionRow,
          PodSequenceRow,
        ],
      } as IAccordionPanel;
      if (
        this.state.Bidder !== DemandSources.publicaCampaign ||
        (this.state.Bidder === DemandSources.publicaCampaign &&
          this.state.EnableSponsorshipMode === EBool.EBool_TRUE)
      ) {
        InventoryPanel.rows.push(TargetingRequestedPodDurationRow);
      }
      if (
        BIDDERS_ADBREAK_TARGETING_ENABLED.includes(this.state.Bidder) &&
        !bulkUpdateEnabled &&
        hasRoleSuperUser(user.user)
      ) {
        InventoryPanel.rows.push(AdbreakRow);
      }
      // Super user only to specify which ad break to add endpoint keys to for APS bidder, should default to last ad break (HB-3654)
      if (hasRoleSuperUser(user.user) && !bulkUpdateEnabled) {
        InventoryPanel.rows.push(TargetedAdbreakRow);
      }
      // Only visible for Samsung
      if (isSamsungPublisher(this.props.session.publisher.ID)) {
        InventoryPanel.rows.push(TargetGvinQueryParamRow);
      }

      if (
        isSamsungPublisher(this.props.session.publisher.ID) ||
        isTestPublisher(this.props.session.publisher.ID)
      ) {
        InventoryPanel.rows.push(EnableTargetingFirstAdbreakInUserSessionParamRow);
      }
      // CONTENT PANEL AND ROWS
      const contentItemToTKey: Record<string, TKey> = {
        Channel: 'Channel',
        Distributor: 'Distributor',
        Genre: 'Genre',
        ID: 'ID',
        Network: 'Network',
        Producer: 'Producer',
        Rating: 'Rating',
        Series: 'Series',
        Title: 'Title',
        Category: 'Category',
        Language: 'Language',
      };
      const contentRows = [
        'Channel',
        'Distributor',
        'Genre',
        'ID',
        'Network',
        'Producer',
        'Rating',
        'Series',
        'Title',
        'Category',
        'Language',
      ].map((contentItem: string) => {
        const field = `TargetingContent${contentItem}`;
        const isAllowedName = `TargetingContent${contentItem}IsAllowed`;
        const isAllowed = this.state[isAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndInclude',
          tooltipText: ct('TooltipContentItemToBidOn', {
            item: ct(contentItemToTKey[contentItem]),
          }),
          title1: ct('ContentItem', { item: ct(contentItemToTKey[contentItem]) }),
          field1: field,
          value1: this.state[field],
          defaultValue1: '',
          handleChange1: this.handleChange,
          isActiveValue1: () => this.state[field].length > 0,
          getActiveTag1: () =>
            this.generateActiveTagForCommaSepField(this.state[field], contentItem),
          value2: isAllowed,
          defaultValue2: true,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: isAllowedName,
                value:
                  this.state[isAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : (EAllowStatus.ALLOW as any),
              },
            } as any),
          placeholderText: ct('PlaceholderEnterContentItemToBidOn', {
            item: ct(contentItemToTKey[contentItem]),
          }),
          markedEnabled: bulkUpdateEnabled,
          cloneEnabled: cloneBidderEnabled,
          compareValues: this.state.compareValues,
          marked: this.checkIfRowIsMarked([field, isAllowedName]),
          handleChangeMarked: () =>
            this.handleChangeMarked([
              {
                key: field,
                displayTitle: ct('ContentItem', { item: ct(contentItemToTKey[contentItem]) }),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                genDisplayValue: () => this.state[field] || ct('EmptyString'),
                enabled: false,
                genType: () => this.getCloneType(field),
                defaultValue: '',
                tab: 'Targeting',
              },
              {
                key: isAllowedName,
                displayTitle: ct('ContentItemAllowed', {
                  item: ct(contentItemToTKey[contentItem]),
                }),
                genDisplayValue: () =>
                  this.state[isAllowedName] === EAllowStatus.ALLOW ? ct('Include') : ct('Exclude'),
                enabled: false,
                genType: () => this.getCloneType(isAllowedName),
                defaultValue: EAllowStatus.ALLOW,
                tab: 'Targeting',
              },
            ]),
        } as IInputRow;
      });
      const ContentPanel = {
        title: ct('Content'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [...contentRows],
        StaticTooltip: StaticAdvancedTargetingTooltip,
      } as IAccordionPanel;

      // GEO PANEL AND ROWS
      const countriesCount = Object.values(this.state.targetingCountriesList).filter(
        (item) => item.selected,
      ).length;
      const TargetedCountriesRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedCountries'),
        value1: this.state.targetingCountriesList,
        defaultValue1: false,
        handleChange1: this.handleChangeList('targetingCountriesList'),
        handleAccept1: () => null,
        isActiveValue1: () => countriesCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', { count: countriesCount, label: ct('Countries') })
            : ct('AllItems', { item: ct('Countries') }),
        value2: this.state.deviceTargetingCountrySelectMode === SelectMode.Allowlist,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'deviceTargetingCountrySelectMode',
              value:
                this.state.deviceTargetingCountrySelectMode === SelectMode.Allowlist
                  ? SelectMode.Denylist
                  : (SelectMode.Allowlist as any),
            },
          } as any),
        // if no countries are selected, all countries are selected (optional material search dropdown param)
        isNoneSelectedAllSelected: true,
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'targetingCountriesList',
          'deviceTargetingCountrySelectMode',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'targetingCountriesList',
              displayTitle: ct('TargetedCountries'),
              genDisplayValue: () =>
                Object.values(this.state.targetingCountriesList)
                  .filter((item) => item.selected)
                  .length.toString() + ' Countries',
              enabled: false,
              genType: () => this.getCloneType('targetingCountriesList'),
              defaultValue: getDefaultMenuList(this.state.targetingCountriesList, false),
              tab: 'Targeting',
            },
            {
              key: 'deviceTargetingCountrySelectMode',
              displayTitle: ct('TargetedCountriesAllowed'),
              genDisplayValue: () =>
                this.state.deviceTargetingCountrySelectMode === SelectMode.Allowlist
                  ? ct('Allowed')
                  : ct('Denied'),
              enabled: false,
              genType: () => this.getCloneType('deviceTargetingCountrySelectMode'),
              defaultValue: SelectMode.Allowlist,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const TargetedRegionsRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderAllRegionsDialog({
            renderType: 'MaterialDropdown',
            title1: ct('TargetedRegions'),
            value1: this.state.targetingCountryGroupList,
            defaultValue1: false,
            handleChange1: this.handleChangeList('targetingCountryGroupList'),
            isActiveValue1: () => countryGroupCount > 0,
            getActiveTag1: (active: boolean) =>
              active
                ? ct('FormatLabelWithCount', {
                    count: countryGroupCount,
                    label: ct('Regions'),
                  })
                : ct('AllItems', { item: ct('Regions') }),
            value2: this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW,
            defaultValue2: true,
            handleChange2: () =>
              this.handleChange({
                target: {
                  name: 'TargetingCountryGroupIDsIsAllowed',
                  value:
                    this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW
                      ? EAllowStatus.DENY
                      : (EAllowStatus.ALLOW as any),
                },
              } as any),
            // if no country groups are selected, all country groups are selected by default
            isNoneSelectedAllSelected: true,
            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([
              'TargetingCountryGroupIDs',
              'TargetingCountryGroupIDsIsAllowed',
            ]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: 'TargetingCountryGroupIDs',
                  displayTitle: ct('TargetedRegions'),
                  genDisplayValue: () =>
                    Object.values(this.state.targetingCountryGroupList)
                      .filter((item) => item.selected)
                      .length.toString() + ' Regions',
                  enabled: false,
                  genType: () => this.getCloneType('TargetingCountryGroupIDs'),
                  defaultValue: '',
                  tab: 'Targeting',
                },
                {
                  key: 'TargetingCountryGroupIDsIsAllowed',
                  displayTitle: ct('TargetedRegionsAllowed'),
                  genDisplayValue: () =>
                    this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW
                      ? ct('Include')
                      : ct('Exclude'),
                  enabled: false,
                  genType: () => this.getCloneType('TargetingCountryGroupIDsIsAllowed'),
                  defaultValue: EAllowStatus.ALLOW,
                  tab: 'Targeting',
                },
              ]),
            showModalButton: true,
            modalButton: (
              <ModelSecondaryButton
                onClick={() => this.setState({ openRegionSelectTable: true })}
                disabled={!writeAuthorization.isAuthorized}
              >
                {ct('SeeItem', { item: ct('Regions') })}
              </ModelSecondaryButton>
            ),
          });
        },
        title1: '',
        isActiveValue1: () => countryGroupCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? ct('FormatLabelWithCount', { count: countryGroupCount, label: ct('Regions') })
            : ct('AllItems', { item: ct('Regions') }),
      } as IInputRow;
      const LocalTargetingRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderLocalTargetingPanel();
        },
        title1: '',
        field1: 'LocalTargeting',
        value1: this.state.localTargetingParameters,
        defaultValue1: [] as ILocalTargetingParameter[],
        handleChange1: noopVoid,
        value2: this.state.LocalTargetingIsAllowed,
        defaultValue2: true,
        isActiveValue1: () => this.state.localTargetingParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return ct('FormatLabelWithCount', {
            count: this.state.localTargetingParameters.length,
            label: ct('LocalTargetTypes'),
          });
        },
        cloneEnabled: !!cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['LocalTargeting', 'LocalTargetingIsAllowed']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'LocalTargeting',
              displayTitle: ct('LocalTargeting'),
              genDisplayValue: () =>
                ct('FormatLabelWithCount', {
                  count: this.state.localTargetingParameters.length,
                  label: ct('LocalTarget'),
                }),
              enabled: false,
              genType: () => this.getCloneType('LocalTargeting'),
              defaultValue: '',
              tab: 'Targeting',
            },
            {
              key: 'LocalTargetingIsAllowed',
              displayTitle: ct('LocalTargetingAllowed'),
              genDisplayValue: () =>
                this.state.LocalTargetingIsAllowed ? ct('Allowed') : ct('Denied'),
              enabled: false,
              genType: () => this.getCloneType('LocalTargetingIsAllowed'),
              defaultValue: true,
              tab: 'Targeting',
            },
            {
              key: 'LocalTargetingLogic',
              displayTitle: ct('LocalTargetingLogic'),
              genDisplayValue: () =>
                this.state.LocalTargetingLogic === TargetingLogicOR ? ct('Or') : ct('And'),
              enabled: false,
              genType: () => this.getCloneType('LocalTargetingLogic'),
              defaultValue: true,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const GeoPanel = {
        title: ct('Geo'),
        panelInactiveRowTag: ct('AllItems', { item: ct('Geo') }),
        panelActiveChipTitle: ct('Custom'),
        rows: [TargetedRegionsRow, TargetedCountriesRow, LocalTargetingRow],
      } as IAccordionPanel;

      // DAYPARTING PANEL
      const daypartingRow = {
        renderType: 'custom',
        customRender: this.renderDayparting,
        title1: '',
        field1: '',
        value1: this.state.isDaypartingActive === true,
        defaultValue1: false,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.isDaypartingActive,
        getActiveTag1: (active: boolean) => {
          return active ? ct('AllItems', { item: ct('Daypartings') }) : ct('None');
        },
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'Dayparting',
          'isDaypartingActive',
          'DaypartingIsAllowed',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'isDaypartingActive',
              displayTitle: ct('DaypartingActive'),
              genDisplayValue: () =>
                this.state.isDaypartingActive === true ? ct('Active') : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('isDaypartingActive'),
              defaultValue: false,
              tab: 'Targeting',
            },
            {
              key: 'Dayparting',
              displayTitle: ct('Dayparting'),
              genDisplayValue: () => {
                const items = parseDaypartingGenerateDisplay(
                  this.state.DaypartingIntervals,
                  this.state.isDaypartingActive,
                  this.props.session.publisher.Timezone,
                  true,
                );
                return (
                  <>
                    {items.map((item: string) => (
                      <div style={{ width: 320 }}>
                        {item}
                        <br></br>
                      </div>
                    ))}
                  </>
                );
              },
              enabled: false,
              genType: () => this.getCloneType('Dayparting'),
              defaultValue: [],
              tab: 'Targeting',
            },
            {
              key: 'DaypartingIsAllowed',
              displayTitle: ct('DaypartingIsAllowed'),
              genDisplayValue: () =>
                this.state.DaypartingIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('DaypartingIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const DaypartingPanel = {
        title: ct('Dayparting'),
        panelInactiveRowTag: ct('AllItems', { item: ct('Daypartings') }),
        panelActiveChipTitle: ct('Custom'),
        rows: [daypartingRow],
      } as IAccordionPanel;

      // COPPA PANEL AND ROWS
      const CoppaRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: [
          { key: TargetingCoppaAll, text: ct('All') },
          { key: TargetingCoppa0, text: '0' },
          { key: TargetingCoppa1, text: '1' },
        ],
        title1: ct('COPPA'),
        field1: 'TargetingCoppa',
        value1: this.state.TargetingCoppa,
        defaultValue1: TargetingCoppaAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingCoppa !== TargetingCoppaAll,
        getActiveTag1: (active: boolean) =>
          active ? (this.state.TargetingCoppa === TargetingCoppa0 ? 'COPPA = 0' : 'COPPA = 1') : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingCoppa']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingCoppa',
              displayTitle: ct('COPPA'),
              genDisplayValue: () => ConvertTargetingCoppaToText[this.state.TargetingCoppa],
              enabled: false,
              genType: () => this.getCloneType('TargetingCoppa'),
              defaultValue: TargetingCoppaAll,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const LATRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: [
          { key: TargetBoolTypeAll, text: ct('All') },
          { key: TargetBoolTypeFalse, text: ct('False') },
          { key: TargetBoolTypeTrue, text: ct('True') },
        ],
        title1: ct('LimitedAdTracking'),
        field1: 'TargetingLimitedAdTracking',
        value1: this.state.TargetingLimitedAdTracking,
        defaultValue1: TargetBoolTypeAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingLimitedAdTracking !== TargetBoolTypeAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingLimitedAdTracking === TargetBoolTypeTrue
              ? 'LAT = True'
              : 'LAT = False'
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingLimitedAdTracking']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingLimitedAdTracking',
              displayTitle: ct('LimitedAdTracking'),
              genDisplayValue: () =>
                this.state.TargetingLimitedAdTracking === TargetBoolTypeTrue
                  ? ct('True')
                  : ct('False'),
              enabled: false,
              genType: () => this.getCloneType('TargetingLimitedAdTracking'),
              defaultValue: TargetBoolTypeAll,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const CCPARow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: [
          { key: TargetingCCPAAll, text: ct('All') },
          { key: TargetingCCPAOptOut, text: ct('OptOut') },
          { key: TargetingCCPANonOptOut, text: ct('NonOptOut') },
        ],
        title1: ct('CCPA'),
        field1: 'TargetingCCPA',
        value1: this.state.TargetingCCPA,
        defaultValue1: TargetingCCPAAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingCCPA !== TargetingCCPAAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingCCPA !== TargetingCCPAAll
              ? 'CCPA Targeted'
              : 'CCPA All'
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingCCPA']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingCCPA',
              displayTitle: ct('CCPA'),
              genDisplayValue: () =>
                this.state.TargetingCCPA === TargetingCCPAAll
                  ? ct('All')
                  : this.state.TargetingCCPA === TargetingCCPAOptOut
                  ? ct('OptOut')
                  : ct('NonOptOut'),
              enabled: false,
              genType: () => this.getCloneType('TargetingCCPA'),
              defaultValue: TargetingCCPAAll,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const GDPRRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: [
          { key: TargetingGDPRAll, text: ct('All') },
          { key: TargetingGDPR0, text: '0' },
          { key: TargetingGDPR1, text: '1' },
        ],
        title1: ct('GDPR'),
        field1: 'TargetingGDPR',
        value1: this.state.TargetingGDPR,
        defaultValue1: TargetingGDPRAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingGDPR !== TargetingGDPRAll,
        getActiveTag1: (active: boolean) =>
          active ? (this.state.TargetingGDPR === TargetingGDPR0 ? 'GDPR = 0' : 'GDPR = 1') : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingGDPR']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingGDPR',
              displayTitle: ct('GDPR'),
              genDisplayValue: () => ConvertTargetingCoppaToText[this.state.TargetingGDPR],
              enabled: false,
              genType: () => this.getCloneType('TargetingGDPR'),
              defaultValue: TargetingGDPRAll,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const GDPRConsentRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: [
          { key: TargetBoolTypeAll, text: ct('All') },
          { key: TargetBoolTypeFalse, text: ct('False') },
          { key: TargetBoolTypeTrue, text: ct('True') },
        ],
        title1: ct('GDPRConsent'),
        field1: 'TargetingGDPRConsent',
        value1: this.state.TargetingGDPRConsent,
        defaultValue1: TargetBoolTypeAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingGDPRConsent !== TargetBoolTypeAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingGDPRConsent === TargetBoolTypeTrue
              ? 'GDPR Consent = True'
              : 'GDPR Consent = False'
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingGDPRConsent']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingGDPRConsent',
              displayTitle: ct('GDPRConsent'),
              genDisplayValue: () =>
                this.state.TargetingGDPRConsent === TargetBoolTypeTrue ? ct('True') : ct('False'),
              enabled: false,
              genType: () => this.getCloneType('TargetingGDPRConsent'),
              defaultValue: TargetBoolTypeAll,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const TargetingDeviceIDTypeRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: [
          { key: ETargetingDeviceIDTypes.ALL, text: ct('All') },
          { key: ETargetingDeviceIDTypes.ORIGINAL, text: ct('OriginalDIDs') },
          { key: ETargetingDeviceIDTypes.SYNTHETIC, text: ct('SyntheticDIDs') },
        ],
        title1: ct('TargetingDeviceIDType'),
        field1: 'TargetingDeviceIDType',
        value1: this.state.TargetingDeviceIDType,
        defaultValue1: ETargetingDeviceIDTypes.ALL,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingDeviceIDType !== ETargetingDeviceIDTypes.ALL,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingDeviceIDType !== ETargetingDeviceIDTypes.ORIGINAL
              ? ct('SyntheticDIDs')
              : ct('OriginalDIDs')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingDeviceIDType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingDeviceIDType',
              displayTitle: ct('TargetingDeviceIDType'),
              genDisplayValue: () =>
                this.state.TargetingDeviceIDType !== ETargetingDeviceIDTypes.ALL
                  ? this.state.TargetingDeviceIDType === ETargetingDeviceIDTypes.ORIGINAL
                    ? ct('OriginalDIDs')
                    : ct('SyntheticDIDs')
                  : '',
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceIDType'),
              defaultValue: ETargetingDeviceIDTypes.ALL,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const PrivacyPanel = {
        title: ct('Privacy'),
        panelInactiveRowTag: ct('AllItems', { item: ct('Values') }),
        panelActiveChipTitle: ct('Custom'),
        rows:
          this.state.TargetingGDPR === TargetingGDPR1
            ? [CoppaRow, LATRow, CCPARow, GDPRRow, GDPRConsentRow, TargetingDeviceIDTypeRow]
            : [CoppaRow, LATRow, CCPARow, GDPRRow, TargetingDeviceIDTypeRow],
      } as IAccordionPanel;

      // CUSTOM PANEL AND ROWS
      const customRows = [
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        'Targeting',
      ].map((customItem: string) => {
        // DO NOT COPY THIS!!! THIS IS A HACK!
        const tKey = `Custom${customItem}`;
        const title = ct(tKey as TKey);

        const field = `Custom${customItem}`;
        const isAllowedName = field + 'Inclusion';
        const isAllowedNameDisplay = ct('CustomItemInclusion', {
          item: customItem === 'Targeting' ? ct('Targeting') : customItem,
        });
        const isAllowed = this.state[isAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndInclude',
          tooltipText: ct('TooltipCustomParamReseller', {
            item: getResellerTitle(),
          }),
          title1: title,
          field1: field,
          value1: this.state[field],
          defaultValue1: '',
          handleChange1: this.handleChange,
          isActiveValue1: () => this.state[field].length > 0,
          getActiveTag1: () => this.generateActiveTagForCommaSepField(this.state[field], title),
          value2: isAllowed,
          defaultValue2: true,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: isAllowedName,
                value:
                  this.state[isAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : (EAllowStatus.ALLOW as any),
              },
            } as any),
          placeholderText: ct('PlaceholderEnterContentItemToBeBidOnHereCommaSeparated', {
            item: customItem === 'Targeting' ? ct('Targeting') : customItem,
          }),
          markedEnabled: bulkUpdateEnabled,
          cloneEnabled: cloneBidderEnabled,
          compareValues: this.state.compareValues,
          marked: this.checkIfRowIsMarked([field]),
          handleChangeMarked: () =>
            this.handleChangeMarked([
              {
                key: field,
                displayTitle: title,
                genDisplayValue: () => this.state[field],
                enabled: false,
                genType: () => this.getCloneType(field),
                defaultValue: '',
                tab: 'Targeting',
              },
              {
                key: isAllowedName,
                displayTitle: isAllowedNameDisplay,
                genDisplayValue: () =>
                  this.state[isAllowedName] === EAllowStatus.ALLOW ? ct('Include') : ct('Exclude'),
                enabled: false,
                genType: () => this.getCloneType(isAllowedName),
                defaultValue: EAllowStatus.ALLOW,
                tab: 'Targeting',
              },
            ]),
        } as IInputRow;
      });
      const CustomPanel = {
        title: ct('Custom'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: customRows,
        StaticTooltip: StaticAdvancedTargetingTooltip,
      } as IAccordionPanel;

      // DEVICE PANEL AND ROWS
      const TargetedDevicesRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedDevices'),
        value1: getDeviceEnvironmentAsItems(this.state.TargetingDevices),
        defaultValue1: true,
        handleChange1: this.handleChangeList('TargetingDevices'),
        handleAccept1: () => null,
        isActiveValue1: () => !this.state.TargetingDevices.split(',').includes('0'),
        getActiveTag1: (active: boolean) => {
          if (active) {
            let deviceCount = 0;
            if (this.state.TargetingDevices !== '') {
              deviceCount = this.state.TargetingDevices.split(',').length;
            }
            return ct('FormatLabelWithCount', {
              count: deviceCount,
              label: ct('Devices'),
            });
          }
          return ct('AllItems', { item: ct('Devices') });
        },
        value2: this.state.TargetingDevicesIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDevicesIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDevicesIsAllowed) as any,
            },
          } as any),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingDevices', 'TargetingDevicesIsAllowed']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingDevices',
              displayTitle: ct('TargetedDevices'),
              genDisplayValue: () => {
                let deviceCount = 0;
                if (this.state.TargetingDevices !== '') {
                  if (this.state.TargetingDevices.split(',')[0] === '0') {
                    return ct('All');
                  }
                  deviceCount = this.state.TargetingDevices.split(',').length;
                }
                if (deviceCount === 0) {
                  return ct('All');
                }
                return ct('FormatLabelWithCount', {
                  count: deviceCount,
                  label: ct('Devices'),
                });
              },
              enabled: false,
              genType: () => this.getCloneType('TargetingDevices'),
              defaultValue: '0',
              tab: 'Targeting',
            },
            {
              key: 'TargetingDevicesIsAllowed',
              displayTitle: ct('TargetedDevicesAllowed'),
              genDisplayValue: () =>
                this.state.TargetingDevicesIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingDevicesIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const TargetedDeviceSubTypesRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedDeviceSubtypes'),
        value1: getDeviceEnvironmentSubTypesAsItems(
          this.state.TargetingDeviceSubTypes,
          this.props.session.publisher.ID,
          hasRoleSuperUser(this.props.user.user),
        ),
        defaultValue1: true,
        handleChange1: this.handleChangeList('TargetingDeviceSubTypes'),
        handleAccept1: () => null,
        isActiveValue1: () => !this.state.TargetingDeviceSubTypes.split(',').includes('0'),
        getActiveTag1: (active: boolean) => {
          if (active) {
            let subTypeCount = 0;
            if (this.state.TargetingDeviceSubTypes !== '') {
              subTypeCount = this.state.TargetingDeviceSubTypes.split(',').length;
            }
            return ct('FormatLabelWithCount', {
              count: subTypeCount,
              label: ct('Subtypes'),
            });
          }
          return ct('AllItems', { item: ct('Subtypes') });
        },
        value2: this.state.TargetingDeviceSubTypesIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDeviceSubTypesIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDeviceSubTypesIsAllowed) as any,
            },
          } as any),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'TargetingDeviceSubTypes',
          'TargetingDeviceSubTypesIsAllowed',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingDeviceSubTypes',
              displayTitle: ct('TargetedDeviceSubtypes'),
              genDisplayValue: () => {
                let subTypeCount = 0;
                if (this.state.TargetingDeviceSubTypes !== '') {
                  if (this.state.TargetingDeviceSubTypes.split(',')[0] === '0') {
                    return ct('All');
                  }
                  subTypeCount = this.state.TargetingDeviceSubTypes.split(',').length;
                }
                if (subTypeCount === 0) {
                  return ct('All');
                }
                return ct('FormatLabelWithCount', {
                  count: subTypeCount,
                  label: ct('Subtypes'),
                });
              },
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceSubTypes'),
              defaultValue: '0',
              tab: 'Targeting',
            },
            {
              key: 'TargetingDeviceSubTypesIsAllowed',
              displayTitle: ct('TargetedDeviceSubtypesAllowed'),
              genDisplayValue: () =>
                this.state.TargetingDeviceSubTypesIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceSubTypesIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const TargetedDeviceTypesRow = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems: deviceORTBTypes || [],
        title1: ct('TargetedDeviceTypes'),
        field1: 'TargetingDeviceTypes',
        value1: this.getDisplayedDeviceTypes(false),
        defaultValue1: this.getDisplayedDeviceTypes(true),
        handleChange1: this.handleChangeMultiSelect,
        isActiveValue1: () =>
          this.state.TargetingDeviceTypes !== '' &&
          this.state.TargetingDeviceTypes.split(',').length !== deviceORTBTypes.length,
        getActiveTag1: (active: boolean) => {
          if (active) {
            const deviceTypesCount = this.state.TargetingDeviceTypes.split(',').length;
            return ct('FormatLabelWithCount', {
              count: deviceTypesCount,
              label: ct('DeviceTypes'),
            });
          }
          return ct('AllItems', { item: ct('DeviceTypes') });
        },
        value2: this.state.TargetingDeviceTypesIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDeviceTypesIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDeviceTypesIsAllowed) as any,
            },
          } as any),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingDeviceTypes', 'TargetingDeviceTypesIsAllowed']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingDeviceTypes',
              displayTitle: ct('TargetedDeviceTypes'),
              genDisplayValue: () => {
                let deviceTypesCount = 0;
                if (this.state.TargetingDeviceTypes !== '') {
                  deviceTypesCount = this.state.TargetingDeviceTypes.split(',').length;
                }
                if (deviceTypesCount === 0) {
                  return ct('All');
                }
                return ct('FormatLabelWithCount', {
                  count: deviceTypesCount,
                  label: ct('DeviceTypes'),
                });
              },
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceTypes'),
              defaultValue: '',
              tab: 'Targeting',
            },
            {
              key: 'TargetingDeviceTypesIsAllowed',
              displayTitle: ct('TargetedDeviceTypesAllowed'),
              genDisplayValue: () =>
                this.state.TargetingDeviceTypesIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceTypesIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const TargetedDeviceModelsRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedDeviceModels'),
        value1: getDeviceEnvironmentModelsAsItems(
          this.state.TargetingDeviceModels,
          this.props.session.publisher.ID,
          hasRoleSuperUser(this.props.user.user),
        ),
        defaultValue1: true,
        handleChange1: this.handleChangeList('TargetingDeviceModels'),
        handleAccept1: () => null,
        isActiveValue1: () => !this.state.TargetingDeviceModels.split(',').includes('0'),
        getActiveTag1: (active: boolean) => {
          if (active) {
            let modelCount = 0;
            if (this.state.TargetingDeviceModels !== '') {
              modelCount = this.state.TargetingDeviceModels.split(',').length;
            }
            return ct('FormatLabelWithCount', {
              count: modelCount,
              label: ct('DeviceModels'),
            });
          }
          return ct('AllItems', { item: ct('DeviceModels') });
        },
        value2: this.state.TargetingDeviceModelsIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () => {
          const event = {
            target: {
              name: 'TargetingDeviceModelsIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDeviceModelsIsAllowed),
            },
          };
          this.handleChange(event);
        },
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'TargetingDeviceModels',
          'TargetingDeviceModelsIsAllowed',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingDeviceModels',
              displayTitle: ct('TargetedDeviceModels'),
              genDisplayValue: () => {
                let modelCount = 0;
                if (this.state.TargetingDeviceModels !== '') {
                  if (this.state.TargetingDeviceModels.split(',')[0] === '0') {
                    return ct('All');
                  }
                  modelCount = this.state.TargetingDeviceModels.split(',').length;
                }
                if (modelCount === 0) {
                  return ct('All');
                }
                return ct('FormatLabelWithCount', {
                  count: modelCount,
                  label: ct('DeviceModels'),
                });
              },
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceModels'),
              defaultValue: '0',
              tab: 'Targeting',
            },
            {
              key: 'TargetingDeviceModelsIsAllowed',
              displayTitle: ct('TargetedDeviceModelsAllowed'),
              genDisplayValue: () =>
                this.state.TargetingDeviceModelsIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingDeviceModelsIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const IPFilterRow = {
        renderType: 'TextfieldAndInclude',
        title1: ct('IPFilterWithAsterisk'),
        field1: 'IPFilter',
        value1: this.state.IPFilter,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.IPFilter.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.IPFilter, 'IP Filter'),
        tooltipText: ct('BiddersTooltipIPFilter'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('IPFilters') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['IPFilter']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'IPFilter',
              displayTitle: ct('IPFilter'),
              genDisplayValue: () => this.state.IPFilter,
              enabled: false,
              genType: () => this.getCloneType('IPFilter'),
              defaultValue: '',
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const DevicePanel = {
        title: ct('Device'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [TargetedDevicesRow, TargetedDeviceTypesRow],
      } as IAccordionPanel;
      const deviceEnvironmentSubTypes = getDeviceEnvironmentSubTypes(
        this.props.session.publisher.ID,
        hasRoleSuperUser(this.props.user.user),
      );
      const deviceEnvironmentModels = getDeviceEnvironmentModels(
        this.props.session.publisher.ID,
        hasRoleSuperUser(this.props.user.user),
      );
      const deviceRowsToInsert = [];
      if (deviceEnvironmentSubTypes.length > 0) {
        deviceRowsToInsert.push(TargetedDeviceSubTypesRow);
      }
      if (
        deviceEnvironmentModels.length > 0 &&
        isSamsungPublisher(this.props.session.publisher.ID)
      ) {
        deviceRowsToInsert.push(TargetedDeviceModelsRow);
      }
      // Insert IP Filter row for super users
      if (hasRoleSuperUser(this.props.user.user)) {
        DevicePanel.rows.push(IPFilterRow);
      }
      DevicePanel.rows.splice(1, 0, ...deviceRowsToInsert);

      // DEALS PANEL AND ROWS
      const DealIDRow = {
        renderType: 'TextfieldAndInclude',
        title1: ct('DealID'),
        field1: 'TargetingDealID',
        value1: this.state.TargetingDealID,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingDealID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingDealID, 'Deal ID'),
        tooltipText: ct('BiddersTooltipDealID'),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('DealIDs') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingDealID']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingDealID',
              displayTitle: ct('DealID'),
              genDisplayValue: () => this.state.TargetingDealID,
              enabled: false,
              genType: () => this.getCloneType('TargetingDealID'),
              defaultValue: '',
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      // Freewheel Section ID ROWS for Deals Panel
      const FWSectionIDsRow = {
        renderType: 'TextfieldAndInclude',
        title1: ct('FreewheelSectionIDs'),
        field1: 'TargetingFWSectionIDs',
        value1: this.state.TargetingFWSectionIDs,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingFWSectionIDs.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingFWSectionIDs, 'Section ID'),
        tooltipText: ct('BiddersTooltipFreewheelSectionIDs'),
        value2: this.state.TargetingFWSectionIDsIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingFWSectionIDsIsAllowed',
              value:
                this.state.TargetingFWSectionIDsIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('SectionIDs') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingFWSectionIDs']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingFWSectionIDs',
              displayTitle: ct('FWSectionIDs'),
              genDisplayValue: () => this.state.TargetingFWSectionIDs,
              enabled: false,
              genType: () => this.getCloneType('TargetingFWSectionIDs'),
              defaultValue: '',
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      // const TargetingFWSectionIDsPanel = {
      //   title: 'Sections', panelInactiveRowTag: 'None', panelActiveChipTitle: 'Custom',
      //   rows: [FWSectionIDsRow],
      // } as IAccordionPanel;
      const DealsPanel = {
        title: ct('Deals'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [DealIDRow, FWSectionIDsRow],
      } as IAccordionPanel;

      // STREAM PANEL AND ROWS
      const LivestreamRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedLivestream'),
        value1: getSelectedLivestreamOptions(
          this.state.LivestreamTargeting,
          this.state.Bidder,
          this.props.user.publisher.ID,
        ),
        defaultValue1: true,
        handleChange1: this.handleChangeList('LivestreamTargeting'),
        handleAccept1: () => null,
        isActiveValue1: () => {
          if (
            this.state.LivestreamTargeting &&
            this.state.LivestreamTargeting.split(',').includes('0')
          ) {
            return false;
          }
          return true;
        },
        getActiveTag1: (active: boolean) => {
          if (active) {
            let livestreamOptionsCount = 0;
            if (this.state.LivestreamTargeting !== '') {
              livestreamOptionsCount = (this.state.LivestreamTargeting || '').split(',').length;
            }
            return ct('FormatLabelWithCount', {
              count: livestreamOptionsCount,
              label: ct('Livestreams'),
            });
          }
          return ct('AllItems', { item: ct('Livestreams') });
        },
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['LivestreamTargeting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'LivestreamTargeting',
              displayTitle: ct('TargetedLivestream'),
              genDisplayValue: () => {
                if (
                  this.state.LivestreamTargeting &&
                  this.state.LivestreamTargeting.split(',').includes('0')
                ) {
                  return ct('All');
                }
                let livestreamOptionsCount = 0;
                if (this.state.LivestreamTargeting !== '') {
                  livestreamOptionsCount = (this.state.LivestreamTargeting || '').split(',').length;
                }
                return ct('FormatLabelWithCount', {
                  count: livestreamOptionsCount,
                  label: ct('Livestreams'),
                });
              },
              enabled: false,
              genType: () => this.getCloneType('LivestreamTargeting'),
              defaultValue: '0',
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const StreamPanel = {
        title: ct('Stream'),
        panelInactiveRowTag: ct('AllItems', { item: ct('StreamTypes') }),
        panelActiveChipTitle: ct('Custom'),
        rows: [LivestreamRow],
      } as IAccordionPanel;

      // AUDIENCE SEGMENT PANEL AND ROWS
      const AudienceSegmentRow = {
        renderType: 'custom',
        customRender: this.renderAudienceSegmentRow,
        title1: '',
        field1: '',
        handleChange1: noopVoid,
        isActiveValue1: () =>
          this.state.TargetingAudienceSegmentID.length &&
          this.state.TargetingAudienceSegmentID.split(',').length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingAudienceSegmentID, 'Segment'),
        value1: this.state.TargetingAudienceSegmentIDIsAllowed,
        defaultValue1: EAllowStatus.ALLOW,
        value2: this.state.TargetingAudienceSegmentID || 'All',
        defaultValue2: 'All',
        value3: this.state.SegmentTargeting,
        defaultValue3: SegmentTargetingOR,
        cloneEnabled: !!cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'TargetingAudienceSegmentIDIsAllowed',
          'TargetingAudienceSegmentID',
          'SegmentTargeting',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingAudienceSegmentIDIsAllowed',
              displayTitle: ct('TargetedSegmentsAllowed'),
              genDisplayValue: () =>
                this.state.TargetingAudienceSegmentIDIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingAudienceSegmentIDIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
            {
              key: 'TargetingAudienceSegmentID',
              displayTitle: ct('TargetedSegments'),
              genDisplayValue: () => this.state.TargetingAudienceSegmentID || ct('All'),
              enabled: false,
              genType: () => this.getCloneType('TargetingAudienceSegmentID'),
              defaultValue: '',
              tab: 'Targeting',
            },
            {
              key: 'SegmentTargeting',
              displayTitle: ct('SegmentAndOr'),
              genDisplayValue: () =>
                this.state.SegmentTargeting === SegmentTargetingOR ? ct('Or') : ct('And'),
              enabled: false,
              genType: () => this.getCloneType('SegmentTargeting'),
              defaultValue: SegmentTargetingOR,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const ContextualSegmentRow = {
        renderType: 'custom',
        customRender: this.renderContextualSegmentRow,
        title1: '',
        field1: '',
        handleChange1: noopVoid,
        value1: this.state.ContextualSegmentIDS,
        defaultValue1: [] as number[],
        isActiveValue1: () => this.state.ContextualSegmentIDS.length > 0,
        getActiveTag1: () =>
          this.state.ContextualSegmentIDS.length > 0 ? ct('ContextualSegment') : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: !!cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['ContextualSegmentIDS']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'ContextualSegmentIDS',
              displayTitle: ct('ContextualSegmentIDs'),
              genDisplayValue: () => this.state.ContextualSegmentIDS.join(', '),
              enabled: false,
              genType: () => this.getCloneType('ContextualSegmentIDS'),
              defaultValue: [] as number[],
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const AudienceSegmentPanel = {
        title: ct('Segments'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [AudienceSegmentRow, ContextualSegmentRow],
      } as IAccordionPanel;

      // PRICE TARGETING PANEL AND ROWS
      const PriceRow = {
        renderType: 'TextfieldAndInclude',
        title1: ct('Price'),
        field1: 'TargetingPrice',
        value1: this.state.TargetingPrice,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingPrice.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingPrice, 'Price'),
        tooltipText: ct('BiddersTooltipPrice'),
        value2: this.state.TargetingPriceIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingPriceIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingPriceIsAllowed) as any,
            },
          } as any),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('Prices') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingPrice']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingPrice',
              displayTitle: ct('Price'),
              genDisplayValue: () => this.state.TargetingPrice,
              enabled: false,
              genType: () => this.getCloneType('TargetingPrice'),
              defaultValue: '',
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const PricePanel = {
        title: ct('Price'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [PriceRow],
      } as IAccordionPanel;

      // APP BUNDLE, SITE PAGES, SITE DOMAIN
      // APP BUNDLE ROW
      const AppBundleIDRow = {
        renderType: 'TextfieldAndIncludeAndLogic',
        title1: ct('AppBundleID'),
        field1: 'TargetingAppBundleID',
        value1: this.state.TargetingAppBundleID,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingAppBundleID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingAppBundleID, 'App Bundle ID'),
        value2: this.state.TargetingAppBundleIDIsAllowed,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingAppBundleIDIsAllowed',
              value: !this.state.TargetingAppBundleIDIsAllowed,
            },
          } as any),
        tooltipText: (
          <div>
            App Bundle ID to bid on, comma separated
            <br /> More info{' '}
            <a
              href='https://iabtechlab.com/wp-content/uploads/2020/08/IAB-Tech-Lab-OTT-store-assigned-App-Identification-Guidelines-2020.pdf'
              rel='noopener'
              target='_blank'
            >
              here
            </a>
          </div>
        ),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('AppBundleIDs') }),
        value3: this.state.TargetingAppBundleSitePagesLogic,
        defaultValue3: ELogicalOperator.AND,
        handleChange3: () =>
          this.handleChange({
            target: {
              name: 'TargetingAppBundleSitePagesLogic',
              value:
                this.state.TargetingAppBundleSitePagesLogic === ELogicalOperator.OR
                  ? ELogicalOperator.AND
                  : ELogicalOperator.OR,
            },
          } as any),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingAppBundleID', 'TargetingAppBundleIDIsAllowed']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingAppBundleID',
              displayTitle: ct('AppBundleID'),
              genDisplayValue: () => this.state.TargetingAppBundleID,
              enabled: false,
              genType: () => this.getCloneType('TargetingAppBundleID'),
              defaultValue: '',
              tab: 'Targeting',
            },
            {
              key: 'TargetingAppBundleIDIsAllowed',
              displayTitle: ct('AppBundleIDAllowed'),
              genDisplayValue: () =>
                this.state.TargetingAppBundleIDIsAllowed ? ct('Include') : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingAppBundleIDIsAllowed'),
              defaultValue: true,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      // SITE PAGE ROW
      const SitePagesRow = {
        renderType: 'TextfieldAndInclude',
        title1: ct('SitePages'),
        field1: 'TargetingSitePages',
        value1: this.state.TargetingSitePages,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingSitePages.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingSitePages, 'Site Pages'),
        tooltipText: ct('BiddersTooltipSitePages'),
        value2: this.state.TargetingSitePagesIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingSitePagesIsAllowed',
              value:
                this.state.TargetingSitePagesIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('SitePages') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingSitePages', 'TargetingSitePagesIsAllowed']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingSitePages',
              displayTitle: ct('SitePages'),
              genDisplayValue: () => this.state.TargetingSitePages,
              enabled: false,
              genType: () => this.getCloneType('TargetingSitePages'),
              defaultValue: '',
              tab: 'Targeting',
            },
            {
              key: 'TargetingSitePagesIsAllowed',
              displayTitle: ct('TargetedSitePagesAllowed'),
              genDisplayValue: () =>
                this.state.TargetingSitePagesIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingSitePagesIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      // SITE DOMAIN ROW
      const SiteDomainRow = {
        renderType: 'TextfieldAndInclude',
        title1: ct('SiteDomains'),
        field1: 'TargetingSiteDomain',
        value1: this.state.TargetingSiteDomain,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingSiteDomain.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingSiteDomain, 'Site Domain'),
        tooltipText: ct('BiddersTooltipSiteDomains'),
        value2: this.state.TargetingSiteDomainIsAllowed !== EAllowStatus.DENY,
        defaultValue2: true,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingSiteDomainIsAllowed',
              value:
                this.state.TargetingSiteDomainIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('SiteDomains') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingSiteDomain', 'TargetingSiteDomainIsAllowed']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingSiteDomain',
              displayTitle: ct('SiteDomain'),
              genDisplayValue: () => this.state.TargetingSiteDomain,
              enabled: false,
              genType: () => this.getCloneType('TargetingSiteDomain'),
              defaultValue: '',
              tab: 'Targeting',
            },
            {
              key: 'TargetingSiteDomainIsAllowed',
              displayTitle: ct('TargetedSiteDomainAllowed'),
              genDisplayValue: () =>
                this.state.TargetingSiteDomainIsAllowed === EAllowStatus.ALLOW
                  ? ct('Include')
                  : ct('Exclude'),
              enabled: false,
              genType: () => this.getCloneType('TargetingSiteDomainIsAllowed'),
              defaultValue: EAllowStatus.ALLOW,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;
      const AppBundleSitePagesPanel = {
        title: ct('AppAndSite'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [AppBundleIDRow, SitePagesRow, SiteDomainRow],
      } as IAccordionPanel;

      const extendedIDTargetingTypeSelectItems = [
        { key: ExtendedIDTargetingTypeDisabled, text: ct('Disabled') },
        { key: ExtendedIDTargetingTypeEnabledIfPresent, text: ct('TargetIfPresent') },
        { key: ExtendedIDTargetingTypeEnabledIfMissing, text: ct('TargetIfMissing') },
      ];

      const convertExtendedIDTargetingTypeToText: { [key: number]: string } = {
        1: ct('Disabled'),
        2: ct('TargetIfPresent'),
        3: ct('TargetIfMissing'),
      };

      const UID20Row = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'UID 2.0',
        field1: 'TargetingUID20TargetingType',
        value1: this.state.TargetingUID20TargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingUID20TargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'UID 2.0' : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingUID20TargetingType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingUID20TargetingType',
              displayTitle: 'UID 2.0',
              genDisplayValue: () =>
                convertExtendedIDTargetingTypeToText[this.state.TargetingUID20TargetingType],
              enabled: false,
              genType: () => this.getCloneType('TargetingUID20TargetingType'),
              defaultValue: ExtendedIDTargetingTypeDisabled,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const GooglePairIDRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'Google Pair ID',
        field1: 'TargetingGooglePairIDTargetingType',
        value1: this.state.TargetingGooglePairIDTargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingGooglePairIDTargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'Google Pair ID' : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingGooglePairIDTargetingType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingGooglePairIDTargetingType',
              displayTitle: 'Google Pair ID',
              genDisplayValue: () =>
                convertExtendedIDTargetingTypeToText[this.state.TargetingGooglePairIDTargetingType],
              enabled: false,
              genType: () => this.getCloneType('TargetingGooglePairIDTargetingType'),
              defaultValue: ExtendedIDTargetingTypeDisabled,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const LiveRampATSRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'LiveRamp ATS',
        field1: 'TargetingLiveRampATSTargetingType',
        value1: this.state.TargetingLiveRampATSTargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingLiveRampATSTargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'LiveRamp ATS' : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingLiveRampATSTargetingType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingLiveRampATSTargetingType',
              displayTitle: 'LiveRamp ATS',
              genDisplayValue: () =>
                convertExtendedIDTargetingTypeToText[this.state.TargetingLiveRampATSTargetingType],
              enabled: false,
              genType: () => this.getCloneType('TargetingLiveRampATSTargetingType'),
              defaultValue: ExtendedIDTargetingTypeDisabled,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const IrisSignalRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'Iris Signal',
        field1: 'TargetingIrisSignalTargetingType',
        value1: this.state.TargetingIrisSignalTargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingIrisSignalTargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'Iris Signal' : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['TargetingIrisSignalTargetingType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'TargetingIrisSignalTargetingType',
              displayTitle: 'Iris Signal',
              genDisplayValue: () =>
                convertExtendedIDTargetingTypeToText[this.state.TargetingIrisSignalTargetingType],
              enabled: false,
              genType: () => this.getCloneType('TargetingIrisSignalTargetingType'),
              defaultValue: ExtendedIDTargetingTypeDisabled,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      // const SamsungIdentityRow = {
      //   renderType: 'SimpleSingleSelect',
      //   simpleSelectItems: extendedIDTargetingTypeSelectItems,
      //   title1: 'Samsung Identity',
      //   field1: 'TargetingSamsungIdentityTargetingType',
      //   value1: this.state.TargetingSamsungIdentityTargetingType,
      //   defaultValue1: ExtendedIDTargetingTypeDisabled,
      //   handleChange1: this.handleChange,
      //   isActiveValue1: () =>
      //     this.state.TargetingSamsungIdentityTargetingType !== ExtendedIDTargetingTypeDisabled,
      //   getActiveTag1: (active: boolean) => (active ? 'Samsung Identity' : ''),
      //   markedEnabled: bulkUpdateEnabled,
      //   cloneEnabled: cloneBidderEnabled,
      //   compareValues: this.state.compareValues,
      //   marked: this.checkIfRowIsMarked(['TargetingSamsungIdentityTargetingType']),
      //   handleChangeMarked: () =>
      //     this.handleChangeMarked([
      //       {
      //         key: 'TargetingSamsungIdentityTargetingType',
      //         displayTitle: 'Samsung Identity',
      //         genDisplayValue: () =>
      //           convertExtendedIDTargetingTypeToText[
      //             this.state.TargetingSamsungIdentityTargetingType
      //           ],
      //         enabled: false,
      //         genType: () => this.getCloneType('TargetingSamsungIdentityTargetingType'),
      //         defaultValue: ExtendedIDTargetingTypeDisabled,
      //         tab: 'Targeting',
      //       },
      //     ]),
      // } as IInputRow;

      // const SamsungEPGMetadataRow = {
      //   renderType: 'SimpleSingleSelect',
      //   simpleSelectItems: extendedIDTargetingTypeSelectItems,
      //   title1: 'Samsung EPG Metadata',
      //   field1: 'TargetingSamsungEPGMetadataTargetingType',
      //   value1: this.state.TargetingSamsungEPGMetadataTargetingType,
      //   defaultValue1: ExtendedIDTargetingTypeDisabled,
      //   handleChange1: this.handleChange,
      //   isActiveValue1: () =>
      //     this.state.TargetingSamsungEPGMetadataTargetingType !== ExtendedIDTargetingTypeDisabled,
      //   getActiveTag1: (active: boolean) => (active ? 'Samsung EPG Metadata' : ''),
      //   markedEnabled: bulkUpdateEnabled,
      //   cloneEnabled: cloneBidderEnabled,
      //   compareValues: this.state.compareValues,
      //   marked: this.checkIfRowIsMarked(['TargetingSamsungEPGMetadataTargetingType']),
      //   handleChangeMarked: () =>
      //     this.handleChangeMarked([
      //       {
      //         key: 'TargetingSamsungEPGMetadataTargetingType',
      //         displayTitle: 'Samsung EPG Metadata',
      //         genDisplayValue: () =>
      //           convertExtendedIDTargetingTypeToText[
      //             this.state.TargetingSamsungEPGMetadataTargetingType
      //           ],
      //         enabled: false,
      //         genType: () => this.getCloneType('TargetingSamsungEPGMetadataTargetingType'),
      //         defaultValue: ExtendedIDTargetingTypeDisabled,
      //         tab: 'Targeting',
      //       },
      //     ]),
      // } as IInputRow;

      const extendedIDsRows = [UID20Row, GooglePairIDRow, LiveRampATSRow, IrisSignalRow];

      // if (isPublisherSamsung(this.props.session.publisher.ID)) {
      //   extendedIDsRows.push(SamsungIdentityRow, SamsungEPGMetadataRow);
      // }

      const ExtendedIDsPanel = {
        title: ct('ExtendedIDs'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: extendedIDsRows,
        StaticTooltip: StaticExtendedIDTooltip,
      } as IAccordionPanel;

      // publica campaign only has inventory targeting
      const panels = [InventoryPanel];
      if (
        (this.state.Bidder !== DemandSources.publicaCampaign ||
          (this.state.Bidder === DemandSources.publicaCampaign &&
            this.state.EnableSponsorshipMode === EBool.EBool_TRUE)) &&
        !bulkUpdateIDsIncludesDirectCampaign
      ) {
        panels.push(
          ContentPanel,
          GeoPanel,
          DaypartingPanel,
          PrivacyPanel,
          CustomPanel,
          DevicePanel,
          AppBundleSitePagesPanel,
          DealsPanel,
          StreamPanel,
          AudienceSegmentPanel,
          ExtendedIDsPanel,
        );
      }
      if (this.state.Bidder === DemandSources.rokuHB) {
        panels.push(PricePanel);
      }
      return (
        <Grid item style={{ height: '100%' }}>
          <Cols paddingBottom={spacing.small} gap={spacing.small} style={{ alignItems: 'center' }}>
            <Col width={32} displayFlex>
              <IconV2 name='code' small />
            </Col>
            <Col>
              <Text small bold tKey='CustomTargeting' />
            </Col>
          </Cols>
          <MultiAccordion
            title={ct('TargetingParameters')}
            subtitle={ct('BiddersMessageTargetingParameters')}
            panels={panels}
            disableEdit={this.hasNoWriteRights()}
            forcePanelsOpen={bulkUpdateEnabled}
          />
        </Grid>
      );
    };

    // custom render function for deal id
    renderAppendDealIDRow = (rowInfo: IInputRow) => {
      const { classes } = this.props;
      return (
        DEAL_SSP_LIST.includes(this.state.Bidder) && (
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
              <Grid item xs={3}>
                <Grid
                  container
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  spacing={0}
                >
                  {this.isCloneBidderOrBulkUpdate() && (
                    <Grid item>
                      <Checkbox
                        className={this.props.classes.checkbox}
                        checked={rowInfo.marked}
                        onChange={rowInfo.handleChangeMarked}
                      />
                    </Grid>
                  )}
                  <Grid item>
                    <Typography className={classes.insideAccordionText}>
                      Append Deal ID
                      <Tooltip title={ct('BiddersTooltipPublicaDealIDs')} placement='bottom-start'>
                        <InfoIcon
                          style={{
                            width: '1rem',
                            color: '#929599',
                            position: 'relative',
                            top: 8,
                            left: 8,
                          }}
                        />
                      </Tooltip>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={6}>
                <Grid container>
                  <Grid item xs={5}>
                    <DealTargetingMultiSelect
                      name='Deals'
                      bidderType={this.state.Bidder}
                      onChange={this.handleDealSelectChange}
                      publisherID={this.props.session.publisher.ID}
                      value={this.state.Deals}
                      isDealPrivateAuctionEnabled={
                        this.state.PrivateAuction === PrivateAuctionTypeEnabled
                      }
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      style={{
                        color: getColorTheme('secondaryButtonText'),
                        width: 200,
                      }}
                      onClick={() => this.setState({ openDealSelectTable: true })}
                    >
                      {ct('ShowItem', { item: ct('TargetedDeals') })}
                    </Button>
                    <Dialog
                      fullWidth
                      maxWidth='lg'
                      keepMounted
                      open={this.state.openDealSelectTable}
                      onClose={() => this.setState({ openDealSelectTable: false })}
                    >
                      <BidderSettingsDealsTable
                        deals={this.state.Deals}
                        user={this.props.user.user}
                        publisherID={this.props.session.publisher.ID}
                      />
                    </Dialog>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )
      );
    };

    renderTargetingIDsRow = (): JSX.Element => {
      return DEAL_SSP_LIST.includes(this.state.Bidder) ? (
        <Grid item style={{ width: '100%' }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Text small tKey='TargetedDeals' />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={6}>
              <Button
                style={{
                  color: getColorTheme('secondaryButtonText'),
                  width: 200,
                }}
                onClick={() => this.setState({ openDealSelectTable: true })}
              >
                {ct('ShowItem', { item: ct('TargetedDeals') })}
              </Button>
              <Dialog
                fullWidth
                maxWidth='lg'
                keepMounted
                open={this.state.openDealSelectTable}
                onClose={() => this.setState({ openDealSelectTable: false })}
              >
                <BidderSettingsDealsTable
                  deals={this.state.Deals}
                  user={this.props.user.user}
                  publisherID={this.props.session.publisher.ID}
                />
              </Dialog>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <></>
      );
    };

    // Read notes in multi-accordion and multi-accordion-panel components to understand
    // props required to use that component
    renderBidRequestRewrite = () => {
      const { bulkUpdateIDs, cloneBidderEnabled, session, user } = this.props;

      const { MimeTypeOverride } = this.state;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      // if there have been new impressions since the last test was created, params used in testing are disabled
      const newImpressionsSinceLastTest =
        this.state.CRONQuantityCount !== this.state.CRONQuantityCountSinceLastTest;
      const paramsInTesting = this.getParamsInTesting();
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      const enableExtendedRewrites =
        this.props.session.publisher.EnableExtendedRewrites === EBool.EBool_TRUE;
      // APP PANEL AND ROWS
      const AppBundleOverrideRow = {
        renderType: 'TextfieldAndSwitch',
        title1: ct('AppBundleOverride'),
        field1: 'AppBundleOverride',
        value1: this.state.AppBundleOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.AppBundleOverride !== '',
        getActiveTag1: (active: boolean) => (active ? ct('AppBundle') : ''),
        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.AppBundleOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        handleChange2: () => this.handleChangeEBool('AppBundleOverrideIfEmpty'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('AppBundleOverride') }),
        disabled1: paramsInTesting.includes('AppBundleOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('AppBundleOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AppBundleOverride', 'AppBundleOverrideIfEmpty']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AppBundleOverride',
              displayTitle: ct('AppBundleOverride'),
              genDisplayValue: () => this.state.AppBundleOverride,
              enabled: false,
              genType: () => this.getCloneType('AppBundleOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
            {
              key: 'AppBundleOverrideIfEmpty',
              displayTitle: ct('AppBundleOverrideIfEmpty'),
              genDisplayValue: () => EBool.toBoolString(this.state.AppBundleOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('AppBundleOverrideIfEmpty'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const AppIDOverrideRow = {
        renderType: 'TextfieldAndSwitch',
        title1: ct('AppIDOverride'),
        field1: 'AppIDOverride',
        value1: this.state.AppIDOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.AppIDOverride !== '',
        getActiveTag1: (active: boolean) => (active ? ct('AppID') : ''),
        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.AppIDOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        handleChange2: () => this.handleChangeEBool('AppIDOverrideIfEmpty'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('AppIDOverride') }),
        disabled1: paramsInTesting.includes('AppIDOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('AppIDOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AppIDOverride', 'AppIDOverrideIfEmpty']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AppIDOverride',
              displayTitle: ct('AppIDOverride'),
              genDisplayValue: () => this.state.AppIDOverride,
              enabled: false,
              genType: () => this.getCloneType('AppIDOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
            {
              key: 'AppIDOverrideIfEmpty',
              displayTitle: ct('AppIDOverrideIfEmpty'),
              genDisplayValue: () => EBool.toBoolString(this.state.AppIDOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('AppIDOverrideIfEmpty'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const AppNameOverrideRow = {
        renderType: 'TextfieldAndSwitch',
        title1: ct('AppNameOverride'),
        field1: 'AppNameOverride',
        value1: this.state.AppNameOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.AppNameOverride !== '',
        getActiveTag1: (active: boolean) => (active ? ct('AppName') : ''),

        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.AppNameOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        handleChange2: () => this.handleChangeEBool('AppNameOverrideIfEmpty'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('AppNameOverride') }),
        disabled1: paramsInTesting.includes('AppNameOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('AppNameOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AppNameOverride', 'AppNameOverrideIfEmpty']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AppNameOverride',
              displayTitle: ct('AppNameOverride'),
              genDisplayValue: () => this.state.AppNameOverride,
              enabled: false,
              genType: () => this.getCloneType('AppNameOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
            {
              key: 'AppNameOverrideIfEmpty',
              displayTitle: ct('AppNameOverrideIfEmpty'),
              genDisplayValue: () => EBool.toBoolString(this.state.AppNameOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('AppNameOverrideIfEmpty'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const AppDomainOverrideRow = {
        renderType: 'TextfieldAndSwitch',
        title1: ct('AppDomainOverrideWithAsterisk'),
        field1: 'AppDomainOverride',
        value1: this.state.AppDomainOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.AppDomainOverride !== '',
        getActiveTag1: (active: boolean) => (active ? ct('AppDomain') : ''),
        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.AppDomainOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        errors2: this.state.errors.AppDomainOverrideIfEmpty,
        handleChange2: () => this.handleChangeEBool('AppDomainOverrideIfEmpty'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('AppDomainOverride') }),
        disabled1: paramsInTesting.includes('AppDomainOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('AppDomainOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AppDomainOverride', 'AppDomainOverrideIfEmpty']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AppDomainOverride',
              displayTitle: ct('AppDomainOverride'),
              genDisplayValue: () => this.state.AppDomainOverride,
              enabled: false,
              genType: () => this.getCloneType('AppDomainOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
            {
              key: 'AppDomainOverrideIfEmpty',
              displayTitle: ct('AppDomainOverrideIfEmpty'),
              genDisplayValue: () => EBool.toBoolString(this.state.AppDomainOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('AppDomainOverrideIfEmpty'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const AppPanel = {
        title: enableExtendedRewrites ? ct('App') : ct('AppWithAsterisk'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows:
          isSuperUser || hasPermSuperUser(session.publisher.ID, user.user.PermissionRole.id)
            ? [AppBundleOverrideRow, AppIDOverrideRow, AppNameOverrideRow, AppDomainOverrideRow]
            : [AppBundleOverrideRow, AppIDOverrideRow, AppNameOverrideRow],
      } as IAccordionPanel;

      // APP STORE URL PANEL AND ROWS
      const AppStoreURLRows = this.generateRewriteInputRows({
        stateKey: 'AppStoreURL',
        activeRows: this.state.rewriteInputRows.AppStoreURL,
        handleChange: this.handleChangeAppStoreURLOverride,
        selectTitle: ct('Device'),
        textfieldTitle: ct('AppStoreURL'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('StoreURL') }),
      });
      const AppStoreURLOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        singleLineSwitchText: true,
        value1: EBool.isTrue(this.state.AppStoreUrlOverrideIfEmpty),
        defaultValue1: EBool.EBool_FALSE,
        isActiveValue1: () =>
          EBool.isTrue(this.state.AppStoreUrlOverrideIfEmpty) &&
          !isEmpty(this.state.rewriteInputRows.AppStoreURL),
        getActiveTag1: (active: boolean) => (active ? ct('AppStoreURL') : ''),
        handleChange1: () => this.handleChangeEBool('AppStoreUrlOverrideIfEmpty'),
        disabled1: isEmpty(this.state.rewriteInputRows.AppStoreURL),
      } as IInputRow;
      const AppStoreURLRemoveToggleRow = {
        renderType: 'SimpleSwitch',
        title1: ct('RemoveItemFromRequest', { item: ct('AppStoreURL') }),
        singleLineSwitchText: true,
        value1: EBool.isTrue(this.state.RemoveAppStoreURLFromBidRequest),
        defaultValue1: EBool.EBool_FALSE,
        isActiveValue1: () => EBool.isTrue(this.state.RemoveAppStoreURLFromBidRequest),
        getActiveTag1: (active: boolean) => (active ? ct('AppStoreURL') : ''),
        handleChange1: () => this.handleChangeEBool('RemoveAppStoreURLFromBidRequest'),
        disabled1: !isEmpty(this.state.rewriteInputRows.AppStoreURL),
      } as IInputRow;
      const AppStoreUrlPanel = {
        title: enableExtendedRewrites ? ct('AppStoreURL') : ct('AppStoreURLWithAsterisk'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [...AppStoreURLRows, AppStoreURLOverrideToggleRow, AppStoreURLRemoveToggleRow],
      } as IAccordionPanel;

      // CONTENT PANEL AND ROWS
      const RemoveContentFromBidRequestRow = {
        renderType: 'SimpleSwitch',
        title1: ct('RemoveEntireContentObjectFromBidRequest'),
        field1: 'RemoveContentFromBidRequest',
        value1: this.state.RemoveContentFromBidRequest === EBool.EBool_TRUE,
        defaultValue1: false,
        handleChange1: () => this.handleChangeEBool('RemoveContentFromBidRequest'),
        isActiveValue1: () => this.state.RemoveContentFromBidRequest === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) =>
          active ? ct('RemoveItem', { item: ct('Content') }) : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['RemoveContentFromBidRequest']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'RemoveContentFromBidRequest',
              displayTitle: ct('RemoveItemFromRequest', { item: ct('Content') }),
              genDisplayValue: () => EBool.toBoolString(this.state.RemoveContentFromBidRequest),
              enabled: false,
              genType: () => this.getCloneType('RemoveContentFromBidRequest'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      const ContentDistribNameOverrideRow = {
        renderType: 'TextfieldAndDoubleSwitch',
        title1: ct('ContentDistributorNameOverride'),
        field1: 'ContentDistribNameOverride',
        value1: this.state.ContentDistribNameOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          (this.state.ContentDistribNameOverride !== '' ||
            this.state.RemoveContentDistribNameFromBidRequest === EBool.EBool_TRUE) &&
          this.state.RemoveContentFromBidRequest === EBool.EBool_FALSE,
        getActiveTag1: (active: boolean) => (active ? ct('ContentDistributorName') : ''),

        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.ContentDistribNameOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        handleChange2: () => this.handleChangeEBool('ContentDistribNameOverrideIfEmpty'),

        title3: ct('RemoveItemFromRequest', { item: ct('DistributorName') }),
        value3: this.state.RemoveContentDistribNameFromBidRequest,
        defaultValue3: EBool.EBool_FALSE,
        handleChange3: () => this.handleChangeEBool('RemoveContentDistribNameFromBidRequest'),

        placeholderText: ct('PlaceholderEnterItem', { item: ct('ContentDistributorNameOverride') }),
        disabled1:
          (paramsInTesting.includes('ContentDistribNameOverride') && newImpressionsSinceLastTest) ||
          this.state.RemoveContentFromBidRequest === EBool.EBool_TRUE,

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'RemoveContentDistribNameFromBidRequest',
          'ContentDistribNameOverrideIfEmpty',
          'ContentDistribNameOverride',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'RemoveContentDistribNameFromBidRequest',
              displayTitle: ct('RemoveItemFromRequest', { item: ct('DistributorName') }),
              genDisplayValue: () =>
                EBool.toBoolString(this.state.RemoveContentDistribNameFromBidRequest),
              enabled: false,
              genType: () => this.getCloneType('RemoveContentDistribNameFromBidRequest'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
            {
              key: 'ContentDistribNameOverrideIfEmpty',
              displayTitle: ct('ItemIfEmpty', { item: ct('ContentDistributorNameOverride') }),
              genDisplayValue: () =>
                EBool.toBoolString(this.state.ContentDistribNameOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('ContentDistribNameOverrideIfEmpty'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
            {
              key: 'ContentDistribNameOverride',
              displayTitle: ct('ContentDistributorNameOverride'),
              genDisplayValue: () => this.state.ContentDistribNameOverride,
              enabled: false,
              genType: () => this.getCloneType('ContentDistribNameOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      const RemoveContentDistribNameRow = {
        renderType: 'SimpleSwitch',
        title1: ct('RemoveItemFromRequest', { item: ct('DistributorName') }),
        field1: 'RemoveContentDistribNameFromBidRequest',
        value1: this.state.RemoveContentDistribNameFromBidRequest === EBool.EBool_TRUE,
        handleChange1: () => this.handleChangeEBool('RemoveContentDistribNameFromBidRequest'),
        isActiveValue1: () =>
          this.state.RemoveContentDistribNameFromBidRequest === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) =>
          active ? ct('RemoveItem', { item: ct('DistributorName') }) : '',
      } as IInputRow;

      const contentOverrideItemToTKey: Record<string, TKey> = {
        Channel: 'Channel',
        Network: 'Network',
        Series: 'Series',
        Title: 'Title',
        Category: 'Category',
        Genre: 'Genre',
        Rating: 'Rating',
        ID: 'ID',
        Prodqual: 'Prodqual',
        ProducerName: 'ProducerName',
        ProducerID: 'ProducerID',
        Keywords: 'Keywords',
        Language: 'Language',
        Season: 'Season',
      };
      const ContentOverrideRows = [
        'Channel',
        'Network',
        'Series',
        'Title',
        'Category',
        'Genre',
        'Rating',
        'ID',
        'Prodqual',
        'ProducerName',
        'ProducerID',
        'Keywords',
        'Language',
        'Season',
      ].map((contentItem: string) => {
        const contentTitle = ct('ContentItemOverride', {
          item: ct(contentOverrideItemToTKey[contentItem]),
        });
        const contentField = `Content${contentItem}Override`;
        const contentFieldIfEmpty = `Content${contentItem}OverrideIfEmpty`;
        const removeContentField = `RemoveContent${contentItem}FromBidRequest`;
        return {
          renderType: 'TextfieldAndDoubleSwitch',
          title1: contentTitle,
          field1: contentField,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          value1: this.state[contentField],
          defaultValue1: '',
          handleChange1: this.handleChange,
          isActiveValue1: () =>
            (this.state[contentField] !== '' ||
              this.state[removeContentField] === EBool.EBool_TRUE) &&
            this.state.RemoveContentFromBidRequest === EBool.EBool_FALSE,
          getActiveTag1: (active: boolean) =>
            active
              ? ct('ContentItemOverride', { item: ct(contentOverrideItemToTKey[contentItem]) })
              : '',

          title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
          value2: this.state[contentFieldIfEmpty],
          defaultValue2: EBool.EBool_FALSE,
          handleChange2: () => this.handleChangeEBool(contentFieldIfEmpty),

          title3: ct('RemoveItemFromRequest', { item: ct(contentOverrideItemToTKey[contentItem]) }),
          value3: this.state[removeContentField],
          defaultValue3: EBool.EBool_FALSE,
          handleChange3: () => this.handleChangeEBool(removeContentField),

          placeholderText: ct('PlaceholderEnterItem', { item: contentTitle }),
          disabled1:
            (paramsInTesting.includes(contentField) && newImpressionsSinceLastTest) ||
            this.state.RemoveContentFromBidRequest === EBool.EBool_TRUE,

          markedEnabled: bulkUpdateEnabled,
          cloneEnabled: cloneBidderEnabled,
          compareValues: this.state.compareValues,
          marked: this.checkIfRowIsMarked([removeContentField, contentFieldIfEmpty, contentField]),
          handleChangeMarked: () =>
            this.handleChangeMarked([
              {
                key: removeContentField,
                displayTitle: ct('RemoveContentItem', {
                  item: ct(contentOverrideItemToTKey[contentItem]),
                }),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                genDisplayValue: () => EBool.toBoolString(this.state[removeContentField]),
                enabled: false,
                genType: () => this.getCloneType(removeContentField),
                defaultValue: EBool.EBool_FALSE,
                tab: 'Rewrites',
              },
              {
                key: contentFieldIfEmpty,
                displayTitle: ct('ItemIfEmpty', { item: contentTitle }),
                genDisplayValue: () => EBool.toBoolString(this.state[contentFieldIfEmpty]),
                enabled: false,
                genType: () => this.getCloneType(contentFieldIfEmpty),
                defaultValue: EBool.EBool_FALSE,
                tab: 'Rewrites',
              },
              {
                key: contentField,
                displayTitle: contentTitle,
                genDisplayValue: () => this.state[contentField],
                enabled: false,
                genType: () => this.getCloneType(contentField),
                defaultValue: '',
                tab: 'Rewrites',
              },
            ]),
        } as IInputRow;
      });

      const removeContentItemToTKey: Record<string, TKey> = {
        Channel: 'Channel',
        Network: 'Network',
        Series: 'Series',
        Title: 'Title',
        Category: 'Category',
        Genre: 'Genre',
        Rating: 'Rating',
        Prodqual: 'Prodqual',
        ProducerName: 'ProducerName',
        ProducerID: 'ProducerID',
        Keywords: 'Keywords',
        Language: 'Language',
      };
      const RemoveContentRows = [
        'Channel',
        'Network',
        'Series',
        'Title',
        'Category',
        'Genre',
        'Rating',
        'Prodqual',
        'ProducerName',
        'ProducerID',
        'Keywords',
        'Language',
      ].map((contentItem: string) => {
        const removeContentField = `RemoveContent${contentItem}FromBidRequest`;
        return {
          renderType: 'SimpleSwitch',
          title1: ct('RemoveContentItemFromRequest', {
            item: ct(removeContentItemToTKey[contentItem]),
          }),
          field1: removeContentField,
          value1: (this.state as any)[removeContentField] === EBool.EBool_TRUE,
          handleChange1: () => this.handleChangeEBool(removeContentField),
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          isActiveValue1: () => (this.state as any)[removeContentField] === EBool.EBool_TRUE,
          getActiveTag1: (active: boolean) =>
            active ? ct('RemoveItem', { item: ct(removeContentItemToTKey[contentItem]) }) : '',
        } as IInputRow;
      });

      const ContentOverridePanel = {
        title: !enableExtendedRewrites && isSuperUser ? ct('ContentWithAsterisk') : ct('Content'),
        panelActiveChipTitle: ct('Active'),
        panelInactiveRowTag: ct('Inactive'),
        rows:
          enableExtendedRewrites || isSuperUser
            ? [
                RemoveContentFromBidRequestRow,
                ContentDistribNameOverrideRow,
                ...ContentOverrideRows,
              ]
            : [RemoveContentFromBidRequestRow, RemoveContentDistribNameRow, ...RemoveContentRows],
      } as IAccordionPanel;

      // DEVICE PANEL AND ROWS
      const AnonymizeDeviceIDRow = {
        renderType: 'CheckboxAndInfo',
        title1: ct('AnonymizeDeviceID'),
        field1: 'AnonymizeDeviceID',
        value1: this.state.AnonymizeDeviceID,
        defaultValue1: EBool.EBool_FALSE,
        handleChange1: () => this.handleChangeEBool('AnonymizeDeviceID'),
        isActiveValue1: () => this.state.AnonymizeDeviceID === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('AnonymizeDeviceID') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AnonymizeDeviceID']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AnonymizeDeviceID',
              displayTitle: ct('AnonymizeDeviceID'),
              genDisplayValue: () => EBool.toBoolString(this.state.AnonymizeDeviceID),
              enabled: false,
              genType: () => this.getCloneType('AnonymizeDeviceID'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const DoohDeviceTypeRewriteEnabled = {
        renderType: 'CheckboxAndInfo',
        tooltipText: ct('BiddersTooltipDOOHDeviceTypeRewrite'),
        title1: ct('DOOHDeviceTypeRewrite'),
        field1: 'DOOHDeviceTypeRewriteEnabled',
        value1: this.state.DOOHDeviceTypeRewriteEnabled,
        defaultValue1: EBool.EBool_FALSE,
        handleChange1: () => this.handleChangeEBool('DOOHDeviceTypeRewriteEnabled'),
        isActiveValue1: () => this.state.DOOHDeviceTypeRewriteEnabled === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('DOOHDeviceTypeRewrite') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['DOOHDeviceTypeRewriteEnabled']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'DOOHDeviceTypeRewriteEnabled',
              displayTitle: ct('DOOHDeviceTypeRewrite'),
              genDisplayValue: () => EBool.toBoolString(this.state.DOOHDeviceTypeRewriteEnabled),
              enabled: false,
              genType: () => this.getCloneType('DOOHDeviceTypeRewriteEnabled'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const DevicePanel = {
        title: ct('Device'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [AnonymizeDeviceIDRow, DoohDeviceTypeRewriteEnabled],
      } as IAccordionPanel;

      // PMP PANEL AND ROWS
      const AppendDealIDRow = {
        renderType: 'custom',
        customRender: this.renderAppendDealIDRow,
        title1: '',
        field1: '',
        value1: this.state.Deals,
        defaultValue1: [] as IDeal[],
        handleChange1: noopVoid,
        isActiveValue1: (): boolean => this.state.Deals && this.state.Deals.length > 0,
        getActiveTag1: (active: boolean) => (active ? ct('PublicaDealID') : ''),
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Deals']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Deals',
              displayTitle: ct('Deals'),
              genDisplayValue: () => this.state.Deals.length + ' Deals',
              enabled: false,
              genType: () => this.getCloneType('Deals'),
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      const TargetedDealsRow = {
        renderType: 'custom',
        customRender: this.renderTargetingIDsRow,
        title1: '',
        field1: '',
        value1: this.state.Deals,
        defaultValue1: [] as IDeal[],
        handleChange1: noopVoid,
        isActiveValue1: (): boolean => this.state.Deals && this.state.Deals.length > 0,
        getActiveTag1: (active: boolean) => (active ? ct('PublicaDealID') : ''),
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Deals']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Deals',
              displayTitle: ct('Deals'),
              genDisplayValue: () => this.state.Deals.length + ' Deals',
              enabled: false,
              genType: () => this.getCloneType('Deals'),
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const EndpointDealIDPassthroughActiveRow = {
        renderType: 'CheckboxAndInfo',
        title1: ct('DealIDPassthroughFromEndpoint'),
        field1: 'EndpointDealIDPassthroughActive',
        value1: this.state.EndpointDealIDPassthroughActive,
        defaultValue1: EBool.EBool_FALSE,
        handleChange1: () => this.handleChangeEBool('EndpointDealIDPassthroughActive'),
        isActiveValue1: () => this.state.EndpointDealIDPassthroughActive === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('EndpointDealID') : ''),
        tooltipText: ct('BiddersTooltipDealIDPassthroughFromEndpoint'),

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['EndpointDealIDPassthroughActive']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EndpointDealIDPassthroughActive',
              displayTitle: ct('DealIDPassthrough'),
              genDisplayValue: () =>
                this.state.EndpointDealIDPassthroughActive === EBool.EBool_TRUE
                  ? ct('Active')
                  : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('EndpointDealIDPassthroughActive'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      const PrivateAuctionDealMatchRow = {
        renderType: 'SimpleSwitch',
        title1: ct('EnforceMatchingDealIDInBidResponse'),
        field1: 'MatchDealID',
        value1: this.state.MatchDealID === MatchDealIDTypeEnabled,
        defaultValue1: false,
        handleChange1: this.handleMatchDealIDChange,
        isActiveValue1: () => false,
        tooltipText: ct('BiddersTooltipEnforceMatchingDealIDInBidResponse'),
        getActiveTag1: (active: boolean) => (active ? ct('MatchDealID') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['MatchDealID']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'MatchDealID',
              displayTitle: ct('MatchDealID'),
              genDisplayValue: () => (this.state.MatchDealID === 2 ? ct('Restrict') : ct('Accept')),
              enabled: false,
              genType: () => this.getCloneType('MatchDealID'),
              defaultValue: MatchDealIDTypeDisabled,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      // Row to select the bidder's Private Auction.
      const PrivateAuctionRow = {
        renderType: 'SimpleSwitch',
        title1: ct('PrivateAuction'),
        field1: 'PrivateAuction',
        value1: this.state.PrivateAuction === PrivateAuctionTypeEnabled,
        defaultValue1: false,
        handleChange1: this.handlePrivateAuctionChange,
        isActiveValue1: () => false, // temp fix: private auction row should not impact active/inactive tag
        getActiveTag1: (active: boolean) => (active ? ct('PrivateAuction') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['PrivateAuction']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'PrivateAuction',
              displayTitle: ct('PrivateAuction'),
              genDisplayValue: () =>
                this.state.PrivateAuction === 2 ? ct('Restrict') : ct('Accept'),
              enabled: false,
              genType: () => this.getCloneType('PrivateAuction'),
              defaultValue: PrivateAuctionTypeDisabled,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      // Row to enable deal priority override.
      const EnableDealPriorityOverrideRow = {
        renderType: 'SimpleSwitch',
        title1: ct('EnableItem', { item: ct('DealPriorityOverride') }),
        field1: 'EnableDealPriorityOverride',
        value1: EBool.isTrue(this.state.EnableDealPriorityOverride),
        defaultValue1: false,
        handleChange1: this.handleEnableDealPriorityOverrideChange,
        isActiveValue1: () => EBool.isTrue(this.state.EnableDealPriorityOverride),
        getActiveTag1: (active: boolean) =>
          active ? ct('EnableItem', { item: ct('DealPriorityOverride') }) : '',
        // markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['EnableDealPriorityOverride']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'EnableDealPriorityOverride',
              displayTitle: ct('EnableItem', { item: ct('DealPriorityOverride') }),
              genDisplayValue: () =>
                EBool.isTrue(this.state.EnableDealPriorityOverride) ? ct('Disable') : ct('Enable'),
              enabled: false,
              genType: () => this.getCloneType('EnableDealPriorityOverride'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;

      const DealAtRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generateAtOptions() || [],
        title1: ct('AuctionType'),
        field1: 'DealAtTargeting',
        value1: this.state.DealAtTargeting,
        defaultValue1: EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_None,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.DealAtTargeting !==
          EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_None,
        getActiveTag1: (active: boolean) =>
          active ? HeaderBidderDealAtTargetingToString(this.state.DealAtTargeting) : ct('None'),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['DealAtTargeting']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'DealAtTargeting',
              displayTitle: ct('At'),
              genDisplayValue: () =>
                HeaderBidderDealAtTargetingToString(this.state.DealAtTargeting),
              enabled: false,
              genType: () => this.getCloneType('DealAtTargeting'),
              defaultValue: EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_None,
              tab: 'Targeting',
            },
          ]),
      } as IInputRow;

      const PMPPanel = {
        title: ct('PMP'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [EndpointDealIDPassthroughActiveRow, PrivateAuctionRow],
      } as IAccordionPanel;

      if (!bulkUpdateEnabled) {
        PMPPanel.rows.push(AppendDealIDRow);
        PMPPanel.rows.push(EnableDealPriorityOverrideRow);
      }

      if (this.state.Bidder === DemandSources.madhive) {
        PMPPanel.rows.push(DealAtRow);
      }

      if (this.state.PrivateAuction === PrivateAuctionTypeEnabled && this.state.Deals.length > 0) {
        PMPPanel.rows.push(PrivateAuctionDealMatchRow);
      }

      // USER PANEL AND ROWS
      const AnonymizeIPRow = {
        renderType: 'CheckboxAndInfo',
        title1: ct('AnonymizeIP'),
        field1: 'AnonymizeIP',
        value1: this.state.AnonymizeIP,
        defaultValue1: EBool.EBool_FALSE,
        handleChange1: () => this.handleChangeEBool('AnonymizeIP'),
        isActiveValue1: () => this.state.AnonymizeIP === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('AnonymizeIP') : ''),

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['AnonymizeIP']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'AnonymizeIP',
              displayTitle: ct('AnonymizeIP'),
              genDisplayValue: () => EBool.toBoolString(this.state.AnonymizeIP),
              enabled: false,
              genType: () => this.getCloneType('AnonymizeIP'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const UserPanel = {
        title: ct('User'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [AnonymizeIPRow],
      } as IAccordionPanel;

      // VIDEO PANEL AND ROWS
      const MinAdDurationOverrideRow = {
        renderType: 'NumberTextfield',
        title1: ct('MinAdDurationOverride'),
        field1: 'MinAdDurationOverride',
        value1: this.state.MinAdDurationOverride,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.MinAdDurationOverride !== 0,
        getActiveTag1: (active: boolean) => (active ? ct('MinAdDuration') : ''),
        placeholderText: ct('InSeconds'),
        disabled1: paramsInTesting.includes('MinAdDurationOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('MinAdDurationOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['MinAdDurationOverride']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'MinAdDurationOverride',
              displayTitle: ct('MinAdDurationOverride'),
              genDisplayValue: () => (this.state.MinAdDurationOverride || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('MinAdDurationOverride'),
              defaultValue: 0,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const MaxAdDurationOverrideRow = {
        renderType: 'NumberTextfield',
        title1: ct('MaxAdDurationOverride'),
        field1: 'MaxAdDurationOverride',
        value1: this.state.MaxAdDurationOverride,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.MaxAdDurationOverride !== 0,
        getActiveTag1: (active: boolean) => (active ? ct('MaxAdDuration') : ''),
        placeholderText: ct('InSeconds'),
        disabled1: paramsInTesting.includes('MaxAdDurationOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('MaxAdDurationOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['MaxAdDurationOverride']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'MaxAdDurationOverride',
              displayTitle: ct('MaxAdDurationOverride'),
              genDisplayValue: () => (this.state.MaxAdDurationOverride || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('MaxAdDurationOverride'),
              defaultValue: 0,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const StartDelayOverrideRow = {
        renderType: 'NumberTextfield',
        title1: ct('StartDelayOverride'),
        field1: 'StartDelayOverride',
        value1:
          this.state.StartDelayOverride === EStartDelay.StartDelay_UnknownNotSet
            ? undefined
            : this.state.StartDelayOverride,
        defaultValue1: EStartDelay.StartDelay_UnknownNotSet,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.StartDelayOverride &&
          this.state.StartDelayOverride !== EStartDelay.StartDelay_UnknownNotSet,
        getActiveTag1: (active: boolean) => (active ? ct('StartDelayOverride') : ''),
        tooltipText: ct('BiddersTooltipStartDelayOverride'),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['StartDelayOverride']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'StartDelayOverride',
              displayTitle: ct('StartDelayOverride'),
              genDisplayValue: () => (this.state.StartDelayOverride || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('StartDelayOverride'),
              defaultValue: 0,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const ClearMaxMinBitrateRow = {
        renderType: 'CheckboxAndInfo',
        title1: ct('ClearDefaultMaxMinBitrate'),
        field1: 'ClearDefaultBitrateLimits',
        value1: this.state.ClearDefaultBitrateLimits,
        defaultValue1: EBool.EBool_FALSE,
        handleChange1: () => this.handleChangeEBool('ClearDefaultBitrateLimits'),
        isActiveValue1: () => this.state.ClearDefaultBitrateLimits === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('ClearBitrate') : ''),
        tooltipText: ct('BiddersTooltipClearDefaultMaxMinBitrate'),

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['ClearDefaultBitrateLimits']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'ClearDefaultBitrateLimits',
              displayTitle: ct('ClearMaxMinBitrate'),
              genDisplayValue: () => EBool.toBoolString(this.state.ClearDefaultBitrateLimits),
              enabled: false,
              genType: () => this.getCloneType('ClearDefaultBitrateLimits'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const SkipRow = {
        renderType: 'SimpleSwitch',
        title1: ct('Skip'),
        field1: 'Skip',
        value1: this.state.Skip === EBool.EBool_TRUE,
        defaultValue1: false,
        handleChange1: this.toggleSkip,
        isActiveValue1: () => this.state.Skip === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('Skip') : ''),

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['Skip']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'Skip',
              displayTitle: ct('Skip'),
              genDisplayValue: () => EBool.toBoolString(this.state.Skip),
              enabled: false,
              genType: () => this.getCloneType('Skip'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const SkipMinRow = {
        renderType: 'NumberTextfield',
        title1: ct('SkipMin'),
        field1: 'SkipMin',
        value1: this.state.SkipMin,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.SkipMin !== 0,
        getActiveTag1: (active: boolean) => (active ? ct('SkipMin') : ''),
        disabled1: this.state.Skip !== EBool.EBool_TRUE,
        tooltipText: ct('BiddersTooltipSkipMin'),
        placeholderText: ct('InSeconds'),

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['SkipMin']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'SkipMin',
              displayTitle: ct('SkipMin'),
              genDisplayValue: () => (this.state.SkipMin || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('SkipMin'),
              defaultValue: 0,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const SkipAfterRow = {
        renderType: 'NumberTextfield',
        title1: ct('SkipAfter'),
        field1: 'SkipAfter',
        value1: this.state.SkipAfter,
        defaultValue1: 0,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.SkipAfter !== 0,
        getActiveTag1: (active: boolean) => (active ? ct('SkipAfter') : ''),
        disabled1: this.state.Skip !== EBool.EBool_TRUE,
        tooltipText: ct('BiddersTooltipSkipAfter'),
        placeholderText: ct('InSeconds'),

        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['SkipAfter']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'SkipAfter',
              displayTitle: ct('SkipAfter'),
              genDisplayValue: () => (this.state.SkipAfter || 0).toString(),
              enabled: false,
              genType: () => this.getCloneType('SkipAfter'),
              defaultValue: 0,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const playbackMethodRow = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems: [
          {
            key: 1,
            text: ct('PageLoadSoundOn'),
          },
          {
            key: 2,
            text: ct('PageLoadSoundOff'),
          },
          {
            key: 3,
            text: ct('ClickSoundOn'),
          },
          {
            key: 4,
            text: ct('MouseOverSoundOn'),
          },
          {
            key: 5,
            text: ct('EnteringViewportSoundOn'),
          },
          {
            key: 6,
            text: ct('EnteringViewportSoundOff'),
          },
        ],
        title1: ct('PlaybackMethods'),
        field1: 'PlaybackMethod',
        value1: this.getDisplayedPlaybackMethods(),
        defaultValue1: '1',
        handleChange1: this.handleChangeMultiSelect,
        isActiveValue1: () => this.state.PlaybackMethod !== '1',
        getActiveTag1: (active: boolean) => (active ? ct('PlaybackMethod') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
      } as IInputRow;
      const MimeTypeOverrideRow = {
        renderType: 'SimpleMultiSelect',
        defaultLabel:
          MimeTypeOverride.length === 0 ? ct('SelectItem', { item: ct('MimeTypes') }) : '',
        simpleSelectItems: MimeTypeList || [],
        title1: ct('MimeTypes'),
        field1: 'MimeTypeOverride',
        value1: this.getDisplayedMimeTypeOverride(false),
        handleChange1: this.handleChangeMimeTypeOverride,
        isActiveValue1: () =>
          MimeTypeOverride.length > 0 && MimeTypeOverride.split(',').length !== MimeTypeList.length,
        getActiveTag1: (active: boolean) => {
          if (active) {
            const mimeTypeCount = MimeTypeOverride.split(',').length;
            return ct('FormatLabelWithCount', {
              count: mimeTypeCount,
              label: ct('MimeTypes'),
            });
          }
          return '';
        },
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
      } as IInputRow;
      const VideoPanel = {
        title: ct('Video'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [
          MinAdDurationOverrideRow,
          MaxAdDurationOverrideRow,
          StartDelayOverrideRow,
          ClearMaxMinBitrateRow,
          SkipRow,
          SkipMinRow,
          SkipAfterRow,
          playbackMethodRow,
          MimeTypeOverrideRow,
        ],
      } as IAccordionPanel;

      // SITE PANEL AND ROWS
      const SiteDomainOverrideRow = {
        renderType: 'TextfieldAndSwitch',
        title1: ct('SiteDomainOverrideWithAsterisk'),
        field1: 'SiteDomainOverride',
        value1: this.state.SiteDomainOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.SiteDomainOverride !== '',
        getActiveTag1: (active: boolean) => (active ? ct('SiteDomain') : ''),
        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.SiteDomainOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        errors2: this.state.errors.SiteDomainOverrideIfEmpty,
        handleChange2: () => this.handleChangeEBool('SiteDomainOverrideIfEmpty'),
        placeholderText: ct('PlaceholderEnterItem', { item: ct('SiteDomainOverride') }),
        disabled1: paramsInTesting.includes('SiteDomainOverride') && newImpressionsSinceLastTest,
        helperText:
          paramsInTesting.includes('SiteDomainOverride') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['SiteDomainOverride', 'SiteDomainOverrideIfEmpty']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'SiteDomainOverride',
              displayTitle: ct('SiteDomainOverride'),
              genDisplayValue: () => this.state.SiteDomainOverride,
              enabled: false,
              genType: () => this.getCloneType('SiteDomainOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
            {
              key: 'SiteDomainOverrideIfEmpty',
              displayTitle: ct('SiteDomainOverrideIfEmpty'),
              genDisplayValue: () => EBool.toBoolString(this.state.SiteDomainOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('SiteDomainOverrideIfEmpty'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const SitePanel = {
        title: ct('SiteWithAsterisk'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [SiteDomainOverrideRow],
      } as IAccordionPanel;

      // INVENTORY PARTNER DOMAIN PANEL AND ROWS
      const InventoryPartnerDomainOverrideRow = {
        renderType: 'TextfieldAndDoubleSwitch',

        title1: ct('InventoryPartnerDomainOverride'),
        field1: 'InventoryPartnerDomainOverride',
        value1: this.state.InventoryPartnerDomainOverride,
        defaultValue1: '',
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.InventoryPartnerDomainOverride !== '' ||
          this.state.RemoveInventoryPartnerDomainFromBidRequest === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('InventoryPartnerDomain') : ''),

        title2: ct('AddValueOnlyIfObjEmptyInBidRequest'),
        value2: this.state.InventoryPartnerDomainOverrideIfEmpty,
        defaultValue2: EBool.EBool_FALSE,
        errors2: this.state.errors.InventoryPartnerDomainOverrideIfEmpty,
        handleChange2: () => this.handleChangeEBool('InventoryPartnerDomainOverrideIfEmpty'),

        title3: ct('RemoveItemFromRequest', { item: ct('InventoryPartnerDomain') }),
        value3: this.state.RemoveInventoryPartnerDomainFromBidRequest,
        defaultValue3: EBool.EBool_FALSE,
        handleChange3: () => this.handleChangeEBool('RemoveInventoryPartnerDomainFromBidRequest'),

        placeholderText: ct('PlaceholderEnterItem', { item: ct('InventoryPartnerDomainOverride') }),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked([
          'InventoryPartnerDomainOverride',
          'InventoryPartnerDomainOverrideIfEmpty',
          'RemoveInventoryPartnerDomainFromBidRequest',
        ]),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'InventoryPartnerDomainOverride',
              displayTitle: ct('InventoryPartnerDomainOverride'),
              genDisplayValue: () => this.state.InventoryPartnerDomainOverride,
              enabled: false,
              genType: () => this.getCloneType('InventoryPartnerDomainOverride'),
              defaultValue: '',
              tab: 'Rewrites',
            },
            {
              key: 'InventoryPartnerDomainOverrideIfEmpty',
              displayTitle: ct('InventoryPartnerDomainOverrideIfEmpty'),
              genDisplayValue: () =>
                EBool.toBoolString(this.state.InventoryPartnerDomainOverrideIfEmpty),
              enabled: false,
              genType: () => this.getCloneType('InventoryPartnerDomainOverrideIfEmpty'),
              defaultValue: EBool.EBool_TRUE,
              tab: 'Rewrites',
            },
            {
              key: 'RemoveInventoryPartnerDomainFromBidRequest',
              displayTitle: ct('RemoveItemFromRequest', { item: ct('InventoryPartnerDomain') }),
              genDisplayValue: () =>
                EBool.toBoolString(this.state.RemoveInventoryPartnerDomainFromBidRequest),
              enabled: false,
              genType: () => this.getCloneType('RemoveInventoryPartnerDomainFromBidRequest'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Rewrites',
            },
          ]),
      } as IInputRow;
      const InventoryPartnerDomainPanel = {
        title: enableExtendedRewrites
          ? ct('InventoryPartnerDomain')
          : ct('InventoryPartnerDomainWithAsterisk'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Active'),
        rows: [InventoryPartnerDomainOverrideRow],
      } as IAccordionPanel;

      // define the rows and then the panel to which they belong
      if (isSuperUser || hasPermSuperUser(session.publisher.ID, user.user.PermissionRole.id)) {
        const panels = [
          AppPanel,
          AppStoreUrlPanel,
          ContentOverridePanel,
          DevicePanel,
          PMPPanel,
          UserPanel,
          VideoPanel,
          SitePanel,
          InventoryPartnerDomainPanel,
        ];
        return (
          <Grid item style={{ height: '100%' }}>
            <MultiAccordion
              title={ct('ORTBObjects')}
              subtitle={ct('BiddersMessageORTBObjects')}
              panels={panels}
              disableEdit={this.hasNoWriteRights()}
              forcePanelsOpen={bulkUpdateEnabled}
            />
          </Grid>
        );
      } else {
        let panels = [
          AppPanel,
          AppStoreUrlPanel,
          ContentOverridePanel,
          DevicePanel,
          PMPPanel,
          UserPanel,
          VideoPanel,
          InventoryPartnerDomainPanel,
        ];
        if (
          this.props.session.publisher.EnableExtendedRewrites === EBool.EBool_FALSE &&
          !isSuperUser
        ) {
          // remove the app panel
          panels = [
            ContentOverridePanel,
            DevicePanel,
            PMPPanel,
            UserPanel,
            VideoPanel,
            AppStoreUrlPanel,
          ];
        }
        return (
          <Grid item style={{ height: '100%' }}>
            <MultiAccordion
              title={ct('ORTBObjects')}
              subtitle={ct('BiddersMessageORTBObjects')}
              panels={panels}
              disableEdit={this.hasNoWriteRights()}
              forcePanelsOpen={bulkUpdateEnabled}
            />
          </Grid>
        );
      }
    };

    parseBidRequestJson(request: any) {
      const tmp = request.split('\n') as string[];

      const out = {} as any;
      out.bidRequest = tmp[0];
      tmp.shift();

      for (const ob of tmp) {
        if (ob[0] !== '{') {
          const obSplitted = ob.split(':');
          const Ipv6InXForwardedFor = obSplitted[0] === 'x-forwarded-for' && obSplitted.length > 2;
          if (typeof obSplitted[1] === 'string') {
            if (Ipv6InXForwardedFor) {
              const ipv6Value = obSplitted.slice(1, obSplitted.length).join(':').trim();
              out[obSplitted[0]] = ipv6Value;
            } else {
              out[obSplitted[0]] = obSplitted[1].trim();
            }
          } else {
            out[obSplitted[0]] = obSplitted[1];
          }
        } else {
          out.data = JSON.parse(ob);
        }
      }
      const parsedDebugInfo: {} = out;

      return parsedDebugInfo;
    }

    renderLiveLogs() {
      const { classes } = this.props;

      const {
        bidRequestLiveLogs,
        bidRequestLiveLogsOpenDialog,
        bidResponseLiveLogs,
        liveLogsTabIndex,
        requestLiveLogFilter,
        responseLiveLogFilter,
        refreshingLiveLogs,
        refreshingLiveLogsTimestamp,
      } = this.state;

      // Format Bid Requests Data
      const formattedBidRequestData = (bidRequestLiveLogs || []).map(
        (log: IBidRequestLiveLogs): IBidRequestLiveLogs => {
          let parsedDebugInfo: {};
          try {
            parsedDebugInfo = this.parseBidRequestJson(
              JSON.parse(JSON.parse(log.debugInfo).response).bidRequest,
            );
          } catch (e) {
            parsedDebugInfo = {
              error: ct('SnackbarFailedToParseDebugInfo'),
              raw: log.debugInfo,
            };
            console.warn(e);
          }
          return {
            ...log,
            publisherUUID: log.publisherUUID,
            bidderType: log.bidderType,
            timestamp: log.timestamp,
            debugInfo: parsedDebugInfo as string,
          };
        },
      );

      // Format BidResponseUI Data
      const formattedBidResponseData = (bidResponseLiveLogs || []).map(
        (log: IBidResponseUIData): IBidResponseUIData => {
          let parsedDebugInfo: {};
          try {
            parsedDebugInfo = this.parseBidRequestJson(
              JSON.parse(JSON.parse(log.debugInfo).response).bidRequest,
            );
          } catch (e) {
            parsedDebugInfo = {
              error: ct('SnackbarFailedToParseDebugInfo'),
              raw: log.debugInfo,
            };
            console.warn(e);
          }

          return {
            ...log,
            debugInfo: parsedDebugInfo as string,
          };
        },
      );

      return (
        <>
          <Drawer
            anchor='right'
            open={bidRequestLiveLogsOpenDialog}
            onClose={() => this.setState({ bidRequestLiveLogsOpenDialog: false })}
            classes={{ paper: classes.drawerPaper }}
          >
            <Grid
              container
              direction='row'
              justify='flex-start'
              alignItems='center'
              style={{
                paddingLeft: '20px',
                width: '100%',
              }}
            >
              <Grid item style={{ paddingRight: '20px' }}>
                <h1>{ct('LiveLogs')}</h1>
              </Grid>
              <Grid item>
                <ButtonView
                  onClick={() => this.getLiveLogs()}
                  text={ct('Refresh')}
                  active={refreshingLiveLogs}
                />
              </Grid>
              {refreshingLiveLogsTimestamp && (
                <Grid item style={{ paddingLeft: '10px' }}>
                  {ct('LastUpdatedAtTimestamp', { timestamp: refreshingLiveLogsTimestamp })}
                </Grid>
              )}
            </Grid>

            <Paper classes={{ root: classes.paper }}>
              <Grid
                container
                direction='row'
                alignItems='center'
                spacing={5}
                style={{ marginTop: 10, marginBottom: 10 }}
              >
                <div
                  style={{
                    backgroundColor: '#F8F8F8',
                    display: 'inline-block',
                    marginBottom: '10px',
                    minWidth: 350,
                    width: '100%',
                  }}
                  onClick={() => this.trackEvent('Bidder Settings - Search Live Logs')}
                >
                  <IconButton classes={{ root: classes.iconButton }}>
                    <SearchIcon />
                  </IconButton>
                  <InputBase
                    style={{ width: 'calc(100% - 3em)' }}
                    placeholder={ct('SearchByKeywordOrValue')}
                    name={liveLogsTabIndex === 0 ? 'requestLiveLogFilter' : 'responseLiveLogFilter'}
                    value={liveLogsTabIndex === 0 ? requestLiveLogFilter : responseLiveLogFilter}
                    onChange={this.handleChange}
                  />
                </div>
              </Grid>
            </Paper>

            <AppBar
              position='static'
              style={{ backgroundColor, boxShadow: 'none', color: 'black' }}
            >
              <Tabs
                value={liveLogsTabIndex}
                onChange={(_: any, newIndex: number) => {
                  if (newIndex === 0) {
                    this.setState({
                      liveLogsTabIndex: newIndex,
                      responseLiveLogFilter: '',
                    });
                  } else {
                    this.setState({
                      liveLogsTabIndex: newIndex,
                      requestLiveLogFilter: '',
                    });
                  }
                }}
                aria-label='simple tabs'
              >
                <Tab label={ct('BidRequests')} {...MakeTabProps(0)} />
                <Tab label={ct('BidResponses')} {...MakeTabProps(1)} />
              </Tabs>
            </AppBar>
            <TabPanel value={liveLogsTabIndex} index={0}>
              <LogBidRequestTable
                logs={filterLiveLogs(formattedBidRequestData, requestLiveLogFilter)}
              />
            </TabPanel>
            <TabPanel value={liveLogsTabIndex} index={1}>
              <LogBidResponseTable
                data={filterLiveLogs(formattedBidResponseData, responseLiveLogFilter)}
              />
            </TabPanel>
          </Drawer>
          <Fab
            style={{
              margin: 0,
              top: 'auto',
              right: 20,
              bottom: 20,
              left: 'auto',
              position: 'fixed',
              zIndex: 999,
            }}
            variant='extended'
            color='primary'
            onClick={() => {
              this.trackEvent('Bidder Settings - Open Live Logs');
              this.setState({ bidRequestLiveLogsOpenDialog: true });
            }}
          >
            {ct('OpenItem', { item: ct('LiveLogs') })}
          </Fab>
        </>
      );
    }

    renderParamOptions(isSuperUser: boolean, disableEdit: boolean) {
      const { classes, cloneBidderEnabled } = this.props;

      const bidderCampaignTargetingItems: IPriorityOption[] = [
        { value: HeaderBidderCampaignTargetingInactive, text: ct('Inactive') },
        { value: HeaderBidderCampaignTargetingAll, text: ct('AllLineItems') },
        { value: HeaderBidderCampaignTargetingSelected, text: ct('SelectedLineItems') },
        { value: HeaderBidderCampaignTargetingPaid, text: ct('AllDirect') },
        { value: HeaderBidderCampaignTargetingHouse, text: ct('AllHouse') },
        { value: HeaderBidderOrderTargetingSelected, text: ct('SelectedOrders') },
      ];

      if (!this.state.ParamOptions) {
        return '';
      }

      return this.state.ParamOptions.filter((option: IHeaderBidderParamOption) => {
        // hide endpoint domain dropdown for yahoo demand source when enabling multiBid - for now CTV-3695
        if (
          this.state.MultiBidActive === EBool.EBool_TRUE &&
          this.state.Bidder === DemandSources.verizon &&
          option.Name === 'endpoint'
        ) {
          return false;
        }

        if (
          ALL_PLATFORM_CONNECTION_BIDDERS.includes(option.Bidder) &&
          option.Name === 'globalTimeoutOffset'
        ) {
          if (option.Value === '') {
            // default
            this.handleChangeParamOption({
              target: {
                value: '150',
                name: option.Name,
              },
            } as any);
          }

          if (!isSuperUser) {
            return false;
          }
        }

        // spotx has historical baggage and needs to be singled out and handled separately
        if (
          option.Bidder === 'spotx' &&
          option.Name === 'additional_bids' &&
          this.state.MultiBidActive !== EBool.EBool_TRUE
        ) {
          return false;
        }

        if (
          BIDDERS_MULTI_BID_ENABLED.includes(option.Bidder) &&
          option.Bidder !== 'spotx' &&
          option.Name === 'number_of_ads' &&
          this.state.MultiBidActive !== EBool.EBool_TRUE
        ) {
          return false;
        }

        if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'onlyForSuperUser', true)) {
          if (!isSuperUser) {
            return false;
          }
        }

        if (hasParamOption(option.Bidder, option.Name, 'isVisible')) {
          return getParamOption<(o: IHeaderBidderParamOption[]) => boolean>(
            option.Bidder,
            option.Name,
            'isVisible',
          )(this.state.ParamOptions);
        }

        if (
          option.Bidder === DemandSources.magnitectv &&
          option.Name === 'max_seq' &&
          this.state.PoddedRequestActive === EBool.EBool_FALSE
        ) {
          return false;
        }

        return (
          !shouldParamOptionOverwritten(option.Bidder, option.Name, 'deprecated') &&
          !shouldParamOptionOverwritten(option.Bidder, option.Name, 'hidden')
        );
      })
        .sort(sortParamOptions)
        .map((option: IHeaderBidderParamOption, _, options) => {
          let customLabel = option.Name;
          let customDescription = option.Description;
          const samsungsspAfterParamsNameChange = moment(
            parseDate(this.props.headerbidder.CreatedAt),
          ).isAfter(parseDate('2023-09-10T15:52:02Z'));
          if (
            customLabel === 'channel_id' &&
            isSamsungPublisher(this.props.user.publisher.ID) &&
            (samsungsspAfterParamsNameChange || this.props.headerbidder.CreatedAt === '')
          ) {
            customLabel = 'supplybidder_id';
          }
          if (
            customLabel === 'tag_id' &&
            isSamsungPublisher(this.props.user.publisher.ID) &&
            (samsungsspAfterParamsNameChange || this.props.headerbidder.CreatedAt === '')
          ) {
            customLabel = 'adunit_id';
          }
          if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'renameDescription')) {
            customDescription = this.HeaderBidderParamsUIconfig[option.Bidder][
              option.Name
            ].renameDescription(option.Description);
          }
          if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'rename')) {
            customLabel = this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].rename;
          }
          const defaultValue = getParamDefaultValue(option.Name);
          customLabel += shouldParamOptionOverwritten(
            option.Bidder,
            option.Name,
            'onlyForSuperUser',
            true,
          )
            ? ' *'
            : '';

          const standardParamRow = {
            renderType: 'Textfield',
            enableSmallRow: true,
            title1: customLabel,
            field1: option.Name,
            value1: option.Value,
            defaultValue1: defaultValue,
            maxWidth: 400,
            handleChange1: this.handleChangeParamOption,
            isActiveValue1: () => false,
            getActiveTag1: () => '',
            tooltipText: customDescription,
            helperText: this.state.errors['ParamsOptions_' + option.Name],
            error: !!this.state.errors['ParamsOptions_' + option.Name],
            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([option.Name]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: option.Name,
                  displayTitle: customLabel,
                  genDisplayValue: () => option.Value.toString(),
                  enabled: false,
                  genType: () => this.getCloneType(option.Name),
                  defaultValue,
                  tab: 'Parameters',
                },
              ]),
          } as IInputRow;
          const standard2ParamRow = {
            renderType: 'Textfield',
            enableSmallRow: true,
            title1: customLabel,
            field1: option.Name,
            value1: option.Value,
            defaultValue1: defaultValue,
            maxWidth: 400,
            handleChange1: this.handleChangeParamOption,
            isActiveValue1: () => false,
            getActiveTag1: () => '',
            tooltipText: customDescription,
            helperText: this.state.errors['ParamsOptions_' + option.Name],
            error: !!this.state.errors['ParamsOptions_' + option.Name],

            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([option.Name]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: option.Name,
                  displayTitle: customLabel,
                  genDisplayValue: () => option.Value.toString(),
                  enabled: false,
                  genType: () => this.getCloneType(option.Name),
                  defaultValue,
                  tab: 'Parameters',
                },
              ]),
          } as IInputRow;
          const iabCategoryRow = {
            renderType: 'custom',
            customRender: (rowInfo: IInputRow) =>
              this.renderCustomRow(
                <Grid item style={{ width: '100%', marginBottom: 20 }}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={1}
                  >
                    <Grid item xs={8}>
                      <IABBlocklist
                        selectedIABCategories={
                          typeof option.Value === 'string'
                            ? option.Value.split(',')[0].length === 0
                              ? []
                              : option.Value.split(',')
                            : []
                        }
                        updatingIABCategories={this.state.updatingIABCatBlocklist}
                        hasWriteRights={!this.hasNoWriteRights()}
                        handleChangeIABCategories={this.handleChangeIABCategories}
                        handleSetSnackbar={this.handleSetSnackbar}
                      />
                    </Grid>
                  </Grid>
                </Grid>,
                customLabel,
                rowInfo,
              )(),
            title1: '',
            field1: '',
            value1: option.Value,
            defaultValue1: '',
            handleChange1: noopVoid,
            isActiveValue1: () => false,
            getActiveTag1: () => '',
            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([option.Name]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: option.Name,
                  displayTitle: customLabel,
                  genDisplayValue: () => option.Value.toString(),
                  enabled: false,
                  genType: () => this.getCloneType(option.Name),
                  defaultValue: '',
                  tab: 'Parameters',
                },
              ]),
          } as IInputRow;
          const vastUrlRow = {
            renderType: 'custom',
            customRender: (rowInfo: IInputRow) => this.renderVastUrl(rowInfo, option, disableEdit),
            title1: '',
            field1: '',
            value1: option.Value,
            defaultValue1: '',
            handleChange1: noopVoid,
            isActiveValue1: () => false,
            getActiveTag1: () => '',
            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([option.Name]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: option.Name,
                  displayTitle: ct('VASTURL'),
                  genDisplayValue: () => option.Value.toString(),
                  enabled: false,
                  genType: () => this.getCloneType(option.Name),
                  defaultValue: '',
                  tab: 'Parameters',
                },
              ]),
          } as IInputRow;
          const channelIdRow = {
            renderType: 'Textfield',
            disableEdit: false,
            enableSmallRow: true,
            title1: customLabel,
            field1: option.Name,
            value1: option.Value,
            defaultValue1: defaultValue,
            maxWidth: 400,
            handleChange1: this.handleChangeParamOption,
            isActiveValue1: () => false,
            getActiveTag1: () => '',
            tooltipText: customDescription,
            helperText: this.state.errors['ParamsOptions_' + option.Name],
            error: !!this.state.errors['ParamsOptions_' + option.Name],

            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([option.Name]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: option.Name,
                  displayTitle: customLabel,
                  genDisplayValue: () => option.Value.toString(),
                  enabled: false,
                  genType: () => this.getCloneType(option.Name),
                  defaultValue,
                  tab: 'Parameters',
                },
              ]),
          } as IInputRow;
          const tagIdRow = {
            renderType: 'Textfield',
            disableEdit: true,
            enableSmallRow: true,
            title1: customLabel,
            field1: option.Name,
            value1: option.Value,
            defaultValue1: defaultValue,
            maxWidth: 400,
            handleChange1: this.handleChangeParamOption,
            isActiveValue1: () => false,
            getActiveTag1: () => '',
            tooltipText: customDescription,
            helperText: this.state.errors['ParamsOptions_' + option.Name],
            error: !!this.state.errors['ParamsOptions_' + option.Name],

            cloneEnabled: cloneBidderEnabled,
            compareValues: this.state.compareValues,
            marked: this.checkIfRowIsMarked([option.Name]),
            handleChangeMarked: () =>
              this.handleChangeMarked([
                {
                  key: option.Name,
                  displayTitle: customLabel,
                  genDisplayValue: () => option.Value.toString(),
                  enabled: false,
                  genType: () => this.getCloneType(option.Name),
                  defaultValue,
                  tab: 'Parameters',
                },
              ]),
          } as IInputRow;

          // do not render these options as they are rendered together with option price
          if (option.Name === 'uiPrice' || option.Name === 'uiCurrency') {
            return null;
          }

          let component = shouldParamOptionOverwritten(
            option.Bidder,
            option.Name,
            'errorHandler',
          ) ? (
            <InputRow rowInfo={standardParamRow} disableEdit={disableEdit} />
          ) : option.Name === 'vastURL' ? (
            <InputRow rowInfo={vastUrlRow} disableEdit={disableEdit} />
          ) : option.Name === 'iabCategories' ? (
            <InputRow rowInfo={iabCategoryRow} disableEdit={disableEdit} />
          ) : option.Name === 'channel_id' ? (
            <InputRow
              rowInfo={channelIdRow}
              disableEdit={
                this.props.headerbidder.CreatedAt !== '' && samsungsspAfterParamsNameChange
              }
            />
          ) : option.Name === 'tag_id' ? (
            <InputRow
              rowInfo={tagIdRow}
              disableEdit={
                this.props.headerbidder.CreatedAt !== '' && samsungsspAfterParamsNameChange
              }
            />
          ) : (
            <InputRow
              rowInfo={standard2ParamRow}
              disableEdit={
                disableEdit ||
                (option.Name === 'index' && this.state.Bidder === DemandSources.rokuHB)
              }
            />
          );
          if (
            option.Bidder === DemandSources.apsGuarantee &&
            ['price', 'fixedPrice'].includes(option.Name)
          ) {
            const apsPriceRow = {
              renderType: 'NumberTextfield',
              enableSmallRow: true,
              title1: customLabel,
              field1: option.Name,
              value1: option.Value,
              defaultValue1: defaultValue,
              maxWidth: 180,
              handleChange1: this.handleChangeParamOption,
              isActiveValue1: () => false,
              getActiveTag1: () => '',
              placeholderText: '',
              disabled1: disableEdit,
              error: !!this.state.errors['ParamsOptions_' + option.Name],
              helperText: this.state.errors['ParamsOptions_' + option.Name],
              startAdornment: <InputAdornment position='start'>$</InputAdornment>,
              endAdornment: this.renderExchangeAdornment(option.Value.toString()),

              cloneEnabled: cloneBidderEnabled,
              compareValues: this.state.compareValues,
              marked: this.checkIfRowIsMarked([option.Name]),
              handleChangeMarked: () =>
                this.handleChangeMarked([
                  {
                    key: option.Name,
                    displayTitle: ct('Price'),
                    genDisplayValue: () => option.Value.toString(),
                    enabled: false,
                    genType: () => this.getCloneType(option.Name),
                    defaultValue,
                    tab: 'Parameters',
                  },
                ]),
            } as IInputRow;

            // CTV-383
            let priceLessThanBidFloorWarning;
            const filteredChannelList = objectFilter(this.bidderBidFloor, apsPriceRow);
            if (Object.keys(filteredChannelList).length !== 0) {
              this.renderBidFloor(this.paramsDisabled());
              priceLessThanBidFloorWarning =
                generatePriceLessThanBidFloorWarning(filteredChannelList);
            }

            return (
              <div>
                <InputRow rowInfo={apsPriceRow} disableEdit={disableEdit} />
                <div style={{ color: 'red' }}>{priceLessThanBidFloorWarning}</div>
              </div>
            );
          } else if (option.Name === 'price' && option.Bidder === DemandSources.publica) {
            const {
              bidderChannelList,
              channelIDs,
              errors,
              openChannelSelectTable,
              HonorChannelFloor,
            } = this.state;

            // parse all the values that we can display for price
            const priceUSD = option.Value;
            const uiPrice = options.find((opt) => opt.Name === 'uiPrice')?.Value;
            const uiCurrency = options.find((opt) => opt.Name === 'uiCurrency')?.Value;
            const priceAndBidFloorElement = (
              <Rows>
                <Row noPadding paddingTop={spacing.small} style={{ width: 'fit-content' }}>
                  <Cols style={{ alignItems: 'flex-end' }}>
                    <Col>
                      {EBool.isTrue(this.props.session.publisher.EnableOtherCurrency) ? (
                        <CurrencyConverter
                          className='pb-bidder-settings-form-view_textfield-bid-floor'
                          currencies={CurrencyDisplayedItem}
                          currency={uiCurrency || CurrencyTypeUSD}
                          isDisabled={disableEdit}
                          isErrored={!!errors.BidFloor}
                          onChange={this.handleChangePrice}
                          price={uiPrice || priceUSD}
                          displayCurrencyLabel={false}
                        />
                      ) : (
                        <NumberFormat
                          name='price'
                          value={option.Value === '0' ? '' : option.Value}
                          className='pb-bidder-settings-form-view_textfield-bid-floor'
                          disabled={disableEdit}
                          onChange={this.handleChangeParamOption}
                          error={!!errors.BidFloor}
                          customInput={TextField}
                          thousandSeparator={true}
                          InputProps={{
                            startAdornment: <InputAdornment position='start'>$</InputAdornment>,
                            endAdornment: this.renderExchangeAdornment(option.Value),
                          }}
                          style={{ maxWidth: '150px' }}
                        />
                      )}
                    </Col>

                    <Col style={{ marginLeft: spacing.base, alignSelf: 'center' }}>
                      <Tooltip title={ct('BiddersTooltipBidFloor')} placement='bottom-start'>
                        <InfoIcon
                          style={{
                            verticalAlign: 'bottom',
                            width: '1rem',
                            color: publicaColors.mediumGray,
                          }}
                        />
                      </Tooltip>
                    </Col>
                  </Cols>
                </Row>

                <Row noPadding paddingTop={spacing.base}>
                  <Cols style={{ alignItems: 'center' }}>
                    <Col>
                      <Text
                        small
                        bold={EBool.isTrue(HonorChannelFloor)}
                        muted={HonorChannelFloor === EBool.EBool_FALSE}
                      >
                        {ct('HonorChannelFloor')}
                      </Text>
                    </Col>
                    <Col>
                      <Switch
                        className='pb-bidder-settings-form-view_button_honor-channel-floor'
                        disabled={this.hasNoWriteRights() || disableEdit}
                        checked={EBool.isTrue(HonorChannelFloor)}
                        onChange={this.toggleHonorChannelFloor}
                      />
                    </Col>
                  </Cols>
                </Row>

                <Row noPadding paddingBottom={spacing.small}>
                  <Cols
                    onClick={() => this.setState({ openChannelSelectTable: true })}
                    style={{ alignItems: 'center', cursor: 'pointer' }}
                  >
                    <Col displayFlex marginRight={spacing.extraSmall}>
                      <IconV2 large name='columns' color={publicaColors.blue} />
                    </Col>
                    <Col>
                      <Text
                        bold
                        small
                        color={publicaColors.blue}
                        tKey='ViewCurrentItem'
                        tProps={{ item: ct('ChannelFloors') }}
                      />
                    </Col>
                  </Cols>
                  <Dialog
                    fullWidth
                    maxWidth='sm'
                    keepMounted
                    open={openChannelSelectTable}
                    onClose={() => this.setState({ openChannelSelectTable: false })}
                  >
                    <BidFloorTable
                      user={this.props.user.user}
                      title={ct('ChannelFloors')}
                      channels={this.state.sites.filter((s: ISmallSite) => {
                        if (bidderChannelList[s.ID]) {
                          if (bidderChannelList[s.ID].selected === true && s.BidFloor != null) {
                            this.bidderBidFloor[s.Name] = {
                              currencyDisplayed:
                                s.CurrencyDisplayed || ECurrencyType.CURRENCY_TYPE_USD,
                              bidFloor: s.BidFloor || 0,
                              bidFloorUSD: s.BidFloorUSD || 0,
                            };
                          } else {
                            delete this.bidderBidFloor[s.Name];
                          }
                        }
                        // if channel s has been selected
                        return (
                          (bidderChannelList[s.ID] || { selected: false }).selected ||
                          // if channel s is in the channel groups selected and its BidFloor is not 0
                          (channelIDs.includes(s.ID) && (s.BidFloor ?? 0) > 0)
                        );
                      })}
                      currencyDisplayed={convertStringToECurrencyType(
                        uiCurrency || CurrencyTypeUSD,
                      )}
                      interactive={true}
                      bidderFloor={uiPrice || priceUSD}
                      bidderFloorUSD={priceUSD || 0}
                      isHonorChannelFloorEnabled={EBool.toBool(HonorChannelFloor)}
                      onSelectRow={(siteID: string) => {
                        this.setState({ openChannelSelectTable: false });
                        navigate(RouteChannelExisting, extractRouteParams(this.props), {
                          ch: siteID,
                        });
                      }}
                    />
                  </Dialog>
                </Row>
              </Rows>
            );

            const publicaPriceRow = {
              renderType: 'custom',
              customRender: (rowInfo: IInputRow) =>
                this.renderCustomRow(priceAndBidFloorElement, ct('Price'), rowInfo)(),
              title1: '',
              field1: '',
              value1: option.Value || '0',
              defaultValue1: '0',
              handleChange1: noopVoid,
              isActiveValue1: () => false,
              getActiveTag1: () => '',
              cloneEnabled: cloneBidderEnabled,
              compareValues: this.state.compareValues,
              marked: this.checkIfRowIsMarked([option.Name, 'HonorChannelFloor']),
              handleChangeMarked: () =>
                this.handleChangeMarked([
                  {
                    key: option.Name,
                    displayTitle: ct('Price'),
                    genDisplayValue: () => '$' + option.Value.toString(),
                    enabled: false,
                    genType: () => this.getCloneType(option.Name),
                    defaultValue: '0',
                    tab: 'Parameters',
                  },
                  {
                    key: 'HonorChannelFloor',
                    displayTitle: ct('HonorChannelFloor'),
                    genDisplayValue: () => EBool.toBoolString(this.state.HonorChannelFloor),
                    enabled: false,
                    genType: () => this.getCloneType('HonorChannelFloor'),
                    defaultValue: EBool.EBool_TRUE,
                    tab: 'Parameters',
                  },
                ]),
            } as IInputRow;

            let priceLessThanBidFloorWarning;
            const filteredChannelList = objectFilter(this.bidderBidFloor, publicaPriceRow);
            if (Object.keys(filteredChannelList).length !== 0) {
              this.renderBidFloor(this.paramsDisabled());
              priceLessThanBidFloorWarning =
                generatePriceLessThanBidFloorWarning(filteredChannelList);
            }

            return (
              <Grid>
                <Grid container direction='row' justify='flex-start' alignItems='center'>
                  <InputRow rowInfo={publicaPriceRow} disableEdit={disableEdit} />
                  {EBool.isTrue(HonorChannelFloor) && (
                    <div style={{ color: 'red' }}>{priceLessThanBidFloorWarning}</div>
                  )}
                </Grid>
                <Grid style={{ marginLeft: '4px' }}>
                  {/* VAST Price Extension */}
                  {this.renderEnableVastExtensionPrice()}
                </Grid>
              </Grid>
            );
          } else if (
            option.Name === 'price_range' &&
            option.Bidder === DemandSources.apsOpenAuction
          ) {
            const apsOpenAuctionPriceRow = {
              renderType: 'custom',
              customRender: (rowInfo: IInputRow) =>
                this.renderAPSOpenAuctionRow(option, customDescription, rowInfo),
              title1: '',
              field1: '',
              value1: option.Value,
              defaultValue1: defaultValue,
              handleChange1: noopVoid,
              isActiveValue1: () => false,
              getActiveTag1: () => '',
              cloneEnabled: cloneBidderEnabled,
              compareValues: this.state.compareValues,
              marked: this.checkIfRowIsMarked([option.Name]),
              handleChangeMarked: () =>
                this.handleChangeMarked([
                  {
                    key: option.Name,
                    displayTitle: ct('PriceRange'),
                    genDisplayValue: () => option.Value.toString(),
                    enabled: false,
                    genType: () => this.getCloneType(option.Name),
                    defaultValue,
                    tab: 'Parameters',
                  },
                ]),
            } as IInputRow;
            return <InputRow rowInfo={apsOpenAuctionPriceRow} disableEdit={disableEdit} />;
          } else if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'defaultValue')) {
            const paramDefaultValueRow = {
              renderType: 'custom',
              customRender: (rowInfo: IInputRow) =>
                this.renderCustomRow(
                  <TextFieldWithDefaultValue
                    bidder={option.Bidder}
                    name={option.Name}
                    description={customDescription}
                    isSuperUser={isSuperUser}
                    defaultValue={
                      option.Value !== ''
                        ? option.Value
                        : this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].defaultValue
                    }
                    canEdit={false}
                    cb={this.setDefaultValue}
                  />,
                  customLabel,
                  rowInfo,
                )(),
              title1: '',
              field1: '',
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              value1: option.Value,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              defaultValue1:
                this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].defaultValue,
              handleChange1: noopVoid,
              isActiveValue1: () => false,
              getActiveTag1: () => '',
              cloneEnabled: cloneBidderEnabled,
              compareValues: this.state.compareValues,
              marked: false,
            } as IInputRow;
            return <InputRow rowInfo={paramDefaultValueRow} disableEdit={disableEdit} />;
          } else if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'type', 'enum')) {
            let value = option.Value;
            if (option.Bidder === DemandSources.publicaCampaign && option.Name === 'vastURL') {
              value = getCampaignIDFromVastURL(value);
              const lineItemTargetingRow = {
                renderType: 'custom',
                customRender: (rowInfo: IInputRow) =>
                  this.renderCustomRow(
                    <TextField
                      name='CampaignTargeting'
                      select={true}
                      style={{ width: 200, height: 40 }}
                      onChange={this.handleChange}
                      value={this.state.CampaignTargeting}
                      InputProps={{
                        classes: {
                          input: this.props.classes.inputWide,
                        },
                      }}
                    >
                      {bidderCampaignTargetingItems.map((item: IPriorityOption) => {
                        return (
                          <MenuItem className={classes.menuItem} key={item.text} value={item.value}>
                            {item.text}
                          </MenuItem>
                        );
                      })}
                    </TextField>,
                    ct('LineItemTargeting'),
                    rowInfo,
                  )(),
                title1: '',
                field1: '',
                value1: this.state.CampaignTargeting,
                defaultValue1: HeaderBidderCampaignTargetingInactive,
                handleChange1: noopVoid,
                isActiveValue1: () => false,
                getActiveTag1: () => '',
                cloneEnabled: cloneBidderEnabled,
                compareValues: this.state.compareValues,
                marked: this.checkIfRowIsMarked(['CampaignTargeting']),
                handleChangeMarked: () =>
                  this.handleChangeMarked([
                    {
                      key: 'CampaignTargeting',
                      displayTitle: ct('LineItemTargeting'),
                      genDisplayValue: () =>
                        bidderCampaignTargetingItems[this.state.CampaignTargeting].text,
                      enabled: false,
                      genType: () => this.getCloneType('CampaignTargeting'),
                      defaultValue: HeaderBidderCampaignTargetingInactive,
                      tab: 'Parameters',
                    },
                  ]),
              } as IInputRow;
              component = (
                <Grid item style={{ width: '100%' }}>
                  <Grid
                    container
                    direction='row'
                    justifyContent='flex-start'
                    alignItems='center'
                    spacing={1}
                  >
                    <InputRow rowInfo={lineItemTargetingRow} disableEdit={disableEdit} />
                    {this.state.CampaignTargeting === HeaderBidderCampaignTargetingSelected &&
                      !cloneBidderEnabled && (
                        <Grid item style={{ width: '100%', marginBottom: 10 }}>
                          <Grid
                            container
                            direction='row'
                            justify='flex-start'
                            alignItems='center'
                            spacing={1}
                          >
                            <Grid item xs={3}>
                              <Typography className={classes.insideAccordionText}>
                                {ct('TargetedLineItems')}
                              </Typography>
                            </Grid>
                            <Grid item xs={8}>
                              <MaterialSearchDropdownMulti
                                getValueFromSearchElement={(src: IListItem) => src.title}
                                fontSize='14px'
                                fontColor={
                                  'TargetedCampaigns' in this.state.errors ? 'red' : 'black'
                                }
                                selectAll={true}
                                menuTitle={ct('LineItems')}
                                list={this.state.bidderTargetedCampaignsList}
                                onChange={(list: IMenuList) =>
                                  this.setState({ bidderTargetedCampaignsList: list })
                                }
                                handleMenuAcceptClick={this.handleTargetedCampaignsAcceptClick}
                                helperText={ct('BiddersErrorTargetAtLeastOneLineItem')}
                                width='400px'
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    {this.state.CampaignTargeting === HeaderBidderOrderTargetingSelected && (
                      <Grid item style={{ width: '100%', marginBottom: 10 }}>
                        <Grid
                          container
                          direction='row'
                          justify='flex-start'
                          alignItems='center'
                          spacing={1}
                        >
                          <Grid item xs={3}>
                            <Typography className={classes.insideAccordionText}>
                              {ct('TargetedOrders')}
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MaterialSearchDropdownMulti
                              getValueFromSearchElement={(src: IListItem) => src.title}
                              fontSize='14px'
                              fontColor={'TargetedOrders' in this.state.errors ? 'red' : 'black'}
                              selectAll={true}
                              menuTitle={ct('Orders')}
                              list={this.state.bidderTargetedOrdersList}
                              onChange={(list: IMenuList) =>
                                this.setState({ bidderTargetedOrdersList: list })
                              }
                              handleMenuAcceptClick={this.handleTargetedOrdersAcceptClick}
                              helperText={ct('BiddersErrorTargetAtLeastOneOrder')}
                              width='400px'
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              );
            } else if (
              option.Name === 'platformMarketplacePublisher' &&
              this.props.session.publisher.EnablePlatformMarketplace === EBool.EBool_TRUE
            ) {
              // if the bidder option is the platform marketplace dropdown, then populate its options with the publishers
              // that opted-in

              // get the needed values from the state
              const { platformMarketplacePublishers } = this.state;
              // Hides buying publisher dropdown for all Ottera publishers except '475', '924' and '925'
              const hideForOttera =
                !['475', '924', '925'].includes(this.props.session.publisher.ID) && isOttera();

              // create the new row info data struct, will be inserted after in the component override
              const platformMarketplaceRowInfo = {
                renderType: 'custom',
                customRender: (rowInfo: IInputRow) =>
                  this.renderCustomRow(
                    <TextField
                      disabled={cloneBidderEnabled}
                      name='PlatformMarketplaceTargetedPublisher'
                      select={true}
                      style={{ width: 200, height: 40, display: hideForOttera ? 'none' : '' }}
                      onChange={this.handlePlatformMarketplaceChange}
                      value={this.state.PlatformMarketplaceTargetedPublisher}
                      InputProps={{
                        classes: {
                          input: this.props.classes.inputWide,
                        },
                      }}
                    >
                      {platformMarketplacePublishers.map((pub: IPublisher) => {
                        return (
                          <MenuItem className={classes.menuItem} key={pub.name} value={pub.ID}>
                            {pub.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>,
                    hideForOttera ? '' : ct('BuyingPartner'),
                    rowInfo,
                  )(),
                title1: '',
                field1: '',
                value1: this.state.PlatformMarketplaceTargetedPublisher,
                defaultValue1: '0',
                handleChange1: noopVoid,
                isActiveValue1: () => false,
                getActiveTag1: () => '',
                cloneEnabled: false,
                compareValues: this.state.compareValues,
                marked: false,
              } as IInputRow;

              // override the component
              component = (
                <InputRow rowInfo={platformMarketplaceRowInfo} disableEdit={disableEdit} />
              );
            } else {
              if (
                option.Bidder === DemandSources.indexExchange &&
                option.Name === 'endpoint' &&
                ![
                  ENDPOINT_STAGING_KEY,
                  ENDPOINT_PROD_KEY,
                  ENDPOINT_DEFAULT_KEY,
                  ENDPOINT_EU_KEY,
                  ENDPOINT_APAC_KEY,
                  ENDPOINT_US_WEST_KEY,
                  ENDPOINT_APAC_NORTH_KEY,
                ].includes(option.Value)
              ) {
                option.Value = ENDPOINT_DEFAULT_KEY;
              }
              const customRender = (rowInfo: IInputRow) =>
                this.renderCustomRow(
                  <TextField
                    name={option.Name}
                    select={!disableEdit}
                    disabled={disableEdit}
                    fullWidth
                    onChange={this.handleChangeParamOption}
                    value={value}
                    helperText={customDescription}
                    style={{ width: 400, height: 40, marginBottom: 10 }}
                    InputProps={{
                      classes: {
                        input: this.props.classes.inputExtraWide,
                      },
                    }}
                  >
                    {
                      // If we have a base value, then we don't need a None enum option since the base value should be the starting value
                      !this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].baseValue && (
                        <MenuItem value='' className={classes.inputExtraWide}>
                          None
                        </MenuItem>
                      )
                    }
                    {this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].items &&
                      this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].items.map(
                        (item: { [key: string]: string }) => {
                          return (
                            <MenuItem
                              key={item.key}
                              value={item.key}
                              className={classes.inputExtraWide}
                            >
                              {item.text}
                            </MenuItem>
                          );
                        },
                      )}
                    {isSuperUser &&
                      this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].itemsSuperOnly &&
                      this.HeaderBidderParamsUIconfig[option.Bidder][
                        option.Name
                      ].itemsSuperOnly.map((item: { [key: string]: string }) => {
                        return (
                          <MenuItem
                            key={item.key}
                            value={item.key}
                            className={classes.inputExtraWide}
                          >
                            {item.text}
                          </MenuItem>
                        );
                      })}
                    {option.Bidder === DemandSources.publicaCampaign &&
                      option.Name === 'vastURL' &&
                      typeof this.HeaderBidderParamsUIconfig[option.Bidder][option.Name]
                        .getItems === 'function' &&
                      this.HeaderBidderParamsUIconfig[option.Bidder][option.Name]
                        .getItems((this.props.session.site || {}).ID, this.state.campaigns)
                        .map((item: { [key: string]: string }) => {
                          return (
                            <MenuItem
                              key={item.key}
                              value={item.key}
                              className={classes.inputExtraWide}
                            >
                              {item.text}
                            </MenuItem>
                          );
                        })}
                  </TextField>,
                  customLabel,
                  rowInfo,
                )();

              const paramTextFieldRow = {
                renderType: 'custom',
                customRender,
                title1: '',
                field1: '',
                value1: option.Value,
                defaultValue1: defaultValue,
                handleChange1: noopVoid,
                isActiveValue1: () => false,
                getActiveTag1: () => '',
                cloneEnabled: cloneBidderEnabled,
                compareValues: this.state.compareValues,
                marked: this.checkIfRowIsMarked([option.Name]),
                handleChangeMarked: () =>
                  this.handleChangeMarked([
                    {
                      key: option.Name,
                      displayTitle: option.Name,
                      genDisplayValue: () => option.Value.toString(),
                      enabled: false,
                      genType: () => this.getCloneType(option.Name),
                      defaultValue,
                      tab: 'Parameters',
                    },
                  ]),
              } as IInputRow;
              return <InputRow rowInfo={paramTextFieldRow} disableEdit={disableEdit} />;
            }
          } else if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'type', 'switch')) {
            const paramSwitchRow = {
              renderType: 'custom',
              customRender: (rowInfo: IInputRow) =>
                this.renderCustomRow(
                  <Grid style={{ marginLeft: -10 }}>
                    <Switch
                      name={option.Name}
                      checked={
                        option.Value ===
                        this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].trueValue
                      }
                      onChange={this.handleChangeSwitchOption}
                    />
                  </Grid>,
                  customLabel,
                  rowInfo,
                )(),
              title1: '',
              field1: '',
              value1: option.Value,
              defaultValue1: this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].trueValue,
              handleChange1: noopVoid,
              isActiveValue1: () => false,
              getActiveTag1: () => '',
              cloneEnabled: cloneBidderEnabled,
              compareValues: this.state.compareValues,
              marked: this.checkIfRowIsMarked([option.Name]),
              handleChangeMarked: () =>
                this.handleChangeMarked([
                  {
                    key: option.Name,
                    displayTitle: option.Name,
                    genDisplayValue: () => JSON.stringify(option.Value),
                    enabled: false,
                    genType: () => this.getCloneType(option.Name),
                    defaultValue:
                      this.HeaderBidderParamsUIconfig[option.Bidder][option.Name].trueValue,
                    tab: 'Parameters',
                  },
                ]),
            } as IInputRow;
            return <InputRow rowInfo={paramSwitchRow} disableEdit={disableEdit} />;
          }
          if (shouldParamOptionOverwritten(option.Bidder, option.Name, 'onlyForSuperUser', true)) {
            return isSuperUser && component;
          }
          return component;
        });
    }

    renderRootKeyValueParameters = (rowInfo: IInputRow) => {
      const { rootKeyValueParameters } = this.state;
      return this.renderCustomRow(
        <Grid item style={{ marginBottom: 10 }}>
          {Object.keys(rootKeyValueParameters).map((prefix) => {
            return rootKeyValueParameters[prefix].map(
              (rootKeyValueParameter: IRootKeyValueParameter, idx: number) => {
                return (
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={2}
                  >
                    {/* Prefix */}
                    <Grid item>
                      <TextField
                        style={{ width: '100px' }}
                        inputProps={{ style: { textAlign: 'center' } }}
                        placeholder={ct('Prefix')}
                        value={rootKeyValueParameter.prefix}
                        onChange={(event: any) => {
                          this.editPrefixRootKeyValueParameter(prefix, event.target.value, idx);
                        }}
                      />
                    </Grid>
                    {/* Key */}
                    <Grid item>
                      <TextField
                        style={{ width: '100px' }}
                        inputProps={{ style: { textAlign: 'center' } }}
                        placeholder={ct('Key')}
                        value={rootKeyValueParameter.key}
                        onChange={(event: any) => {
                          const clonedRootKeyValueParameter = cloneDeep(rootKeyValueParameter);
                          clonedRootKeyValueParameter.key = event.target.value;
                          this.editRootKeyValueParameter(prefix, idx, clonedRootKeyValueParameter);
                        }}
                      />
                    </Grid>
                    {/* Arrow */}
                    <Grid item style={{ fontSize: '25px' }}>
                      →
                    </Grid>
                    {/* Value */}
                    <Grid item>
                      <TextField
                        style={{ width: '150px' }}
                        inputProps={{ style: { textAlign: 'center' } }}
                        value={rootKeyValueParameter.value}
                        placeholder={ct('Value')}
                        onChange={(event: any) => {
                          const clonedRootKeyValueParameter = cloneDeep(rootKeyValueParameter);
                          clonedRootKeyValueParameter.value = event.target.value;
                          this.editRootKeyValueParameter(prefix, idx, clonedRootKeyValueParameter);
                        }}
                      />
                    </Grid>
                    {/* Delete Button */}
                    <Grid item>
                      <Button
                        style={{ color: getColorTheme('secondaryButtonText') }} // Delete button for key-value parameters
                        onClick={() => this.deleteRootKeyValueParameter(prefix, idx)}
                      >
                        {ct('Delete')}
                      </Button>
                    </Grid>
                    {/* New Button */}
                  </Grid>
                );
              },
            );
          })}
          <br />
          <Button
            style={{
              backgroundColor: getColorTheme('primaryButton'),
              color: 'white',
              fontSize: '13px',
              marginBottom: 6,
            }} // Add new button for key-value parameter
            onClick={() => this.createNewRootKeyValueParameter('')}
          >
            {ct('AddNewExtensionKeyValueParameter')}
          </Button>
        </Grid>,
        ct('ExtensionKeyValueParameters'),
        rowInfo,
      )();
    };

    renderKeyValueParameters = (rowInfo: IInputRow) => {
      const isTelaria = this.state.Bidder === DemandSources.telaria;
      const isNexstar = this.state.Bidder === DemandSources.nexstar;
      const isNexxen = this.state.Bidder === DemandSources.rhythmone;

      const shouldDisableEdit = isNexstar || isNexxen;

      const count = this.state.keyValueParameters.length;

      return this.renderCustomRow(
        <div style={{ marginBottom: 10 }}>
          {this.state.keyValueParameters.map((param: IKeyValueParameter, index: number) => (
            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
              {/* Key */}
              <Grid item>
                <TextField
                  style={{ width: '100px' }}
                  className='pb-bidder-settings-form-view_textfield-key'
                  inputProps={{ style: { textAlign: 'center' } }}
                  placeholder={ct('Key')}
                  value={param.key}
                  onChange={(event: any) => {
                    param.key = event.target.value;
                    this.editKeyValueParameter(index, param);
                  }}
                  disabled={
                    (isTelaria && ['custom', 'c1', 'c2', 'c3'].includes(param.key)) ||
                    shouldDisableEdit ||
                    param.isNotEditable
                  }
                />
              </Grid>
              {/* Arrow */}
              <Grid item style={{ fontSize: '25px' }}>
                →
              </Grid>
              {/* Value */}
              <Grid item>
                <TextField
                  style={{ width: '150px' }}
                  className='pb-bidder-settings-form-view_textfield-key-value'
                  inputProps={{ style: { textAlign: 'center' } }}
                  value={param.value}
                  placeholder={ct('Value')}
                  onChange={(event: any) => {
                    param.value = event.target.value;
                    this.editKeyValueParameter(index, param);
                  }}
                  disabled={param.isNotEditable}
                />
              </Grid>
              {/* Delete Button */}
              {!param.isNotEditable && (
                <Grid item>
                  <Button
                    style={{ color: getColorTheme('secondaryButtonText') }} // Delete button for key-value parameters
                    onClick={() => {
                      this.deleteKeyValueParameter(index);
                    }}
                  >
                    {ct('Delete')}
                  </Button>
                </Grid>
              )}
            </Grid>
          ))}
          <br />
          {/* New Button */}
          <Button
            style={{
              backgroundColor: getColorTheme('primaryButton'),
              color: 'white',
              fontSize: '13px',
              marginBottom: 6,
            }} // Add new button for key-value parameter
            onClick={() => {
              this.newKeyValueParameter(count, this.state.Bidder);
            }}
          >
            {ct('AddNewKeyValueParameter')}
          </Button>
        </div>,
        'Key Value Parameters',
        rowInfo,
      )();
    };

    renderPacingType = (rowInfo: IInputRow) => {
      const { classes } = this.props;
      const { PacingType } = this.state;

      return this.renderCustomRow(
        <Grid
          container
          direction='row'
          justify='flex-start'
          alignItems='center'
          style={{
            maxWidth: '450px',
            marginBottom: '15px',
          }}
        >
          <Grid item>
            <TextField
              fullWidth
              select={true}
              name='PacingType'
              value={(getPacingTypeOption(PacingType) || { text: '' }).text}
              onChange={this.handleChangePacingTypeSelect}
              margin='normal'
              InputProps={{
                classes: {
                  input: classes.inputWide,
                },
              }}
            >
              {pacingTypeOptions.map(({ text, value }) => {
                return (
                  <MenuItem key={value} value={text} style={{ fontSize: 14 }}>
                    {text}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
          <Tooltip title={ct('BiddersTooltipDailyRequests')} placement='bottom-start'>
            <InfoIcon
              style={{ verticalAlign: 'bottom', width: '1rem', color: '#929599', marginTop: '8px' }}
            />
          </Tooltip>
        </Grid>,
        ct('Pacing'),
        rowInfo,
      )();
    };

    renderFrequencyCapping = (rowInfo: IInputRow) => {
      const { classes } = this.props;
      const {
        FrequencyActive,
        FrequencyLimit,
        frequencyLimitDuration,
        frequencyLimitUnit,
        bulkUpdateEnabled,
      } = this.state;
      const disableParams = this.paramsDisabled();

      return this.renderCustomRow(
        <Grid item style={{ width: '100%' }}>
          <Grid container direction='row'>
            <span className={classes.spanActive} style={{ marginTop: 10 }}>
              {FrequencyActive === ResourceActiveEnabled ? ct('Active') : ct('Inactive')}
            </span>

            <Grid item style={{ marginTop: 15, marginLeft: -20 }}>
              <Switch
                disabled={disableParams}
                className={classes.centeredSwitch}
                checked={FrequencyActive === ResourceActiveEnabled}
                name='FrequencyActive'
                onChange={this.handleChange}
                value={FrequencyActive}
                color='primary'
              />
            </Grid>

            {(FrequencyActive === ResourceActiveEnabled || bulkUpdateEnabled) && (
              <>
                <span className={classes.spanDescription}>{ct('SetLimitTo')}</span>

                <Grid item style={{ maxWidth: 75, marginTop: 5 }}>
                  <FocusedTextfield
                    label={ct('Frequency')}
                    name='FrequencyLimit'
                    style={{ width: '100%' }}
                    value={FrequencyLimit}
                    disabled={disableParams}
                    onChange={this.handleChange}
                  />
                </Grid>

                <span className={classes.spanDescription}>{ct('ImpressionsPerUserPer')}</span>

                <Grid item style={{ maxWidth: 75, marginTop: 5 }}>
                  <FocusedTextfield
                    label={ct('Duration')}
                    name='frequencyLimitDuration'
                    style={{ width: '100%' }}
                    value={frequencyLimitDuration}
                    disabled={disableParams}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item style={{ width: 75, margin: '10px 0 0 10px' }}>
                  <Select
                    style={{ width: 75, fontSize: 14 }}
                    name='frequencyLimitUnit'
                    value={frequencyLimitUnit}
                    disabled={disableParams}
                    onChange={this.handleChange}
                  >
                    <MenuItem
                      key={FrequencyLimitUnitDays}
                      value={FrequencyLimitUnitDays}
                      style={{ width: '100%', fontSize: 14 }}
                    >
                      {ct('Days')}
                    </MenuItem>
                    <MenuItem
                      key={FrequencyLimitUnitHours}
                      value={FrequencyLimitUnitHours}
                      style={{ width: '100%', fontSize: 14 }}
                    >
                      {ct('Hours')}
                    </MenuItem>
                  </Select>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>,
        ct('FrequencyCapping'),
        rowInfo,
      )();
    };

    renderPoddedRequest = () => {
      const isVast = this.state.Bidder === DemandSources.publica;

      const { cloneBidderEnabled } = this.props;

      const { bulkUpdateEnabled, disableParams } = this.state;

      const newImpressionsSinceLastTest =
        this.state.CRONQuantityCount !== this.state.CRONQuantityCountSinceLastTest;
      const paramsInTesting = this.getParamsInTesting();

      const PoddedRequest = {
        renderType: 'SimpleSwitch',
        title1: ct('PoddedRequest'),
        enableSmallRow: true,
        field1: 'PoddedRequestActive',
        value1: this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive,
        defaultValue1: false,
        handleChange1: this.handlePoddedRequestActiveChange,
        isActiveValue1: () =>
          this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive,
        getActiveTag1: (active: boolean) => (active ? ct('PoddedRequest') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['PoddedRequestActive']),
        disabled1:
          (paramsInTesting.includes('PoddedRequestActive') && newImpressionsSinceLastTest) ||
          this.state.MultiBidActive === EBool.EBool_TRUE,
        helperText:
          paramsInTesting.includes('PoddedRequestActive') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        tooltipText: isVast ? ct('BiddersTooltipPoddedRequest') : '',
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'PoddedRequestActive',
              displayTitle: ct('PoddedRequest'),
              genDisplayValue: () =>
                this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive
                  ? ct('Active')
                  : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('PoddedRequestActive'),
              defaultValue: HeaderBidderPoddedRequestActiveInactive,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      return <InputRow rowInfo={PoddedRequest} disableEdit={disableParams} />;
    };

    renderPoddedRequestType = () => {
      const { cloneBidderEnabled } = this.props;

      const { bulkUpdateEnabled, disableParams, Bidder, PoddedRequestType } = this.state;

      const poddedRequestTypeOptions = generateORTB26PoddedRequestTypeOptions(Bidder);
      const splitHybridStructuredSlotDurations =
        this.state.HybridStructuredSlotDurations.length > 0
          ? this.state.HybridStructuredSlotDurations.split(',')
          : [];

      let poddedOptionType = EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeNonPodded;
      if (poddedRequestTypeOptions.length > 0) {
        poddedOptionType = Number(poddedRequestTypeOptions[0].key);
      }

      const PoddedRequestTypeRow = {
        renderType: 'SimpleSingleSelect',
        enableSmallRow: true,
        simpleSelectItems: poddedRequestTypeOptions || [],
        title1: ct('PoddedRequestType'),
        field1: 'PoddedRequestType',
        value1: this.state.PoddedRequestType,
        defaultValue1: poddedOptionType,
        handleChange1: this.handlePoddedRequestTypeChange,
        isActiveValue1: () =>
          this.state.PoddedRequestType !==
          EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeNonPodded,
        getActiveTag1: (active: boolean) =>
          active ? HeaderBidderPoddedRequestTypeToString(PoddedRequestType) : ct('All'),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        tooltipText:
          this.state.PoddedRequestType ===
          EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeHybrid
            ? ct('BiddersTooltipPoddedRequestTypeHybrid')
            : '',
        hasButton:
          this.state.PoddedRequestType ===
          EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeHybrid,
        buttonOnClick: this.handleAddStructuredSlot,
        buttonText:
          this.state.PoddedRequestType ===
          EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeHybrid
            ? ct('PlusAddItem', { item: ct('StructuredSlot') })
            : '',
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['PoddedRequestType']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'PoddedRequestType',
              displayTitle: ct('PoddedRequestType'),
              genDisplayValue: () => HeaderBidderPoddedRequestTypeToString(PoddedRequestType),
              enabled: false,
              genType: () => this.getCloneType('PoddedRequestType'),
              defaultValue: '',
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      const hybridSlotRowsArr =
        this.state.PoddedRequestType ===
        EHeaderBidder_PoddedRequestType.HeaderBidderPoddedRequestTypeHybrid
          ? splitHybridStructuredSlotDurations.map((duration, index) => {
              const durationInt = parseInt(duration, 10);

              const PoddedRequestTypeHybridSlotRow = {
                renderType: 'NumberTextfield',
                enableSmallRow: true,
                title1: `Slot ${index + 1}`,
                field1: `Slot${index + 1}`,
                value1: durationInt,
                defaultValue1: false,
                handleChange1: (event: React.ChangeEvent<HTMLInputElement>) =>
                  this.handleChangeHybridStructuredSlotDuration(
                    event,
                    index,
                    'HybridStructuredSlotDuration',
                  ),
                isActiveValue1: () => durationInt !== 0,
                getActiveTag1: (active: boolean) => (active ? duration : ct('Length')),
                markedEnabled: false,
                cloneEnabled: false,
                hasButton: splitHybridStructuredSlotDurations.length === index + 1,
                buttonOnClick: () => this.handleRemoveStructuredSlot(index),
                buttonText:
                  splitHybridStructuredSlotDurations.length === index + 1
                    ? ct('RemoveItem', { item: ct('Slot') })
                    : '',
                isSubRow: true,
                compareValues: this.state.compareValues,
              };
              return PoddedRequestTypeHybridSlotRow;
            })
          : [];

      return (
        <>
          <InputRow rowInfo={PoddedRequestTypeRow} disableEdit={disableParams} />
          {hybridSlotRowsArr.map((row) => {
            return (
              <div>
                <InputRow rowInfo={row} disableEdit={disableParams} />
              </div>
            );
          })}
        </>
      );
    };

    renderExtendedContentIDVendors = (
      showLegacyIris: boolean,
      showNewContentIDVendors: boolean,
    ): JSX.Element => {
      const { cloneBidderEnabled } = this.props;
      const { bulkUpdateEnabled, disableParams } = this.state;
      const paramsInTesting = this.getParamsInTesting();

      const simpleSelectItems = [];

      if (showNewContentIDVendors) {
        simpleSelectItems.push(
          {
            key: 'peer39.com',
            text: 'Peer 39 (New)',
          },
          {
            key: 'iris.tv',
            text: 'Iris TV (New)',
          },
        );
      }

      if (showLegacyIris) {
        simpleSelectItems.push({
          key: 'enableirissignal',
          text: 'Iris TV (Legacy)',
        });
      }

      const defaultValue = [];
      if (this.state.ExtendedContentIDVendors) {
        defaultValue.push(...this.state.ExtendedContentIDVendors.split(','));
      }
      if (this.state.EnableIrisSignal === EBool.EBool_TRUE) {
        defaultValue.push('enableirissignal');
      }

      const enableExtendedContentIDVendors = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems,
        title1: 'Extended Content ID Vendors',
        enableSmallRow: true,
        field1: 'ExtendedContentIDVendors',
        value1: defaultValue,
        defaultValue1: '',
        handleChange1: this.handleChangeMultiSelect,
        isActiveValue1: () =>
          this.state.EnableIrisSignal === EBool.EBool_TRUE ||
          (this.state.ExtendedContentIDVendors && this.state.ExtendedContentIDVendors.length > 0),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        disabled1: paramsInTesting.includes('ExtendedContentIDVendors'),
        helperText: paramsInTesting.includes('ExtendedContentIDVendors')
          ? ct('DisabledWhileInTesting')
          : '',
      } as IInputRow;
      return (
        <Grid container direction='row' alignItems='center' spacing={2}>
          <InputRow rowInfo={enableExtendedContentIDVendors} disableEdit={disableParams} />
        </Grid>
      );
    };

    // First ID is taken since the dropdowns, while normally multi-select, are set to single
    handleChangeBuyType = (buyTypeIDs: number[], buyTypeNames: string[]): void => {
      if (buyTypeIDs.length) {
        this.setState({
          BuyTypeID: buyTypeIDs[0],
          BuyTypeName: buyTypeNames[0] || '',
        });
      } else {
        this.setState({
          BuyTypeID: 0,
          BuyTypeName: '',
        });
      }
    };

    addOrUpdateCompany = (Name: string, CompanyType: ECompanyType, ID: number) => {
      this.setState(
        {
          updating: true,
        },
        () => {
          if (ID === 0) {
            createCompany(
              {
                ID: 0,
                CompanyType,
                Name,
                PublisherID: parseInt(this.props.session.publisher.ID, 10),
              },
              this.props.session.publisher.ID,
            )
              .then(() => {
                this.setState({
                  updating: false,
                  snackbarMessage: ct('SnackbarSuccessfullyCreatedItem', {
                    item: ct('Company'),
                  }),
                  companyUpdateCounter: this.state.companyUpdateCounter + 1,
                });
              })
              .catch(() => {
                this.setState({
                  updating: false,
                  snackbarMessage: ct('SnackbarFailedToCreateItem', {
                    item: ct('Company'),
                  }),
                  snackbarError: true,
                });
              });
          } else {
            updateCompany(
              {
                ID,
                CompanyType,
                Name,
                PublisherID: parseInt(this.props.session.publisher.ID, 10),
              },
              this.props.session.publisher.ID,
              false,
            )
              .then(() => {
                this.setState({
                  updating: false,
                  snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', {
                    item: ct('Company'),
                  }),
                  companyUpdateCounter: this.state.companyUpdateCounter + 1,
                });
              })
              .catch(() => {
                this.setState({
                  updating: false,
                  snackbarMessage: ct('SnackbarFailedToUpdateItem', { item: ct('Company') }),
                  snackbarError: true,
                });
              });
          }
        },
      );
    };

    deleteCompany = (id: number) => {
      this.setState(
        {
          updating: true,
        },
        () => {
          deleteCompany(id.toString(), this.props.session.publisher.ID)
            .then(() => {
              this.setState({
                updating: false,
                snackbarMessage: ct('SnackbarItemIDDeletedSuccessfully', {
                  item: ct('Company'),
                  id,
                }),
                companyUpdateCounter: this.state.companyUpdateCounter + 1,
              });
            })
            .catch(() => {
              this.setState({
                updating: false,
                snackbarMessage: ct('SnackbarItemIDDeletionFailed', {
                  item: ct('Company'),
                  id,
                }),
                snackbarError: true,
              });
            });
        },
      );
    };

    renderBuyTypeDrowdown = () => {
      const { cloneBidderEnabled } = this.props;
      const { buyTypeUpdateCounter, BuyTypeID, BuyTypeName, disableParams, bulkUpdateEnabled } =
        this.state;
      const buyTypeIDs = [] as number[];
      if (BuyTypeID) {
        buyTypeIDs.push(BuyTypeID);
      }
      const buyTypeNames = [] as string[];
      if (BuyTypeName) {
        buyTypeNames.push(BuyTypeName);
      }

      const buyTypeRow = {
        renderType: 'custom',
        customRender: (rowInfo: IInputRow) =>
          this.renderCustomRow(
            <Grid item xs={7} style={{ alignItems: 'center', marginBottom: 10 }}>
              <CompanyMultiSelect
                onChange={this.handleChangeBuyType}
                publisherID={this.props.session.publisher.ID}
                companyIDs={buyTypeIDs}
                enableMultiSelect={false}
                companyTypesAllowed={[ECompanyType.TYPE_BUY_TYPE]}
                openAddEditCompanyModelHandler={() =>
                  this.setState({ AddEditBuyTypeModelActive: true })
                }
                counter={buyTypeUpdateCounter}
                menuTitle={companyTypes[ECompanyType.TYPE_BUY_TYPE].text}
                username={this.props.user.user.Username}
                topListItemText={ct('AddEditItem', { item: ct('BuyType') })}
              />
            </Grid>,
            ct('BuyType'),
            rowInfo,
          )(),
        title1: '',
        field1: '',
        value1: '',
        handleChange1: noopVoid,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        markedEnabled: bulkUpdateEnabled,
        marked: this.checkIfRowIsMarked(['BuyTypeID']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'BuyTypeID',
              displayTitle: ct('BuyType'),
              genDisplayValue: () => this.state.BuyTypeName || '',
              enabled: false,
              genType: () => this.getCloneType('BuyTypeID'),
              defaultValue: '',
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;

      return <InputRow rowInfo={buyTypeRow} disableEdit={disableParams} />;
    };

    renderEnableVastExtensionPrice = () => {
      const { cloneBidderEnabled } = this.props;

      const { bulkUpdateEnabled, disableParams } = this.state;

      const enableVastExtensionPrice = {
        renderType: 'SimpleSwitch',
        title1: ct('VASTPriceExtension'),
        enableSmallRow: true,
        tooltipText: ct('BiddersTooltipVASTPriceExtension'),
        field1: 'VastExtensionPriceEnabled',
        value1: this.state.VastExtensionPriceEnabled === EBool.EBool_TRUE,
        defaultValue1: false,
        handleChange1: () => this.handleReverseToggle('VastExtensionPriceEnabled'),
        isActiveValue1: () => this.state.VastExtensionPriceEnabled === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('UseVASTPriceExtension') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['VastExtensionPriceEnabled']),
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'VastExtensionPriceEnabled',
              displayTitle: ct('VASTPriceExtension'),
              genDisplayValue: () =>
                this.state.VastExtensionPriceEnabled === EBool.EBool_TRUE
                  ? ct('Active')
                  : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('VastExtensionPriceEnabled'),
              defaultValue: EBool.EBool_FALSE,
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      return (
        <Grid container direction='row' alignItems='center' xs='auto'>
          <Grid item xs={3}></Grid>
          <Grid item xs={9}>
            <InputRow rowInfo={enableVastExtensionPrice} disableEdit={disableParams} />
          </Grid>
        </Grid>
      );
    };

    renderMultiBid = () => {
      const { cloneBidderEnabled } = this.props;

      const { bulkUpdateEnabled, disableParams } = this.state;

      const newImpressionsSinceLastTest =
        this.state.CRONQuantityCount !== this.state.CRONQuantityCountSinceLastTest;
      const paramsInTesting = this.getParamsInTesting();

      const MultiBid = {
        renderType: 'SimpleSwitch',
        title1: ct('MultiBid'),
        enableSmallRow: true,
        field1: 'MultiBidActive',
        value1: this.state.MultiBidActive === EBool.EBool_TRUE,
        defaultValue1: false,
        handleChange1: () => this.handleReverseToggle('MultiBidActive'),
        isActiveValue1: () => this.state.MultiBidActive === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? ct('MultiBid') : ''),
        markedEnabled: bulkUpdateEnabled,
        cloneEnabled: cloneBidderEnabled,
        compareValues: this.state.compareValues,
        marked: this.checkIfRowIsMarked(['MultiBidActive']),
        disabled1:
          (paramsInTesting.includes('MultiBidActive') && newImpressionsSinceLastTest) ||
          this.state.PoddedRequestActive === HeaderBidderPoddedRequestActiveActive,
        helperText:
          paramsInTesting.includes('MultiBidActive') && newImpressionsSinceLastTest
            ? ct('DisabledWhileInTesting')
            : '',
        handleChangeMarked: () =>
          this.handleChangeMarked([
            {
              key: 'MultiBidActive',
              displayTitle: ct('MultiBid'),
              genDisplayValue: () =>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
                this.state.MultiBidActive === EBool.EBool_TRUE ? ct('Active') : ct('Inactive'),
              enabled: false,
              genType: () => this.getCloneType('MultiBidActive'),
              tab: 'Parameters',
            },
          ]),
      } as IInputRow;
      return <InputRow rowInfo={MultiBid} disableEdit={disableParams} />;
    };

    renderFlexibleBiddingBidding = (rowInfo: IInputRow) => {
      // Also the Bidder Tier
      const { classes } = this.props;

      const { marked, handleChangeMarked } = rowInfo;

      const {
        errors,
        disableParams,
        Priority,
        SubPriority,
        FlexibleBiddingEnabled,
        FlexibleBiddingThresholds,
        FlexibleBiddingType,
        flexibleBiddingDialogInvalidThresholds,
        EnableSpotxBidderAssociation,
        EnableMagniteCTVBidderAssociation,
        EnableSamsungSSPBidderAssociation,
      } = this.state;

      const isSpotxTierDisabled = this.props.isSpotxTierEnabled !== EBool.EBool_TRUE;
      const isMagniteCTVTierDisabled = this.props.isMagniteCTVTierEnabled !== EBool.EBool_TRUE;
      const isSamsungSSPTierDisabled = this.props.isSamsungSSPTierEnabled !== EBool.EBool_TRUE;
      const areFlexibleBidderTiersAvailable = 10 - Priority - FlexibleBiddingThresholds.length > 0;

      return (
        <div style={{ marginTop: 12, marginBottom: 12 }}>
          <Grid container direction='row' alignItems='center' spacing={1} xs={12}>
            {/* Title */}
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {this.isCloneBidderOrBulkUpdate() && handleChangeMarked && (
                  <Grid item>
                    <Checkbox
                      className={classes.checkbox}
                      checked={marked}
                      onChange={handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography className={classes.insideAccordionText}>
                    {ct('BidderTier')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* Text Field */}
            <Grid item>
              <TextField
                select={true}
                className='pb-bidder-settings-form-view_textfield-priority'
                name='Priority'
                value={Priority}
                onChange={this.handleChange}
                helperText={errors.Priority}
                error={!!errors.Priority}
                style={{ width: 100 }}
              >
                {generatePriorityOptions(
                  this.props.session.publisher,
                  false,
                  this.state.Bidder,
                ).map((option: IPriorityOption) => (
                  <MenuItem value={option.value}>{option.text}</MenuItem>
                ))}
              </TextField>
            </Grid>
            {/* Sub-tier field*/}
            {(isSuper(this.props.user.user) ||
              isSamsungPublisher(this.props.session.publisher.ID)) && (
              <Grid item>
                <TextField
                  select={true}
                  className='pb-bidder-settings-form-view_textfield-subpriority'
                  name='SubPriority'
                  value={SubPriority}
                  onChange={this.handleChange}
                  helperText={errors.SubPriority}
                  error={!!errors.SubPriority}
                  style={{ width: 100 }}
                  disabled={
                    !IS_AUTHORIZED(['write_bidder_subtier'], this.props.user.user).isAuthorized
                  }
                >
                  {generateSubPriorityOptions().map((option: IPriorityOption) => (
                    <MenuItem value={option.value}>{option.text}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
          </Grid>
          {Priority !== 10 && (
            <Grid container direction='row' spacing={1} xs={12}>
              <Grid item xs={3} />
              <Grid item>
                <span style={{ position: 'relative', top: 10 }}>
                  <FlexibleBiddingIconWithTooltip width={16} height={16} />
                </span>
              </Grid>
              <Grid item>
                <span
                  style={{
                    color: 'black',
                    fontSize: 14,
                    fontWeight: 500,
                    position: 'relative',
                    top: 8,
                  }}
                >
                  {ct('FlexibleBidding')}
                </span>
              </Grid>
              <Grid item style={{ marginLeft: -10 }}>
                <Switch
                  disabled={disableParams}
                  className={`${classes.centeredSwitch} pb-bidder-settings-form-view_button_flexible-bidding`}
                  checked={FlexibleBiddingEnabled === EBool.EBool_TRUE}
                  name='FlexibleBiddingEnabled'
                  onChange={this.handleChange}
                  value={FlexibleBiddingEnabled}
                  color='secondary'
                  style={{ marginRight: '0px' }}
                />
              </Grid>
              <Grid item style={{ marginLeft: -40, paddingTop: 12 }}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontWeight: 500,
                    fontSize: '14px',
                  }}
                >
                  {FlexibleBiddingEnabled === EBool.EBool_TRUE ? ct('Active') : ct('Inactive')}
                </span>
              </Grid>
              <Grid item>
                {/*/ / Flexible Bidding Errors*/}
                <Typography color={'error'} style={{ paddingLeft: 12 }}>
                  {errors.FlexibleBiddingError}
                </Typography>
              </Grid>
            </Grid>
          )}
          {
            // Flexible Bidding Thresholds Form
            FlexibleBiddingEnabled === EBool.EBool_TRUE && (
              <>
                <Grid
                  container
                  direction='row'
                  alignItems='center'
                  spacing={1}
                  xs={12}
                  style={{ marginTop: '4px' }}
                >
                  <Grid item xs={3} />
                  <PillSwitcher
                    currentText={flexibleBiddingTypeToString(FlexibleBiddingType)}
                    pills={FLEXIBLE_BIDDING_PILLS}
                    onChange={(value: string) => this.handleChangeFlexibleBiddingType(value)}
                  />
                </Grid>
                <Grid
                  container
                  direction='row'
                  alignItems='center'
                  spacing={1}
                  xs={12}
                  style={{ marginTop: '5px' }}
                >
                  <Grid item xs={3} />
                  <Grid
                    item
                    xs={6}
                    style={{ backgroundColor: publicaColors.veryLightGray, borderRadius: '5px' }}
                  >
                    {FlexibleBiddingThresholds.map((flexibleBiddingThreshold, idx) => (
                      <Grid
                        container
                        direction='row'
                        alignItems='center'
                        key={idx}
                        style={{
                          paddingTop: 12,
                          paddingBottom: 12,
                          borderBottom: '1px solid',
                          borderColor: publicaColors.lightGray,
                        }}
                      >
                        <Grid item xs={4}>
                          <TextField
                            label={`${flexibleBiddingTypeToString(FlexibleBiddingType)} ${ct(
                              'Threshold',
                            )}`}
                            className='pb-bidder-settings-form-view_textfield-threshold'
                            name={`FlexibleBiddingThresholds[${idx}].CPMThreshold`}
                            disabled={disableParams}
                            fullWidth={true}
                            type='number'
                            value={flexibleBiddingThreshold.CPMThreshold}
                            onChange={this.handleChange}
                            helperText={errors.FlexibleBiddingThreshold}
                            error={!!errors.FlexibleBiddingThreshold}
                          />
                        </Grid>
                        <Grid item xs={4} style={{ margin: '0 20px' }}>
                          <TextField
                            label={ct('MaxTier')}
                            select={true}
                            className='pb-bidder-settings-form-view_textfield-max-tier'
                            name={`FlexibleBiddingThresholds[${idx}].BidderPriority`}
                            value={flexibleBiddingThreshold.BidderPriority}
                            onChange={this.handleChange}
                            fullWidth={true}
                            helperText={errors.FlexibleBiddingMaxPriority}
                            error={!!errors.FlexibleBiddingMaxPriority}
                          >
                            {generatePriorityOptions(
                              this.props.session.publisher,
                              false,
                              this.state.Bidder,
                            ).map((option: IPriorityOption) => (
                              <MenuItem value={option.value}>{option.text}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={2}>
                          {FlexibleBiddingThresholds.length > 1 && (
                            <Button
                              style={{
                                color: publicaColors.lightBlue,
                                paddingLeft: 16,
                                paddingRight: 16,
                              }}
                              onClick={() => this.handleRemoveFlexibleBiddingThreshold(idx)}
                            >
                              {ct('Remove')}
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    ))}
                    <Grid item xs={12} style={{ marginTop: 6 }}>
                      <Tooltip
                        title={
                          areFlexibleBidderTiersAvailable
                            ? ct('BiddersTooltipAddTierThreshold')
                            : ct('BiddersTooltipAddTierThresholdNotice')
                        }
                        placement='right'
                      >
                        <div style={{ display: 'inline-block' }}>
                          <Button
                            style={{
                              color: areFlexibleBidderTiersAvailable ? publicaColors.lightBlue : '',
                            }}
                            disabled={10 - Priority - FlexibleBiddingThresholds.length <= 0}
                            onClick={this.handleAddFlexibleBiddingThreshold}
                          >
                            {ct('PlusAddItem', { item: ct('Threshold') })}
                          </Button>
                        </div>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )
          }
          {/* Flexible Bidding Dialog */}
          <FlexibleBiddingDialog
            open={this.state.flexibleBiddingDialogIsOpen}
            onRevert={() => this.toggle('flexibleBiddingDialogIsOpen')}
            onConfirm={this.removeInvalidFlexibleBiddingBiddingThresholdsAndCloseDialog}
            invalidThresholds={flexibleBiddingDialogInvalidThresholds}
          />
          {this.state.Bidder === 'spotx' && (
            <Tooltip title={isSpotxTierDisabled ? ct('BiddersTooltipTierMappingTable') : ''}>
              <Grid container direction='row' alignItems='center' spacing={1} xs={12}>
                <Grid item xs={3} />
                <Grid
                  item
                  container
                  xs={9}
                  direction='row'
                  alignItems='center'
                  spacing={1}
                  style={{
                    marginTop: isSpotxTierDisabled ? '8px' : '',
                    borderRadius: '5px',
                    maxWidth: isSpotxTierDisabled ? '420px' : '100%', // nice
                  }}
                >
                  <Grid item>
                    <span style={{ position: 'relative' }}>
                      <DoNotUseDemandSourceSettingsIconWithTooltip width={16} height={16} />
                    </span>
                  </Grid>
                  <Grid item>
                    <span
                      style={{
                        color: isSpotxTierDisabled ? 'gray' : 'black',
                        fontSize: 14,
                        fontWeight: 500,
                        position: 'relative',
                      }}
                    >
                      Use tier from Demand Source
                    </span>
                  </Grid>
                  <Grid item>
                    <div style={{ marginLeft: 16, position: 'relative' }}>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          fontWeight: 500,
                          color: isSpotxTierDisabled ? 'gray' : 'black',
                        }}
                      >
                        {isSpotxTierDisabled
                          ? ct('Inactive')
                          : EnableSpotxBidderAssociation === EBool.EBool_TRUE
                          ? ct('Active')
                          : ct('Inactive')}
                      </span>
                      <Switch
                        disabled={disableParams || isSpotxTierDisabled}
                        className={classes.centeredSwitch}
                        checked={
                          isSpotxTierDisabled
                            ? false
                            : EnableSpotxBidderAssociation === EBool.EBool_TRUE
                        }
                        name='EnableSpotxBidderAssociation'
                        onChange={this.handleChange}
                        value={EnableSpotxBidderAssociation}
                        color='secondary'
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Tooltip>
          )}
          {this.state.Bidder === DemandSources.magnitectv && (
            <Tooltip title={isMagniteCTVTierDisabled ? ct('BiddersTooltipTierMappingTable') : ''}>
              <Grid container direction='row' alignItems='center' spacing={1} xs={12}>
                <Grid item xs={3} />
                <Grid
                  item
                  container
                  xs={9}
                  direction='row'
                  alignItems='center'
                  spacing={1}
                  style={{
                    marginTop: isMagniteCTVTierDisabled ? '8px' : '',
                    borderRadius: '5px',
                    maxWidth: isMagniteCTVTierDisabled ? '420px' : '100%', // nice
                  }}
                >
                  <Grid item>
                    <span style={{ position: 'relative' }}>
                      <DoNotUseDemandSourceSettingsIconWithTooltip width={16} height={16} />
                    </span>
                  </Grid>
                  <Grid item>
                    <span
                      style={{
                        color: isMagniteCTVTierDisabled ? 'gray' : 'black',
                        fontSize: 14,
                        fontWeight: 500,
                        position: 'relative',
                      }}
                    >
                      Use tier from Demand Source
                    </span>
                  </Grid>
                  <Grid item>
                    <div style={{ marginLeft: 16, position: 'relative' }}>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          fontWeight: 500,
                          color: isMagniteCTVTierDisabled ? 'gray' : 'black',
                        }}
                      >
                        {isMagniteCTVTierDisabled
                          ? ct('Inactive')
                          : EnableMagniteCTVBidderAssociation === EBool.EBool_TRUE
                          ? ct('Active')
                          : ct('Inactive')}
                      </span>
                      <Switch
                        disabled={disableParams || isMagniteCTVTierDisabled}
                        className={classes.centeredSwitch}
                        checked={
                          isMagniteCTVTierDisabled
                            ? false
                            : EnableMagniteCTVBidderAssociation === EBool.EBool_TRUE
                        }
                        name='EnableMagniteCTVBidderAssociation'
                        onChange={this.handleChange}
                        value={EnableMagniteCTVBidderAssociation}
                        color='secondary'
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Tooltip>
          )}
          {this.state.Bidder === DemandSources.samsungssp && (
            <Tooltip title={isSamsungSSPTierDisabled ? ct('BiddersTooltipTierMappingTable') : ''}>
              <Grid container direction='row' alignItems='center' spacing={1} xs={12}>
                <Grid item xs={3} />
                <Grid
                  item
                  container
                  xs={9}
                  direction='row'
                  alignItems='center'
                  spacing={1}
                  style={{
                    marginTop: isSamsungSSPTierDisabled ? '8px' : '',
                    borderRadius: '5px',
                    maxWidth: isSamsungSSPTierDisabled ? '420px' : '100%', // nice
                  }}
                >
                  <Grid item>
                    <span style={{ position: 'relative' }}>
                      <DoNotUseDemandSourceSettingsIconWithTooltip width={16} height={16} />
                    </span>
                  </Grid>
                  <Grid item>
                    <span
                      style={{
                        color: isSamsungSSPTierDisabled ? 'gray' : 'black',
                        fontSize: 14,
                        fontWeight: 500,
                        position: 'relative',
                      }}
                    >
                      Use tier from Demand Source
                    </span>
                  </Grid>
                  <Grid item>
                    <div style={{ marginLeft: 16, position: 'relative' }}>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          fontWeight: 500,
                          color: isSamsungSSPTierDisabled ? 'gray' : 'black',
                        }}
                      >
                        {!isSamsungSSPTierDisabled &&
                        EnableSamsungSSPBidderAssociation === EBool.EBool_TRUE
                          ? ct('Active')
                          : ct('Inactive')}
                      </span>
                      <Switch
                        disabled={disableParams || isSamsungSSPTierDisabled}
                        className={classes.centeredSwitch}
                        checked={
                          isSamsungSSPTierDisabled
                            ? false
                            : EnableSamsungSSPBidderAssociation === EBool.EBool_TRUE
                        }
                        name='EnableSamsungSSPBidderAssociation'
                        onChange={this.handleChange}
                        value={EnableSamsungSSPBidderAssociation}
                        color='secondary'
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Tooltip>
          )}
        </div>
      );
    };

    renderIsPublicaTagFallbackEnabled = (rowInfo: IInputRow) => {
      const { classes, cloneBidderEnabled } = this.props;
      const { IsPublicaTagFallbackEnabled, IsFallbackBackfillEnabled } = this.state;
      const disableParams = this.paramsDisabled();

      const { marked, handleChangeMarked } = rowInfo;

      return (
        <div style={{ marginTop: 12, marginBottom: 12 }}>
          <Grid container direction='row' alignItems='center' spacing={1} xs={12}>
            {/* Title */}
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {!!cloneBidderEnabled && handleChangeMarked && (
                  <Grid item>
                    <Checkbox
                      className={classes.checkbox}
                      checked={marked}
                      onChange={handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography className={classes.insideAccordionText}>
                    {ct('SOVParallelAuctions')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* IsPublicaTagFallbackEnabled Switch */}
            <Grid item>
              <Switch
                disabled={disableParams}
                className={classes.centeredSwitch}
                checked={IsPublicaTagFallbackEnabled === PublicaTagFallbackEnabled}
                name='IsPublicaTagFallbackEnabled'
                onChange={this.handleChange}
                value={IsPublicaTagFallbackEnabled}
                color='primary'
              />
            </Grid>
          </Grid>
          {IsPublicaTagFallbackEnabled === PublicaTagFallbackEnabled && (
            <Grid container direction='row' alignItems='center' spacing={1} xs={12}>
              <Grid item xs={3} />
              <Grid item>
                <span
                  style={{
                    color: 'black',
                    fontSize: 14,
                    fontWeight: 500,
                    position: 'relative',
                    top: 8,
                  }}
                >
                  Backfill
                </span>
              </Grid>
              <Grid item>
                <div style={{ marginLeft: 16, position: 'relative', top: 8 }}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      fontWeight: 500,
                    }}
                  >
                    {IsFallbackBackfillEnabled === FallbackBackfillEnabled
                      ? ct('Enabled')
                      : ct('Disabled')}
                  </span>
                  <Switch
                    disabled={disableParams}
                    className={classes.centeredSwitch}
                    checked={IsFallbackBackfillEnabled === FallbackBackfillEnabled}
                    name='IsFallbackBackfillEnabled'
                    onChange={this.handleChange}
                    value={IsFallbackBackfillEnabled}
                    color='primary'
                  />
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      );
    };

    renderVastUrl = (
      rowInfo: IInputRow,
      option: IHeaderBidderParamOption,
      disableEdit: boolean,
    ) => {
      // Also the Bidder Tier
      const { classes, cloneBidderEnabled } = this.props;

      const { publisher } = this.props.session;

      const { marked, handleChangeMarked } = rowInfo;

      return (
        // vast URL component
        <Grid item style={{ width: '100%' }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {!!cloneBidderEnabled && (
                  <Grid item>
                    <Checkbox
                      className={classes.checkbox}
                      checked={marked}
                      onChange={handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography className={classes.insideAccordionText}>{ct('VASTURL')}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8}>
              <VastEditor
                url={option.Value}
                urlID={option.ID}
                highlight={(code) => highlight(code, languages.elm, 'elm')}
                padding={5}
                maxLength={2000}
                onURLChange={(text: string) => {
                  this.handleChangeParamOptionVASTUrl(text);
                }}
                textStyle={{
                  background: 'aliceblue',
                  borderRadius: smallRadius,
                  opacity: '1',
                  padding: '5px 10px',
                }}
                wikiMsgHidden={publisher.Reseller && publisher.Reseller.ID === '4'}
                disableSiteIDMacro={
                  this.state.Bidder === DemandSources.publica && isPBSDomain(String(option.Value))
                }
                disabled={disableEdit}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // create a new key-value parameter for the current bidder
    newKeyValueParameter(count: number, biddername: string) {
      const isTelaria = biddername === DemandSources.telaria;
      const isNexstar = biddername === DemandSources.nexstar;
      const isNexxen = biddername === DemandSources.rhythmone;

      // telaria
      if (isTelaria) {
        // the empty string provides a single freeform KVP for Telaria bidders
        this.createFixedKeyValueParameter(count, ['custom', 'c1', 'c2', 'c3', ''], isTelaria);
        return;
      }
      // nexstar
      if (isNexstar) {
        this.createFixedKeyValueParameter(count, ['custom1', 'custom2', 'custom3'], false);
        return;
      }
      // nexxen ctrl
      if (isNexxen) {
        this.createFixedKeyValueParameter(
          count,
          ['customkey1', 'customkey2', 'customkey3', 'customkey4', 'customkey5'],
          false,
        );
        return;
      }

      // default
      this.createNewKeyValueParameter();
    }

    // editKeyValueParameter apply changed to key-value parameter in the state at a defined index
    editKeyValueParameter = (
      index: number,
      editedParameter: IKeyValueParameter,
      bidder: string,
    ): void => {
      if (bidder === DemandSources.thetradedesk) {
        if (editedParameter.key.length > 50) {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('MaxKeyLengthIs') + ' 50',
          });
        } else if (editedParameter.value.length > 150) {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('MaxValueLengthIs') + ' 150',
          });
        }
      }
      this.setState(
        {
          keyValueParameters: update(this.state.keyValueParameters, {
            [index]: {
              $set: editedParameter,
            },
          }),
        },
        () => this.updateParams(this.state.ParamOptions),
      );
    };

    // editPrefixRootKeyValueParameter updates a prefix for one of the root key-value parameters at a defined index
    editPrefixRootKeyValueParameter = (oldPrefix: string, newPrefix: string, idx: number) => {
      const { rootKeyValueParameters, ParamOptions } = this.state;

      const clonedRootKeyValueParameters = cloneDeep(rootKeyValueParameters);

      // track the old kvp
      if (
        clonedRootKeyValueParameters &&
        clonedRootKeyValueParameters[oldPrefix] &&
        clonedRootKeyValueParameters[oldPrefix][idx]
      ) {
        const oldRootKeyValueParameter = clonedRootKeyValueParameters[oldPrefix][idx];
        if (oldRootKeyValueParameter) {
          clonedRootKeyValueParameters[oldPrefix][idx].prefix = newPrefix;
        }
      }

      this.setState(
        {
          rootKeyValueParameters: clonedRootKeyValueParameters,
        },
        () => this.updateParams(ParamOptions),
      );
    };

    // editRootKeyValueParameter updates a key-value parameter in the state at a defined index, with the provided prefix
    editRootKeyValueParameter = (
      prefix: string,
      idx: number,
      updatedKeyValueParameter: IRootKeyValueParameter,
    ) => {
      const { rootKeyValueParameters, ParamOptions } = this.state;

      const clonedRootKeyValueParameters = cloneDeep(rootKeyValueParameters);
      if (
        !!clonedRootKeyValueParameters &&
        !!clonedRootKeyValueParameters[prefix] &&
        !!clonedRootKeyValueParameters[prefix][idx]
      ) {
        clonedRootKeyValueParameters[prefix][idx] = updatedKeyValueParameter;
      }

      this.setState(
        {
          rootKeyValueParameters: clonedRootKeyValueParameters,
        },
        () => this.updateParams(ParamOptions),
      );
    };

    // createFixedKeyValueParameter creates a new key-value parameter using fixed keys for telaria bidder (HB-608)
    createFixedKeyValueParameter = (count: number, fixedKeys: string[], isTelaria: boolean) => {
      if (count === fixedKeys.length && !isTelaria) {
        this.setState(
          {
            snackbarMessage: ct('BiddersSnackbarMaximumAllowedParameters'),
            snackbarError: true,
          },
          () => {
            setTimeout(this.snackbarClose, 4000);
          },
        );
        return;
      }

      // select next key based on available fixed keys to avoid duplication on deletion
      let nextKey;
      for (const key of fixedKeys) {
        let taken = false;
        this.state.keyValueParameters.forEach((param: IKeyValueParameter) => {
          if (key === param.key) {
            taken = true;
          }
        });
        if (!taken) {
          nextKey = key;
          break;
        }
      }

      if (nextKey === undefined) {
        nextKey = '';
      }

      this.setState(
        {
          keyValueParameters: update(this.state.keyValueParameters, {
            $push: [{ key: `${nextKey}`, value: '', typ: '' } as IKeyValueParameter],
          }),
        },
        () => this.updateParams(this.state.ParamOptions),
      );
    };

    // createNewKeyValueParameter creates a new key-value parameter in the state
    createNewKeyValueParameter = () => {
      this.setState(
        {
          keyValueParameters: update(this.state.keyValueParameters, {
            $push: [{ key: '', value: '', typ: '' } as IKeyValueParameter],
          }),
        },
        () => this.updateParams(this.state.ParamOptions),
      );
    };

    // deleteKeyValueParameter deletes a key-value parameter in the state at a defined index
    deleteKeyValueParameter = (index: number) => {
      this.setState(
        {
          keyValueParameters: update(this.state.keyValueParameters, {
            $splice: [[index, 1]],
          }),
        },
        () => this.updateParams(this.state.ParamOptions),
      );
    };

    // createNewRootKeyValueParameter creates a new root key-value parameter under a given prefix
    createNewRootKeyValueParameter = (prefix: string) => {
      const { rootKeyValueParameters, ParamOptions } = this.state;
      const clonedRootKeyValueParameters = cloneDeep(rootKeyValueParameters);

      if (!clonedRootKeyValueParameters[prefix]) {
        clonedRootKeyValueParameters[prefix] = [] as IRootKeyValueParameter[];
      }
      clonedRootKeyValueParameters[prefix].push({
        key: '',
        value: '',
        typ: '',
        prefix: '',
      } as IRootKeyValueParameter);

      this.setState(
        {
          rootKeyValueParameters: clonedRootKeyValueParameters,
        },
        () => this.updateParams(ParamOptions),
      );
    };

    // deleteRootKeyValueParameter deletes a root key-value parameter at a given prefix + index
    deleteRootKeyValueParameter = (prefix: string, idx: number) => {
      const { rootKeyValueParameters, ParamOptions } = this.state;
      const clonedRootKeyValueParameters = cloneDeep(rootKeyValueParameters);
      if (!!clonedRootKeyValueParameters && !!clonedRootKeyValueParameters[prefix]) {
        clonedRootKeyValueParameters[prefix].splice(idx, 1);
      }
      this.setState(
        {
          rootKeyValueParameters: clonedRootKeyValueParameters,
        },
        () => this.updateParams(ParamOptions),
      );
    };

    // parseKeyValueParametersFromParams gets the key-value parameters from the bidder's params
    parseKeyValueParametersFromParams = () => {
      const { Params } = this.state;
      const newKeyValueParameters: IKeyValueParameter[] = [];
      const newRootKeyValueParameters: { [key: string]: IRootKeyValueParameter[] } = {};
      const keyValueParameters = Params.split('\n');
      for (const keyValueParameter of keyValueParameters) {
        // check for ": specifically since that splits each key value pair in json and the user might use : in the value
        const colonIdx = keyValueParameter.indexOf(`":`) + 1;
        if (colonIdx === 0) {
          continue; // Bad format, skip
        }

        // remove all quotes and trailing commas from the data
        const data = [
          keyValueParameter.substring(0, colonIdx),
          keyValueParameter.substring(colonIdx + 1),
        ];
        const unquotedKey = data[0].substring(1, data[0].length - 1);
        let unquotedValue = data[1].substring(1, data[1].length - 1);
        if (unquotedValue[unquotedValue.length - 1] === '"') {
          unquotedValue = unquotedValue.substring(0, unquotedValue.length - 1);
        }

        // skip processing if the data is a key-value parameter (through the keyvalue- prefix)
        if (!unquotedKey.startsWith('keyvalue-') && !unquotedKey.startsWith('root-keyvalue-')) {
          continue;
        }

        if (unquotedKey.startsWith('keyvalue-')) {
          // create and append a new key-value parameter object
          newKeyValueParameters.push({
            key: unquotedKey.substring(9),
            value: unquotedValue,
            typ: '',
            isNotEditable:
              (unquotedKey.substring(9) === 'c4' &&
                this.state.Bidder === DemandSources.magnitectv) ||
              (unquotedKey.substring(9) === 'iris_context' &&
                this.state.Bidder === DemandSources.videobyte)
                ? true
                : false,
          } as IKeyValueParameter);
        } else {
          // create and append a new root key-value parameter object under a prefix
          const prefix = unquotedKey.substring(14).split('-')[0];
          if (!newRootKeyValueParameters[prefix]) {
            newRootKeyValueParameters[prefix] = [] as IRootKeyValueParameter[];
          }
          newRootKeyValueParameters[prefix].push({
            key: unquotedKey.substring(14 + prefix.length + 1), // account for prefix and hyphen
            value: unquotedValue,
            typ: '',
            prefix,
          } as IRootKeyValueParameter);
        }
      }
      this.setState({
        rootKeyValueParameters: newRootKeyValueParameters,
        keyValueParameters: newKeyValueParameters,
        Params: keyValueParameters.join('\n'), // clone bug - CTV-1375
      });
    };

    // parseKeyValueParametersFromBidder gets the key-value parameters from the bidder's custom params
    // WITHOUT removing the 'keyvalue-' prefix, and is used for cloning bidders
    parseKeyValueParametersFromBidder = (bidder: IHeaderBidder) => {
      const keyValueParameters: IKeyValueParameter[] = [];
      const bidderParams = bidder.Params.split('\n');
      for (const bidderParam of bidderParams) {
        const splitBidderParam = bidderParam.split(':');
        // check for bad param format
        if (splitBidderParam.length < 2) {
          continue;
        }

        // remove '"' and ','
        const mappedBidderParams = splitBidderParam.map((bidderParam) =>
          bidderParam.substring(1, bidderParam.length - 1),
        );
        const bidderParamKey = mappedBidderParams[0];
        let bidderParamValue = mappedBidderParams[1];
        bidderParamValue =
          bidderParamValue[bidderParamValue.length - 1] === '"'
            ? bidderParamValue.substring(0, bidderParamValue.length - 1)
            : bidderParamValue;

        // check if the data is a key value param
        if (!bidderParamKey.startsWith('keyvalue-')) {
          continue;
        }

        keyValueParameters.push({
          key: bidderParamKey,
          value: bidderParamValue,
          typ: '',
        });
      }
      return keyValueParameters;
    };

    renderAPSOpenAuctionRow = (
      option: IHeaderBidderParamOption,
      customDescription: string,
      rowInfo: IInputRow,
    ) => {
      const { classes, cloneBidderEnabled } = this.props;
      const { marked, handleChangeMarked } = rowInfo;

      return (
        <Grid item style={{ width: '100%' }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {!!cloneBidderEnabled && handleChangeMarked && (
                  <Grid item>
                    <Checkbox
                      className={classes.checkbox}
                      checked={marked}
                      onChange={handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography className={classes.insideAccordionText}>
                    {ct('PriceRange')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <TextField
                name={option.Name}
                select={true}
                style={{ width: 400, height: 60 }}
                onChange={this.handleChangeParamOption}
                value={option.Value}
                helperText={
                  this.state.errors['ParamsOptions_' + option.Name]
                    ? this.state.errors['ParamsOptions_' + option.Name]
                    : customDescription
                }
                error={!!this.state.errors['ParamsOptions_' + option.Name]}
              >
                {[
                  { text: ct('All'), value: 'All' },
                  { text: '$0-$50', value: '$0-$50' },
                  { text: '$50-$100', value: '$50-$100' },
                  { text: '$100+', value: '$100+' },
                ].map((item: any) => {
                  return (
                    <MenuItem key={item.text} value={item.value}>
                      {item.text}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    handleCloneBidder = (): void => {
      this.props.dispatch(SESSION_ACTIONS_SET({ cloneBidderID: this.state.ID }));
      navigate(RouteBidderSettingsClone, extractRouteParams(this.props), { b: this.state.ID });
    };

    checkIfRowIsMarked = (fields: string[]): boolean => {
      for (const field of fields) {
        if (
          this.state.bulkUpdateEnabledFields[field] === undefined ||
          !this.state.bulkUpdateEnabledFields[field].enabled
        ) {
          return false;
        }
      }
      return true;
    };

    handleDisableMarkedForBulkUpdate = (key: string) => {
      const bulkUpdateEnabledFields = cloneDeep(this.state.bulkUpdateEnabledFields);
      if (key in bulkUpdateEnabledFields) {
        bulkUpdateEnabledFields[key].enabled = false;
      }
      this.setState({
        bulkUpdateEnabledFields,
      });
    };

    handleChangeMarked = (bulkUpdateItems: IBulkUpdateItem[]): void => {
      const bulkUpdateEnabledFields = cloneDeep(this.state.bulkUpdateEnabledFields);
      let startOver = false;
      for (const item of bulkUpdateItems) {
        if (bulkUpdateEnabledFields[item.key] === undefined) {
          bulkUpdateEnabledFields[item.key] = item;
          bulkUpdateEnabledFields[item.key].enabled = true;
        } else if (bulkUpdateEnabledFields[item.key].enabled) {
          bulkUpdateEnabledFields[item.key].enabled = false;
        } else {
          startOver = true;
          bulkUpdateEnabledFields[item.key].enabled = true;
        }
      }
      if (startOver) {
        for (const item of bulkUpdateItems) {
          bulkUpdateEnabledFields[item.key].enabled = true;
        }
      }
      this.genTimezoneList();
      this.setState({
        bulkUpdateEnabledFields,
      });
    };

    renderCustomRow = (
      customElement: ReactElement,
      customLabel: string,
      rowInfo: IInputRow,
      alignItems: string = 'center',
    ) => {
      const { classes } = this.props;
      const { marked, handleChangeMarked } = rowInfo;

      return () => {
        return (
          <Grid item style={{ width: '100%' }}>
            <Grid
              container
              direction='row'
              justify='flex-start'
              alignItems={alignItems}
              spacing={1}
            >
              <Grid item xs={3}>
                <Grid
                  container
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  spacing={0}
                >
                  {this.isCloneBidderOrBulkUpdate() && (
                    <Grid item>
                      <Checkbox
                        className={this.props.classes.checkbox}
                        checked={marked}
                        onChange={handleChangeMarked}
                      />
                    </Grid>
                  )}
                  <Grid item>
                    <Typography className={classes.insideAccordionText}>{customLabel}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={9}>
                {customElement}
              </Grid>
            </Grid>
          </Grid>
        );
      };
    };

    renderLocalTargetingPanel = () => {
      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], this.props.user.user);
      return (
        <LocalTargeting
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed}
          LocalTargetingLogic={this.state.LocalTargetingLogic}
          localTargetingLogicFieldName='LocalTargetingLogic'
          localTargetingParameters={[...this.state.localTargetingParameters]}
          disabled={!writeAuthorization.isAuthorized}
          resourceName='Bidder'
          isCloneOrBulkUpdate={this.isCloneBidderOrBulkUpdate()}
          checkIfRowIsMarked={this.checkIfRowIsMarked}
          handleChangeMarked={this.handleChangeMarked}
          getCloneType={this.getCloneType}
          addLocalTargetingParam={this.addLocalTargetingParam}
          handleChange={this.handleChange}
          updateLocalTargetingParam={this.updateLocalTargetingParam}
          deleteLocalTargetingParam={this.deleteLocalTargetingParam}
        />
      );
    };

    // custom render for audience segment panel
    renderAudienceSegmentRow = (rowInfo: IInputRow) => {
      const { classes } = this.props;
      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], this.props.user.user);
      const isActive =
        this.state.TargetingAudienceSegmentID.length &&
        this.state.TargetingAudienceSegmentID.split(',').length;
      return (
        <Grid item style={{ width: '100%', marginBottom: 5 }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {this.isCloneBidderOrBulkUpdate() && (
                  <Grid item>
                    <Checkbox
                      className={this.props.classes.checkbox}
                      checked={rowInfo.marked}
                      onChange={rowInfo.handleChangeMarked}
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography
                    className={
                      isActive ? classes.insideAccordionTextBold : classes.insideAccordionText
                    }
                  >
                    Audience Segments
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* Grid for extra space/can be replaced with optional icon */}
            <Grid item xs={1} />
            <Grid item xs={1}>
              <ConfirmationDialogButton
                title={ct('TargetingChange')}
                description={makeTargetingChangeDescription(
                  this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY,
                )}
                triggerComponentInfo={makeTargetingChangeInfoHover(
                  this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY,
                )}
                acceptButtonTitle={ct('Confirm')}
                acceptButtonCallBack={() =>
                  this.handleChange({
                    target: {
                      name: 'TargetingAudienceSegmentIDIsAllowed',
                      value: reverseEAllowStatus(
                        this.state.TargetingAudienceSegmentIDIsAllowed,
                      ) as any,
                    },
                  } as any)
                }
                refuseButtonTitle={ct('Cancel')}
                disabled={!writeAuthorization.isAuthorized}
              >
                <IconButton>
                  {this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY ? (
                    <IconV2 name='checkmark-plain' large color={publicaColors.green} />
                  ) : (
                    <IconV2 name='unavailable' large color={publicaColors.red} />
                  )}
                </IconButton>
              </ConfirmationDialogButton>
            </Grid>
            <Grid item xs={5}>
              <MaterialSearchDropdownMulti
                getValueFromSearchElement={(src: IListItem) => src.title}
                selectAll={true}
                menuTitle={ct('AudienceSegments')}
                list={this.getAudienceSegmentsAsItems()}
                disabled={!writeAuthorization.isAuthorized}
                onChange={(values: IMenuList) => {
                  this.setState({
                    TargetingAudienceSegmentID: Object.values(values)
                      .filter((src: IListItem) => {
                        return src.selected;
                      })
                      .map((src: IListItem) => src.ID)
                      .join(','),
                  });
                }}
                handleMenuAcceptClick={() => null}
                allowDenyLogicEnabled={true}
                isAllowedSelected={
                  this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY
                }
                onChangeAllowDenyToggle={(isAllowed: boolean) =>
                  this.setState({
                    TargetingAudienceSegmentIDIsAllowed: isAllowed
                      ? EAllowStatus.ALLOW
                      : EAllowStatus.DENY,
                  })
                }
                isNoneSelectedAllSelected={false}
                helperText={ct('BiddersMessageAudienceSegment')}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControl component='fieldset'>
                <RadioGroup
                  row
                  aria-label='position'
                  name='SegmentTargeting'
                  defaultValue='top'
                  value={this.state.SegmentTargeting}
                  onChange={this.handleChange}
                >
                  <Tooltip title={ct('BiddersTooltipTargetedRequestCanBeInSegment')}>
                    <FormControlLabel
                      disabled={!writeAuthorization.isAuthorized}
                      value={SegmentTargetingOR}
                      control={<Radio color='primary' size='small' />}
                      label={
                        <Typography className={this.props.classes.formControlLabel}>
                          {ct('Or')}
                        </Typography>
                      }
                      labelPlacement='top'
                    />
                  </Tooltip>
                  <Tooltip title={ct('BiddersTooltipTargetedRequestMustBeInSegment')}>
                    <FormControlLabel
                      disabled={!writeAuthorization.isAuthorized}
                      value={SegmentTargetingAND}
                      control={<Radio color='primary' size='small' />}
                      label={
                        <Typography className={this.props.classes.formControlLabel}>
                          {ct('And')}
                        </Typography>
                      }
                      labelPlacement='top'
                    />
                  </Tooltip>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderDayparting = (rowInfo: IInputRow) => {
      const { DaypartingIntervals, DaypartingIsAllowed, enableViewerTimezone, isDaypartingActive } =
        this.state;
      const { marked, handleChangeMarked } = rowInfo;

      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], this.props.user.user);

      const { classes } = this.props;

      return (
        <Grid style={{ width: '100%' }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
            {this.isCloneBidderOrBulkUpdate() && (
              <Grid item xs={4}>
                <Checkbox
                  className={classes.checkbox}
                  checked={marked}
                  onChange={handleChangeMarked}
                />
              </Grid>
            )}
            <Grid item xs={8}>
              <Grid>
                <span className={classes.spanSubHeader}>
                  {isDaypartingActive ? ct('Active') : ct('Inactive')}
                  <Tooltip title={ct('BiddersTooltipDayparting')}>
                    <InfoIcon
                      style={{
                        verticalAlign: 'center',
                        width: '1rem',
                        color: publicaColors.lightGray,
                        marginLeft: '5px',
                      }}
                    />
                  </Tooltip>
                </span>
                <span className={classes.centeredSwitchNoLeftMargin}>
                  <Switch
                    className={classes.centeredSwitchNoLeftMargin}
                    checked={isDaypartingActive}
                    name='DaypartingActive'
                    onChange={this.handleChange}
                    value={isDaypartingActive}
                    color='secondary'
                  />
                </span>
              </Grid>
              {isDaypartingActive && (
                <>
                  <Grid>
                    <span className={classes.spanSubHeader}>{ct('Logic')}</span>
                    <span className={classes.centeredSwitchNoLeftMargin}>
                      <span className={classes.spanActive}>
                        {DaypartingIsAllowed === EAllowStatus.ALLOW ? ct('Include') : ct('Exclude')}
                      </span>
                      <ConfirmationDialogButton
                        title={ct('DaypartingIncludeExclude')}
                        description={makeTargetingChangeDescription(
                          DaypartingIsAllowed === EAllowStatus.ALLOW,
                        )}
                        triggerComponentInfo={makeTargetingChangeInfoHover(
                          DaypartingIsAllowed === EAllowStatus.ALLOW,
                        )}
                        acceptButtonTitle={ct('Confirm')}
                        acceptButtonCallBack={() =>
                          this.handleChange({
                            target: {
                              name: 'DaypartingIsAllowed',
                              value:
                                DaypartingIsAllowed === EAllowStatus.ALLOW
                                  ? EAllowStatus.DENY
                                  : (EAllowStatus.ALLOW as any),
                            },
                          } as any)
                        }
                        disabled={!writeAuthorization.isAuthorized}
                        refuseButtonTitle={ct('Cancel')}
                      >
                        <IconButton>
                          {DaypartingIsAllowed === EAllowStatus.ALLOW ? (
                            <IconV2 name='checkmark-plain' large color={publicaColors.green} />
                          ) : (
                            <IconV2 name='unavailable' large color={publicaColors.red} />
                          )}
                        </IconButton>
                      </ConfirmationDialogButton>
                      <Grid style={{ width: '300px' }}>
                        {DaypartingIsAllowed === EAllowStatus.ALLOW ? (
                          <span style={{ fontSize: 10 }}>
                            {ct('BiddersMessageDaypartingWillDeliverDuringSelectedTime')}
                          </span>
                        ) : (
                          <span style={{ fontSize: 10 }}>
                            {ct('BiddersMessageDaypartingWillNotDeliverDuringSelectedTime')}
                          </span>
                        )}
                      </Grid>
                    </span>
                  </Grid>
                  <Grid
                    style={{
                      display: 'inline-flex',
                      marginTop: '6px',
                      marginBottom: '6px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span className={classes.spanSubHeader}>{ct('Timezone')}</span>
                    <Grid>
                      <PillSwitcher
                        currentText={daypartingTimezonesTypeToString(
                          enableViewerTimezone,
                          EDaypartingTimezonesType.Bidder,
                        )}
                        pills={DAYPARTING_TIMEZONES_BIDDER_PILLS}
                        customStyle={{ width: '170px', height: '40px', padding: '10px' }}
                        onChange={(value: string) => {
                          const enableViewerTimezone = daypartingTimezonesTypeToBoolean(value);
                          this.setState({
                            enableViewerTimezone,
                          });
                        }}
                      />
                    </Grid>
                    <Grid>
                      {enableViewerTimezone ? (
                        <span style={{ fontSize: 10, padding: '5px' }}>
                          {ct('BiddersMessageDaypartingDeviceLocation')}
                        </span>
                      ) : (
                        <span style={{ fontSize: 10, padding: '5px' }}>
                          {ct('BiddersMessageDaypartingBidderTimezone')}
                        </span>
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    style={{
                      display: 'inline-flex',
                      alignItems: 'flex-start',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'start',
                        width: 100,
                        fontSize: 15,
                      }}
                    >
                      {ct('Period')}
                    </span>
                    <DaypartingSelector
                      DaypartingIntervals={DaypartingIntervals}
                      handleDateChange={this.handleDaypartingDateChange}
                      handleDayClick={this.handleDayClick}
                      handleDeleteDaypartingPeriod={this.handleDeleteDaypartingPeriod}
                      handleAddDaypartingPeriod={this.handleAddDaypartingPeriod}
                      classes={classes}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // custom render for contextual segment panel
    renderContextualSegmentRow = () => {
      const { classes } = this.props;
      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], this.props.user.user);
      const isActive = this.state.ContextualSegmentIDS.length > 0;
      return (
        <Grid item style={{ width: '100%', marginBottom: 5 }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
                {this.isCloneBidderOrBulkUpdate() && (
                  <Grid item>
                    <Checkbox
                      className={this.props.classes.checkbox}
                      checked={this.checkIfRowIsMarked(['ContextualSegmentIDS'])}
                      onChange={() =>
                        this.handleChangeMarked([
                          {
                            key: 'ContextualSegmentIDS',
                            displayTitle: ct('ContextualSegmentIDs'),
                            genDisplayValue: () => this.state.ContextualSegmentIDS.join(', '),
                            enabled: false,
                          },
                        ])
                      }
                    />
                  </Grid>
                )}
                <Grid item>
                  <Typography
                    className={
                      isActive ? classes.insideAccordionTextBold : classes.insideAccordionText
                    }
                  >
                    {ct('ContextualSegments')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* Grid for extra space/can be replaced with optional icon */}
            <Grid item xs={2} />
            <Grid item xs={5}>
              <MaterialSearchDropdownMulti
                getValueFromSearchElement={(src: IListItem) => src.title}
                selectAll={true}
                menuTitle={ct('ContextualSegments')}
                list={this.state.contextualSegmentList}
                disabled={!writeAuthorization.isAuthorized}
                onChange={(contextualSegmentList: IMenuList) =>
                  this.setState({ contextualSegmentList })
                }
                handleMenuAcceptClick={this.handleContextualSegmentsAcceptClick}
                isNoneSelectedAllSelected={false}
                helperText={ct('BiddersMesssageContextualSegment')}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // [LocalTargeting] updateLocalTargetingParam handles type or value change for local targeting params
    updateLocalTargetingParam = (index: number, updates: object) => {
      this.setState({
        localTargetingParameters: update(this.state.localTargetingParameters, {
          [index]: {
            $set: { ...this.state.localTargetingParameters[index], ...updates },
          },
        }),
      });
    };

    // [LocalTargeting] deleteLocalTargetingParam handles deleting a local targeting param
    deleteLocalTargetingParam = (index: number) => {
      this.setState({
        localTargetingParameters: update(this.state.localTargetingParameters, {
          $splice: [[index, 1]],
        }),
      });
    };

    // [LocalTargeting] addLocalTargetingParam handles adding a new local targeting param
    addLocalTargetingParam = () => {
      this.setState({
        localTargetingParameters: update(this.state.localTargetingParameters, {
          $push: [
            {
              type: 'country',
              country: '',
              states: '',
              cities: '',
              zips: '',
              dmas: '',
              isInputInCommaSeparatedMode: false,
            } as ILocalTargetingParameter,
          ],
        }),
      });
    };

    // [LocalTargeting] exportLocalTargetingParamToJSON exports all the local targeting params to a json string
    exportLocalTargetingParamToJSON = (): string => {
      const filteredList = exportLocalTargetingToJSON(this.state.localTargetingParameters);
      return JSON.stringify(filteredList);
    };

    // [LocalTargeting] importLocalTargetingParamFromJSON imports JSON to local targeting params
    importLocalTargetingParamFromJSON = (inputJSON: string): void => {
      if (inputJSON === undefined || inputJSON.length === 0) {
        return;
      }
      let localParams: ILocalTargetingParameter[] = [];
      try {
        localParams = (JSON.parse(inputJSON) as object[]).map((o: ILocalTargetingParameter) => ({
          ...o,
          currentValue: '',
        }));
      } catch (e) {
        // Ignore JSON parse errors
      }
      this.setState({ localTargetingParameters: localParams });
    };
  },
);
